import { useQuery, useInfiniteQuery, useMutation, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseMutationOptions } from '@tanstack/react-query';
import { useFetchData } from '../Authenticated/ReactQueryProvider';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An attribute value */
  AttributeValue: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
  /** A string, Integer, Float or Boolean */
  RuleValue: { input: any; output: any; }
};

/** Autogenerated input type of ActivateProjectView */
export type ActivateProjectViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectViewId: Scalars['ID']['input'];
};

/** Autogenerated return type of ActivateProjectView. */
export type ActivateProjectViewPayload = {
  __typename?: 'ActivateProjectViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  projectView?: Maybe<ProjectView>;
};

/** Autogenerated input type of AddAudienceDomains */
export type AddAudienceDomainsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  domains: Array<Scalars['String']['input']>;
  projectViewId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddAudienceDomains. */
export type AddAudienceDomainsPayload = {
  __typename?: 'AddAudienceDomainsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  projectView?: Maybe<ProjectView>;
};

/** Autogenerated input type of AddCohortAudienceDomains */
export type AddCohortAudienceDomainsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cohortId: Scalars['ID']['input'];
  domains: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of AddCohortAudienceDomains. */
export type AddCohortAudienceDomainsPayload = {
  __typename?: 'AddCohortAudienceDomainsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  cohort?: Maybe<Cohort>;
  errors: Array<UserError>;
};

/** Autogenerated input type of AddCohortSubscribers */
export type AddCohortSubscribersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cohortId: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of AddCohortSubscribers. */
export type AddCohortSubscribersPayload = {
  __typename?: 'AddCohortSubscribersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  cohort?: Maybe<Cohort>;
  errors: Array<UserError>;
};

/** Autogenerated input type of AddSlackChannels */
export type AddSlackChannelsInput = {
  categories: Array<Scalars['ID']['input']>;
  channels: Array<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Workspace the channels belong to */
  workspaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddSlackChannels. */
export type AddSlackChannelsPayload = {
  __typename?: 'AddSlackChannelsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  missingChannels: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddSubscribers */
export type AddSubscribersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emails: Array<Scalars['String']['input']>;
  projectViewId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddSubscribers. */
export type AddSubscribersPayload = {
  __typename?: 'AddSubscribersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  projectView?: Maybe<ProjectView>;
};

/** The query root of the analytics_schema schema */
export type AnalyticsQuery = {
  __typename?: 'AnalyticsQuery';
  /** Performance data about user interactions with announcements */
  announcementAnalytics?: Maybe<AnnouncementAnalytics>;
  /** Performance data about user feedback */
  feedbackAnalytics?: Maybe<FeedbackAnalytics>;
  /** Performance data about subscribers */
  subscriberAnalytics?: Maybe<SubscriberAnalytics>;
  /** Performance data about work items */
  workItemAnalytics?: Maybe<WorkItemAnalytics>;
};


/** The query root of the analytics_schema schema */
export type AnalyticsQueryAnnouncementAnalyticsArgs = {
  projectId: Scalars['ID']['input'];
};


/** The query root of the analytics_schema schema */
export type AnalyticsQueryFeedbackAnalyticsArgs = {
  projectId: Scalars['ID']['input'];
};


/** The query root of the analytics_schema schema */
export type AnalyticsQuerySubscriberAnalyticsArgs = {
  projectId: Scalars['ID']['input'];
};


/** The query root of the analytics_schema schema */
export type AnalyticsQueryWorkItemAnalyticsArgs = {
  projectId: Scalars['ID']['input'];
};

export type Announcement = Feedbackable & HasContentGenerators & HasFeedbacks & Node & Permalinks & {
  __typename?: 'Announcement';
  archived: Scalars['Boolean']['output'];
  /** The name of the author of the announcement. */
  author?: Maybe<Scalars['String']['output']>;
  authorWithFallback?: Maybe<Scalars['String']['output']>;
  /** The categories that are associated with this announcement. */
  categories: Array<Category>;
  /** The types of changes associated with an announcement */
  changeTypes: ChangeTypeConnection;
  /** Connected external data sources. Internal use only. */
  connectedSources?: Maybe<ConnectedSourceConnection>;
  content?: Maybe<Scalars['String']['output']>;
  contentGenerators?: Maybe<ContentGeneratorConnection>;
  /** The HTML representation of the content. */
  contentHtml?: Maybe<Scalars['String']['output']>;
  /** The plain text representation of the content. */
  contentPlainText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Defines the type of schema the content follows, draftjs to be deprecated. */
  contentType: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The description of the announcement. */
  description?: Maybe<Scalars['String']['output']>;
  descriptionWithFallback?: Maybe<Scalars['String']['output']>;
  /** Whether the announcement should be indexed by search engines. */
  doNotIndex?: Maybe<Scalars['Boolean']['output']>;
  emailAnalytics?: Maybe<EmailAnalyticsObject>;
  /** A short summary of the announcement, can be either auto-generated from content, or overridden by the author. */
  excerpt?: Maybe<Scalars['String']['output']>;
  excerptWithFallback?: Maybe<Scalars['String']['output']>;
  exportFeedbacks?: Maybe<Array<Feedback>>;
  /** The external content links that are associated with this announcement. */
  externalContentLinks?: Maybe<Array<ExternalContentLink>>;
  feedbackHappyCount: Scalars['Int']['output'];
  feedbackMehCount: Scalars['Int']['output'];
  feedbackSadCount: Scalars['Int']['output'];
  feedbacks?: Maybe<FeedbackConnection>;
  /** If there are any content generators in a pending or generating state */
  hasPendingContentGenerators?: Maybe<Scalars['Boolean']['output']>;
  /** The headline of the announcement, displayed */
  headline?: Maybe<Scalars['String']['output']>;
  /** The hero image of the announcement. */
  heroImage?: Maybe<Image>;
  id: Scalars['ID']['output'];
  inPublishedDigest: Scalars['Boolean']['output'];
  /** The name of the announcement. */
  name: Scalars['String']['output'];
  /** If notifications are sent for this announcement, only show the excerpt (instead of the full content) when true. */
  notificationsExcerptOnly?: Maybe<Scalars['Boolean']['output']>;
  notificationsSent: Scalars['Int']['output'];
  privatePermalink: Scalars['String']['output'];
  publicPermalink: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  scheduledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  scheduledAtTimezone?: Maybe<Scalars['String']['output']>;
  /** The share image of the announcement, will be display when this announcement is shared externally. */
  shareImage?: Maybe<Image>;
  /** Whether the subscribers of the page should be notified when this announcement is published. */
  shouldNotifyPageSubscribers?: Maybe<Scalars['Boolean']['output']>;
  /** The number of times the announcement was clicked in a Slack channel */
  slackChannelClickedCount: Scalars['Int']['output'];
  /** The number of Slack channels this announcement went to */
  slackChannelCount: Scalars['Int']['output'];
  /** The number of Slack channels that the announcement will publish in */
  slackChannelCounts: Scalars['Int']['output'];
  slackChannels: ChannelConnection;
  /** The message that is sent to Slack when this announcement is published. */
  slackMessage?: Maybe<Scalars['String']['output']>;
  /** The number of times the announcement was clicked for a Slack subscriber */
  slackSubscriberClickedCount: Scalars['Int']['output'];
  /** The slug of the announcement. This is used in the URL, and must be unique within a project. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The state of the announcement, can be draft, scheduled, published or archived. */
  state?: Maybe<AnnouncementStateEnum>;
  /** The subject line of the email that is sent when this announcement is published. */
  subjectLine?: Maybe<Scalars['String']['output']>;
  subjectLineWithFallback?: Maybe<Scalars['String']['output']>;
  subscriberCounts: Scalars['Int']['output'];
  subscribers: ProjectSubscriptionConnection;
  /** The template that is used to render the announcement if applicable.. */
  template?: Maybe<Template>;
  /** The title of the announcement. */
  title?: Maybe<Scalars['String']['output']>;
  titleWithFallback?: Maybe<Scalars['String']['output']>;
  /** The total number of subscribers for this announcement across all channels. */
  totalSubscriberCounts: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The hero video of the announcement */
  videoAsset?: Maybe<VideoAsset>;
  viewerAnalytics?: Maybe<ViewerAnalyticsObject>;
  /** The work items that are associated with this announcement. */
  workItems?: Maybe<WorkItemConnection>;
};


export type AnnouncementChangeTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type AnnouncementConnectedSourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type AnnouncementContentGeneratorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type AnnouncementEmailAnalyticsArgs = {
  tzOffset?: InputMaybe<Scalars['Int']['input']>;
};


export type AnnouncementFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  feedbackableArchived?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackableIds?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importance?: InputMaybe<Importance>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderAttr?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  organizedState?: InputMaybe<Scalars['String']['input']>;
  reaction?: InputMaybe<Reaction>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  unorganized?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Where>;
};


export type AnnouncementNotificationsSentArgs = {
  transportType: TransportEnum;
};


export type AnnouncementSlackChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type AnnouncementSubscriberCountsArgs = {
  transport: TransportEnum;
};


export type AnnouncementSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Where>;
};


export type AnnouncementViewerAnalyticsArgs = {
  tzOffset?: InputMaybe<Scalars['Int']['input']>;
};


export type AnnouncementWorkItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};

export type AnnouncementAnalytics = {
  __typename?: 'AnnouncementAnalytics';
  /** Total number of announcements in a draft state */
  draft: Scalars['Int']['output'];
  /** Detailed information regarding the email interactions of announcement notifications */
  emailAnalytics?: Maybe<BarChartObject>;
  /** Data regarding interaction with sent emails */
  emailEngagement: EmailAnalyticsData;
  embedAnnouncementViews: Array<TimeseriesData>;
  /** Total subscriber counts for project over a period of time */
  newSubscribers: Scalars['Int']['output'];
  /** Email interactions of recently published announcements */
  notificationPerformance?: Maybe<Array<StackedBarChart>>;
  /** Email interactions of recently published announcements */
  notificationPerformanceTable?: Maybe<Array<Dataseries>>;
  /** Email interactions of open rates recently published announcements */
  notificationRatePerformance?: Maybe<Array<StackedBarChart>>;
  /** Email interactions of open rates recently published announcements */
  notificationRatePerformanceTable?: Maybe<Array<Dataseries>>;
  /** Total notifications sent */
  notificationsSent: Scalars['Int']['output'];
  /** Open rates of announcement notifications by day of week */
  openRatesByDayOfWeek?: Maybe<Array<TimeseriesData>>;
  /** Open rates of announcement notifications by hour of day */
  openRatesByHourOfDay?: Maybe<Array<TimeseriesData>>;
  /** Total content views over a period of time */
  pageViews: Scalars['Int']['output'];
  /** Total content views over a period of time (deprecated) */
  pageViewsDeprecated: Scalars['Int']['output'];
  /** Total number of published announcements */
  published: Scalars['Int']['output'];
  /** Show deprecated page views */
  showPageViewsDeprecated: Scalars['Boolean']['output'];
  /** Total number of announcements */
  total: Scalars['Int']['output'];
  viewsByAnnouncement: Array<Dataseries>;
};


export type AnnouncementAnalyticsEmailAnalyticsArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  tzOffset?: InputMaybe<Scalars['Int']['input']>;
};


export type AnnouncementAnalyticsEmailEngagementArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  tzOffset?: InputMaybe<Scalars['Int']['input']>;
};


export type AnnouncementAnalyticsEmbedAnnouncementViewsArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};


export type AnnouncementAnalyticsNewSubscribersArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};


export type AnnouncementAnalyticsNotificationPerformanceArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};


export type AnnouncementAnalyticsNotificationPerformanceTableArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};


export type AnnouncementAnalyticsNotificationRatePerformanceArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};


export type AnnouncementAnalyticsNotificationRatePerformanceTableArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};


export type AnnouncementAnalyticsNotificationsSentArgs = {
  announcementId?: InputMaybe<Scalars['ID']['input']>;
  transportType: TransportEnum;
};


export type AnnouncementAnalyticsOpenRatesByDayOfWeekArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};


export type AnnouncementAnalyticsOpenRatesByHourOfDayArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};


export type AnnouncementAnalyticsPageViewsArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};


export type AnnouncementAnalyticsPageViewsDeprecatedArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};


export type AnnouncementAnalyticsViewsByAnnouncementArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};

export enum AnnouncementAttachment {
  /** heroImage */
  HeroImage = 'hero_image',
  /** shareImage */
  ShareImage = 'share_image',
  /** videoAsset */
  VideoAsset = 'video_asset'
}

/** The connection type for Announcement. */
export type AnnouncementConnection = {
  __typename?: 'AnnouncementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AnnouncementEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Announcement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AnnouncementDigest = Node & {
  __typename?: 'AnnouncementDigest';
  announcements?: Maybe<AnnouncementConnection>;
  categories: Array<Category>;
  content?: Maybe<Scalars['String']['output']>;
  /** The HTML representation of the content. */
  contentHtml?: Maybe<Scalars['String']['output']>;
  /** The plain text representation of the content. */
  contentPlainText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Defines the type of schema the content follows, draftjs to be deprecated. */
  contentType: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  emailClickedThroughCount: Scalars['Int']['output'];
  emailOpenedCount: Scalars['Int']['output'];
  emailSentCount: Scalars['Int']['output'];
  emailSubscriberCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  labels: Array<ChangeType>;
  order: Array<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sendToAll: Scalars['Boolean']['output'];
  slackChannelClickedThroughCount: Scalars['Int']['output'];
  slackChannelCount: Scalars['Int']['output'];
  slackChannelSentCount: Scalars['Int']['output'];
  slackChannels: Array<Channel>;
  slackSubscriberClickedThroughCount: Scalars['Int']['output'];
  slackSubscriberCount: Scalars['Int']['output'];
  slackSubscriberSentCount: Scalars['Int']['output'];
  /** The state of the digest, can be draft, published or archived. */
  state?: Maybe<AnnouncementDigestStateEnum>;
  subjectLine?: Maybe<Scalars['String']['output']>;
  subscribers: ProjectSubscriptionConnection;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type AnnouncementDigestAnnouncementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type AnnouncementDigestSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Where>;
};

/** The connection type for AnnouncementDigest. */
export type AnnouncementDigestConnection = {
  __typename?: 'AnnouncementDigestConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AnnouncementDigestEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AnnouncementDigest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AnnouncementDigestEdge = {
  __typename?: 'AnnouncementDigestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AnnouncementDigest>;
};

export enum AnnouncementDigestStateEnum {
  /** Archived */
  Archived = 'archived',
  /** Draft */
  Draft = 'draft',
  /** Published */
  Published = 'published'
}

/** An edge in a connection. */
export type AnnouncementEdge = {
  __typename?: 'AnnouncementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Announcement>;
};

export enum AnnouncementStateEnum {
  /** Archived */
  Archived = 'archived',
  /** Draft */
  Draft = 'draft',
  /** Generating */
  Generating = 'generating',
  /** Published */
  Published = 'published',
  /** Scheduled */
  Scheduled = 'scheduled'
}

/** An API consumer */
export type ApiConsumer = {
  /** Retrieve a project by ID */
  project: Project;
  projects: ProjectConnection;
};


/** An API consumer */
export type ApiConsumerProjectArgs = {
  id: Scalars['ID']['input'];
};


/** An API consumer */
export type ApiConsumerProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};

/** API Token belonging to a project. */
export type ApiToken = Node & {
  __typename?: 'ApiToken';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for ApiToken. */
export type ApiTokenConnection = {
  __typename?: 'ApiTokenConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ApiTokenEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ApiToken>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ApiTokenEdge = {
  __typename?: 'ApiTokenEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ApiToken>;
};

export enum ApiTokenTypeEnum {
  /** Management */
  ManagementApiUser = 'ManagementApiUser',
  /** Published */
  PublishedApiUser = 'PublishedApiUser'
}

export type ApiUser = ApiConsumer & Node & {
  __typename?: 'ApiUser';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The email of the API user */
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The name of the API user */
  name: Scalars['String']['output'];
  /** The owning organization of the API user */
  organization: Organization;
  /** Retrieve a project by ID */
  project: Project;
  projects: ProjectConnection;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type ApiUserProjectArgs = {
  id: Scalars['ID']['input'];
};


export type ApiUserProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};

/** Autogenerated input type of ArchiveAnnouncement */
export type ArchiveAnnouncementInput = {
  /** The id of the announcement you would like to archive */
  announcementId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ArchiveAnnouncement. */
export type ArchiveAnnouncementPayload = {
  __typename?: 'ArchiveAnnouncementPayload';
  announcement?: Maybe<Announcement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of ArchiveDigest */
export type ArchiveDigestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  digestId: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveDigest. */
export type ArchiveDigestPayload = {
  __typename?: 'ArchiveDigestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ArchiveFeedback */
export type ArchiveFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveFeedback. */
export type ArchiveFeedbackPayload = {
  __typename?: 'ArchiveFeedbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  feedback?: Maybe<Feedback>;
};

/** Autogenerated input type of ArchiveFeedbacks */
export type ArchiveFeedbacksInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  feedbackIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ArchiveFeedbacks. */
export type ArchiveFeedbacksPayload = {
  __typename?: 'ArchiveFeedbacksPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  feedbacks: Array<Feedback>;
};

/** Autogenerated input type of ArchiveIdeas */
export type ArchiveIdeasInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ideaIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ArchiveIdeas. */
export type ArchiveIdeasPayload = {
  __typename?: 'ArchiveIdeasPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  ideas: Array<Idea>;
};

/** Autogenerated input type of ArchiveProject */
export type ArchiveProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the project you would like to archive */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveProject. */
export type ArchiveProjectPayload = {
  __typename?: 'ArchiveProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  project?: Maybe<Project>;
};

/** Autogenerated input type of ArchiveStage */
export type ArchiveStageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the stage you would like to archive */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveStage. */
export type ArchiveStagePayload = {
  __typename?: 'ArchiveStagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  stage?: Maybe<Stage>;
};

/** Autogenerated input type of ArchiveTemplate */
export type ArchiveTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the template you would like to archive */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveTemplate. */
export type ArchiveTemplatePayload = {
  __typename?: 'ArchiveTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  template?: Maybe<Template>;
};

/** Autogenerated input type of ArchiveWorkItem */
export type ArchiveWorkItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the work item you would like to archive */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveWorkItem. */
export type ArchiveWorkItemPayload = {
  __typename?: 'ArchiveWorkItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  workItem?: Maybe<WorkItem>;
};

export type AtlassianApp = Node & {
  __typename?: 'AtlassianApp';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  siteId: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
  siteUrl: Scalars['String']['output'];
  token?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Attribute = {
  __typename?: 'Attribute';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['AttributeValue']['output']>;
};

export type AttributeDefinition = Node & {
  __typename?: 'AttributeDefinition';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The owning project for this attribute definition. */
  project: Project;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  valueType?: Maybe<Value>;
};

/** The connection type for AttributeDefinition. */
export type AttributeDefinitionConnection = {
  __typename?: 'AttributeDefinitionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AttributeDefinitionEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AttributeDefinition>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AttributeDefinitionEdge = {
  __typename?: 'AttributeDefinitionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AttributeDefinition>;
};

export enum AttributeDefinitionTypeClass {
  Feedback = 'feedback'
}

export type AudienceDomain = Node & {
  __typename?: 'AudienceDomain';
  averageFeedbackSentiment?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  feedbackCount: Scalars['Int']['output'];
  feedbacks: FeedbackConnection;
  firstSeen: Scalars['ISO8601DateTime']['output'];
  hostname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  subscriberCount: Scalars['Int']['output'];
  subscribers: SubscriberConnection;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  voteCount: Scalars['Int']['output'];
  votes: VoteConnection;
};


export type AudienceDomainFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type AudienceDomainSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type AudienceDomainVotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};

/** The connection type for AudienceDomain. */
export type AudienceDomainConnection = {
  __typename?: 'AudienceDomainConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AudienceDomainEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AudienceDomain>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AudienceDomainEdge = {
  __typename?: 'AudienceDomainEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AudienceDomain>;
};

export enum AuthenticationTypeEnum {
  Jwt = 'JWT',
  Saml = 'SAML',
  Sso = 'SSO'
}

export type AvailableCrmStage = {
  __typename?: 'AvailableCrmStage';
  /** ID of crm stage */
  id: Scalars['String']['output'];
  /** Name of crm stage */
  name?: Maybe<Scalars['String']['output']>;
};

export type BarChartData = {
  __typename?: 'BarChartData';
  clicked?: Maybe<Scalars['Int']['output']>;
  date: Scalars['ISO8601DateTime']['output'];
  opened?: Maybe<Scalars['Int']['output']>;
  /** Number of emails sent succesfully */
  sent?: Maybe<Scalars['Int']['output']>;
};

export type BarChartObject = {
  __typename?: 'BarChartObject';
  clicked?: Maybe<Scalars['Int']['output']>;
  date: Scalars['ISO8601DateTime']['output'];
  opened?: Maybe<Scalars['Int']['output']>;
  sent?: Maybe<Scalars['Int']['output']>;
};

export type BatchFeedback = {
  affectedCustomerEmail: Scalars['String']['input'];
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  ideaCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  ideaCreatedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  ideaName?: InputMaybe<Scalars['String']['input']>;
  ideaNotes?: InputMaybe<Scalars['String']['input']>;
  ideaPublished?: InputMaybe<Scalars['Boolean']['input']>;
  importance?: InputMaybe<Importance>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  reaction?: InputMaybe<Reaction>;
  reporterEmail?: InputMaybe<Scalars['String']['input']>;
};

export type BatchSubscriber = {
  /** Subscribed categories */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  email: Scalars['String']['input'];
};

export type Blob = {
  __typename?: 'Blob';
  /** JSON of required HTTP headers */
  headers: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['ID']['output']>;
  signedId: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type Category = Node & {
  __typename?: 'Category';
  /** The background color of the Category, shown on the public page */
  backgroundColor: Scalars['String']['output'];
  /** The color of the Category, reflected on the public page */
  color: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The internal description given to a Category */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** A list of all ideas associated with this category. */
  ideas?: Maybe<IdeaConnection>;
  /** The name of the Category (e.g. API, Admin, Enterprise plan) */
  name: Scalars['String']['output'];
  /** The position of the Category, relative to the set */
  position: Scalars['Int']['output'];
  /** The project ID the Category is associated to */
  project?: Maybe<Project>;
  /** The API slug of the Category */
  slug: Scalars['String']['output'];
  /** The text color of the Category, reflected on the public page */
  textColor: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type CategoryIdeasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};

/** Attributes for creating or updating a category */
export type CategoryAttributes = {
  /** Background color to use for category display */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Color to use for category display */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Internal description of the announcement */
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name of the announcement */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Position of category relative to set */
  position?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  /** Text color to use for category display */
  textColor?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for Category. */
export type CategoryConnection = {
  __typename?: 'CategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CategoryEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Category>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CategoryEdge = {
  __typename?: 'CategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Category>;
};

/** A way to indicate the type of change that is being released. Change types are called Labels in the management portal. */
export type ChangeType = Node & {
  __typename?: 'ChangeType';
  /** The API slug for the Change Type */
  apiSlug: Scalars['String']['output'];
  /** The color of the Change Type */
  color: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The name of the Change Type */
  name: Scalars['String']['output'];
  /** The project this Change Type belongs to */
  project: Project;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for ChangeType. */
export type ChangeTypeConnection = {
  __typename?: 'ChangeTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ChangeTypeEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ChangeType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ChangeTypeEdge = {
  __typename?: 'ChangeTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ChangeType>;
};

export type Channel = Node & {
  __typename?: 'Channel';
  categories: Array<Category>;
  channelId: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  workspace: Workspace;
};

/** The connection type for Channel. */
export type ChannelConnection = {
  __typename?: 'ChannelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ChannelEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Channel>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ChannelEdge = {
  __typename?: 'ChannelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Channel>;
};

export type Cohort = Node & {
  __typename?: 'Cohort';
  allSubscribers: Array<Subscriber>;
  audienceDomains: AudienceDomainConnection;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  feedbackCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  project: Project;
  subscriberCount: Scalars['Int']['output'];
  subscribers: SubscriberConnection;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  voteCount: Scalars['Int']['output'];
};


export type CohortAudienceDomainsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type CohortSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};

export type CohortAttributes = {
  /** The internal description of the view */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The id of the view */
  id: Scalars['ID']['input'];
  /** The name of the project view you would like to create */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for Cohort. */
export type CohortConnection = {
  __typename?: 'CohortConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CohortEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Cohort>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CohortEdge = {
  __typename?: 'CohortEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Cohort>;
};

export enum Comparator {
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  Ilike = 'ilike',
  Is = 'is',
  Isnot = 'isnot',
  Like = 'like',
  Lt = 'lt',
  Lte = 'lte',
  Neq = 'neq',
  Search = 'search'
}

/** Autogenerated input type of ConfirmProjectSubscription */
export type ConfirmProjectSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Input to confirm a project subscription */
  projectSubscription: ProjectSubscriptionInput;
};

/** Autogenerated return type of ConfirmProjectSubscription. */
export type ConfirmProjectSubscriptionPayload = {
  __typename?: 'ConfirmProjectSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The confirmed project subscription */
  projectSubscription?: Maybe<ProjectSubscription>;
};

/** Autogenerated input type of ConfirmSubscribers */
export type ConfirmSubscribersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  subscriberIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ConfirmSubscribers. */
export type ConfirmSubscribersPayload = {
  __typename?: 'ConfirmSubscribersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  subscriberIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type ConnectedSource = Node & {
  __typename?: 'ConnectedSource';
  /** Identifier of parent object */
  contextId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identifier of connected object. Can be used to look up in system */
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Additional fields of source object */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** The name of the connected data source */
  name?: Maybe<Scalars['String']['output']>;
  /** The name of the provider source */
  providerName: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The url of connected source */
  url: Scalars['String']['output'];
};

/** The connection type for ConnectedSource. */
export type ConnectedSourceConnection = {
  __typename?: 'ConnectedSourceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ConnectedSourceEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ConnectedSource>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ConnectedSourceEdge = {
  __typename?: 'ConnectedSourceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ConnectedSource>;
};

export type ContentGenerator = Node & {
  __typename?: 'ContentGenerator';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  inputData: Scalars['String']['output'];
  outputData?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for ContentGenerator. */
export type ContentGeneratorConnection = {
  __typename?: 'ContentGeneratorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ContentGeneratorEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ContentGenerator>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ContentGeneratorEdge = {
  __typename?: 'ContentGeneratorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContentGenerator>;
};

/** Autogenerated input type of CopyAnnouncementToProject */
export type CopyAnnouncementToProjectInput = {
  announcementId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newProjectId: Scalars['ID']['input'];
};

/** Autogenerated return type of CopyAnnouncementToProject. */
export type CopyAnnouncementToProjectPayload = {
  __typename?: 'CopyAnnouncementToProjectPayload';
  announcement?: Maybe<Announcement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  targetProject?: Maybe<Project>;
};

/** Attributes for copying a work item to another project */
export type CopyToProjectAttributes = {
  /** The ID of the project to copy to */
  projectId: Scalars['ID']['input'];
  /** The ID of the stage to copy to */
  stageId: Scalars['ID']['input'];
  /** The ID of the work item to copy */
  workItemId: Scalars['ID']['input'];
};

/** Autogenerated input type of CopyToProject */
export type CopyToProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  copyParams: CopyToProjectAttributes;
};

/** Autogenerated return type of CopyToProject. */
export type CopyToProjectPayload = {
  __typename?: 'CopyToProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UserError>>;
  targetProject?: Maybe<Project>;
  targetStage?: Maybe<Stage>;
  workItem?: Maybe<WorkItem>;
};

/** Autogenerated input type of CreateAiAnnouncement */
export type CreateAiAnnouncementInput = {
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateAiAnnouncement. */
export type CreateAiAnnouncementPayload = {
  __typename?: 'CreateAiAnnouncementPayload';
  announcementId: Scalars['ID']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Attributes for creating an announcement */
export type CreateAnnouncementAttributes = {
  /** Associated categories of the release */
  categories?: InputMaybe<Array<CategoryAttributes>>;
  /** HTML content to be converted */
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  /** Jira Wiki Syntax */
  contentJira?: InputMaybe<Scalars['String']['input']>;
  contentMarkdown?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  shouldNotifyPageSubscribers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pre-fill the announcement with a template. If this is provided, all other input is ignored. */
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of CreateAnnouncement */
export type CreateAnnouncementInput = {
  announcement: CreateAnnouncementAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateAnnouncement. */
export type CreateAnnouncementPayload = {
  __typename?: 'CreateAnnouncementPayload';
  announcement?: Maybe<Announcement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Attributes to create a new API Token */
export type CreateApiTokenAttributes = {
  /** The name of the API Key */
  name: Scalars['String']['input'];
  /** The project that the API Token applies to. */
  projectId: Scalars['ID']['input'];
  /** Token type, either 'Read-only', or 'Management' */
  type: Scalars['String']['input'];
};

/** Autogenerated input type of CreateApiToken */
export type CreateApiTokenInput = {
  apiToken: CreateApiTokenAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateApiToken. */
export type CreateApiTokenPayload = {
  __typename?: 'CreateApiTokenPayload';
  apiToken?: Maybe<ApiToken>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Attributes to create an attribute definition */
export type CreateAttributeDefinitionAttributes = {
  /** An optional description to give this attribute definition more context. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The key used to reference this attribute on it's associated object. This can not be edited after creation. */
  key: Scalars['String']['input'];
  /** The name of the attribute definition. */
  name: Scalars['String']['input'];
  /** The attribute definition's project ID */
  projectId: Scalars['ID']['input'];
  /** The type of object this attribute definition will be associated with */
  typeClass: AttributeDefinitionTypeClass;
  /** The data type of the value */
  valueType: Value;
};

/** Autogenerated input type of CreateAttributeDefinition */
export type CreateAttributeDefinitionInput = {
  attributeDefinition: CreateAttributeDefinitionAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateAttributeDefinition. */
export type CreateAttributeDefinitionPayload = {
  __typename?: 'CreateAttributeDefinitionPayload';
  attributeDefinition?: Maybe<AttributeDefinition>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of CreateBatchEmailSubscriptions */
export type CreateBatchEmailSubscriptionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  /** If set to true, opt in a newly created subscriber without sending a confirmation email. */
  skipOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  subscribers: Array<BatchSubscriber>;
};

/** Autogenerated return type of CreateBatchEmailSubscriptions. */
export type CreateBatchEmailSubscriptionsPayload = {
  __typename?: 'CreateBatchEmailSubscriptionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Attributes to create a project category */
export type CreateCategoryAttributes = {
  /**
   * Used to generate the text and background colors when rendered throughout
   * LaunchNotes. Will be randomly selected if left blank.
   */
  color?: InputMaybe<Scalars['String']['input']>;
  /** An optional description to give this category more context. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the category. This will be used to generate its unique slug. */
  name: Scalars['String']['input'];
  /** The category's project ID */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated input type of CreateCategory */
export type CreateCategoryInput = {
  category: CreateCategoryAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCategory. */
export type CreateCategoryPayload = {
  __typename?: 'CreateCategoryPayload';
  category?: Maybe<Category>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of CreateChange */
export type CreateChangeInput = {
  changeType: CreateChangeTypeAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateChange. */
export type CreateChangePayload = {
  __typename?: 'CreateChangePayload';
  changeType?: Maybe<ChangeType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Attributes to create a project change type */
export type CreateChangeTypeAttributes = {
  /** The color of the change type */
  color?: InputMaybe<Scalars['String']['input']>;
  /** The name of the change type. This will be used to generate its unique slug. */
  name: Scalars['String']['input'];
  /** The change type's project ID */
  projectId: Scalars['ID']['input'];
};

/** Attributes for creating a project cohort */
export type CreateCohortAttributes = {
  /** The internal description of the cohort */
  description: Scalars['String']['input'];
  /** The name of the project cohort you would like to create */
  name: Scalars['String']['input'];
  /** The ID of the project you would like to create the cohort for */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated input type of CreateCohort */
export type CreateCohortInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cohort: CreateCohortAttributes;
};

/** Autogenerated return type of CreateCohort. */
export type CreateCohortPayload = {
  __typename?: 'CreateCohortPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  cohort?: Maybe<Cohort>;
  errors: Array<UserError>;
};

/** Autogenerated input type of CreateDigest */
export type CreateDigestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateDigest. */
export type CreateDigestPayload = {
  __typename?: 'CreateDigestPayload';
  announcementDigest?: Maybe<AnnouncementDigest>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateDirectUpload */
export type CreateDirectUploadInput = {
  byteSize: Scalars['Int']['input'];
  checksum: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

/** Autogenerated return type of CreateDirectUpload. */
export type CreateDirectUploadPayload = {
  __typename?: 'CreateDirectUploadPayload';
  blob?: Maybe<Blob>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of CreateEmbedApp */
export type CreateEmbedAppInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  subtitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateEmbedApp. */
export type CreateEmbedAppPayload = {
  __typename?: 'CreateEmbedAppPayload';
  app: EmbedApp;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateExternalContentLink */
export type CreateExternalContentLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalContentLink: CreateLinkAttributes;
};

/** Autogenerated return type of CreateExternalContentLink. */
export type CreateExternalContentLinkPayload = {
  __typename?: 'CreateExternalContentLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  stage?: Maybe<Stage>;
};

/** Attributes for creating a feedback */
export type CreateFeedbackAttributes = {
  affectedCustomerEmail: Scalars['String']['input'];
  content: Scalars['String']['input'];
  feedbackableId?: InputMaybe<Scalars['ID']['input']>;
  feedbackableType?: InputMaybe<Scalars['String']['input']>;
  importance?: InputMaybe<Importance>;
  notes?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  reaction?: InputMaybe<Reaction>;
};

/** Autogenerated input type of CreateFeedback */
export type CreateFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  feedback: CreateFeedbackAttributes;
};

/** Autogenerated return type of CreateFeedback. */
export type CreateFeedbackPayload = {
  __typename?: 'CreateFeedbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  feedback?: Maybe<Feedback>;
};

/** Autogenerated input type of CreateIdea */
export type CreateIdeaInput = {
  /** Associated categories of the idea */
  categories?: InputMaybe<Array<CategoryAttributes>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateIdea. */
export type CreateIdeaPayload = {
  __typename?: 'CreateIdeaPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  idea?: Maybe<Idea>;
};

/** Attributes for creating a stage */
export type CreateLinkAttributes = {
  /** The roadmap item or announcement you are creating this link on. */
  ownerId: Scalars['ID']['input'];
  /** The display name of the link. */
  title: Scalars['String']['input'];
  /** Destination URL of the link. */
  url: Scalars['String']['input'];
};

/** Autogenerated input type of CreateOrganizationProfile */
export type CreateOrganizationProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  creatorId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  userReferralSource: UserReferralSourceEnum;
  userRole: UserRoleEnum;
};

/** Autogenerated return type of CreateOrganizationProfile. */
export type CreateOrganizationProfilePayload = {
  __typename?: 'CreateOrganizationProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UserError>>;
  projectId: Scalars['ID']['output'];
};

/** Autogenerated input type of CreateOutboundWebhook */
export type CreateOutboundWebhookInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The list of event types that the webhook should react to */
  eventTypes: Array<Scalars['ID']['input']>;
  /** What you wish to call this webhook */
  name: Scalars['String']['input'];
  /** The ID of the object that should own the webhook */
  ownerId: Scalars['ID']['input'];
  /** Authorization password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** The URL the webhook should events to */
  url: Scalars['String']['input'];
  /** Authorization username */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateOutboundWebhook. */
export type CreateOutboundWebhookPayload = {
  __typename?: 'CreateOutboundWebhookPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  outboundWebhook?: Maybe<OutboundWebhook>;
};

/** Autogenerated input type of CreateProject */
export type CreateProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the project you would like to create */
  name: Scalars['String']['input'];
  /** The id of the organization you would like to create the project in */
  organizationId: Scalars['String']['input'];
};

/** Autogenerated return type of CreateProject. */
export type CreateProjectPayload = {
  __typename?: 'CreateProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  project?: Maybe<Project>;
};

/** Attributes for creating a subscription */
export type CreateProjectSubscriptionAttributes = {
  /** Subscribed categories */
  categories?: InputMaybe<Array<CategoryAttributes>>;
  /** The project id to create a subscription for */
  projectId: Scalars['ID']['input'];
  /** If set to true, opt in a newly created subscriber without sending a confirmation email. */
  skipOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** The subscription owner */
  subscriber: SubscriberAttributes;
  /** Subscribed work items */
  workItems?: InputMaybe<Array<WorkItemAttributes>>;
};

/** Autogenerated input type of CreateProjectSubscription */
export type CreateProjectSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectSubscription: CreateProjectSubscriptionAttributes;
};

/** Autogenerated return type of CreateProjectSubscription. */
export type CreateProjectSubscriptionPayload = {
  __typename?: 'CreateProjectSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  projectSubscription?: Maybe<ProjectSubscription>;
};

/** Attributes for creating a project view */
export type CreateProjectViewAttributes = {
  /** Associated categories of the view */
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The internal description of the view */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The IDs of the users who are members of the view */
  memberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The name of the project view you would like to create */
  name: Scalars['String']['input'];
  /** The IDs of the users who are owners of the view */
  ownerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The ID of the project you would like to create the view for */
  projectId: Scalars['ID']['input'];
  /** Associated stages of the view */
  stageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated input type of CreateProjectView */
export type CreateProjectViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectView: CreateProjectViewAttributes;
};

/** Autogenerated return type of CreateProjectView. */
export type CreateProjectViewPayload = {
  __typename?: 'CreateProjectViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  projectView?: Maybe<ProjectView>;
};

/** Attributes for creating an update for a work_item */
export type CreateRoadmapUpdateAttributes = {
  /** The body of the update */
  content: Scalars['String']['input'];
  /** Whether update should be displayed on published page timeline */
  internalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** The new stage to move the roadmap item to */
  newStageId?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the update */
  title: Scalars['String']['input'];
  workItemId: Scalars['ID']['input'];
};

/** Autogenerated input type of CreateRoadmapUpdate */
export type CreateRoadmapUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roadmapUpdate: CreateRoadmapUpdateAttributes;
};

/** Autogenerated return type of CreateRoadmapUpdate. */
export type CreateRoadmapUpdatePayload = {
  __typename?: 'CreateRoadmapUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UserError>>;
  roadmapUpdate?: Maybe<RoadmapUpdate>;
};

/** Autogenerated input type of CreateSecureConnection */
export type CreateSecureConnectionInput = {
  /** The type of secure connection you would like to create */
  authenticationType: AuthenticationTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the project you would like the create the secure connection on */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateSecureConnection. */
export type CreateSecureConnectionPayload = {
  __typename?: 'CreateSecureConnectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of CreateSource */
export type CreateSourceInput = {
  /** announcement to connect source to */
  announcementId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  providerName: Scalars['String']['input'];
  url: Scalars['String']['input'];
  /** work item to connect source to */
  workItemId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateSource. */
export type CreateSourcePayload = {
  __typename?: 'CreateSourcePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  connectedSource: ConnectedSource;
  errors: Array<UserError>;
};

/** Attributes for creating a stage */
export type CreateStageAttributes = {
  /** If specified, automatically archive work items after N days in this stage */
  archiveAfterDays?: InputMaybe<Scalars['Int']['input']>;
  /** A description of the stage */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the stage */
  name: Scalars['String']['input'];
  /** The project you are creating this stage on */
  projectId: Scalars['ID']['input'];
  /** Whether or not the stage is published to your roadmap */
  published?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of CreateStage */
export type CreateStageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  stage: CreateStageAttributes;
};

/** Autogenerated return type of CreateStage. */
export type CreateStagePayload = {
  __typename?: 'CreateStagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  stage?: Maybe<Stage>;
};

/** Attributes for creating a template */
export type CreateTemplateAttributes = {
  /** Associated categories of the release */
  categories?: InputMaybe<Array<CategoryAttributes>>;
  /** The content of the announcement */
  content?: InputMaybe<Scalars['String']['input']>;
  /** A description of the template */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The excerpt of the announcement */
  excerpt?: InputMaybe<Scalars['String']['input']>;
  /** The headline of the announcement */
  headline?: InputMaybe<Scalars['String']['input']>;
  /** The marketplace template you are basing the template on */
  marketplaceTemplateId?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the template */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The project you are creating this template on */
  projectId: Scalars['ID']['input'];
  /** Associated categories */
  workItems?: InputMaybe<Array<WorkItemAttributes>>;
};

/** Autogenerated input type of CreateTemplate */
export type CreateTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  template: CreateTemplateAttributes;
};

/** Autogenerated return type of CreateTemplate. */
export type CreateTemplatePayload = {
  __typename?: 'CreateTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  template?: Maybe<Template>;
};

/** Attributes for creating a work_item */
export type CreateWorkItemAttributes = {
  /** Associated categories of the work item */
  categories?: InputMaybe<Array<CategoryAttributes>>;
  /** A description of the work item */
  content?: InputMaybe<Scalars['String']['input']>;
  /** HTML Content to be converted */
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  /** Jira Wiki Syntax */
  contentJira?: InputMaybe<Scalars['String']['input']>;
  /** Markdown content to be converted */
  contentMarkdown?: InputMaybe<Scalars['String']['input']>;
  /** The name of the work item */
  name: Scalars['String']['input'];
  /** The owner for the work item */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** What stage you would like the work item to be added to */
  stageId: Scalars['ID']['input'];
};

/** Autogenerated input type of CreateWorkItem */
export type CreateWorkItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  workItem: CreateWorkItemAttributes;
};

/** Autogenerated input type of CreateWorkItemMovedUpdate */
export type CreateWorkItemMovedUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isTestEmail?: InputMaybe<Scalars['Boolean']['input']>;
  workItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateWorkItemMovedUpdate. */
export type CreateWorkItemMovedUpdatePayload = {
  __typename?: 'CreateWorkItemMovedUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UserError>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated return type of CreateWorkItem. */
export type CreateWorkItemPayload = {
  __typename?: 'CreateWorkItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  workItem?: Maybe<WorkItem>;
};

export type CrmStage = {
  __typename?: 'CrmStage';
  /** Stages a user can select from */
  availableStages?: Maybe<Array<AvailableCrmStage>>;
  /** Stages currently selected for project */
  crmStageFilters: Array<Scalars['String']['output']>;
};

export type Dataseries = {
  __typename?: 'Dataseries';
  metaValues?: Maybe<Array<Scalars['String']['output']>>;
  xValue?: Maybe<Scalars['String']['output']>;
  yValue?: Maybe<Scalars['Float']['output']>;
};

/** Autogenerated input type of DeactivateProjectView */
export type DeactivateProjectViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectViewId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeactivateProjectView. */
export type DeactivateProjectViewPayload = {
  __typename?: 'DeactivateProjectViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  projectView?: Maybe<ProjectView>;
};

/** Autogenerated input type of DeleteAttributeDefinition */
export type DeleteAttributeDefinitionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteAttributeDefinition. */
export type DeleteAttributeDefinitionPayload = {
  __typename?: 'DeleteAttributeDefinitionPayload';
  attributeDefinition?: Maybe<AttributeDefinition>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of DeleteExternalContentLink */
export type DeleteExternalContentLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteExternalContentLink. */
export type DeleteExternalContentLinkPayload = {
  __typename?: 'DeleteExternalContentLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  stage?: Maybe<Stage>;
};

/** Autogenerated input type of Delete */
export type DeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated input type of DeleteOutboundWebhook */
export type DeleteOutboundWebhookInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the webhook to delete */
  webhookId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteOutboundWebhook. */
export type DeleteOutboundWebhookPayload = {
  __typename?: 'DeleteOutboundWebhookPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of Delete. */
export type DeletePayload = {
  __typename?: 'DeletePayload';
  appId: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteSlackChannel */
export type DeleteSlackChannelInput = {
  /** The channel to delete */
  channelId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteSlackChannel. */
export type DeleteSlackChannelPayload = {
  __typename?: 'DeleteSlackChannelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteVotes */
export type DeleteVotesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ideaId: Scalars['ID']['input'];
  voteIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of DeleteVotes. */
export type DeleteVotesPayload = {
  __typename?: 'DeleteVotesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of DestroyUserAccount */
export type DestroyUserAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyUserAccount. */
export type DestroyUserAccountPayload = {
  __typename?: 'DestroyUserAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  user?: Maybe<User>;
};

/** Autogenerated input type of DuplicateAnnouncement */
export type DuplicateAnnouncementInput = {
  announcementId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DuplicateAnnouncement. */
export type DuplicateAnnouncementPayload = {
  __typename?: 'DuplicateAnnouncementPayload';
  announcement?: Maybe<Announcement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of DuplicateDigest */
export type DuplicateDigestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  digestId: Scalars['ID']['input'];
};

/** Autogenerated return type of DuplicateDigest. */
export type DuplicateDigestPayload = {
  __typename?: 'DuplicateDigestPayload';
  announcementDigest?: Maybe<AnnouncementDigest>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DuplicateProjectView */
export type DuplicateProjectViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the project view you would like to duplicate */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DuplicateProjectView. */
export type DuplicateProjectViewPayload = {
  __typename?: 'DuplicateProjectViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  projectView?: Maybe<ProjectView>;
};

/** Autogenerated input type of DuplicateWorkItem */
export type DuplicateWorkItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the work item you would like to duplicate */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DuplicateWorkItem. */
export type DuplicateWorkItemPayload = {
  __typename?: 'DuplicateWorkItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  workItem?: Maybe<WorkItem>;
};

export type EmailAnalyticsData = {
  __typename?: 'EmailAnalyticsData';
  clickRate: Scalars['Float']['output'];
  clickToOpenRate: Scalars['Float']['output'];
  openRate: Scalars['Float']['output'];
  sentCount: Scalars['Float']['output'];
};

export type EmailAnalyticsObject = {
  __typename?: 'EmailAnalyticsObject';
  chartData: Array<BarChartData>;
  clickRate: Scalars['Float']['output'];
  clickToOpenRate: Scalars['Float']['output'];
  openRate: Scalars['Float']['output'];
  /** Number of emails sent */
  sentCount: Scalars['Float']['output'];
};

export type EmbedApp = Node & {
  __typename?: 'EmbedApp';
  createdAt: Scalars['ISO8601DateTime']['output'];
  enforceToken: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Additional settings for the embed app */
  settings?: Maybe<Scalars['JSON']['output']>;
  subtitle: Scalars['String']['output'];
  token: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Event = Node & {
  __typename?: 'Event';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** More details about the event, will vary based on the event type. */
  data?: Maybe<Scalars['JSON']['output']>;
  /** The object that was affected by the event */
  eventObject?: Maybe<EventObjectUnion>;
  /** The type of the event */
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internalOnly: Scalars['Boolean']['output'];
  notifications?: Maybe<NotificationConnection>;
  processingCompletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  processingStartedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The project that the event belongs to */
  project: Project;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The user that triggered the event */
  user?: Maybe<EventUser>;
  /** More details about the acting user, will vary based on the event type. */
  userData: Scalars['JSON']['output'];
};


export type EventNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};

/** The connection type for Event. */
export type EventConnection = {
  __typename?: 'EventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EventEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Event>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventEdge = {
  __typename?: 'EventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Event>;
};

/** Represents that possible types of objects that can be associated with an event */
export type EventObjectUnion = Announcement | AnnouncementDigest | ConnectedSource | Feedback | Idea | Project | ProjectSubscription | ProjectView | Stage | Subscriber | Template | WorkItem;

export type EventType = Node & {
  __typename?: 'EventType';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for EventType. */
export type EventTypeConnection = {
  __typename?: 'EventTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EventTypeEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EventType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventTypeEdge = {
  __typename?: 'EventTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EventType>;
};

/** Represents the possible types of users on an event */
export type EventUser = Subscriber | User;

export type ExternalContentLink = Node & {
  __typename?: 'ExternalContentLink';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The URL of the image for this Link. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The owning Work Item for this Link. */
  owner: WorkItem;
  /** The title of the Link. */
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The destination URL for this Link. */
  url: Scalars['String']['output'];
};

export type Feedback = HasAttributes & Node & {
  __typename?: 'Feedback';
  affectedCustomer: Subscriber;
  /** The subscriber who reported this but, or who had it reported on their behalf. */
  affectedCustomerEmail: Scalars['String']['output'];
  /** Whether or not this feedback is archived */
  archived: Scalars['Boolean']['output'];
  attributes: Array<Attribute>;
  /** @deprecated canFollowUp will not be supported in Feedback v2. */
  canFollowUp: Scalars['Boolean']['output'];
  /** @deprecated canUseTestimonial will not be supported in Feedback v2. */
  canUseTestimonial?: Maybe<Scalars['Boolean']['output']>;
  /** Content body of the feedback */
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The object that this feedback relates to (announcement, roadmap item, or idea) */
  feedbackable?: Maybe<Feedbackable>;
  id: Scalars['ID']['output'];
  /** @deprecated Ideas should be associated as Feedbackable objects instead of directly via the ID */
  idea?: Maybe<Idea>;
  /** Perceived importance of this feedback (high, medium, low) */
  importance?: Maybe<Importance>;
  /** Additional context, left by the reporter on behalf of the affected customer. */
  notes?: Maybe<Scalars['String']['output']>;
  /** The owning project for this feedback. */
  project: Project;
  /** Reaction sentiment of this feedback (happy, meh, or sad) */
  reaction?: Maybe<Reaction>;
  /** The support agent that logged this feedback. */
  reporter?: Maybe<User>;
  /** The sentiment magnitude of the feedback */
  sentimentMagnitude?: Maybe<Scalars['Float']['output']>;
  /** The sentiment score of the feedback */
  sentimentScore?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Starred will not be supported in Feedback v2. */
  starred: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type FeedbackAnalytics = {
  __typename?: 'FeedbackAnalytics';
  avgFeedbackSentiment: Array<TimeseriesData>;
  feedbackWordStats: Array<Dataseries>;
  /** Stacked bar chart of happy sad and meh feedback */
  feedbacksBySentiment: Array<StackedBarChart>;
  /** Total number of new feedback over a period of time */
  newFeedbackCount: Scalars['Int']['output'];
  /** Total vote counts for project over a period of time */
  newVotes: Scalars['Int']['output'];
  timeSeries: Array<TimeseriesData>;
  total: Scalars['Int']['output'];
  trendingFeedbacks: Array<TrendingFeedbackable>;
};


export type FeedbackAnalyticsAvgFeedbackSentimentArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};


export type FeedbackAnalyticsFeedbackWordStatsArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};


export type FeedbackAnalyticsFeedbacksBySentimentArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};


export type FeedbackAnalyticsNewFeedbackCountArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};


export type FeedbackAnalyticsNewVotesArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};

/** The connection type for Feedback. */
export type FeedbackConnection = {
  __typename?: 'FeedbackConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FeedbackEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Feedback>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FeedbackEdge = {
  __typename?: 'FeedbackEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Feedback>;
};

export type Feedbackable = {
  archived: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  privatePermalink: Scalars['String']['output'];
  publicPermalink: Scalars['String']['output'];
};

/** Autogenerated input type of GenerateBernieAnnouncement */
export type GenerateBernieAnnouncementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of GenerateBernieAnnouncement. */
export type GenerateBernieAnnouncementPayload = {
  __typename?: 'GenerateBernieAnnouncementPayload';
  announcementId?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of GenerateLoomAnnouncement */
export type GenerateLoomAnnouncementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  heightRatio?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  thumbnailUrl: Scalars['String']['input'];
  videoUrl: Scalars['String']['input'];
};

/** Autogenerated return type of GenerateLoomAnnouncement. */
export type GenerateLoomAnnouncementPayload = {
  __typename?: 'GenerateLoomAnnouncementPayload';
  announcementId?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of GetConsumerSession */
export type GetConsumerSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetConsumerSession. */
export type GetConsumerSessionPayload = {
  __typename?: 'GetConsumerSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The url for the API deck vault */
  sessionUri?: Maybe<Scalars['String']['output']>;
  /** The access token for the user */
  token?: Maybe<Scalars['String']['output']>;
};

export type HasAttributeDefinitions = {
  attributeDefinitions: AttributeDefinitionConnection;
  id: Scalars['ID']['output'];
};


export type HasAttributeDefinitionsAttributeDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};

export type HasAttributes = {
  attributes: Array<Attribute>;
  id: Scalars['ID']['output'];
};

export type HasContentGenerators = {
  contentGenerators?: Maybe<ContentGeneratorConnection>;
  /** If there are any content generators in a pending or generating state */
  hasPendingContentGenerators?: Maybe<Scalars['Boolean']['output']>;
};


export type HasContentGeneratorsContentGeneratorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};

export type HasFeedbacks = {
  exportFeedbacks?: Maybe<Array<Feedback>>;
  feedbackHappyCount: Scalars['Int']['output'];
  feedbackMehCount: Scalars['Int']['output'];
  feedbackSadCount: Scalars['Int']['output'];
  feedbacks?: Maybe<FeedbackConnection>;
  id: Scalars['ID']['output'];
};


export type HasFeedbacksFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  feedbackableArchived?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackableIds?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importance?: InputMaybe<Importance>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderAttr?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  organizedState?: InputMaybe<Scalars['String']['input']>;
  reaction?: InputMaybe<Reaction>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  unorganized?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Where>;
};

export type HubspotApp = Node & {
  __typename?: 'HubspotApp';
  /** The ID of the HubSpot account. */
  accountId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The custom reply-to email address in HubSpot. */
  customReplyToEmail?: Maybe<Scalars['String']['output']>;
  /** Description of the app. */
  description: Scalars['String']['output'];
  /** The ID of the email subscription list in HubSpot. */
  emailSubscriptionId?: Maybe<Scalars['String']['output']>;
  /** The name of the email subscription list in HubSpot. */
  emailSubscriptionName?: Maybe<Scalars['String']['output']>;
  /** Email subscriptions available in HubSpot. */
  emailSubscriptions?: Maybe<Array<HubspotEmailSubscription>>;
  /** The ID of the template in HubSpot to be used for announcements. */
  emailTemplateId?: Maybe<Scalars['String']['output']>;
  /** The name of the template in HubSpot to be used for announcements. */
  emailTemplateName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Whether the app is marked for deletion. */
  markedForDeletion: Scalars['Boolean']['output'];
  /** Name of the app. */
  name: Scalars['String']['output'];
  project: Project;
  /** Whether the app has all required settings configured. */
  ready: Scalars['Boolean']['output'];
  /** The from email address in HubSpot. */
  replyToEmail?: Maybe<Scalars['String']['output']>;
  sendEmailViaHubspot?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if there is an active job syncing your HubSpot data. */
  syncing: Scalars['Boolean']['output'];
  templates?: Maybe<Array<HubspotTemplate>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type HubspotEmailSubscription = {
  __typename?: 'HubspotEmailSubscription';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type HubspotSettingsValidationObject = {
  __typename?: 'HubspotSettingsValidationObject';
  /** List of errors for the email template ID; typically missing variables */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The ID of the email template */
  templateId: Scalars['String']['output'];
  /** The name of the email template */
  templateName: Scalars['String']['output'];
};

export type HubspotTemplate = {
  __typename?: 'HubspotTemplate';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type HubspotTemplateValidationObject = {
  __typename?: 'HubspotTemplateValidationObject';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  templateId: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
};

export type Idea = Feedbackable & HasFeedbacks & Node & Permalinks & {
  __typename?: 'Idea';
  archived: Scalars['Boolean']['output'];
  /** A list of all categories associated with this idea. */
  categories?: Maybe<CategoryConnection>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Date item was deactivated at. Item will be found in archive views once deactivated. */
  deactivatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The number of emails that will be sent if an idea is promoted */
  emailPromotionCount: Scalars['Int']['output'];
  exportFeedbacks?: Maybe<Array<Feedback>>;
  /** The number of feedbacks associated with this idea. */
  feedbackCount: Scalars['Int']['output'];
  feedbackHappyCount: Scalars['Int']['output'];
  feedbackMehCount: Scalars['Int']['output'];
  feedbackSadCount: Scalars['Int']['output'];
  feedbacks?: Maybe<FeedbackConnection>;
  id: Scalars['ID']['output'];
  /** The number of votes associated with this idea. */
  ideaVotesCount: Scalars['Int']['output'];
  /** @deprecated Idea#updated_at updates when feedback is added to an idea. */
  lastFeedback?: Maybe<Scalars['ISO8601DateTime']['output']>;
  latestWorkItemId?: Maybe<Scalars['String']['output']>;
  /** The name of the Idea */
  name: Scalars['String']['output'];
  /** Detailed notes describing the idea. */
  notes?: Maybe<Scalars['String']['output']>;
  privatePermalink: Scalars['String']['output'];
  /** The project ID the Category is associated to */
  project?: Maybe<Project>;
  publicPermalink: Scalars['String']['output'];
  /** Published ideas will be displayed on your LaunchNotes Page. */
  published: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** A list of all votes associated with this idea. */
  votes?: Maybe<VoteConnection>;
};


export type IdeaCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type IdeaFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  feedbackableArchived?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackableIds?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importance?: InputMaybe<Importance>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderAttr?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  organizedState?: InputMaybe<Scalars['String']['input']>;
  reaction?: InputMaybe<Reaction>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  unorganized?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Where>;
};


export type IdeaVotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderAttr?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Where>;
};

/** The connection type for Idea. */
export type IdeaConnection = {
  __typename?: 'IdeaConnection';
  /** A list of edges. */
  edges?: Maybe<Array<IdeaEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Idea>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IdeaEdge = {
  __typename?: 'IdeaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Idea>;
};

export type IdeaVote = Node & {
  __typename?: 'IdeaVote';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  idea: Idea;
  subscriber: Subscriber;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for IdeaVote. */
export type IdeaVoteConnection = {
  __typename?: 'IdeaVoteConnection';
  /** A list of edges. */
  edges?: Maybe<Array<IdeaVoteEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IdeaVote>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IdeaVoteEdge = {
  __typename?: 'IdeaVoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IdeaVote>;
};

export type Image = {
  __typename?: 'Image';
  byteSize?: Maybe<Scalars['Int']['output']>;
  checksum?: Maybe<Scalars['ID']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['ID']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of ImportFeedback */
export type ImportFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  feedbacks: Array<BatchFeedback>;
  projectId: Scalars['ID']['input'];
  skipOptIn?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of ImportFeedback. */
export type ImportFeedbackPayload = {
  __typename?: 'ImportFeedbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum Importance {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

/** Autogenerated input type of InitializeApp */
export type InitializeAppInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
  projectUrl: Scalars['String']['input'];
  webhookUrl: Scalars['String']['input'];
};

/** Autogenerated return type of InitializeApp. */
export type InitializeAppPayload = {
  __typename?: 'InitializeAppPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  integrationKey: Scalars['String']['output'];
};

/** Autogenerated input type of InviteProjectUser */
export type InviteProjectUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  role: ProjectRoleEnum;
};

/** Autogenerated return type of InviteProjectUser. */
export type InviteProjectUserPayload = {
  __typename?: 'InviteProjectUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  projectUser?: Maybe<User>;
};

export type JiraApp = Node & {
  __typename?: 'JiraApp';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  project: Project;
  projects: Array<JiraProject>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type JiraProject = {
  __typename?: 'JiraProject';
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MailAppSetting = Node & {
  __typename?: 'MailAppSetting';
  activeEsp?: Maybe<Scalars['String']['output']>;
  announcementButtonCta?: Maybe<Scalars['String']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  bodyBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** Whether or not categories are shown in emails */
  categoriesEnabled?: Maybe<Scalars['Boolean']['output']>;
  containerBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** @deprecated Courier is no longer supported */
  courierBrandId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customLayout?: Maybe<Scalars['String']['output']>;
  digestBackgroundColor?: Maybe<Scalars['String']['output']>;
  digestTextColor?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  euDomain: Scalars['Boolean']['output'];
  fontFamily?: Maybe<Scalars['String']['output']>;
  headingColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Image>;
  logoHeight?: Maybe<Scalars['String']['output']>;
  notificationsExcerptOnly: Scalars['Boolean']['output'];
  primaryColor?: Maybe<Scalars['String']['output']>;
  replyToEmail?: Maybe<Scalars['String']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
  smtpHost?: Maybe<Scalars['String']['output']>;
  smtpPassword?: Maybe<Scalars['String']['output']>;
  smtpPort?: Maybe<Scalars['String']['output']>;
  smtpSecure?: Maybe<Scalars['Boolean']['output']>;
  smtpUser?: Maybe<Scalars['String']['output']>;
  subscriberConfirmButtonCta?: Maybe<Scalars['String']['output']>;
  superscriptColor?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A marketplace template */
export type MarketplaceTemplate = Node & {
  __typename?: 'MarketplaceTemplate';
  category?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<Image>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for MarketplaceTemplate. */
export type MarketplaceTemplateConnection = {
  __typename?: 'MarketplaceTemplateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MarketplaceTemplateEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MarketplaceTemplate>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MarketplaceTemplateEdge = {
  __typename?: 'MarketplaceTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MarketplaceTemplate>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateProjectView?: Maybe<ActivateProjectViewPayload>;
  addCohortAudienceDomains?: Maybe<AddCohortAudienceDomainsPayload>;
  addCohortSubscribers?: Maybe<AddCohortSubscribersPayload>;
  addProjectViewAudienceDomains?: Maybe<AddAudienceDomainsPayload>;
  addProjectViewSubscribers?: Maybe<AddSubscribersPayload>;
  archiveAnnouncement?: Maybe<ArchiveAnnouncementPayload>;
  archiveDigest?: Maybe<ArchiveDigestPayload>;
  archiveFeedback?: Maybe<ArchiveFeedbackPayload>;
  archiveFeedbacks?: Maybe<ArchiveFeedbacksPayload>;
  archiveIdeas?: Maybe<ArchiveIdeasPayload>;
  archiveProject?: Maybe<ArchiveProjectPayload>;
  archiveStage?: Maybe<ArchiveStagePayload>;
  archiveTemplate?: Maybe<ArchiveTemplatePayload>;
  archiveWorkItem?: Maybe<ArchiveWorkItemPayload>;
  /** Confirms a project subscription */
  confirmProjectSubscription?: Maybe<ConfirmProjectSubscriptionPayload>;
  /** @deprecated Use confirmProjectSubscription instead */
  confirmSubscribers?: Maybe<ConfirmSubscribersPayload>;
  copyAnnouncementToProject?: Maybe<CopyAnnouncementToProjectPayload>;
  copyWorkItemToProject?: Maybe<CopyToProjectPayload>;
  createAiAnnouncement?: Maybe<CreateAiAnnouncementPayload>;
  createAnnouncement?: Maybe<CreateAnnouncementPayload>;
  createApiToken?: Maybe<CreateApiTokenPayload>;
  createAttributeDefinition?: Maybe<CreateAttributeDefinitionPayload>;
  createBatchEmailSubscriptions?: Maybe<CreateBatchEmailSubscriptionsPayload>;
  createCategory?: Maybe<CreateCategoryPayload>;
  /** Create a new change type. Change types are called Labels in the management portal */
  createChangeType?: Maybe<CreateChangePayload>;
  createCohort?: Maybe<CreateCohortPayload>;
  createConnectedSource?: Maybe<CreateSourcePayload>;
  createDigest?: Maybe<CreateDigestPayload>;
  createDirectUpload?: Maybe<CreateDirectUploadPayload>;
  createEmbedApp?: Maybe<CreateEmbedAppPayload>;
  createExternalContentLink?: Maybe<CreateExternalContentLinkPayload>;
  createFeedback?: Maybe<CreateFeedbackPayload>;
  /** Attributes for creating an idea */
  createIdea?: Maybe<CreateIdeaPayload>;
  /** Creates a new create_organization_profile */
  createOrganizationProfile?: Maybe<CreateOrganizationProfilePayload>;
  createOutboundWebhook?: Maybe<CreateOutboundWebhookPayload>;
  createProject?: Maybe<CreateProjectPayload>;
  /** Create a new subscription.  If a subscription already exists, we will return the matching subscription. */
  createProjectSubscription?: Maybe<CreateProjectSubscriptionPayload>;
  createProjectView?: Maybe<CreateProjectViewPayload>;
  createRoadmapUpdate?: Maybe<CreateRoadmapUpdatePayload>;
  createSecureConnection?: Maybe<CreateSecureConnectionPayload>;
  createSlackChannels?: Maybe<AddSlackChannelsPayload>;
  createStage?: Maybe<CreateStagePayload>;
  createTemplate?: Maybe<CreateTemplatePayload>;
  createWorkItem?: Maybe<CreateWorkItemPayload>;
  createWorkItemMovedUpdate?: Maybe<CreateWorkItemMovedUpdatePayload>;
  deactivateProjectView?: Maybe<DeactivateProjectViewPayload>;
  deleteAtlassianApp?: Maybe<DeletePayload>;
  deleteAttributeDefinition?: Maybe<DeleteAttributeDefinitionPayload>;
  deleteExternalContentLink?: Maybe<DeleteExternalContentLinkPayload>;
  deleteOutboundWebhook?: Maybe<DeleteOutboundWebhookPayload>;
  deleteSlackChannel?: Maybe<DeleteSlackChannelPayload>;
  /** Delete votes from an Idea */
  deleteVotes?: Maybe<DeleteVotesPayload>;
  destroyUser?: Maybe<DestroyUserAccountPayload>;
  duplicateAnnouncement?: Maybe<DuplicateAnnouncementPayload>;
  duplicateDigest?: Maybe<DuplicateDigestPayload>;
  duplicateProjectView?: Maybe<DuplicateProjectViewPayload>;
  duplicateWorkItem?: Maybe<DuplicateWorkItemPayload>;
  generateBernieAnnouncement?: Maybe<GenerateBernieAnnouncementPayload>;
  generateLoomAnnouncement?: Maybe<GenerateLoomAnnouncementPayload>;
  /** Get a session token for API Deck */
  getConsumerToken?: Maybe<GetConsumerSessionPayload>;
  importFeedback?: Maybe<ImportFeedbackPayload>;
  initializeJiraApp?: Maybe<InitializeAppPayload>;
  inviteProjectUser?: Maybe<InviteProjectUserPayload>;
  organizeFeedbacks?: Maybe<OrganizeFeedbacksPayload>;
  previewAnnouncementSlack?: Maybe<PreviewAnnouncementSlackPayload>;
  /** Promote an Idea to a Roadmap item */
  promoteIdea?: Maybe<PromoteIdeaPayload>;
  publishAnnouncement?: Maybe<PublishAnnouncementPayload>;
  publishDigest?: Maybe<PublishDigestPayload>;
  publishWorkItem?: Maybe<PublishWorkItemPayload>;
  regenerateEmbedAppToken?: Maybe<RegenerateTokenPayload>;
  removeAllowedDomain?: Maybe<RemoveAllowedDomainPayload>;
  removeAnnouncementAttachment?: Maybe<RemoveAttachmentPayload>;
  removeAnnouncementWorkItem?: Maybe<RemoveAnnouncementWorkItemPayload>;
  /** Remove an API Token */
  removeApiToken?: Maybe<RemoveApiTokenPayload>;
  removeCategory?: Maybe<RemoveCategoryPayload>;
  removeChangeType?: Maybe<RemoveChangePayload>;
  removeCohortAudienceDomains?: Maybe<RemoveCohortAudienceDomainsPayload>;
  removeCohortSubscribers?: Maybe<RemoveCohortSubscribersPayload>;
  removeConnectedJiraProject?: Maybe<RemoveConnectedJiraProjectPayload>;
  removeConnectedSource?: Maybe<RemoveSourcePayload>;
  /** Removes a CRM integration by deleting an Apideck Vault connection */
  removeCrmIntegration?: Maybe<RemoveCrmIntegrationPayload>;
  removeEmailLogo?: Maybe<RemoveEmailLogoPayload>;
  removeProjectEmptyFieldImage?: Maybe<RemoveEmptyFieldImagePayload>;
  removeProjectFavicon?: Maybe<RemoveFaviconPayload>;
  removeProjectLogo?: Maybe<RemoveLogoPayload>;
  removeProjectShareImage?: Maybe<RemoveShareImagePayload>;
  /** @deprecated Use unsubscribeProjectSubscription instead */
  removeProjectSubscribers?: Maybe<RemoveFromProjectPayload>;
  /** Removes a project subscription */
  removeProjectSubscription?: Maybe<RemoveProjectSubscriptionPayload>;
  removeProjectUser?: Maybe<RemoveProjectUserPayload>;
  removeProjectViewAudienceDomains?: Maybe<RemoveAudienceDomainsPayload>;
  removeProjectViewSubscribers?: Maybe<RemoveSubscribersPayload>;
  removeSecureConnection?: Maybe<RemoveSecureConnectionPayload>;
  removeTemplateAttachment?: Maybe<RemoveTemplateAttachmentPayload>;
  removeUserAvatarImage?: Maybe<RemoveAvatarImagePayload>;
  removeWorkItemHeroImage?: Maybe<RemoveHeroImagePayload>;
  removeWorkItemOwner?: Maybe<RemoveOwnerPayload>;
  reorderCategory?: Maybe<ReorderCategoryPayload>;
  reorderExternalContentLinks?: Maybe<ReorderExternalContentLinksPayload>;
  reorderStage?: Maybe<ReorderStagePayload>;
  repositionWorkItem?: Maybe<RepositionWorkItemPayload>;
  /** Resubscribes a project subscription */
  resubscribeProjectSubscription?: Maybe<ResubscribeProjectSubscriptionPayload>;
  /** @deprecated Use resubscribeProjectSubscription instead */
  resubscribeToProject?: Maybe<ResubscribeToProjectPayload>;
  retryWebhookEvent?: Maybe<RetryWebhookEventPayload>;
  scheduleAnnouncement?: Maybe<ScheduleAnnouncementPayload>;
  /** Send a test promotion email to the current user */
  sendPromoteTest?: Maybe<SendPromoteTestPayload>;
  sendRoadmapUpdateTestEmail?: Maybe<SendRoadmapUpdateTestEmailPayload>;
  sendTestEmail?: Maybe<SendTestEmailPayload>;
  sendWebhookTestEvent?: Maybe<SendWebhookTestEventPayload>;
  /** Set email settings for a HubSpot app in a project */
  setEmailSettings?: Maybe<SetEmailSettingsPayload>;
  setEmailSubscription?: Maybe<SetEmailSubscriptionPayload>;
  /** Subscribes a project subscription to a category */
  subscribeProjectSubscriptionCategory?: Maybe<SubscribeProjectSubscriptionCategoryPayload>;
  /** Subscribes a project subscription to a work item */
  subscribeProjectSubscriptionWorkItem?: Maybe<SubscribeProjectSubscriptionWorkItemPayload>;
  /** Syncs revenue CRM revenue data for a given project */
  syncCrmCompanies?: Maybe<SyncCrmCompaniesPayload>;
  toggleEnforceEmbedToken?: Maybe<ToggleEnforceEmbedTokenPayload>;
  toggleEventType?: Maybe<ToggleEventPayload>;
  toggleOutboundWebhookEnabled?: Maybe<ToggleOutboundWebhookEnabledPayload>;
  togglePublicStageDescriptions?: Maybe<TogglePublicStageDescriptionsPayload>;
  /** Attributes for updating an idea */
  togglePublishedIdea?: Maybe<TogglePublishedIdeaPayload>;
  toggleRollup?: Maybe<ToggleRollupPayload>;
  toggleSendToAll?: Maybe<ToggleSendToAllPayload>;
  toggleSubscriberReport?: Maybe<ToggleSubscriberReportPayload>;
  trackViewedAnnouncements?: Maybe<TrackViewedAnnouncementsPayload>;
  triggerTestEmail?: Maybe<TriggerTestEmailPayload>;
  unarchiveAnnouncement?: Maybe<UnarchiveAnnouncementPayload>;
  unarchiveFeedback?: Maybe<UnarchiveFeedbackPayload>;
  unarchiveFeedbacks?: Maybe<UnarchiveFeedbacksPayload>;
  unarchiveIdeas?: Maybe<UnarchiveIdeasPayload>;
  unarchiveWorkItem?: Maybe<UnarchiveWorkItemPayload>;
  unpublishAnnouncement?: Maybe<UnpublishAnnouncementPayload>;
  unpublishWorkItem?: Maybe<UnpublishWorkItemPayload>;
  unscheduleAnnouncement?: Maybe<UnscheduleAnnouncementPayload>;
  /** @deprecated Use unsubscribeProjectSubscription intead */
  unsubscribeAll?: Maybe<UnsubscribeAllPayload>;
  /** @deprecated Use unsubscribeProjectSubscription instead */
  unsubscribeFromProject?: Maybe<UnsubscribeFromProjectPayload>;
  /** Unsubscribes a project subscription */
  unsubscribeProjectSubscription?: Maybe<UnsubscribeProjectSubscriptionPayload>;
  /** Unsubscribes a project subscription from everything */
  unsubscribeProjectSubscriptionAll?: Maybe<UnsubscribeProjectSubscriptionAllPayload>;
  /** Unsubscribes a project subscription from a category */
  unsubscribeProjectSubscriptionCategory?: Maybe<UnsubscribeProjectSubscriptionCategoryPayload>;
  /** Unsubscribes a project subscription to a work item */
  unsubscribeProjectSubscriptionWorkItem?: Maybe<UnsubscribeProjectSubscriptionWorkItemPayload>;
  updateAnnouncement?: Maybe<UpdateAnnouncementPayload>;
  updateAtlassianOauthApp?: Maybe<UpdatePayload>;
  updateAttribute?: Maybe<UpdateAttributePayload>;
  updateCategory?: Maybe<UpdateCategoryPayload>;
  updateChangeType?: Maybe<UpdateChangePayload>;
  updateCohort?: Maybe<UpdateCohortPayload>;
  updateConnectedSource?: Maybe<UpdateSourcePayload>;
  updateDigest?: Maybe<UpdateDigestPayload>;
  updateEmbedApp?: Maybe<UpdateEmbedAppPayload>;
  updateExternalContentLink?: Maybe<UpdateExternalContentLinkPayload>;
  updateFeedback?: Maybe<UpdateFeedbackPayload>;
  /** Attributes for updating an idea */
  updateIdea?: Maybe<UpdateIdeaPayload>;
  updateMailAppSettings?: Maybe<UpdateMailAppSettingsPayload>;
  updateOnboardingTasks?: Maybe<UpdateOnboardingTasksPayload>;
  updateOutboundWebhook?: Maybe<UpdateOutboundWebhookPayload>;
  updateProject?: Maybe<UpdateProjectPayload>;
  /** Updates a project subscription's categories or work items */
  updateProjectSubscription?: Maybe<UpdateProjectSubscriptionPayload>;
  /** Update the user's role for the given project. */
  updateProjectUserRole?: Maybe<UpdateProjectUserRolePayload>;
  updateProjectView?: Maybe<UpdateProjectViewPayload>;
  updateSecureConnection?: Maybe<UpdateSecureConnectionPayload>;
  updateStage?: Maybe<UpdateStagePayload>;
  updateTemplate?: Maybe<UpdateTemplatePayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  updateWorkItem?: Maybe<UpdateWorkItemPayload>;
  upsertRollup?: Maybe<UpsertRollupPayload>;
  validateHubspotTemplates?: Maybe<ValidateHubspotTemplatesPayload>;
  verifyOutboundWebhook?: Maybe<VerifyOutboundWebhookPayload>;
};


export type MutationActivateProjectViewArgs = {
  input: ActivateProjectViewInput;
};


export type MutationAddCohortAudienceDomainsArgs = {
  input: AddCohortAudienceDomainsInput;
};


export type MutationAddCohortSubscribersArgs = {
  input: AddCohortSubscribersInput;
};


export type MutationAddProjectViewAudienceDomainsArgs = {
  input: AddAudienceDomainsInput;
};


export type MutationAddProjectViewSubscribersArgs = {
  input: AddSubscribersInput;
};


export type MutationArchiveAnnouncementArgs = {
  input: ArchiveAnnouncementInput;
};


export type MutationArchiveDigestArgs = {
  input: ArchiveDigestInput;
};


export type MutationArchiveFeedbackArgs = {
  input: ArchiveFeedbackInput;
};


export type MutationArchiveFeedbacksArgs = {
  input: ArchiveFeedbacksInput;
};


export type MutationArchiveIdeasArgs = {
  input: ArchiveIdeasInput;
};


export type MutationArchiveProjectArgs = {
  input: ArchiveProjectInput;
};


export type MutationArchiveStageArgs = {
  input: ArchiveStageInput;
};


export type MutationArchiveTemplateArgs = {
  input: ArchiveTemplateInput;
};


export type MutationArchiveWorkItemArgs = {
  input: ArchiveWorkItemInput;
};


export type MutationConfirmProjectSubscriptionArgs = {
  input: ConfirmProjectSubscriptionInput;
};


export type MutationConfirmSubscribersArgs = {
  input: ConfirmSubscribersInput;
};


export type MutationCopyAnnouncementToProjectArgs = {
  input: CopyAnnouncementToProjectInput;
};


export type MutationCopyWorkItemToProjectArgs = {
  input: CopyToProjectInput;
};


export type MutationCreateAiAnnouncementArgs = {
  input: CreateAiAnnouncementInput;
};


export type MutationCreateAnnouncementArgs = {
  input: CreateAnnouncementInput;
};


export type MutationCreateApiTokenArgs = {
  input: CreateApiTokenInput;
};


export type MutationCreateAttributeDefinitionArgs = {
  input: CreateAttributeDefinitionInput;
};


export type MutationCreateBatchEmailSubscriptionsArgs = {
  input: CreateBatchEmailSubscriptionsInput;
};


export type MutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};


export type MutationCreateChangeTypeArgs = {
  input: CreateChangeInput;
};


export type MutationCreateCohortArgs = {
  input: CreateCohortInput;
};


export type MutationCreateConnectedSourceArgs = {
  input: CreateSourceInput;
};


export type MutationCreateDigestArgs = {
  input: CreateDigestInput;
};


export type MutationCreateDirectUploadArgs = {
  input: CreateDirectUploadInput;
};


export type MutationCreateEmbedAppArgs = {
  input: CreateEmbedAppInput;
};


export type MutationCreateExternalContentLinkArgs = {
  input: CreateExternalContentLinkInput;
};


export type MutationCreateFeedbackArgs = {
  input: CreateFeedbackInput;
};


export type MutationCreateIdeaArgs = {
  input: CreateIdeaInput;
};


export type MutationCreateOrganizationProfileArgs = {
  input: CreateOrganizationProfileInput;
};


export type MutationCreateOutboundWebhookArgs = {
  input: CreateOutboundWebhookInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateProjectSubscriptionArgs = {
  input: CreateProjectSubscriptionInput;
};


export type MutationCreateProjectViewArgs = {
  input: CreateProjectViewInput;
};


export type MutationCreateRoadmapUpdateArgs = {
  input: CreateRoadmapUpdateInput;
};


export type MutationCreateSecureConnectionArgs = {
  input: CreateSecureConnectionInput;
};


export type MutationCreateSlackChannelsArgs = {
  input: AddSlackChannelsInput;
};


export type MutationCreateStageArgs = {
  input: CreateStageInput;
};


export type MutationCreateTemplateArgs = {
  input: CreateTemplateInput;
};


export type MutationCreateWorkItemArgs = {
  input: CreateWorkItemInput;
};


export type MutationCreateWorkItemMovedUpdateArgs = {
  input: CreateWorkItemMovedUpdateInput;
};


export type MutationDeactivateProjectViewArgs = {
  input: DeactivateProjectViewInput;
};


export type MutationDeleteAtlassianAppArgs = {
  input: DeleteInput;
};


export type MutationDeleteAttributeDefinitionArgs = {
  input: DeleteAttributeDefinitionInput;
};


export type MutationDeleteExternalContentLinkArgs = {
  input: DeleteExternalContentLinkInput;
};


export type MutationDeleteOutboundWebhookArgs = {
  input: DeleteOutboundWebhookInput;
};


export type MutationDeleteSlackChannelArgs = {
  input: DeleteSlackChannelInput;
};


export type MutationDeleteVotesArgs = {
  input: DeleteVotesInput;
};


export type MutationDestroyUserArgs = {
  input: DestroyUserAccountInput;
};


export type MutationDuplicateAnnouncementArgs = {
  input: DuplicateAnnouncementInput;
};


export type MutationDuplicateDigestArgs = {
  input: DuplicateDigestInput;
};


export type MutationDuplicateProjectViewArgs = {
  input: DuplicateProjectViewInput;
};


export type MutationDuplicateWorkItemArgs = {
  input: DuplicateWorkItemInput;
};


export type MutationGenerateBernieAnnouncementArgs = {
  input: GenerateBernieAnnouncementInput;
};


export type MutationGenerateLoomAnnouncementArgs = {
  input: GenerateLoomAnnouncementInput;
};


export type MutationGetConsumerTokenArgs = {
  input: GetConsumerSessionInput;
};


export type MutationImportFeedbackArgs = {
  input: ImportFeedbackInput;
};


export type MutationInitializeJiraAppArgs = {
  input: InitializeAppInput;
};


export type MutationInviteProjectUserArgs = {
  input: InviteProjectUserInput;
};


export type MutationOrganizeFeedbacksArgs = {
  input: OrganizeFeedbacksInput;
};


export type MutationPreviewAnnouncementSlackArgs = {
  input: PreviewAnnouncementSlackInput;
};


export type MutationPromoteIdeaArgs = {
  input: PromoteIdeaInput;
};


export type MutationPublishAnnouncementArgs = {
  input: PublishAnnouncementInput;
};


export type MutationPublishDigestArgs = {
  input: PublishDigestInput;
};


export type MutationPublishWorkItemArgs = {
  input: PublishWorkItemInput;
};


export type MutationRegenerateEmbedAppTokenArgs = {
  input: RegenerateTokenInput;
};


export type MutationRemoveAllowedDomainArgs = {
  input: RemoveAllowedDomainInput;
};


export type MutationRemoveAnnouncementAttachmentArgs = {
  input: RemoveAttachmentInput;
};


export type MutationRemoveAnnouncementWorkItemArgs = {
  input: RemoveAnnouncementWorkItemInput;
};


export type MutationRemoveApiTokenArgs = {
  input: RemoveApiTokenInput;
};


export type MutationRemoveCategoryArgs = {
  input: RemoveCategoryInput;
};


export type MutationRemoveChangeTypeArgs = {
  input: RemoveChangeInput;
};


export type MutationRemoveCohortAudienceDomainsArgs = {
  input: RemoveCohortAudienceDomainsInput;
};


export type MutationRemoveCohortSubscribersArgs = {
  input: RemoveCohortSubscribersInput;
};


export type MutationRemoveConnectedJiraProjectArgs = {
  input: RemoveConnectedJiraProjectInput;
};


export type MutationRemoveConnectedSourceArgs = {
  input: RemoveSourceInput;
};


export type MutationRemoveCrmIntegrationArgs = {
  input: RemoveCrmIntegrationInput;
};


export type MutationRemoveEmailLogoArgs = {
  input: RemoveEmailLogoInput;
};


export type MutationRemoveProjectEmptyFieldImageArgs = {
  input: RemoveEmptyFieldImageInput;
};


export type MutationRemoveProjectFaviconArgs = {
  input: RemoveFaviconInput;
};


export type MutationRemoveProjectLogoArgs = {
  input: RemoveLogoInput;
};


export type MutationRemoveProjectShareImageArgs = {
  input: RemoveShareImageInput;
};


export type MutationRemoveProjectSubscribersArgs = {
  input: RemoveFromProjectInput;
};


export type MutationRemoveProjectSubscriptionArgs = {
  input: RemoveProjectSubscriptionInput;
};


export type MutationRemoveProjectUserArgs = {
  input: RemoveProjectUserInput;
};


export type MutationRemoveProjectViewAudienceDomainsArgs = {
  input: RemoveAudienceDomainsInput;
};


export type MutationRemoveProjectViewSubscribersArgs = {
  input: RemoveSubscribersInput;
};


export type MutationRemoveSecureConnectionArgs = {
  input: RemoveSecureConnectionInput;
};


export type MutationRemoveTemplateAttachmentArgs = {
  input: RemoveTemplateAttachmentInput;
};


export type MutationRemoveUserAvatarImageArgs = {
  input: RemoveAvatarImageInput;
};


export type MutationRemoveWorkItemHeroImageArgs = {
  input: RemoveHeroImageInput;
};


export type MutationRemoveWorkItemOwnerArgs = {
  input: RemoveOwnerInput;
};


export type MutationReorderCategoryArgs = {
  input: ReorderCategoryInput;
};


export type MutationReorderExternalContentLinksArgs = {
  input: ReorderExternalContentLinksInput;
};


export type MutationReorderStageArgs = {
  input: ReorderStageInput;
};


export type MutationRepositionWorkItemArgs = {
  input: RepositionWorkItemInput;
};


export type MutationResubscribeProjectSubscriptionArgs = {
  input: ResubscribeProjectSubscriptionInput;
};


export type MutationResubscribeToProjectArgs = {
  input: ResubscribeToProjectInput;
};


export type MutationRetryWebhookEventArgs = {
  input: RetryWebhookEventInput;
};


export type MutationScheduleAnnouncementArgs = {
  input: ScheduleAnnouncementInput;
};


export type MutationSendPromoteTestArgs = {
  input: SendPromoteTestInput;
};


export type MutationSendRoadmapUpdateTestEmailArgs = {
  input: SendRoadmapUpdateTestEmailInput;
};


export type MutationSendTestEmailArgs = {
  input: SendTestEmailInput;
};


export type MutationSendWebhookTestEventArgs = {
  input: SendWebhookTestEventInput;
};


export type MutationSetEmailSettingsArgs = {
  input: SetEmailSettingsInput;
};


export type MutationSetEmailSubscriptionArgs = {
  input: SetEmailSubscriptionInput;
};


export type MutationSubscribeProjectSubscriptionCategoryArgs = {
  input: SubscribeProjectSubscriptionCategoryInput;
};


export type MutationSubscribeProjectSubscriptionWorkItemArgs = {
  input: SubscribeProjectSubscriptionWorkItemInput;
};


export type MutationSyncCrmCompaniesArgs = {
  input: SyncCrmCompaniesInput;
};


export type MutationToggleEnforceEmbedTokenArgs = {
  input: ToggleEnforceEmbedTokenInput;
};


export type MutationToggleEventTypeArgs = {
  input: ToggleEventInput;
};


export type MutationToggleOutboundWebhookEnabledArgs = {
  input: ToggleOutboundWebhookEnabledInput;
};


export type MutationTogglePublicStageDescriptionsArgs = {
  input: TogglePublicStageDescriptionsInput;
};


export type MutationTogglePublishedIdeaArgs = {
  input: TogglePublishedIdeaInput;
};


export type MutationToggleRollupArgs = {
  input: ToggleRollupInput;
};


export type MutationToggleSendToAllArgs = {
  input: ToggleSendToAllInput;
};


export type MutationToggleSubscriberReportArgs = {
  input: ToggleSubscriberReportInput;
};


export type MutationTrackViewedAnnouncementsArgs = {
  input: TrackViewedAnnouncementsInput;
};


export type MutationTriggerTestEmailArgs = {
  input: TriggerTestEmailInput;
};


export type MutationUnarchiveAnnouncementArgs = {
  input: UnarchiveAnnouncementInput;
};


export type MutationUnarchiveFeedbackArgs = {
  input: UnarchiveFeedbackInput;
};


export type MutationUnarchiveFeedbacksArgs = {
  input: UnarchiveFeedbacksInput;
};


export type MutationUnarchiveIdeasArgs = {
  input: UnarchiveIdeasInput;
};


export type MutationUnarchiveWorkItemArgs = {
  input: UnarchiveWorkItemInput;
};


export type MutationUnpublishAnnouncementArgs = {
  input: UnpublishAnnouncementInput;
};


export type MutationUnpublishWorkItemArgs = {
  input: UnpublishWorkItemInput;
};


export type MutationUnscheduleAnnouncementArgs = {
  input: UnscheduleAnnouncementInput;
};


export type MutationUnsubscribeAllArgs = {
  input: UnsubscribeAllInput;
};


export type MutationUnsubscribeFromProjectArgs = {
  input: UnsubscribeFromProjectInput;
};


export type MutationUnsubscribeProjectSubscriptionArgs = {
  input: UnsubscribeProjectSubscriptionInput;
};


export type MutationUnsubscribeProjectSubscriptionAllArgs = {
  input: UnsubscribeProjectSubscriptionAllInput;
};


export type MutationUnsubscribeProjectSubscriptionCategoryArgs = {
  input: UnsubscribeProjectSubscriptionCategoryInput;
};


export type MutationUnsubscribeProjectSubscriptionWorkItemArgs = {
  input: UnsubscribeProjectSubscriptionWorkItemInput;
};


export type MutationUpdateAnnouncementArgs = {
  input: UpdateAnnouncementInput;
};


export type MutationUpdateAtlassianOauthAppArgs = {
  input: UpdateInput;
};


export type MutationUpdateAttributeArgs = {
  input: UpdateAttributeInput;
};


export type MutationUpdateCategoryArgs = {
  input: UpdateCategoryInput;
};


export type MutationUpdateChangeTypeArgs = {
  input: UpdateChangeInput;
};


export type MutationUpdateCohortArgs = {
  input: UpdateCohortInput;
};


export type MutationUpdateConnectedSourceArgs = {
  input: UpdateSourceInput;
};


export type MutationUpdateDigestArgs = {
  input: UpdateDigestInput;
};


export type MutationUpdateEmbedAppArgs = {
  input: UpdateEmbedAppInput;
};


export type MutationUpdateExternalContentLinkArgs = {
  input: UpdateExternalContentLinkInput;
};


export type MutationUpdateFeedbackArgs = {
  input: UpdateFeedbackInput;
};


export type MutationUpdateIdeaArgs = {
  input: UpdateIdeaInput;
};


export type MutationUpdateMailAppSettingsArgs = {
  input: UpdateMailAppSettingsInput;
};


export type MutationUpdateOnboardingTasksArgs = {
  input: UpdateOnboardingTasksInput;
};


export type MutationUpdateOutboundWebhookArgs = {
  input: UpdateOutboundWebhookInput;
};


export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};


export type MutationUpdateProjectSubscriptionArgs = {
  input: UpdateProjectSubscriptionInput;
};


export type MutationUpdateProjectUserRoleArgs = {
  input: UpdateProjectUserRoleInput;
};


export type MutationUpdateProjectViewArgs = {
  input: UpdateProjectViewInput;
};


export type MutationUpdateSecureConnectionArgs = {
  input: UpdateSecureConnectionInput;
};


export type MutationUpdateStageArgs = {
  input: UpdateStageInput;
};


export type MutationUpdateTemplateArgs = {
  input: UpdateTemplateInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateWorkItemArgs = {
  input: UpdateWorkItemInput;
};


export type MutationUpsertRollupArgs = {
  input: UpsertRollupInput;
};


export type MutationValidateHubspotTemplatesArgs = {
  input: ValidateHubspotTemplatesInput;
};


export type MutationVerifyOutboundWebhookArgs = {
  input: VerifyOutboundWebhookInput;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

export type Notification = Node & {
  __typename?: 'Notification';
  /** The time the notification was clicked. */
  clickedThroughAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** @deprecated Delivered at is no longer supported */
  deliveredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  event: Event;
  id: Scalars['ID']['output'];
  /** The time the notification was opened. */
  openedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The time the notification was sent. */
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The status of the notification, clicked, opened, sent or undelivered. */
  status: NotificationStatus;
  /** The transport used to send the notification, email or slack. */
  transport: SubscriptionTransport;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Notification. */
export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<NotificationEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Notification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Notification>;
};

export enum NotificationStatus {
  Clicked = 'clicked',
  Opened = 'opened',
  Sent = 'sent',
  Undelivered = 'undelivered'
}

export type OnboardingTasks = Node & {
  __typename?: 'OnboardingTasks';
  addAnnouncement?: Maybe<Scalars['Boolean']['output']>;
  addSubscriber?: Maybe<Scalars['Boolean']['output']>;
  addUser?: Maybe<Scalars['Boolean']['output']>;
  addWorkItem?: Maybe<Scalars['Boolean']['output']>;
  claimSubdomain?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customizeCategories?: Maybe<Scalars['Boolean']['output']>;
  customizeColors?: Maybe<Scalars['Boolean']['output']>;
  customizeEmail?: Maybe<Scalars['Boolean']['output']>;
  customizeHtmlCss?: Maybe<Scalars['Boolean']['output']>;
  customizeRoadmapStages?: Maybe<Scalars['Boolean']['output']>;
  enableRoadmap?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  uploadLogo?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderBy = {
  field: Scalars['String']['input'];
  sort: SortEnum;
  type?: InputMaybe<OrderByField>;
};

export enum OrderByField {
  Boolean = 'boolean',
  Float = 'float',
  Integer = 'integer',
  String = 'string'
}

export type OrderMap = {
  /** ExternalContentLink ID */
  id: Scalars['ID']['input'];
  /** Position in the list of ECLs within the owner */
  position: Scalars['Int']['input'];
};

export type Organization = Node & {
  __typename?: 'Organization';
  /** The active tier of the Organization */
  activeTier?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The name of the Organization */
  name?: Maybe<Scalars['String']['output']>;
  /** The projects associated with the Organization */
  projects?: Maybe<Array<Project>>;
  /** The trial status of the Organization */
  trial?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The users associated with the Organization */
  users: Array<User>;
};

/** Autogenerated input type of OrganizeFeedbacks */
export type OrganizeFeedbacksInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The IDs of the feedbacks you would like to organize. */
  feedbackIds: Array<Scalars['ID']['input']>;
  feedbackableId?: InputMaybe<Scalars['ID']['input']>;
  feedbackableType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of OrganizeFeedbacks. */
export type OrganizeFeedbacksPayload = {
  __typename?: 'OrganizeFeedbacksPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  feedbacks?: Maybe<Array<Feedback>>;
};

export type OutboundWebhook = Node & {
  __typename?: 'OutboundWebhook';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Whether or not the webhook is active */
  enabled: Scalars['Boolean']['output'];
  eventTypes: Array<EventType>;
  events: OutboundWebhookEventConnection;
  id: Scalars['ID']['output'];
  /** Whether or not the webhook is managed by the system or user */
  managed?: Maybe<Scalars['Boolean']['output']>;
  /** The given name of the webhook */
  name: Scalars['String']['output'];
  /** The owner of the webhook */
  owner: WebhookOwner;
  /** The password for authorizing the webhook */
  password?: Maybe<Scalars['String']['output']>;
  /** The current validity state of the webhook */
  status: OutboundWebhookStatus;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The URL that the webhook sends information to */
  url: Scalars['String']['output'];
  /** The username for authorizing the webhook */
  username?: Maybe<Scalars['String']['output']>;
};


export type OutboundWebhookEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};

export type OutboundWebhookEvent = Node & {
  __typename?: 'OutboundWebhookEvent';
  createdAt: Scalars['ISO8601DateTime']['output'];
  event: Event;
  eventType: EventType;
  id: Scalars['ID']['output'];
  outboundWebhook: OutboundWebhook;
  payload: Scalars['JSON']['output'];
  status: OutboundWebhookEventStatus;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for OutboundWebhookEvent. */
export type OutboundWebhookEventConnection = {
  __typename?: 'OutboundWebhookEventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OutboundWebhookEventEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OutboundWebhookEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OutboundWebhookEventEdge = {
  __typename?: 'OutboundWebhookEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OutboundWebhookEvent>;
};

export enum OutboundWebhookEventStatus {
  /** The URL of the webhook accepted the event */
  Delivered = 'delivered',
  /** The webhook attempted and retried delivery but was unsuccessful */
  Failed = 'failed',
  /** Waiting to be sent */
  Pending = 'pending',
  /** The webhook failed a previous attempt but is being retried */
  Retried = 'retried'
}

export enum OutboundWebhookStatus {
  /** Webhook failed validation */
  Failed = 'failed',
  /** Webhook has yet to check status */
  Pending = 'pending',
  /** Webhook has been verified */
  Verified = 'verified'
}

export enum Owner {
  Subscriber = 'Subscriber',
  User = 'User'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Permalinks = {
  privatePermalink: Scalars['String']['output'];
  publicPermalink: Scalars['String']['output'];
};

/** Autogenerated input type of PreviewAnnouncementSlack */
export type PreviewAnnouncementSlackInput = {
  /** The id of the announcement you would like to schedule.  Announcement must be a draft, or scheduled. */
  announcementId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The email you want to send this announcement preview to. */
  recipientEmail: Scalars['String']['input'];
};

/** Autogenerated return type of PreviewAnnouncementSlack. */
export type PreviewAnnouncementSlackPayload = {
  __typename?: 'PreviewAnnouncementSlackPayload';
  announcement?: Maybe<Announcement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** A project */
export type Project = HasAttributeDefinitions & HasFeedbacks & Node & Subscribable & {
  __typename?: 'Project';
  allowedDomains: Array<Scalars['String']['output']>;
  announcementDigests: AnnouncementDigestConnection;
  announcements?: Maybe<AnnouncementConnection>;
  /** The name of the announcements tab for the project */
  announcementsName: Scalars['String']['output'];
  /** Retrieve an API Token by ID */
  apiToken?: Maybe<ApiToken>;
  apiTokens?: Maybe<ApiTokenConnection>;
  attributeDefinitions: AttributeDefinitionConnection;
  audienceDomain?: Maybe<AudienceDomain>;
  audienceDomains: AudienceDomainConnection;
  /** The author of the project */
  author?: Maybe<Scalars['String']['output']>;
  /** If true, new users will be automatically subscribed to the project page. */
  autosubscribeNewUsers: Scalars['Boolean']['output'];
  categories?: Maybe<CategoryConnection>;
  changeTypes?: Maybe<ChangeTypeConnection>;
  cohort?: Maybe<Cohort>;
  /** A list of all cohorts for a project */
  cohorts?: Maybe<CohortConnection>;
  colorTheme: Scalars['String']['output'];
  connectedJiraProjects?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Date time of when CRM data was last synced */
  crmDataLastSync?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** CRM stages used to filter CRM revenue data */
  crmStageData: CrmStage;
  customCss?: Maybe<Scalars['String']['output']>;
  customFooter?: Maybe<Scalars['String']['output']>;
  customHead?: Maybe<Scalars['String']['output']>;
  customHeader?: Maybe<Scalars['String']['output']>;
  customIndexHero?: Maybe<Scalars['String']['output']>;
  defaultNotificationSetting: Scalars['Boolean']['output'];
  defaultPrompt: Scalars['String']['output'];
  defaultWorkItemsDisplayTimeline: Scalars['Boolean']['output'];
  density: Scalars['String']['output'];
  /** The description of the project */
  description?: Maybe<Scalars['String']['output']>;
  editable: Scalars['Boolean']['output'];
  /** The email project subscription for this project, specifically for your User. */
  emailProjectSubscription?: Maybe<ProjectSubscription>;
  emailSettings: MailAppSetting;
  /** The email subscription for this project, specifically for your User. */
  emailSubscription?: Maybe<Subscription>;
  embedApps: Array<EmbedApp>;
  /**
   * The empty field image of the project, to be displayed when no announcements,
   * work items, or ideas are published on the project page.
   */
  emptyFieldImage?: Maybe<Image>;
  eventTypes: EventTypeConnection;
  /** A list of all user triggered events on a project and its entities. */
  events: EventConnection;
  exportFeedbacks?: Maybe<Array<Feedback>>;
  exportSubscribers?: Maybe<SubscriberConnection>;
  /** The favicon of the project */
  favicon?: Maybe<Image>;
  /** Whether the feedback page is accessible on the page. */
  feedbackEnabled: Scalars['Boolean']['output'];
  /** When feedback is received for this project, forward it to these emails. */
  feedbackForwardEmails: Array<Scalars['String']['output']>;
  feedbackHappyCount: Scalars['Int']['output'];
  feedbackMehCount: Scalars['Int']['output'];
  feedbackSadCount: Scalars['Int']['output'];
  feedbackViaEmailEnabled: Scalars['Boolean']['output'];
  feedbackViaSlackEnabled: Scalars['Boolean']['output'];
  feedbacks?: Maybe<FeedbackConnection>;
  /**
   * Number of months from when the fiscal year starts (e.g. -3 causes Q1 2024 to
   * start October 2023, 15 causes Q1 2024 to start April 2025)
   */
  fiscalYearOffset: Scalars['Int']['output'];
  grayColor: Scalars['String']['output'];
  hasPublishedIdea: Scalars['Boolean']['output'];
  /** The heading of the project */
  heading?: Maybe<Scalars['String']['output']>;
  hideNotificationContent: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** A list of all ideas for a project */
  ideas?: Maybe<IdeaConnection>;
  /** The disclaimer text to display on the ideas page */
  ideasDisclaimer?: Maybe<Scalars['String']['output']>;
  ideasDisclaimerEnabled: Scalars['Boolean']['output'];
  /** Whether the ideas page is accessible on the page. */
  ideasEnabled: Scalars['Boolean']['output'];
  /** The name of the ideas page, will display as the title on the page */
  ideasName: Scalars['String']['output'];
  lightGrayColor: Scalars['String']['output'];
  /** The logo of the project */
  logo?: Maybe<Image>;
  marketplaceTemplates: MarketplaceTemplateConnection;
  maxTeamMembers: Scalars['Int']['output'];
  /** The name of the project */
  name: Scalars['String']['output'];
  newSubscriptionsThisMonth: Scalars['Int']['output'];
  noindex: Scalars['Boolean']['output'];
  offWhiteColor: Scalars['String']['output'];
  onboardingTasks: OnboardingTasks;
  organization: Organization;
  outboundWebhooks: Array<OutboundWebhook>;
  primaryColor: Scalars['String']['output'];
  primaryTextColor: Scalars['String']['output'];
  /** URL to use for the privacy policy link in the subscribe modal and in emails */
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  /** The list of users that have an admin role in the project or organization */
  projectAdmins: Array<User>;
  projectApps?: Maybe<ProjectAppConnection>;
  projectSubscription?: Maybe<ProjectSubscription>;
  projectSubscriptionByEmail?: Maybe<ProjectSubscription>;
  projectSubscriptions?: Maybe<ProjectSubscriptionConnection>;
  /** A list of all users that have access to the project */
  projectUsers?: Maybe<UserConnection>;
  projectView?: Maybe<ProjectView>;
  projectViews?: Maybe<ProjectViewConnection>;
  /** The public page URL of the project */
  publicPageUrl: Scalars['String']['output'];
  /** Whether to show or hide stage descriptions on the public roadmap */
  publicStageDescriptionsEnabled: Scalars['Boolean']['output'];
  /** Whether the project is published */
  published: Scalars['Boolean']['output'];
  referralSource?: Maybe<Scalars['String']['output']>;
  restricted: Scalars['Boolean']['output'];
  /** The disclaimer text to display on the roadmap page */
  roadmapDisclaimer?: Maybe<Scalars['String']['output']>;
  roadmapDisclaimerEnabled: Scalars['Boolean']['output'];
  roadmapEnabled: Scalars['Boolean']['output'];
  roadmapMoveUpdatesEnabled: Scalars['Boolean']['output'];
  /** The name of the roadmap, will display as the title on the page */
  roadmapName: Scalars['String']['output'];
  roadmapWatchedStages: Array<Scalars['String']['output']>;
  rollup?: Maybe<Rollup>;
  rssFeedEnabled?: Maybe<Scalars['Boolean']['output']>;
  rssFeedPrivate?: Maybe<Scalars['Boolean']['output']>;
  rssFeedUrl: Scalars['String']['output'];
  rssSecretKey?: Maybe<Scalars['String']['output']>;
  /** Whether the project is a sandbox project or not */
  sandbox: Scalars['Boolean']['output'];
  secondaryColor: Scalars['String']['output'];
  secondaryTextColor: Scalars['String']['output'];
  secureConnectionSettings?: Maybe<SecureConnectionSettings>;
  secured: Scalars['Boolean']['output'];
  /** The share image of the project, will be used when sharing the project externally */
  shareImage?: Maybe<Image>;
  /** The alt text of the share image */
  shareImageAltText?: Maybe<Scalars['String']['output']>;
  /** Show table of contents on announcement page */
  showToc: Scalars['Boolean']['output'];
  slackAuthenticationUrl: Scalars['String']['output'];
  /** The slack project subscription for this project, specifically for your User. */
  slackProjectSubscription?: Maybe<ProjectSubscription>;
  /** The slack subscription for this project, specifically for your User. */
  slackSubscription?: Maybe<Subscription>;
  /** The workspaces connected to this project for publishing announcements */
  slackWorkspaces: Array<Workspace>;
  /** The slug of the project, must be URL friendly, and unique. */
  slug: Scalars['String']['output'];
  stages?: Maybe<StageConnection>;
  /** The subheading of the project */
  subheading?: Maybe<Scalars['String']['output']>;
  subscriberReportEnabled: Scalars['Boolean']['output'];
  subscribers?: Maybe<SubscriberConnection>;
  subscriptionByEmail?: Maybe<Subscription>;
  /** @deprecated Use projectSubscriptions instead */
  subscriptions?: Maybe<SubscriptionConnection>;
  supportingPalette?: Maybe<Scalars['String']['output']>;
  templates: TemplateConnection;
  /** URL to use for the terms and conditions link in the subscribe modal and in emails */
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  /** The title of the project */
  title?: Maybe<Scalars['String']['output']>;
  totalConfirmedSubscriptions: Scalars['Int']['output'];
  totalUnsubscribedSubscriptions: Scalars['Int']['output'];
  /** The twitter username of the project */
  twitterUsername?: Maybe<Scalars['String']['output']>;
  /**
   * Given an anonymous user id and a set of categories, return the number of new
   * announcements since the last time trackOpen was called
   */
  unreadCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Array of connection IDs to the Apideck vault */
  vaultConnections: Array<Scalars['String']['output']>;
  /** If true, display the vote count on published ideas */
  voteCountDisplay: Scalars['String']['output'];
  /** If true, allow subscribers to vote on published ideas */
  votingEnabled: Scalars['Boolean']['output'];
  whiteColor: Scalars['String']['output'];
  workItems?: Maybe<WorkItemConnection>;
};


/** A project */
export type ProjectAnnouncementDigestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  digestId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  state?: InputMaybe<AnnouncementDigestStateEnum>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectAnnouncementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  changeTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  state?: InputMaybe<AnnouncementStateEnum>;
  view?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectApiTokenArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** A project */
export type ProjectApiTokensArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  type?: InputMaybe<ApiTokenTypeEnum>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectAttributeDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectAudienceDomainArgs = {
  id: Scalars['ID']['input'];
};


/** A project */
export type ProjectAudienceDomainsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectChangeTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectCohortArgs = {
  id: Scalars['ID']['input'];
};


/** A project */
export type ProjectCohortsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectEventTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventTypeName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectExportSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  feedbackableArchived?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackableIds?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importance?: InputMaybe<Importance>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderAttr?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  organizedState?: InputMaybe<Scalars['String']['input']>;
  reaction?: InputMaybe<Reaction>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  unorganized?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectIdeasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderAttr?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectMarketplaceTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectOutboundWebhooksArgs = {
  webhookIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** A project */
export type ProjectProjectAppsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectProjectSubscriptionArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** A project */
export type ProjectProjectSubscriptionByEmailArgs = {
  email: Scalars['String']['input'];
  transport?: InputMaybe<Owner>;
};


/** A project */
export type ProjectProjectSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  transport?: InputMaybe<TransportTypeEnum>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectProjectUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectProjectViewArgs = {
  id: Scalars['ID']['input'];
};


/** A project */
export type ProjectProjectViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectStagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  status?: InputMaybe<Array<SubscriptionStatus>>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectSubscriptionByEmailArgs = {
  email: Scalars['String']['input'];
  type?: InputMaybe<SubscriptionTypes>;
};


/** A project */
export type ProjectSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  transport?: InputMaybe<TransportTypeEnum>;
  type?: InputMaybe<Owner>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


/** A project */
export type ProjectUnreadCountArgs = {
  anonymousUserId: Scalars['ID']['input'];
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** A project */
export type ProjectWorkItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};

export type ProjectApp = AtlassianApp | HubspotApp | JiraApp | SimpleMailApp | SlackApp | SlackCommandApp | ZapierApp;

/** The connection type for ProjectApp. */
export type ProjectAppConnection = {
  __typename?: 'ProjectAppConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProjectAppEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectApp>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProjectAppEdge = {
  __typename?: 'ProjectAppEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectApp>;
};

/** The connection type for Project. */
export type ProjectConnection = {
  __typename?: 'ProjectConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProjectEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Project>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProjectEdge = {
  __typename?: 'ProjectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Project>;
};

export enum ProjectRoleEnum {
  /** admin */
  Admin = 'admin',
  /** contribute */
  Contribute = 'contribute',
  /** feedback_agent */
  FeedbackAgent = 'feedback_agent',
  /** publisher */
  Publisher = 'publisher'
}

/** A project subscription */
export type ProjectSubscription = Node & {
  __typename?: 'ProjectSubscription';
  announcementPublished: Scalars['Boolean']['output'];
  /** Subscribed categories. An empty array means all categories are subscribed */
  categories: Array<Category>;
  /** The time the subscription was confirmed */
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The time the subscription was deactivated */
  deactivatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  eventTypes: Array<EventType>;
  events?: Maybe<EventConnection>;
  id: Scalars['ID']['output'];
  /** The project this subscription is for */
  project: Project;
  source?: Maybe<Scalars['String']['output']>;
  /** The state of the subscription */
  state: ProjectSubscriptionStateEnum;
  /** The subscriber of the subscription */
  subscriber: Subscriber;
  /** The transport types the subscription is using */
  transportTypes: Array<Scalars['String']['output']>;
  /** The time the subscription was unsubscribed */
  unsubscribedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Subscribed work items */
  workItems: Array<WorkItem>;
};


/** A project subscription */
export type ProjectSubscriptionEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};

/** The connection type for ProjectSubscription. */
export type ProjectSubscriptionConnection = {
  __typename?: 'ProjectSubscriptionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProjectSubscriptionEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectSubscription>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProjectSubscriptionEdge = {
  __typename?: 'ProjectSubscriptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectSubscription>;
};

/** Attributes to find, create, or update a project subscription */
export type ProjectSubscriptionInput = {
  /** Email of the subscriber to update. Project ID must also be provided if using email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** ID of the project subscription to update */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the project that the subscription is for. Used with email to find the project subscription */
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

/** The states of a project subscription */
export enum ProjectSubscriptionStateEnum {
  /** The subscription has been blocked */
  Blocked = 'blocked',
  /** The subscription has been confirmed */
  Confirmed = 'confirmed',
  /** The subscription has not been confirmed */
  Unconfirmed = 'unconfirmed',
  /** The subscription has been unsubscribed */
  Unsubscribed = 'unsubscribed'
}

/** A shareable view for a page. */
export type ProjectView = Node & Permalinks & {
  __typename?: 'ProjectView';
  archived: Scalars['Boolean']['output'];
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  audienceDomains: AudienceDomainConnection;
  categories: Array<Category>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  editable: Scalars['Boolean']['output'];
  heading?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  members: Array<User>;
  name?: Maybe<Scalars['String']['output']>;
  owners: Array<User>;
  privatePermalink: Scalars['String']['output'];
  project: Project;
  publicPermalink: Scalars['String']['output'];
  restricted: Scalars['Boolean']['output'];
  security: ProjectViewSecurityEnum;
  slug: Scalars['String']['output'];
  stages: Array<Stage>;
  subheading?: Maybe<Scalars['String']['output']>;
  subscribers: SubscriberConnection;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** A shareable view for a page. */
export type ProjectViewAudienceDomainsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


/** A shareable view for a page. */
export type ProjectViewSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};

export type ProjectViewAttributes = {
  /** Associated categories of the view */
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The internal description of the view */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The heading of the project view you would like to create */
  heading?: InputMaybe<Scalars['String']['input']>;
  /** The id of the view */
  id: Scalars['ID']['input'];
  /** Associated members of the view */
  memberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The name of the project view you would like to create */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Associated owners of the view */
  ownerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Whether the project view is restricted */
  restricted?: InputMaybe<Scalars['Boolean']['input']>;
  /** The security of the project view */
  security?: InputMaybe<ProjectViewSecurityEnum>;
  /** The slug of the project view you would like to create */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Associated stages of the view */
  stageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The subheading of the project view you would like to create */
  subheading?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for ProjectView. */
export type ProjectViewConnection = {
  __typename?: 'ProjectViewConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProjectViewEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectView>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProjectViewEdge = {
  __typename?: 'ProjectViewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectView>;
};

export enum ProjectViewSecurityEnum {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Unpublished = 'UNPUBLISHED'
}

/** Autogenerated input type of PromoteIdea */
export type PromoteIdeaInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the idea to promote to a roadmap item */
  ideaId: Scalars['ID']['input'];
  /** The project id of the associated idea */
  projectId: Scalars['ID']['input'];
  /** Send notifications about the promotion to all Subscribers that left feedback or voted */
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of PromoteIdea. */
export type PromoteIdeaPayload = {
  __typename?: 'PromoteIdeaPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  workItem?: Maybe<WorkItem>;
};

/** Autogenerated input type of PublishAnnouncement */
export type PublishAnnouncementInput = {
  /** The id of the announcement you would like to publish */
  announcementId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PublishAnnouncement. */
export type PublishAnnouncementPayload = {
  __typename?: 'PublishAnnouncementPayload';
  announcement?: Maybe<Announcement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of PublishDigest */
export type PublishDigestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  digestId: Scalars['ID']['input'];
};

/** Autogenerated return type of PublishDigest. */
export type PublishDigestPayload = {
  __typename?: 'PublishDigestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of PublishWorkItem */
export type PublishWorkItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the work item you would like to publish */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PublishWorkItem. */
export type PublishWorkItemPayload = {
  __typename?: 'PublishWorkItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  workItem?: Maybe<WorkItem>;
};

/** The query root of this schema */
export type Query = {
  __typename?: 'Query';
  /** Analytics schema entrypoint. This schema is inaccessible outside the management application. */
  analytics?: Maybe<AnalyticsQuery>;
  announcement: Announcement;
  announcementDigest: AnnouncementDigest;
  feedback: Feedback;
  idea: Idea;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  /** The project API entry point */
  project: Project;
  projectSearch: Array<SearchResult>;
  /** The session API entry point - this is for internal use only (do not build your integration using this) */
  session: User;
  template: Template;
  /** The published and management API entry point */
  viewer: ApiUser;
  workItem: WorkItem;
};


/** The query root of this schema */
export type QueryAnnouncementArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryAnnouncementDigestArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryFeedbackArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryIdeaArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryProjectSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['ID']['input'];
  searchTerm: Scalars['String']['input'];
};


/** The query root of this schema */
export type QueryTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryWorkItemArgs = {
  id: Scalars['ID']['input'];
};

export enum Reaction {
  Happy = 'happy',
  Meh = 'meh',
  Sad = 'sad'
}

/** Autogenerated input type of RegenerateToken */
export type RegenerateTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  embedAppId: Scalars['ID']['input'];
};

/** Autogenerated return type of RegenerateToken. */
export type RegenerateTokenPayload = {
  __typename?: 'RegenerateTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
};

/** Autogenerated input type of RemoveAllowedDomain */
export type RemoveAllowedDomainInput = {
  allowedDomain: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveAllowedDomain. */
export type RemoveAllowedDomainPayload = {
  __typename?: 'RemoveAllowedDomainPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  secureConnection?: Maybe<SecureConnectionSettings>;
};

/** Autogenerated input type of RemoveAnnouncementWorkItem */
export type RemoveAnnouncementWorkItemInput = {
  announcementId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  workItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveAnnouncementWorkItem. */
export type RemoveAnnouncementWorkItemPayload = {
  __typename?: 'RemoveAnnouncementWorkItemPayload';
  announcement?: Maybe<Announcement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of RemoveApiToken */
export type RemoveApiTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the API Token you wish to remove */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveApiToken. */
export type RemoveApiTokenPayload = {
  __typename?: 'RemoveApiTokenPayload';
  apiToken?: Maybe<ApiToken>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of RemoveAttachment */
export type RemoveAttachmentInput = {
  attachment: AnnouncementAttachment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveAttachment. */
export type RemoveAttachmentPayload = {
  __typename?: 'RemoveAttachmentPayload';
  announcement?: Maybe<Announcement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of RemoveAudienceDomains */
export type RemoveAudienceDomainsInput = {
  audienceDomainIds: Array<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectViewId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveAudienceDomains. */
export type RemoveAudienceDomainsPayload = {
  __typename?: 'RemoveAudienceDomainsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  projectView?: Maybe<ProjectView>;
};

/** Autogenerated input type of RemoveAvatarImage */
export type RemoveAvatarImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveAvatarImage. */
export type RemoveAvatarImagePayload = {
  __typename?: 'RemoveAvatarImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  user?: Maybe<User>;
};

/** Autogenerated input type of RemoveCategory */
export type RemoveCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveCategory. */
export type RemoveCategoryPayload = {
  __typename?: 'RemoveCategoryPayload';
  category?: Maybe<Category>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of RemoveChange */
export type RemoveChangeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveChange. */
export type RemoveChangePayload = {
  __typename?: 'RemoveChangePayload';
  changeType?: Maybe<ChangeType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of RemoveCohortAudienceDomains */
export type RemoveCohortAudienceDomainsInput = {
  audienceDomainIds: Array<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cohortId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveCohortAudienceDomains. */
export type RemoveCohortAudienceDomainsPayload = {
  __typename?: 'RemoveCohortAudienceDomainsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  cohort?: Maybe<Cohort>;
  errors: Array<UserError>;
};

/** Autogenerated input type of RemoveCohortSubscribers */
export type RemoveCohortSubscribersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cohortId: Scalars['ID']['input'];
  subscriberIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of RemoveCohortSubscribers. */
export type RemoveCohortSubscribersPayload = {
  __typename?: 'RemoveCohortSubscribersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  cohort?: Maybe<Cohort>;
  errors: Array<UserError>;
};

/** Autogenerated input type of RemoveConnectedJiraProject */
export type RemoveConnectedJiraProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** name of jira project in settings to delete */
  jiraProjectName?: InputMaybe<Scalars['String']['input']>;
  /** url of project to delete */
  jiraProjectUrl?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  /** pass as true to clear out all projects. */
  unlinkAllProjects?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of RemoveConnectedJiraProject. */
export type RemoveConnectedJiraProjectPayload = {
  __typename?: 'RemoveConnectedJiraProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  jiraAppId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RemoveCrmIntegration */
export type RemoveCrmIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  serviceId: Scalars['ID']['input'];
  unifiedApi: Scalars['String']['input'];
};

/** Autogenerated return type of RemoveCrmIntegration. */
export type RemoveCrmIntegrationPayload = {
  __typename?: 'RemoveCrmIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  serviceId?: Maybe<Scalars['ID']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of RemoveEmailLogo */
export type RemoveEmailLogoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveEmailLogo. */
export type RemoveEmailLogoPayload = {
  __typename?: 'RemoveEmailLogoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Scalars['String']['output'];
  mailAppSetting?: Maybe<MailAppSetting>;
};

/** Autogenerated input type of RemoveEmptyFieldImage */
export type RemoveEmptyFieldImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveEmptyFieldImage. */
export type RemoveEmptyFieldImagePayload = {
  __typename?: 'RemoveEmptyFieldImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  project?: Maybe<Project>;
};

/** Autogenerated input type of RemoveFavicon */
export type RemoveFaviconInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveFavicon. */
export type RemoveFaviconPayload = {
  __typename?: 'RemoveFaviconPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  project?: Maybe<Project>;
};

/** Autogenerated input type of RemoveFromProject */
export type RemoveFromProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  subscriberIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of RemoveFromProject. */
export type RemoveFromProjectPayload = {
  __typename?: 'RemoveFromProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscriberIds: Array<Scalars['ID']['output']>;
};

/** Autogenerated input type of RemoveHeroImage */
export type RemoveHeroImageInput = {
  attachment: WorkItemHeroImage;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveHeroImage. */
export type RemoveHeroImagePayload = {
  __typename?: 'RemoveHeroImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  workItem?: Maybe<WorkItem>;
};

/** Autogenerated input type of RemoveLogo */
export type RemoveLogoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveLogo. */
export type RemoveLogoPayload = {
  __typename?: 'RemoveLogoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  project?: Maybe<Project>;
};

/** Autogenerated input type of RemoveOwner */
export type RemoveOwnerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveOwner. */
export type RemoveOwnerPayload = {
  __typename?: 'RemoveOwnerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  workItem?: Maybe<WorkItem>;
};

/** Autogenerated input type of RemoveProjectSubscription */
export type RemoveProjectSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Input to remove a project subscription */
  projectSubscription: ProjectSubscriptionInput;
};

/** Autogenerated return type of RemoveProjectSubscription. */
export type RemoveProjectSubscriptionPayload = {
  __typename?: 'RemoveProjectSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the removed project subscription */
  projectSubscriptionId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of RemoveProjectUser */
export type RemoveProjectUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveProjectUser. */
export type RemoveProjectUserPayload = {
  __typename?: 'RemoveProjectUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  project?: Maybe<Project>;
};

/** Autogenerated input type of RemoveSecureConnection */
export type RemoveSecureConnectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the project you would like the remove the secure connection from */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveSecureConnection. */
export type RemoveSecureConnectionPayload = {
  __typename?: 'RemoveSecureConnectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of RemoveShareImage */
export type RemoveShareImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveShareImage. */
export type RemoveShareImagePayload = {
  __typename?: 'RemoveShareImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  project?: Maybe<Project>;
};

/** Autogenerated input type of RemoveSource */
export type RemoveSourceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contextId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveSource. */
export type RemoveSourcePayload = {
  __typename?: 'RemoveSourcePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedId?: Maybe<Scalars['ID']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of RemoveSubscribers */
export type RemoveSubscribersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectViewId: Scalars['ID']['input'];
  subscriberIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of RemoveSubscribers. */
export type RemoveSubscribersPayload = {
  __typename?: 'RemoveSubscribersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  projectView?: Maybe<ProjectView>;
};

/** Autogenerated input type of RemoveTemplateAttachment */
export type RemoveTemplateAttachmentInput = {
  attachment: TemplateAttachment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveTemplateAttachment. */
export type RemoveTemplateAttachmentPayload = {
  __typename?: 'RemoveTemplateAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  template?: Maybe<Template>;
};

/** Autogenerated input type of ReorderCategory */
export type ReorderCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of ReorderCategory. */
export type ReorderCategoryPayload = {
  __typename?: 'ReorderCategoryPayload';
  categories?: Maybe<Array<Category>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of ReorderExternalContentLinks */
export type ReorderExternalContentLinksInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderMap: Array<OrderMap>;
  ownerId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReorderExternalContentLinks. */
export type ReorderExternalContentLinksPayload = {
  __typename?: 'ReorderExternalContentLinksPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  stage?: Maybe<Stage>;
};

export type ReorderStageAttributes = {
  /** The ID of the stage you would like to update */
  id: Scalars['ID']['input'];
  /** The position you would like to move the stage to */
  position: Scalars['Int']['input'];
};

/** Autogenerated input type of ReorderStage */
export type ReorderStageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  stage: ReorderStageAttributes;
};

/** Autogenerated return type of ReorderStage. */
export type ReorderStagePayload = {
  __typename?: 'ReorderStagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  stages?: Maybe<Array<Stage>>;
};

export type ReorderWorkItemAttributes = {
  /** The ID of the work item you would like to update */
  id: Scalars['ID']['input'];
  /** The position you would like to move the work item to */
  position?: InputMaybe<Scalars['Int']['input']>;
  sourceStageId?: InputMaybe<Scalars['ID']['input']>;
  targetStageId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of RepositionWorkItem */
export type RepositionWorkItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  workItem: ReorderWorkItemAttributes;
};

/** Autogenerated return type of RepositionWorkItem. */
export type RepositionWorkItemPayload = {
  __typename?: 'RepositionWorkItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  sourceStage?: Maybe<Stage>;
  targetStage?: Maybe<Stage>;
  workItem?: Maybe<WorkItem>;
};

/** Autogenerated input type of ResubscribeProjectSubscription */
export type ResubscribeProjectSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Input to resubscribe a project subscription */
  projectSubscription: ProjectSubscriptionInput;
};

/** Autogenerated return type of ResubscribeProjectSubscription. */
export type ResubscribeProjectSubscriptionPayload = {
  __typename?: 'ResubscribeProjectSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The resubscribed project subscription */
  projectSubscription?: Maybe<ProjectSubscription>;
};

/** Autogenerated input type of ResubscribeToProject */
export type ResubscribeToProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  subscriberIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ResubscribeToProject. */
export type ResubscribeToProjectPayload = {
  __typename?: 'ResubscribeToProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  subscriberIds?: Maybe<Array<Scalars['ID']['output']>>;
};

/** Autogenerated input type of RetryWebhookEvent */
export type RetryWebhookEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The event to retry */
  webhookEventId: Scalars['ID']['input'];
};

/** Autogenerated return type of RetryWebhookEvent. */
export type RetryWebhookEventPayload = {
  __typename?: 'RetryWebhookEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RoadmapUpdate = Node & {
  __typename?: 'RoadmapUpdate';
  /** The author of the update */
  author: User;
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The headline of the  */
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Rollup = Node & {
  __typename?: 'Rollup';
  createdAt: Scalars['ISO8601DateTime']['output'];
  daysOfTheWeek: Array<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  events: Array<Scalars['String']['output']>;
  groupedBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  onlyMemberItems: Scalars['Boolean']['output'];
  project: Project;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

export type Rule = {
  expression: Comparator;
  field: Scalars['String']['input'];
  value: Scalars['RuleValue']['input'];
};

/** Autogenerated input type of ScheduleAnnouncement */
export type ScheduleAnnouncementInput = {
  /** The id of the announcement you would like to schedule.  Announcement must be a draft, or scheduled. */
  announcementId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  scheduledAt: Scalars['String']['input'];
  scheduledAtTimezone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ScheduleAnnouncement. */
export type ScheduleAnnouncementPayload = {
  __typename?: 'ScheduleAnnouncementPayload';
  announcement?: Maybe<Announcement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

export type SearchResult = Announcement | AudienceDomain | Idea | Subscriber | WorkItem;

/** A project's private page settings */
export type SecureConnectionSettings = Node & {
  __typename?: 'SecureConnectionSettings';
  allowedDomains: Array<Scalars['String']['output']>;
  autoRedirect?: Maybe<Array<Scalars['Boolean']['output']>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of SendPromoteTest */
export type SendPromoteTestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the idea to send a promote test for */
  ideaId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendPromoteTest. */
export type SendPromoteTestPayload = {
  __typename?: 'SendPromoteTestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UserError>>;
  /** The result of if the email was queued */
  success: Scalars['Boolean']['output'];
};

/** Attributes for sending a test email */
export type SendRoadmapUpdateTestEmailAttributes = {
  /** The body of the update */
  content: Scalars['String']['input'];
  /** New stage to move the roadmap item to */
  newStageId?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the update */
  title: Scalars['String']['input'];
  workItemId: Scalars['ID']['input'];
};

/** Autogenerated input type of SendRoadmapUpdateTestEmail */
export type SendRoadmapUpdateTestEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roadmapUpdate: SendRoadmapUpdateTestEmailAttributes;
};

/** Autogenerated return type of SendRoadmapUpdateTestEmail. */
export type SendRoadmapUpdateTestEmailPayload = {
  __typename?: 'SendRoadmapUpdateTestEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendTestEmail */
export type SendTestEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Arrray of email to send test email to */
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID of the project */
  projectId: Scalars['ID']['input'];
  /** ID of the template */
  templateId: Scalars['String']['input'];
  /** Name of the template */
  templateName: Scalars['String']['input'];
};

/** Autogenerated return type of SendTestEmail. */
export type SendTestEmailPayload = {
  __typename?: 'SendTestEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of SendWebhookTestEvent */
export type SendWebhookTestEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A JSON formatted string to be sent */
  content: Scalars['String']['input'];
  /** The id of the webhook */
  webhookId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendWebhookTestEvent. */
export type SendWebhookTestEventPayload = {
  __typename?: 'SendWebhookTestEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SetEmailSettings */
export type SetEmailSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The custom reply-to email address in HubSpot */
  customReplyToEmail?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the email template */
  emailTemplateId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the email template */
  emailTemplateName?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  /** The from email address in HubSpot */
  replyToEmail?: InputMaybe<Scalars['String']['input']>;
  /** Whether to send emails via HubSpot */
  sendEmailViaHubspot?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of SetEmailSettings. */
export type SetEmailSettingsPayload = {
  __typename?: 'SetEmailSettingsPayload';
  /** The HubSpot app with updated email settings */
  app?: Maybe<HubspotApp>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Validation errors for the email template */
  validation?: Maybe<HubspotSettingsValidationObject>;
};

/** Autogenerated input type of SetEmailSubscription */
export type SetEmailSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the email subscription list in HubSpot. */
  emailSubscriptionId: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetEmailSubscription. */
export type SetEmailSubscriptionPayload = {
  __typename?: 'SetEmailSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emailSubscriptionId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
};

export type SimpleMailApp = Node & {
  __typename?: 'SimpleMailApp';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  project: Project;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SimpleMailTransport = Node & {
  __typename?: 'SimpleMailTransport';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  subscriber: User;
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SlackApp = Node & {
  __typename?: 'SlackApp';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  project: Project;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SlackAppTransport = Node & {
  __typename?: 'SlackAppTransport';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  project: Project;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SlackCommandApp = Node & {
  __typename?: 'SlackCommandApp';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  project: Project;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum SortEnum {
  /** asc */
  Asc = 'ASC',
  /** desc */
  Desc = 'DESC'
}

export type StackedBarChart = {
  __typename?: 'StackedBarChart';
  type: Scalars['String']['output'];
  x: Scalars['String']['output'];
  y: Scalars['Float']['output'];
};

/** A stage in a roadmap */
export type Stage = Node & {
  __typename?: 'Stage';
  archiveAfterDays?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  project: Project;
  published?: Maybe<Scalars['Boolean']['output']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  restricted: Scalars['Boolean']['output'];
  showOnPublicRoadmap: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  workItems?: Maybe<WorkItemConnection>;
};


/** A stage in a roadmap */
export type StageWorkItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};

/** The connection type for Stage. */
export type StageConnection = {
  __typename?: 'StageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<StageEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Stage>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StageEdge = {
  __typename?: 'StageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Stage>;
};

export type Subscribable = {
  exportSubscribers?: Maybe<SubscriberConnection>;
  id: Scalars['ID']['output'];
  projectSubscription?: Maybe<ProjectSubscription>;
  projectSubscriptionByEmail?: Maybe<ProjectSubscription>;
  projectSubscriptions?: Maybe<ProjectSubscriptionConnection>;
  subscribers?: Maybe<SubscriberConnection>;
  /** @deprecated Use projectSubscriptions instead */
  subscriptions?: Maybe<SubscriptionConnection>;
};


export type SubscribableExportSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type SubscribableProjectSubscriptionArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscribableProjectSubscriptionByEmailArgs = {
  email: Scalars['String']['input'];
  transport?: InputMaybe<Owner>;
};


export type SubscribableProjectSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  transport?: InputMaybe<TransportTypeEnum>;
  where?: InputMaybe<Where>;
};


export type SubscribableSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  status?: InputMaybe<Array<SubscriptionStatus>>;
  where?: InputMaybe<Where>;
};


export type SubscribableSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  transport?: InputMaybe<TransportTypeEnum>;
  type?: InputMaybe<Owner>;
  where?: InputMaybe<Where>;
};

/** Autogenerated input type of SubscribeProjectSubscriptionCategory */
export type SubscribeProjectSubscriptionCategoryInput = {
  /** ID of the category to subscribe to */
  categoryId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Input to subscribe a project subscription */
  projectSubscription: ProjectSubscriptionInput;
};

/** Autogenerated return type of SubscribeProjectSubscriptionCategory. */
export type SubscribeProjectSubscriptionCategoryPayload = {
  __typename?: 'SubscribeProjectSubscriptionCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The subscribed project subscription */
  projectSubscription?: Maybe<ProjectSubscription>;
};

/** Autogenerated input type of SubscribeProjectSubscriptionWorkItem */
export type SubscribeProjectSubscriptionWorkItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Input to subscribe to a work item */
  projectSubscription: ProjectSubscriptionInput;
  /** ID of the work item to subscribe to */
  workItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of SubscribeProjectSubscriptionWorkItem. */
export type SubscribeProjectSubscriptionWorkItemPayload = {
  __typename?: 'SubscribeProjectSubscriptionWorkItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated project subscription */
  projectSubscription?: Maybe<ProjectSubscription>;
};

export type Subscriber = Node & {
  __typename?: 'Subscriber';
  /** Hex color code for the avatar background color */
  avatarColor: Scalars['String']['output'];
  /** The date and time the subscriber confirmed their subscription */
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  events: EventConnection;
  /** Number of feedbacks submitted by the subscriber */
  feedbackCount: Scalars['Int']['output'];
  /** Feedback submitted by the subscriber */
  feedbacks: FeedbackConnection;
  id: Scalars['ID']['output'];
  /** Idea votes submitted by the subscriber */
  ideaVotes: IdeaVoteConnection;
  /** Uppercased, first character of the email */
  initials: Scalars['String']['output'];
  isProjectSubscriber: Scalars['Boolean']['output'];
  /** Notifications sent to the subscriber */
  notifications: NotificationConnection;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Number of votes submitted by the subscriber */
  voteCount: Scalars['Int']['output'];
  /** Work items subscribed to by the subscriber */
  workItems: WorkItemConnection;
};


export type SubscriberEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type SubscriberFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type SubscriberIdeaVotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type SubscriberNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type SubscriberWorkItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};

export type SubscriberAnalytics = {
  __typename?: 'SubscriberAnalytics';
  /** Table data of subscriber counts by category */
  recentlySubscribedDomains: Array<Dataseries>;
  /** Table data of subscriber counts by category */
  subscribersByCategory: Array<Dataseries>;
};


export type SubscriberAnalyticsRecentlySubscribedDomainsArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};


export type SubscriberAnalyticsSubscribersByCategoryArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};

export type SubscriberAttributes = {
  /** the email address you would like to subscriber */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the subscribing user */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** what type of subscriber. eg. USER */
  type: SubscriberTypes;
};

/** The connection type for Subscriber. */
export type SubscriberConnection = {
  __typename?: 'SubscriberConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SubscriberEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Subscriber>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubscriberEdge = {
  __typename?: 'SubscriberEdge';
  audienceDomainHostname: Scalars['String']['output'];
  audienceDomainId: Scalars['ID']['output'];
  /** Hex color code for the avatar background color */
  avatarColor: Scalars['String']['output'];
  categories: Array<Category>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  emailTransports: Array<SimpleMailTransport>;
  hasMailTransport: Scalars['Boolean']['output'];
  hasSlackTransport: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The item at the end of the edge. */
  node: Subscriber;
  slackTransports: Array<SlackAppTransport>;
  status: SubscriptionStatus;
};

export enum SubscriberTypes {
  /** a subscriber */
  Subscriber = 'SUBSCRIBER',
  /** a user */
  User = 'USER'
}

/** A subscription */
export type Subscription = Node & {
  __typename?: 'Subscription';
  /** Whether the user is subscribed to announcement.published notifications. */
  announcementPublished: Scalars['Boolean']['output'];
  /** The categories the user is subscribed to. */
  categories: Array<Category>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  eventTypes: Array<EventType>;
  /** Whether the user is subscribed to feedback.submitted notifications. */
  feedbackSubmitted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The owner of the subscription, can be a User or Subscriber. */
  owner: SubscriptionOwner;
  /** The project the user is subscribed to. */
  subscribedObject: Project;
  /** The transport used to send notifications to the subscriber, can be slack or email */
  transport: SubscriptionTransport;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Subscription. */
export type SubscriptionConnection = {
  __typename?: 'SubscriptionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SubscriptionEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Subscription>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubscriptionEdge = {
  __typename?: 'SubscriptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Subscription>;
};

export type SubscriptionOwner = Subscriber | User;

export enum SubscriptionStatus {
  Blocked = 'blocked',
  Confirmed = 'confirmed',
  Unconfirmed = 'unconfirmed',
  Unsubscribed = 'unsubscribed'
}

export type SubscriptionTransport = SimpleMailTransport | SlackAppTransport;

export enum SubscriptionTypes {
  /** simple mail app */
  SimpleMailApp = 'SimpleMailApp',
  /** slack app */
  SlackApp = 'SlackApp'
}

/** Autogenerated input type of SyncCrmCompanies */
export type SyncCrmCompaniesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of SyncCrmCompanies. */
export type SyncCrmCompaniesPayload = {
  __typename?: 'SyncCrmCompaniesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  projectId?: Maybe<Scalars['ID']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

/** An announcement template */
export type Template = Node & {
  __typename?: 'Template';
  categories: Array<Category>;
  content?: Maybe<Scalars['String']['output']>;
  /** The HTML representation of the content. */
  contentHtml?: Maybe<Scalars['String']['output']>;
  /** The plain text representation of the content. */
  contentPlainText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Defines the type of schema the content follows, draftjs to be deprecated. */
  contentType: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  excerpt?: Maybe<Scalars['String']['output']>;
  excerptWithFallback?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  heroImage?: Maybe<Image>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  project: Project;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  workItems?: Maybe<WorkItemConnection>;
};


/** An announcement template */
export type TemplateWorkItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};

export enum TemplateAttachment {
  /** heroImage */
  HeroImage = 'hero_image',
  /** shareImage */
  ShareImage = 'share_image',
  /** videoAsset */
  VideoAsset = 'video_asset'
}

/** The connection type for Template. */
export type TemplateConnection = {
  __typename?: 'TemplateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TemplateEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Template>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TemplateEdge = {
  __typename?: 'TemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Template>;
};

export type TimeseriesData = {
  __typename?: 'TimeseriesData';
  x: Scalars['String']['output'];
  y?: Maybe<Scalars['Float']['output']>;
};

/** Autogenerated input type of ToggleEnforceEmbedToken */
export type ToggleEnforceEmbedTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  embedId: Scalars['ID']['input'];
  enforceToken: Scalars['Boolean']['input'];
};

/** Autogenerated return type of ToggleEnforceEmbedToken. */
export type ToggleEnforceEmbedTokenPayload = {
  __typename?: 'ToggleEnforceEmbedTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ToggleEvent */
export type ToggleEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the event type you would like to add or remove from the Subscription */
  eventTypeName: Scalars['String']['input'];
  /** Owing user ID */
  ownerId: Scalars['ID']['input'];
  /** Owning project ID */
  projectId: Scalars['ID']['input'];
  /** Transport type of the subscription (SimpleMailTransport or SlackAppTransport) */
  transport: Scalars['String']['input'];
};

/** Autogenerated return type of ToggleEvent. */
export type ToggleEventPayload = {
  __typename?: 'ToggleEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  subscription?: Maybe<Subscription>;
};

/** Autogenerated input type of ToggleOutboundWebhookEnabled */
export type ToggleOutboundWebhookEnabledInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the webhook should be enabled */
  enabled: Scalars['Boolean']['input'];
  /** The ID of the webhook to enable */
  outboundWebhookId: Scalars['ID']['input'];
};

/** Autogenerated return type of ToggleOutboundWebhookEnabled. */
export type ToggleOutboundWebhookEnabledPayload = {
  __typename?: 'ToggleOutboundWebhookEnabledPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of TogglePublicStageDescriptions */
export type TogglePublicStageDescriptionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether public stage descriptions should be enabled */
  enabled: Scalars['Boolean']['input'];
  /** The id of the project to enable this for */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of TogglePublicStageDescriptions. */
export type TogglePublicStageDescriptionsPayload = {
  __typename?: 'TogglePublicStageDescriptionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of TogglePublishedIdea */
export type TogglePublishedIdeaInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the idea you would like to update */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of TogglePublishedIdea. */
export type TogglePublishedIdeaPayload = {
  __typename?: 'TogglePublishedIdeaPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  idea?: Maybe<Idea>;
};

/** Autogenerated input type of ToggleRollup */
export type ToggleRollupInput = {
  active: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the project to activate or deactivate */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of ToggleRollup. */
export type ToggleRollupPayload = {
  __typename?: 'ToggleRollupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  rollup?: Maybe<Rollup>;
};

/** Autogenerated input type of ToggleSendToAll */
export type ToggleSendToAllInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  digestId: Scalars['ID']['input'];
  sendToAll: Scalars['Boolean']['input'];
};

/** Autogenerated return type of ToggleSendToAll. */
export type ToggleSendToAllPayload = {
  __typename?: 'ToggleSendToAllPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ToggleSubscriberReport */
export type ToggleSubscriberReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  subscribed: Scalars['Boolean']['input'];
};

/** Autogenerated return type of ToggleSubscriberReport. */
export type ToggleSubscriberReportPayload = {
  __typename?: 'ToggleSubscriberReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of TrackViewedAnnouncements */
export type TrackViewedAnnouncementsInput = {
  anonymousUserId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of TrackViewedAnnouncements. */
export type TrackViewedAnnouncementsPayload = {
  __typename?: 'TrackViewedAnnouncementsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  ok: Scalars['Boolean']['output'];
};

export enum TransportEnum {
  /** Simple Mail */
  SimpleMailTransport = 'SimpleMailTransport',
  /** Slack */
  SlackAppTransport = 'SlackAppTransport'
}

export enum TransportTypeEnum {
  Email = 'Email',
  Slack = 'Slack'
}

export type TrendingFeedbackable = {
  __typename?: 'TrendingFeedbackable';
  count: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Autogenerated input type of TriggerTestEmail */
export type TriggerTestEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of TriggerTestEmail. */
export type TriggerTestEmailPayload = {
  __typename?: 'TriggerTestEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Scalars['String']['output'];
};

/** Autogenerated input type of UnarchiveAnnouncement */
export type UnarchiveAnnouncementInput = {
  /** The id of the announcement you would like to unarchive */
  announcementId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UnarchiveAnnouncement. */
export type UnarchiveAnnouncementPayload = {
  __typename?: 'UnarchiveAnnouncementPayload';
  announcement?: Maybe<Announcement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of UnarchiveFeedback */
export type UnarchiveFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UnarchiveFeedback. */
export type UnarchiveFeedbackPayload = {
  __typename?: 'UnarchiveFeedbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  feedback?: Maybe<Feedback>;
};

/** Autogenerated input type of UnarchiveFeedbacks */
export type UnarchiveFeedbacksInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  feedbackIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of UnarchiveFeedbacks. */
export type UnarchiveFeedbacksPayload = {
  __typename?: 'UnarchiveFeedbacksPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  feedbacks: Array<Feedback>;
};

/** Autogenerated input type of UnarchiveIdeas */
export type UnarchiveIdeasInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ideaIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of UnarchiveIdeas. */
export type UnarchiveIdeasPayload = {
  __typename?: 'UnarchiveIdeasPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  ideas: Array<Idea>;
};

/** Autogenerated input type of UnarchiveWorkItem */
export type UnarchiveWorkItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the work item you would like to unarchive */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UnarchiveWorkItem. */
export type UnarchiveWorkItemPayload = {
  __typename?: 'UnarchiveWorkItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  workItem?: Maybe<WorkItem>;
};

/** Autogenerated input type of UnpublishAnnouncement */
export type UnpublishAnnouncementInput = {
  /** The id of the announcement you would like to unpublish. Must be published. */
  announcementId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UnpublishAnnouncement. */
export type UnpublishAnnouncementPayload = {
  __typename?: 'UnpublishAnnouncementPayload';
  announcement?: Maybe<Announcement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of UnpublishWorkItem */
export type UnpublishWorkItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the work item you would like to unpublish */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UnpublishWorkItem. */
export type UnpublishWorkItemPayload = {
  __typename?: 'UnpublishWorkItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  workItem?: Maybe<WorkItem>;
};

/** Autogenerated input type of UnscheduleAnnouncement */
export type UnscheduleAnnouncementInput = {
  /** The id of the announcement you would like to unschedule. Announcement must be scheduled. */
  announcementId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UnscheduleAnnouncement. */
export type UnscheduleAnnouncementPayload = {
  __typename?: 'UnscheduleAnnouncementPayload';
  announcement?: Maybe<Announcement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of UnsubscribeAll */
export type UnsubscribeAllInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  /** The type of subscription you would like to remove, can be either 'email' or 'slack'. */
  subscriptionType: Scalars['String']['input'];
};

/** Autogenerated return type of UnsubscribeAll. */
export type UnsubscribeAllPayload = {
  __typename?: 'UnsubscribeAllPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  projectId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of UnsubscribeFromProject */
export type UnsubscribeFromProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  subscriberIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of UnsubscribeFromProject. */
export type UnsubscribeFromProjectPayload = {
  __typename?: 'UnsubscribeFromProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  subscriberIds?: Maybe<Array<Scalars['ID']['output']>>;
};

/** Autogenerated input type of UnsubscribeProjectSubscriptionAll */
export type UnsubscribeProjectSubscriptionAllInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Input to unsubscribe a project subscription */
  projectSubscription: ProjectSubscriptionInput;
};

/** Autogenerated return type of UnsubscribeProjectSubscriptionAll. */
export type UnsubscribeProjectSubscriptionAllPayload = {
  __typename?: 'UnsubscribeProjectSubscriptionAllPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The unsubscribed project subscription */
  projectSubscription?: Maybe<ProjectSubscription>;
};

/** Autogenerated input type of UnsubscribeProjectSubscriptionCategory */
export type UnsubscribeProjectSubscriptionCategoryInput = {
  /** ID of the category to unsubscribe from */
  categoryId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Input to unsubscribe a project subscription */
  projectSubscription: ProjectSubscriptionInput;
};

/** Autogenerated return type of UnsubscribeProjectSubscriptionCategory. */
export type UnsubscribeProjectSubscriptionCategoryPayload = {
  __typename?: 'UnsubscribeProjectSubscriptionCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The unsubscribed project subscription */
  projectSubscription?: Maybe<ProjectSubscription>;
};

/** Autogenerated input type of UnsubscribeProjectSubscription */
export type UnsubscribeProjectSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Input to unsubscribe a project subscription */
  projectSubscription: ProjectSubscriptionInput;
};

/** Autogenerated return type of UnsubscribeProjectSubscription. */
export type UnsubscribeProjectSubscriptionPayload = {
  __typename?: 'UnsubscribeProjectSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The unsubscribed project subscription */
  projectSubscription?: Maybe<ProjectSubscription>;
};

/** Autogenerated input type of UnsubscribeProjectSubscriptionWorkItem */
export type UnsubscribeProjectSubscriptionWorkItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Input to subscribe to a work item */
  projectSubscription: ProjectSubscriptionInput;
  /** ID of the work item to subscribe to */
  workItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnsubscribeProjectSubscriptionWorkItem. */
export type UnsubscribeProjectSubscriptionWorkItemPayload = {
  __typename?: 'UnsubscribeProjectSubscriptionWorkItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The unsubscribed project subscription */
  projectSubscription?: Maybe<ProjectSubscription>;
};

/** Attributes for updating a announcement */
export type UpdateAnnouncementAttributes = {
  author?: InputMaybe<Scalars['String']['input']>;
  /** Associated categories of the announcement */
  categories?: InputMaybe<Array<CategoryAttributes>>;
  /** Associated change types of the announcement. Change types are called Labels in the management portal */
  changeTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  confluenceSpaceId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  doNotIndex?: InputMaybe<Scalars['Boolean']['input']>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  heroImage?: InputMaybe<Scalars['String']['input']>;
  /** The id of the announcement you would like to update */
  id: Scalars['ID']['input'];
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  notificationsExcerptOnly?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['String']['input']>;
  shareImage?: InputMaybe<Scalars['String']['input']>;
  shouldNotifyPageSubscribers?: InputMaybe<Scalars['Boolean']['input']>;
  slackMessage?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subjectLine?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** Associated video asset of the announcement */
  videoAsset?: InputMaybe<VideoAssetAttributes>;
  /** Associated work items of the announcement */
  workItems?: InputMaybe<Array<WorkItemAttributes>>;
};

/** Autogenerated input type of UpdateAnnouncement */
export type UpdateAnnouncementInput = {
  announcement: UpdateAnnouncementAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateAnnouncement. */
export type UpdateAnnouncementPayload = {
  __typename?: 'UpdateAnnouncementPayload';
  announcement?: Maybe<Announcement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of UpdateAttribute */
export type UpdateAttributeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['AttributeValue']['input']>;
};

/** Autogenerated return type of UpdateAttribute. */
export type UpdateAttributePayload = {
  __typename?: 'UpdateAttributePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  node?: Maybe<HasAttributes>;
};

/** Autogenerated input type of UpdateCategory */
export type UpdateCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateCategory. */
export type UpdateCategoryPayload = {
  __typename?: 'UpdateCategoryPayload';
  category?: Maybe<Category>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of UpdateChange */
export type UpdateChangeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateChange. */
export type UpdateChangePayload = {
  __typename?: 'UpdateChangePayload';
  changeType?: Maybe<ChangeType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
};

/** Autogenerated input type of UpdateCohort */
export type UpdateCohortInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cohort: CohortAttributes;
};

/** Autogenerated return type of UpdateCohort. */
export type UpdateCohortPayload = {
  __typename?: 'UpdateCohortPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  cohort?: Maybe<Cohort>;
  errors: Array<UserError>;
};

/** Autogenerated input type of UpdateDigest */
export type UpdateDigestInput = {
  announcements?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  digestId: Scalars['ID']['input'];
  order?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjectLine?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateDigest. */
export type UpdateDigestPayload = {
  __typename?: 'UpdateDigestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateEmbedApp */
export type UpdateEmbedAppInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  embedAppId: Scalars['ID']['input'];
  subtitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateEmbedApp. */
export type UpdateEmbedAppPayload = {
  __typename?: 'UpdateEmbedAppPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateExternalContentLink */
export type UpdateExternalContentLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalContentLink: UpdateLinkAttributes;
};

/** Autogenerated return type of UpdateExternalContentLink. */
export type UpdateExternalContentLinkPayload = {
  __typename?: 'UpdateExternalContentLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  stage?: Maybe<Stage>;
};

export type UpdateFeedbackAttributes = {
  affectedCustomerEmail?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  feedbackableId?: InputMaybe<Scalars['ID']['input']>;
  feedbackableType?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the feedback you would like to update */
  id: Scalars['ID']['input'];
  importance?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reaction?: InputMaybe<Scalars['String']['input']>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of UpdateFeedback */
export type UpdateFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  feedback: UpdateFeedbackAttributes;
};

/** Autogenerated return type of UpdateFeedback. */
export type UpdateFeedbackPayload = {
  __typename?: 'UpdateFeedbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  feedback?: Maybe<Feedback>;
};

/** Autogenerated input type of UpdateIdea */
export type UpdateIdeaInput = {
  /** Associated categories of the idea */
  categories?: InputMaybe<Array<CategoryAttributes>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the idea you would like to update */
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Publishing and Unpublishing of ideas now live in the togglePublishIdea mutation */
  published?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateIdea. */
export type UpdateIdeaPayload = {
  __typename?: 'UpdateIdeaPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  idea?: Maybe<Idea>;
};

/** Autogenerated input type of Update */
export type UpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  siteId: Scalars['String']['input'];
};

/** Attributes for creating a stage */
export type UpdateLinkAttributes = {
  /** The ID of the link you want to update. */
  id: Scalars['ID']['input'];
  /** The display name of the link. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Destination URL of the link. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes for updating a MailAppSetting */
export type UpdateMailAppSettingsAttributes = {
  /** Email Service Provider that will be delivering your notifications. Currently supported: Mailgun, Postmark, Sendgrid, SMTP */
  activeEsp?: InputMaybe<Scalars['String']['input']>;
  /** CTA Button text for announcement published emails */
  announcementButtonCta?: InputMaybe<Scalars['String']['input']>;
  /** API Key for your ESP */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  /** Hex color for body background color */
  bodyBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** When set to true, associated categories will be included in emails */
  categoriesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hex color for content text */
  containerBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Hex color for digest background */
  digestBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Hex color for digest text */
  digestTextColor?: InputMaybe<Scalars['String']['input']>;
  /** Domain for your ESP */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** When set to true, the EU domain will be used for email notifications */
  euDomain?: InputMaybe<Scalars['Boolean']['input']>;
  /** Comma seperated list of font families to be inserted into emails. */
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  /** Hex color for heading text */
  headingColor?: InputMaybe<Scalars['String']['input']>;
  /** The id of the settings object you would like to update */
  id: Scalars['ID']['input'];
  /** The logo that will be used in your email templates */
  logo?: InputMaybe<Scalars['String']['input']>;
  /** Height of the logo images in pixels */
  logoHeight?: InputMaybe<Scalars['String']['input']>;
  /** When set to true, only include the announcement excerpt in the notification email */
  notificationsExcerptOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** The accent color that will be used in your email templates */
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  /** Email address on email notifications */
  replyToEmail?: InputMaybe<Scalars['String']['input']>;
  /** Sender name on email notifications */
  senderName?: InputMaybe<Scalars['String']['input']>;
  /** SMTP Host for email notifications */
  smtpHost?: InputMaybe<Scalars['String']['input']>;
  /** SMTP Password for email notifications */
  smtpPassword?: InputMaybe<Scalars['String']['input']>;
  /** SMTP Port for email notifications */
  smtpPort?: InputMaybe<Scalars['String']['input']>;
  /** SMTP sent securely */
  smtpSecure?: InputMaybe<Scalars['Boolean']['input']>;
  /** SMTP Username for email notifications */
  smtpUser?: InputMaybe<Scalars['String']['input']>;
  /** CTA Button text for subscriber confirmation emails */
  subscriberConfirmButtonCta?: InputMaybe<Scalars['String']['input']>;
  /** Hex color for superscript text */
  superscriptColor?: InputMaybe<Scalars['String']['input']>;
  /** Hex color for body text */
  textColor?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateMailAppSettings */
export type UpdateMailAppSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  mailAppSetting: UpdateMailAppSettingsAttributes;
};

/** Autogenerated return type of UpdateMailAppSettings. */
export type UpdateMailAppSettingsPayload = {
  __typename?: 'UpdateMailAppSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  mailAppSetting?: Maybe<MailAppSetting>;
};

export type UpdateOnboardingTasksAttributes = {
  addAnnouncement?: InputMaybe<Scalars['Boolean']['input']>;
  addSubscriber?: InputMaybe<Scalars['Boolean']['input']>;
  addUser?: InputMaybe<Scalars['Boolean']['input']>;
  addWorkItem?: InputMaybe<Scalars['Boolean']['input']>;
  claimSubdomain?: InputMaybe<Scalars['Boolean']['input']>;
  customizeCategories?: InputMaybe<Scalars['Boolean']['input']>;
  customizeColors?: InputMaybe<Scalars['Boolean']['input']>;
  customizeEmail?: InputMaybe<Scalars['Boolean']['input']>;
  customizeHtmlCss?: InputMaybe<Scalars['Boolean']['input']>;
  customizeRoadmapStages?: InputMaybe<Scalars['Boolean']['input']>;
  enableRoadmap?: InputMaybe<Scalars['Boolean']['input']>;
  uploadLogo?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of UpdateOnboardingTasks */
export type UpdateOnboardingTasksInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  onboardingTasks: UpdateOnboardingTasksAttributes;
  /** The ID of the project you would like to update */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateOnboardingTasks. */
export type UpdateOnboardingTasksPayload = {
  __typename?: 'UpdateOnboardingTasksPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  onboardingTasks: OnboardingTasks;
};

/** Autogenerated input type of UpdateOutboundWebhook */
export type UpdateOutboundWebhookInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether to enable the webhook */
  enabled: Scalars['Boolean']['input'];
  /** The list of event types that the webhook should react to */
  eventTypes: Array<Scalars['ID']['input']>;
  /** What you wish to call this webhook */
  name: Scalars['String']['input'];
  /** Authorization password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** The URL the webhook should events to */
  url: Scalars['String']['input'];
  /** Authorization username */
  username?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the object that should own the webhook */
  webhookId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateOutboundWebhook. */
export type UpdateOutboundWebhookPayload = {
  __typename?: 'UpdateOutboundWebhookPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of Update. */
export type UpdatePayload = {
  __typename?: 'UpdatePayload';
  appId: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Attributes for updating a project */
export type UpdateProjectAttributes = {
  allowedDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  announcementsName?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  autosubscribeNewUsers?: InputMaybe<Scalars['Boolean']['input']>;
  colorTheme?: InputMaybe<Scalars['String']['input']>;
  /** Stage ids to include in crm revenue data */
  crmStageFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  customCss?: InputMaybe<Scalars['String']['input']>;
  customFooter?: InputMaybe<Scalars['String']['input']>;
  customHead?: InputMaybe<Scalars['String']['input']>;
  customHeader?: InputMaybe<Scalars['String']['input']>;
  customIndexHero?: InputMaybe<Scalars['String']['input']>;
  defaultNotificationSetting?: InputMaybe<Scalars['Boolean']['input']>;
  defaultWorkItemsDisplayTimeline?: InputMaybe<Scalars['Boolean']['input']>;
  density?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emptyFieldImage?: InputMaybe<Scalars['String']['input']>;
  favicon?: InputMaybe<Scalars['String']['input']>;
  feedbackEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackForwardEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  fiscalYearOffset?: InputMaybe<Scalars['Int']['input']>;
  grayColor?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  hideNotificationContent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the project you would like to update */
  id: Scalars['ID']['input'];
  ideasDisclaimer?: InputMaybe<Scalars['String']['input']>;
  ideasDisclaimerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ideasEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ideasName?: InputMaybe<Scalars['String']['input']>;
  lightGrayColor?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noindex?: InputMaybe<Scalars['Boolean']['input']>;
  offWhiteColor?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  primaryTextColor?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  restricted?: InputMaybe<Scalars['Boolean']['input']>;
  roadmapDisclaimer?: InputMaybe<Scalars['String']['input']>;
  roadmapDisclaimerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  roadmapEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  roadmapMoveUpdatesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  roadmapName?: InputMaybe<Scalars['String']['input']>;
  roadmapWatchedStages?: InputMaybe<Array<Scalars['String']['input']>>;
  rssFeedEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  rssFeedPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryTextColor?: InputMaybe<Scalars['String']['input']>;
  shareImage?: InputMaybe<Scalars['String']['input']>;
  shareImageAltText?: InputMaybe<Scalars['String']['input']>;
  showToc?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  stageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  subheading?: InputMaybe<Scalars['String']['input']>;
  supportingPalette?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitterUsername?: InputMaybe<Scalars['String']['input']>;
  voteCountDisplay?: InputMaybe<Scalars['String']['input']>;
  votingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  whiteColor?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateProject */
export type UpdateProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  project: UpdateProjectAttributes;
};

/** Autogenerated return type of UpdateProject. */
export type UpdateProjectPayload = {
  __typename?: 'UpdateProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  project?: Maybe<Project>;
};

/** Autogenerated input type of UpdateProjectUserRole */
export type UpdateProjectUserRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The project id that the role belongs to. */
  projectId: Scalars['ID']['input'];
  /** The new role for the user. */
  role: ProjectRoleEnum;
  /** The user's id to update. */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateProjectUserRole. */
export type UpdateProjectUserRolePayload = {
  __typename?: 'UpdateProjectUserRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  projectUser?: Maybe<User>;
};

/** Autogenerated input type of UpdateProjectView */
export type UpdateProjectViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectView: ProjectViewAttributes;
};

/** Autogenerated return type of UpdateProjectView. */
export type UpdateProjectViewPayload = {
  __typename?: 'UpdateProjectViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  projectView?: Maybe<ProjectView>;
};

/** Autogenerated input type of UpdateSecureConnection */
export type UpdateSecureConnectionInput = {
  allowedDomain: Scalars['String']['input'];
  autoRedirect?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateSecureConnection. */
export type UpdateSecureConnectionPayload = {
  __typename?: 'UpdateSecureConnectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  secureConnection?: Maybe<SecureConnectionSettings>;
};

/** Autogenerated input type of UpdateSource */
export type UpdateSourceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** work item to connect source to */
  workItemId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateSource. */
export type UpdateSourcePayload = {
  __typename?: 'UpdateSourcePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  connectedSources: ConnectedSource;
  errors: Array<UserError>;
};

export type UpdateStageAttributes = {
  archiveAfterDays?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the stage you would like to update */
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of UpdateStage */
export type UpdateStageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  stage: UpdateStageAttributes;
};

/** Autogenerated return type of UpdateStage. */
export type UpdateStagePayload = {
  __typename?: 'UpdateStagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  stage?: Maybe<Stage>;
};

export type UpdateTemplateAttributes = {
  categories?: InputMaybe<Array<CategoryAttributes>>;
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  heroImage?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  workItems?: InputMaybe<Array<WorkItemAttributes>>;
};

/** Autogenerated input type of UpdateTemplate */
export type UpdateTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  template: UpdateTemplateAttributes;
};

/** Autogenerated return type of UpdateTemplate. */
export type UpdateTemplatePayload = {
  __typename?: 'UpdateTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  template?: Maybe<Template>;
};

/** Attributes for updating a user */
export type UpdateUserAttributes = {
  avatarImage?: InputMaybe<Scalars['String']['input']>;
  /** The id of the project you would like to load automatically */
  defaultProjectId?: InputMaybe<Scalars['ID']['input']>;
  /** First name of the user */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The id of the announcement you would like to update */
  id: Scalars['ID']['input'];
  /** Last name of the user */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use firstName and lastName instead */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  user: UpdateUserAttributes;
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  user?: Maybe<User>;
};

export type UpdateWorkItemAttributes = {
  /** Associated categories of the announcement */
  categories?: InputMaybe<Array<CategoryAttributes>>;
  /** Associated change types of the work item. Change types are called Labels in the management portal */
  changeTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** HTML Content to be converted */
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  /** Jira Wiki Syntax */
  contentJira?: InputMaybe<Scalars['String']['input']>;
  /** Markdown content to be converted */
  contentMarkdown?: InputMaybe<Scalars['String']['input']>;
  /** Publicly display timeline for the work item */
  displayTimeline?: InputMaybe<Scalars['Boolean']['input']>;
  heroImage?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the work_item you would like to update */
  id: Scalars['ID']['input'];
  /** The IDs of the users who are members of the work item */
  memberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user who owns the work item */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** Projected at timestamp; pass in null to unset the date */
  projectedAt?: InputMaybe<Scalars['String']['input']>;
  projectedAtFormat?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateWorkItem */
export type UpdateWorkItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  workItem: UpdateWorkItemAttributes;
};

/** Autogenerated return type of UpdateWorkItem. */
export type UpdateWorkItemPayload = {
  __typename?: 'UpdateWorkItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  workItem?: Maybe<WorkItem>;
};

/** Autogenerated input type of UpsertRollup */
export type UpsertRollupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  daysOfTheWeek: Array<Scalars['String']['input']>;
  events: Array<Scalars['String']['input']>;
  groupedBy: Scalars['String']['input'];
  onlyMemberItems: Scalars['Boolean']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  rollupId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpsertRollup. */
export type UpsertRollupPayload = {
  __typename?: 'UpsertRollupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  rollup?: Maybe<Rollup>;
};

export type User = ApiConsumer & Node & {
  __typename?: 'User';
  /** Connected Atlassian account for the project */
  atlassianAccount?: Maybe<AtlassianApp>;
  /** Get the user's avatar color */
  avatarColor: Scalars['String']['output'];
  /** Get the user's avatar image */
  avatarImage?: Maybe<Image>;
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Get the users default project */
  defaultProject?: Maybe<Project>;
  /** Get the user's display name; becomes email if first and last name is not set */
  displayName: Scalars['String']['output'];
  /** The user's email address */
  email: Scalars['String']['output'];
  /** Get the user's first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `permissions` field instead */
  greatestPermission: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Get the user's initials; becomes first letter of email if first name is not set */
  initials: Scalars['String']['output'];
  /** Get the user's last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The user's full name (first and last) */
  name?: Maybe<Scalars['String']['output']>;
  /** Get user's organization by ID */
  organization?: Maybe<Organization>;
  /** Get listing of organizations the user is associated to, (by ID) */
  organizations: Array<Organization>;
  /** Get a list of the user's roles */
  permissions: Array<Scalars['String']['output']>;
  /** Retrieve a project by ID */
  project: Project;
  projects: ProjectConnection;
  /** The user's referral source, collected during onboarding. */
  referralSource: UserReferralSourceEnum;
  /**
   * The user's role, defined on signup. This could be one of the following:
   * customerSuccess, customerSupport, engineering, executive, marketing, product, or all
   */
  role: UserRoleEnum;
  status: Scalars['String']['output'];
  /** Get listing of user's subscription types to an organization */
  subscriptions: Array<Subscription>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type UserAtlassianAccountArgs = {
  projectId: Scalars['ID']['input'];
};


export type UserGreatestPermissionArgs = {
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type UserOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type UserPermissionsArgs = {
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type UserProjectArgs = {
  id: Scalars['ID']['input'];
};


export type UserProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type UserSubscriptionsArgs = {
  subscribedObjectIds: Array<Scalars['ID']['input']>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UserEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

/** A user-readable error */
export type UserError = {
  __typename?: 'UserError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export enum UserReferralSourceEnum {
  /** A blog or publication */
  BlogPublication = 'blog_publication',
  /** Other */
  Other = 'other',
  /** Powered By link */
  PoweredBy = 'powered_by',
  /** Recommended by a friend or community */
  Recommendation = 'recommendation',
  /** Search engine */
  SearchEngine = 'search_engine'
}

export enum UserRoleEnum {
  /** All of the above */
  All = 'all',
  /** Customer success */
  CustomerSuccess = 'customerSuccess',
  /** Customer support */
  CustomerSupport = 'customerSupport',
  /** Engineering */
  Engineering = 'engineering',
  /** Executive */
  Executive = 'executive',
  /** Marketing */
  Marketing = 'marketing',
  /** Product */
  Product = 'product'
}

/** Autogenerated input type of ValidateHubspotTemplates */
export type ValidateHubspotTemplatesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of ValidateHubspotTemplates. */
export type ValidateHubspotTemplatesPayload = {
  __typename?: 'ValidateHubspotTemplatesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  response?: Maybe<HubspotTemplateValidationObject>;
};

export enum Value {
  Boolean = 'boolean',
  Float = 'float',
  Integer = 'integer',
  String = 'string'
}

/** Autogenerated input type of VerifyOutboundWebhook */
export type VerifyOutboundWebhookInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the webhook to run verify on */
  outboundWebhookId: Scalars['ID']['input'];
};

/** Autogenerated return type of VerifyOutboundWebhook. */
export type VerifyOutboundWebhookPayload = {
  __typename?: 'VerifyOutboundWebhookPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<UserError>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type VideoAsset = Node & {
  __typename?: 'VideoAsset';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** the embedable video type */
  embedType: Scalars['String']['output'];
  /** The video height ratio */
  heightRatio?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The video thumbnail or gif */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The video url to embed */
  videoUrl: Scalars['String']['output'];
};

export type VideoAssetAttributes = {
  /** the embedable video type */
  embedType: Scalars['String']['input'];
  /** The video height ratio */
  heightRatio?: InputMaybe<Scalars['String']['input']>;
  /** The video thumbnail or gif */
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  /** The video url to embed */
  videoUrl: Scalars['String']['input'];
};

export type ViewerAnalyticsObject = {
  __typename?: 'ViewerAnalyticsObject';
  totalUniqueAnonymousCount: Scalars['Int']['output'];
  totalUniqueEmbeddedCount: Scalars['Int']['output'];
  totalUniqueSubscribersCount: Scalars['Int']['output'];
  uniqueVisitors: Array<ViewerChartData>;
};

export type ViewerChartData = {
  __typename?: 'ViewerChartData';
  date: Scalars['ISO8601DateTime']['output'];
  uniqueAnonymousVisitors?: Maybe<Scalars['Int']['output']>;
  uniqueEmbeddedVisitors?: Maybe<Scalars['Int']['output']>;
  uniqueSubscribedVisitors?: Maybe<Scalars['Int']['output']>;
};

export type Vote = Node & {
  __typename?: 'Vote';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  idea: Idea;
  subscriber: Subscriber;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Vote. */
export type VoteConnection = {
  __typename?: 'VoteConnection';
  /** A list of edges. */
  edges?: Maybe<Array<VoteEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Vote>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VoteEdge = {
  __typename?: 'VoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Vote>;
};

/** The Project or Organization that owns the webhook */
export type WebhookOwner = Organization | Project;

export type Where = {
  OR?: InputMaybe<Array<Where>>;
  rules?: InputMaybe<Array<Rule>>;
};

export type WorkItem = Feedbackable & HasFeedbacks & Node & Permalinks & Subscribable & {
  __typename?: 'WorkItem';
  /** Announcements associated with the work item */
  announcements?: Maybe<AnnouncementConnection>;
  archived: Scalars['Boolean']['output'];
  /** The categories the work item is associated with */
  categories: Array<Category>;
  /** The change types the work item is associated with. Change types are called Labels in the management portal */
  changeTypes: ChangeTypeConnection;
  /** Connected external data sources. Internal use only. */
  connectedSources?: Maybe<ConnectedSourceConnection>;
  content?: Maybe<Scalars['String']['output']>;
  /** The HTML representation of the content. */
  contentHtml?: Maybe<Scalars['String']['output']>;
  /** The plain text representation of the content. */
  contentPlainText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Defines the type of schema the content follows, draftjs to be deprecated. */
  contentType: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the timeline is displayed on the work item */
  displayTimeline: Scalars['Boolean']['output'];
  events?: Maybe<EventConnection>;
  /** The excerpt of the work item, falls back to the name if no excerpt is present */
  excerptWithFallback?: Maybe<Scalars['String']['output']>;
  exportFeedbacks?: Maybe<Array<Feedback>>;
  exportSubscribers?: Maybe<SubscriberConnection>;
  /** External content links associated with the work item */
  externalContentLinks?: Maybe<Array<ExternalContentLink>>;
  feedbackHappyCount: Scalars['Int']['output'];
  feedbackMehCount: Scalars['Int']['output'];
  feedbackSadCount: Scalars['Int']['output'];
  feedbacks?: Maybe<FeedbackConnection>;
  /** The hero image of the work item */
  heroImage?: Maybe<Image>;
  id: Scalars['ID']['output'];
  /** The ideas associated with the work item */
  ideas: Array<Idea>;
  /** The users assigned to the work item */
  members: Array<User>;
  /** The name of the work item */
  name: Scalars['String']['output'];
  /** The owning user of the work item */
  owner?: Maybe<User>;
  /** The position of the work item within a stage */
  position: Scalars['Int']['output'];
  privatePermalink: Scalars['String']['output'];
  projectSubscription?: Maybe<ProjectSubscription>;
  projectSubscriptionByEmail?: Maybe<ProjectSubscription>;
  projectSubscriptions?: Maybe<ProjectSubscriptionConnection>;
  /** The projected date of release for the work item */
  projectedAt?: Maybe<Scalars['String']['output']>;
  /** The format of the projected_at date, can be "exact", "fuzzy", "super-fuzzy" or "none" */
  projectedAtFormat: Scalars['String']['output'];
  publicPermalink: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  roadmapUpdates: Array<RoadmapUpdate>;
  /** Whether the work item is shown on the public roadmap */
  showOnPublicRoadmap: Scalars['Boolean']['output'];
  /** The slug of the work item, must be URL safe and unique within the project */
  slug: Scalars['String']['output'];
  /** The stage the work item is displayed under */
  stage?: Maybe<Stage>;
  stageId: Scalars['ID']['output'];
  state: WorkItemStateEnum;
  subscribers?: Maybe<SubscriberConnection>;
  /** @deprecated Use projectSubscriptions instead */
  subscriptions?: Maybe<SubscriptionConnection>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type WorkItemAnnouncementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type WorkItemChangeTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type WorkItemConnectedSourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type WorkItemEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type WorkItemExportSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
};


export type WorkItemFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  feedbackableArchived?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackableIds?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importance?: InputMaybe<Importance>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderAttr?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  organizedState?: InputMaybe<Scalars['String']['input']>;
  reaction?: InputMaybe<Reaction>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  unorganized?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Where>;
};


export type WorkItemProjectSubscriptionArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type WorkItemProjectSubscriptionByEmailArgs = {
  email: Scalars['String']['input'];
  transport?: InputMaybe<Owner>;
};


export type WorkItemProjectSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  transport?: InputMaybe<TransportTypeEnum>;
  where?: InputMaybe<Where>;
};


export type WorkItemSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  status?: InputMaybe<Array<SubscriptionStatus>>;
  where?: InputMaybe<Where>;
};


export type WorkItemSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  transport?: InputMaybe<TransportTypeEnum>;
  type?: InputMaybe<Owner>;
  where?: InputMaybe<Where>;
};

export type WorkItemAnalytics = {
  __typename?: 'WorkItemAnalytics';
  /** Table data of stale work items */
  staleWorkItems: Array<Dataseries>;
  viewsByWorkItem: Array<Dataseries>;
};


export type WorkItemAnalyticsViewsByWorkItemArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};

/** Attributes for creating or updating a category */
export type WorkItemAttributes = {
  /** Description of the work item */
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name of the work item */
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

/** The connection type for WorkItem. */
export type WorkItemConnection = {
  __typename?: 'WorkItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<WorkItemEdge>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<WorkItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WorkItemEdge = {
  __typename?: 'WorkItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WorkItem>;
};

export enum WorkItemHeroImage {
  /** heroImage */
  HeroImage = 'hero_image'
}

export enum WorkItemStateEnum {
  /** Archived */
  Archived = 'archived',
  /** Draft */
  Draft = 'draft',
  /** Published */
  Published = 'published'
}

export type Workspace = Node & {
  __typename?: 'Workspace';
  channels?: Maybe<Array<Channel>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  installed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  project: Project;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ZapierApp = Node & {
  __typename?: 'ZapierApp';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  project: Project;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of updateProjectSubscription */
export type UpdateProjectSubscriptionInput = {
  /** Array of category IDs to subscribe to. Pass in an empty array to subscribe to all categories */
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Input to update a project subscription */
  projectSubscription: ProjectSubscriptionInput;
  /** Array of work item IDs to subscribe to. Pass in an empty array to unsubscribe to all work items */
  workItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of updateProjectSubscription. */
export type UpdateProjectSubscriptionPayload = {
  __typename?: 'updateProjectSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated project subscription */
  projectSubscription?: Maybe<ProjectSubscription>;
};

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  __typename?: '__EnumValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  __typename?: '__Field';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  args: Array<__InputValue>;
  type: __Type;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};


/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  __typename?: '__InputValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  __typename?: '__Type';
  kind: __TypeKind;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  specifiedByUrl?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<__Field>>;
  interfaces?: Maybe<Array<__Type>>;
  possibleTypes?: Maybe<Array<__Type>>;
  enumValues?: Maybe<Array<__EnumValue>>;
  inputFields?: Maybe<Array<__InputValue>>;
  ofType?: Maybe<__Type>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  Scalar = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  Interface = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull = 'NON_NULL'
}

export type AnalyticsCardEmailQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  endDate: Scalars['ISO8601DateTime']['input'];
}>;


export type AnalyticsCardEmailQuery = { __typename?: 'Query', analytics?: { __typename?: 'AnalyticsQuery', announcementAnalytics?: { __typename?: 'AnnouncementAnalytics', emailEngagement: { __typename?: 'EmailAnalyticsData', sentCount: number, openRate: number, clickToOpenRate: number, clickRate: number } } | null } | null };

export type AnalyticsCardSubscriberQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  endDate: Scalars['ISO8601DateTime']['input'];
}>;


export type AnalyticsCardSubscriberQuery = { __typename?: 'Query', analytics?: { __typename?: 'AnalyticsQuery', announcementAnalytics?: { __typename?: 'AnnouncementAnalytics', newSubscribers: number, pageViews: number, showPageViewsDeprecated: boolean, pageViewsDeprecated: number } | null } | null };

export type AnalyticsCardVotesAndFeedbackQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  endDate: Scalars['ISO8601DateTime']['input'];
}>;


export type AnalyticsCardVotesAndFeedbackQuery = { __typename?: 'Query', analytics?: { __typename?: 'AnalyticsQuery', feedbackAnalytics?: { __typename?: 'FeedbackAnalytics', newVotes: number, newFeedbackCount: number } | null } | null };

export type NotificationsPerformanceQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  endDate: Scalars['ISO8601DateTime']['input'];
}>;


export type NotificationsPerformanceQuery = { __typename?: 'Query', analytics?: { __typename?: 'AnalyticsQuery', announcementAnalytics?: { __typename?: 'AnnouncementAnalytics', notificationPerformance?: Array<{ __typename?: 'StackedBarChart', type: string, announcement: string, value: number }> | null, notificationPerformanceTable?: Array<{ __typename?: 'Dataseries', xValue?: string | null, yValue?: number | null, metaValues?: Array<string> | null }> | null } | null } | null };

export type NotificationsRatePerformanceQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  endDate: Scalars['ISO8601DateTime']['input'];
}>;


export type NotificationsRatePerformanceQuery = { __typename?: 'Query', analytics?: { __typename?: 'AnalyticsQuery', announcementAnalytics?: { __typename?: 'AnnouncementAnalytics', notificationRatePerformance?: Array<{ __typename?: 'StackedBarChart', type: string, announcement: string, rate: number }> | null, notificationRatePerformanceTable?: Array<{ __typename?: 'Dataseries', xValue?: string | null, yValue?: number | null, metaValues?: Array<string> | null }> | null } | null } | null };

export type AnalyticsOpenRatesByDayQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  endDate: Scalars['ISO8601DateTime']['input'];
}>;


export type AnalyticsOpenRatesByDayQuery = { __typename?: 'Query', analytics?: { __typename?: 'AnalyticsQuery', announcementAnalytics?: { __typename?: 'AnnouncementAnalytics', openRatesByDayOfWeek?: Array<{ __typename?: 'TimeseriesData', day: string, rate?: number | null }> | null } | null } | null };

export type AvgFeedbackSentimentQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  endDate: Scalars['ISO8601DateTime']['input'];
}>;


export type AvgFeedbackSentimentQuery = { __typename?: 'Query', analytics?: { __typename?: 'AnalyticsQuery', feedbackAnalytics?: { __typename?: 'FeedbackAnalytics', avgFeedbackSentiment: Array<{ __typename?: 'TimeseriesData', date: string, score?: number | null }> } | null } | null };

export type FeedbackBySentimentQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  endDate: Scalars['ISO8601DateTime']['input'];
}>;


export type FeedbackBySentimentQuery = { __typename?: 'Query', analytics?: { __typename?: 'AnalyticsQuery', feedbackAnalytics?: { __typename?: 'FeedbackAnalytics', feedbacksBySentiment: Array<{ __typename?: 'StackedBarChart', y: number, type: string, date: string }> } | null } | null };

export type FeedbackWordStatsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  endDate: Scalars['ISO8601DateTime']['input'];
}>;


export type FeedbackWordStatsQuery = { __typename?: 'Query', analytics?: { __typename?: 'AnalyticsQuery', feedbackAnalytics?: { __typename?: 'FeedbackAnalytics', feedbackWordStats: Array<{ __typename?: 'Dataseries', xValue?: string | null, yValue?: number | null }> } | null } | null };

export type RecentlySubscribedDomainsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  endDate: Scalars['ISO8601DateTime']['input'];
}>;


export type RecentlySubscribedDomainsQuery = { __typename?: 'Query', analytics?: { __typename?: 'AnalyticsQuery', subscriberAnalytics?: { __typename?: 'SubscriberAnalytics', recentlySubscribedDomains: Array<{ __typename?: 'Dataseries', yValue?: number | null, xValue?: string | null, metaValues?: Array<string> | null }> } | null } | null };

export type TopCategoriesBySubscribersQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  endDate: Scalars['ISO8601DateTime']['input'];
}>;


export type TopCategoriesBySubscribersQuery = { __typename?: 'Query', analytics?: { __typename?: 'AnalyticsQuery', subscriberAnalytics?: { __typename?: 'SubscriberAnalytics', subscribersByCategory: Array<{ __typename?: 'Dataseries', xValue?: string | null, yValue?: number | null }> } | null } | null };

export type AnalyticsOpenRatesByHourQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  endDate: Scalars['ISO8601DateTime']['input'];
}>;


export type AnalyticsOpenRatesByHourQuery = { __typename?: 'Query', analytics?: { __typename?: 'AnalyticsQuery', announcementAnalytics?: { __typename?: 'AnnouncementAnalytics', openRatesByHourOfDay?: Array<{ __typename?: 'TimeseriesData', hour: string, rate?: number | null }> | null } | null } | null };

export type ViewsByWorkItemQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  endDate: Scalars['ISO8601DateTime']['input'];
}>;


export type ViewsByWorkItemQuery = { __typename?: 'Query', analytics?: { __typename?: 'AnalyticsQuery', workItemAnalytics?: { __typename?: 'WorkItemAnalytics', viewsByWorkItem: Array<{ __typename?: 'Dataseries', xValue?: string | null, yValue?: number | null, metaValues?: Array<string> | null }> } | null } | null };

export type ViewsByAnnouncementQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  endDate: Scalars['ISO8601DateTime']['input'];
}>;


export type ViewsByAnnouncementQuery = { __typename?: 'Query', analytics?: { __typename?: 'AnalyticsQuery', announcementAnalytics?: { __typename?: 'AnnouncementAnalytics', viewsByAnnouncement: Array<{ __typename?: 'Dataseries', xValue?: string | null, yValue?: number | null, metaValues?: Array<string> | null }> } | null } | null };

export type EmbedViewsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  endDate: Scalars['ISO8601DateTime']['input'];
}>;


export type EmbedViewsQuery = { __typename?: 'Query', analytics?: { __typename?: 'AnalyticsQuery', announcementAnalytics?: { __typename?: 'AnnouncementAnalytics', embedAnnouncementViews: Array<{ __typename?: 'TimeseriesData', x: string, y?: number | null }> } | null } | null };

export type StaleWorkItemsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type StaleWorkItemsQuery = { __typename?: 'Query', analytics?: { __typename?: 'AnalyticsQuery', workItemAnalytics?: { __typename?: 'WorkItemAnalytics', staleWorkItems: Array<{ __typename?: 'Dataseries', xValue?: string | null, yValue?: number | null, metaValues?: Array<string> | null }> } | null } | null };

export type AddCohortAudienceDomainMutationVariables = Exact<{
  input: AddCohortAudienceDomainsInput;
}>;


export type AddCohortAudienceDomainMutation = { __typename?: 'Mutation', addCohortAudienceDomains?: { __typename?: 'AddCohortAudienceDomainsPayload', cohort?: { __typename?: 'Cohort', id: string, audienceDomains: { __typename?: 'AudienceDomainConnection', totalCount: number, edges?: Array<{ __typename?: 'AudienceDomainEdge', node?: { __typename?: 'AudienceDomain', id: string } | null }> | null } } | null } | null };

export type AddCohortSubscriberMutationVariables = Exact<{
  input: AddCohortSubscribersInput;
}>;


export type AddCohortSubscriberMutation = { __typename?: 'Mutation', addCohortSubscribers?: { __typename?: 'AddCohortSubscribersPayload', cohort?: { __typename?: 'Cohort', id: string, subscribers: { __typename?: 'SubscriberConnection', totalCount: number } } | null } | null };

export type CohortDomainsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  cohortId: Scalars['ID']['input'];
}>;


export type CohortDomainsQuery = { __typename?: 'Query', project: { __typename?: 'Project', cohort?: { __typename?: 'Cohort', id: string, audienceDomains: { __typename?: 'AudienceDomainConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'AudienceDomainEdge', node?: { __typename?: 'AudienceDomain', id: string, hostname: string } | null }> | null } } | null } };

export type CohortSubscribersQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  cohortId: Scalars['ID']['input'];
}>;


export type CohortSubscribersQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, cohort?: { __typename?: 'Cohort', id: string, subscribers: { __typename?: 'SubscriberConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'SubscriberEdge', node: { __typename?: 'Subscriber', id: string, email: string } }> | null } } | null } };

export type CreateCohortMutationVariables = Exact<{
  input: CreateCohortInput;
}>;


export type CreateCohortMutation = { __typename?: 'Mutation', createCohort?: { __typename?: 'CreateCohortPayload', cohort?: { __typename?: 'Cohort', id: string, name: string, description?: string | null } | null, errors: Array<{ __typename?: 'UserError', message: string }> } | null };

export type RemoveCohortDomainsMutationVariables = Exact<{
  input: RemoveCohortAudienceDomainsInput;
}>;


export type RemoveCohortDomainsMutation = { __typename?: 'Mutation', removeCohortAudienceDomains?: { __typename?: 'RemoveCohortAudienceDomainsPayload', cohort?: { __typename?: 'Cohort', id: string, audienceDomains: { __typename?: 'AudienceDomainConnection', totalCount: number, edges?: Array<{ __typename?: 'AudienceDomainEdge', node?: { __typename?: 'AudienceDomain', id: string } | null }> | null } } | null } | null };

export type RemoveCohortSubscribersMutationVariables = Exact<{
  input: RemoveCohortSubscribersInput;
}>;


export type RemoveCohortSubscribersMutation = { __typename?: 'Mutation', removeCohortSubscribers?: { __typename?: 'RemoveCohortSubscribersPayload', cohort?: { __typename?: 'Cohort', id: string, name: string, subscribers: { __typename?: 'SubscriberConnection', totalCount: number } } | null } | null };

export type SearchInProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  term: Scalars['String']['input'];
}>;


export type SearchInProjectQuery = { __typename?: 'Query', results: Array<{ __typename?: 'Announcement', id: string, headline?: string | null, privatePermalink: string, publishedAt?: any | null, type: 'Announcement' } | { __typename?: 'AudienceDomain', id: string, hostname: string, type: 'AudienceDomain' } | { __typename?: 'Idea', id: string, name: string, privatePermalink: string, type: 'Idea' } | { __typename?: 'Subscriber', id: string, email: string, type: 'Subscriber' } | { __typename?: 'WorkItem', id: string, name: string, privatePermalink: string, type: 'WorkItem' }> };

export type GetConnectedJiraProjectsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetConnectedJiraProjectsQuery = { __typename?: 'Query', project: { __typename?: 'Project', connectedJiraProjects?: Array<string> | null } };

export type CreateSourceMutationVariables = Exact<{
  workItemId?: InputMaybe<Scalars['ID']['input']>;
  announcementId?: InputMaybe<Scalars['ID']['input']>;
  issueUrl: Scalars['String']['input'];
  providerName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
}>;


export type CreateSourceMutation = { __typename?: 'Mutation', createConnectedSource?: { __typename?: 'CreateSourcePayload', connectedSource: { __typename?: 'ConnectedSource', id: string } } | null };

export type GetConnectedSourcesForWorkItemQueryVariables = Exact<{
  workItemId: Scalars['ID']['input'];
}>;


export type GetConnectedSourcesForWorkItemQuery = { __typename?: 'Query', workItem: { __typename?: 'WorkItem', connectedSources?: { __typename?: 'ConnectedSourceConnection', nodes?: Array<{ __typename?: 'ConnectedSource', id: string, name?: string | null, providerName: string, url: string, externalId: string, contextId?: string | null, metadata?: any | null } | null> | null } | null } };

export type GetConnectedSourcesForAnnouncementQueryVariables = Exact<{
  announcementId: Scalars['ID']['input'];
}>;


export type GetConnectedSourcesForAnnouncementQuery = { __typename?: 'Query', announcement: { __typename?: 'Announcement', connectedSources?: { __typename?: 'ConnectedSourceConnection', nodes?: Array<{ __typename?: 'ConnectedSource', id: string, name?: string | null, providerName: string, url: string, externalId: string, contextId?: string | null, metadata?: any | null } | null> | null } | null } };

export type RemoveConnectedSourceMutationVariables = Exact<{
  sourceId: Scalars['ID']['input'];
  contextId: Scalars['String']['input'];
}>;


export type RemoveConnectedSourceMutation = { __typename?: 'Mutation', removeConnectedSource?: { __typename?: 'RemoveSourcePayload', deletedId?: string | null, errors: Array<{ __typename?: 'UserError', message: string }> } | null };

export type AudienceDomainShowQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type AudienceDomainShowQuery = { __typename?: 'Query', project: { __typename?: 'Project', audienceDomain?: { __typename?: 'AudienceDomain', hostname: string, firstSeen: any, subscriberCount: number, feedbackCount: number, voteCount: number, averageFeedbackSentiment?: number | null } | null } };

export type AudienceDomainFeedbackQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderBy>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type AudienceDomainFeedbackQuery = { __typename?: 'Query', project: { __typename?: 'Project', audienceDomain?: { __typename?: 'AudienceDomain', feedbacks: { __typename?: 'FeedbackConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Feedback', id: string, createdAt: any, sentimentScore?: number | null, importance?: Importance | null, content: string, notes?: string | null, affectedCustomerEmail: string, affectedCustomer: { __typename?: 'Subscriber', id: string, email: string, isProjectSubscriber: boolean }, reporter?: { __typename?: 'User', id: string, name?: string | null, email: string } | null, feedbackable?: { __typename?: 'Announcement', id: string, name: string, privatePermalink: string } | { __typename?: 'Idea', id: string, name: string, privatePermalink: string } | { __typename?: 'WorkItem', id: string, name: string, privatePermalink: string } | null } | null> | null } } | null } };

export type AudienceDomainSubscribersQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderBy>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type AudienceDomainSubscribersQuery = { __typename?: 'Query', project: { __typename?: 'Project', audienceDomain?: { __typename?: 'AudienceDomain', subscribers: { __typename?: 'SubscriberConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'SubscriberEdge', createdAt: any, node: { __typename?: 'Subscriber', id: string, email: string, isProjectSubscriber: boolean, voteCount: number, feedbackCount: number } }> | null } } | null } };

export type AudienceDomainVotesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderBy>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type AudienceDomainVotesQuery = { __typename?: 'Query', project: { __typename?: 'Project', audienceDomain?: { __typename?: 'AudienceDomain', votes: { __typename?: 'VoteConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Vote', id: string, createdAt: any, idea: { __typename?: 'Idea', id: string, name: string, privatePermalink: string }, subscriber: { __typename?: 'Subscriber', id: string, email: string, isProjectSubscriber: boolean } } | null> | null } } | null } };

export type CreateExternalContentLinkMutationVariables = Exact<{
  externalContentLink: CreateLinkAttributes;
}>;


export type CreateExternalContentLinkMutation = { __typename?: 'Mutation', createExternalContentLink?: { __typename?: 'CreateExternalContentLinkPayload', errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type DeleteExternalContentLinkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteExternalContentLinkMutation = { __typename?: 'Mutation', deleteExternalContentLink?: { __typename?: 'DeleteExternalContentLinkPayload', errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type ReorderExternalContentLinksMutationVariables = Exact<{
  ownerId: Scalars['ID']['input'];
  orderMap: Array<OrderMap> | OrderMap;
}>;


export type ReorderExternalContentLinksMutation = { __typename?: 'Mutation', reorderExternalContentLinks?: { __typename?: 'ReorderExternalContentLinksPayload', errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type UpdateExternalContentLinkMutationVariables = Exact<{
  externalContentLink: UpdateLinkAttributes;
}>;


export type UpdateExternalContentLinkMutation = { __typename?: 'Mutation', updateExternalContentLink?: { __typename?: 'UpdateExternalContentLinkPayload', errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type ExportFeedbackQueryVariables = Exact<{
  feedbackableId: Scalars['ID']['input'];
}>;


export type ExportFeedbackQuery = { __typename?: 'Query', node?: { __typename?: 'Announcement', exportFeedbacks?: Array<{ __typename?: 'Feedback', id: string, affectedCustomerEmail: string, createdAt: any, content: string, reaction?: Reaction | null, importance?: Importance | null, archived: boolean }> | null } | { __typename?: 'AnnouncementDigest' } | { __typename?: 'ApiToken' } | { __typename?: 'ApiUser' } | { __typename?: 'AtlassianApp' } | { __typename?: 'AttributeDefinition' } | { __typename?: 'AudienceDomain' } | { __typename?: 'Category' } | { __typename?: 'ChangeType' } | { __typename?: 'Channel' } | { __typename?: 'Cohort' } | { __typename?: 'ConnectedSource' } | { __typename?: 'ContentGenerator' } | { __typename?: 'EmbedApp' } | { __typename?: 'Event' } | { __typename?: 'EventType' } | { __typename?: 'ExternalContentLink' } | { __typename?: 'Feedback' } | { __typename?: 'HubspotApp' } | { __typename?: 'Idea', exportFeedbacks?: Array<{ __typename?: 'Feedback', id: string, affectedCustomerEmail: string, createdAt: any, content: string, reaction?: Reaction | null, importance?: Importance | null, archived: boolean }> | null } | { __typename?: 'IdeaVote' } | { __typename?: 'JiraApp' } | { __typename?: 'MailAppSetting' } | { __typename?: 'MarketplaceTemplate' } | { __typename?: 'Notification' } | { __typename?: 'OnboardingTasks' } | { __typename?: 'Organization' } | { __typename?: 'OutboundWebhook' } | { __typename?: 'OutboundWebhookEvent' } | { __typename?: 'Project', exportFeedbacks?: Array<{ __typename?: 'Feedback', id: string, affectedCustomerEmail: string, createdAt: any, content: string, reaction?: Reaction | null, importance?: Importance | null, archived: boolean }> | null } | { __typename?: 'ProjectSubscription' } | { __typename?: 'ProjectView' } | { __typename?: 'RoadmapUpdate' } | { __typename?: 'Rollup' } | { __typename?: 'SecureConnectionSettings' } | { __typename?: 'SimpleMailApp' } | { __typename?: 'SimpleMailTransport' } | { __typename?: 'SlackApp' } | { __typename?: 'SlackAppTransport' } | { __typename?: 'SlackCommandApp' } | { __typename?: 'Stage' } | { __typename?: 'Subscriber' } | { __typename?: 'Subscription' } | { __typename?: 'Template' } | { __typename?: 'User' } | { __typename?: 'VideoAsset' } | { __typename?: 'Vote' } | { __typename?: 'WorkItem', exportFeedbacks?: Array<{ __typename?: 'Feedback', id: string, affectedCustomerEmail: string, createdAt: any, content: string, reaction?: Reaction | null, importance?: Importance | null, archived: boolean }> | null } | { __typename?: 'Workspace' } | { __typename?: 'ZapierApp' } | null };

export type FeedbackTableQueryVariables = Exact<{
  feedbackableId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  organizedState?: InputMaybe<Scalars['String']['input']>;
  reaction?: InputMaybe<Reaction>;
  importance?: InputMaybe<Importance>;
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
}>;


export type FeedbackTableQuery = { __typename?: 'Query', feedbackable?: { __typename: 'Announcement', hasFeedback?: { __typename?: 'FeedbackConnection', totalCount: number } | null, feedbacks?: { __typename?: 'FeedbackConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, startCursor?: string | null }, edges?: Array<{ __typename?: 'FeedbackEdge', node?: { __typename?: 'Feedback', id: string, archived: boolean, createdAt: any, content: string, notes?: string | null, reaction?: Reaction | null, importance?: Importance | null, affectedCustomerEmail: string, affectedCustomer: { __typename?: 'Subscriber', id: string, avatarColor: string, email: string, initials: string, isProjectSubscriber: boolean }, reporter?: { __typename?: 'User', id: string, name?: string | null, email: string } | null, feedbackable?: { __typename: 'Announcement', id: string, archived: boolean, name: string, privatePermalink: string } | { __typename: 'Idea', id: string, archived: boolean, name: string, privatePermalink: string } | { __typename: 'WorkItem', id: string, archived: boolean, name: string, privatePermalink: string } | null, attributes: Array<{ __typename?: 'Attribute', key: string, value?: any | null }> } | null }> | null } | null } | { __typename?: 'AnnouncementDigest' } | { __typename?: 'ApiToken' } | { __typename?: 'ApiUser' } | { __typename?: 'AtlassianApp' } | { __typename?: 'AttributeDefinition' } | { __typename?: 'AudienceDomain' } | { __typename?: 'Category' } | { __typename?: 'ChangeType' } | { __typename?: 'Channel' } | { __typename?: 'Cohort' } | { __typename?: 'ConnectedSource' } | { __typename?: 'ContentGenerator' } | { __typename?: 'EmbedApp' } | { __typename?: 'Event' } | { __typename?: 'EventType' } | { __typename?: 'ExternalContentLink' } | { __typename?: 'Feedback' } | { __typename?: 'HubspotApp' } | { __typename: 'Idea', hasFeedback?: { __typename?: 'FeedbackConnection', totalCount: number } | null, feedbacks?: { __typename?: 'FeedbackConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, startCursor?: string | null }, edges?: Array<{ __typename?: 'FeedbackEdge', node?: { __typename?: 'Feedback', id: string, archived: boolean, createdAt: any, content: string, notes?: string | null, reaction?: Reaction | null, importance?: Importance | null, affectedCustomerEmail: string, affectedCustomer: { __typename?: 'Subscriber', id: string, avatarColor: string, email: string, initials: string, isProjectSubscriber: boolean }, reporter?: { __typename?: 'User', id: string, name?: string | null, email: string } | null, feedbackable?: { __typename: 'Announcement', id: string, archived: boolean, name: string, privatePermalink: string } | { __typename: 'Idea', id: string, archived: boolean, name: string, privatePermalink: string } | { __typename: 'WorkItem', id: string, archived: boolean, name: string, privatePermalink: string } | null, attributes: Array<{ __typename?: 'Attribute', key: string, value?: any | null }> } | null }> | null } | null } | { __typename?: 'IdeaVote' } | { __typename?: 'JiraApp' } | { __typename?: 'MailAppSetting' } | { __typename?: 'MarketplaceTemplate' } | { __typename?: 'Notification' } | { __typename?: 'OnboardingTasks' } | { __typename?: 'Organization' } | { __typename?: 'OutboundWebhook' } | { __typename?: 'OutboundWebhookEvent' } | { __typename: 'Project', hasFeedback?: { __typename?: 'FeedbackConnection', totalCount: number } | null, feedbacks?: { __typename?: 'FeedbackConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, startCursor?: string | null }, edges?: Array<{ __typename?: 'FeedbackEdge', node?: { __typename?: 'Feedback', id: string, archived: boolean, createdAt: any, content: string, notes?: string | null, reaction?: Reaction | null, importance?: Importance | null, affectedCustomerEmail: string, affectedCustomer: { __typename?: 'Subscriber', id: string, avatarColor: string, email: string, initials: string, isProjectSubscriber: boolean }, reporter?: { __typename?: 'User', id: string, name?: string | null, email: string } | null, feedbackable?: { __typename: 'Announcement', id: string, archived: boolean, name: string, privatePermalink: string } | { __typename: 'Idea', id: string, archived: boolean, name: string, privatePermalink: string } | { __typename: 'WorkItem', id: string, archived: boolean, name: string, privatePermalink: string } | null, attributes: Array<{ __typename?: 'Attribute', key: string, value?: any | null }> } | null }> | null } | null } | { __typename?: 'ProjectSubscription' } | { __typename?: 'ProjectView' } | { __typename?: 'RoadmapUpdate' } | { __typename?: 'Rollup' } | { __typename?: 'SecureConnectionSettings' } | { __typename?: 'SimpleMailApp' } | { __typename?: 'SimpleMailTransport' } | { __typename?: 'SlackApp' } | { __typename?: 'SlackAppTransport' } | { __typename?: 'SlackCommandApp' } | { __typename?: 'Stage' } | { __typename?: 'Subscriber' } | { __typename?: 'Subscription' } | { __typename?: 'Template' } | { __typename?: 'User' } | { __typename?: 'VideoAsset' } | { __typename?: 'Vote' } | { __typename: 'WorkItem', hasFeedback?: { __typename?: 'FeedbackConnection', totalCount: number } | null, feedbacks?: { __typename?: 'FeedbackConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, startCursor?: string | null }, edges?: Array<{ __typename?: 'FeedbackEdge', node?: { __typename?: 'Feedback', id: string, archived: boolean, createdAt: any, content: string, notes?: string | null, reaction?: Reaction | null, importance?: Importance | null, affectedCustomerEmail: string, affectedCustomer: { __typename?: 'Subscriber', id: string, avatarColor: string, email: string, initials: string, isProjectSubscriber: boolean }, reporter?: { __typename?: 'User', id: string, name?: string | null, email: string } | null, feedbackable?: { __typename: 'Announcement', id: string, archived: boolean, name: string, privatePermalink: string } | { __typename: 'Idea', id: string, archived: boolean, name: string, privatePermalink: string } | { __typename: 'WorkItem', id: string, archived: boolean, name: string, privatePermalink: string } | null, attributes: Array<{ __typename?: 'Attribute', key: string, value?: any | null }> } | null }> | null } | null } | { __typename?: 'Workspace' } | { __typename?: 'ZapierApp' } | null };

export type FeedbackAttributeDefinitionsQueryVariables = Exact<{
  project: Scalars['ID']['input'];
}>;


export type FeedbackAttributeDefinitionsQuery = { __typename?: 'Query', project: { __typename?: 'Project', attributeDefinitions: { __typename?: 'AttributeDefinitionConnection', nodes?: Array<{ __typename?: 'AttributeDefinition', key: string, name: string, valueType?: Value | null, description?: string | null } | null> | null } } };

export type UpdateFeedbackAttributeMutationVariables = Exact<{
  feedback: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['AttributeValue']['input']>;
}>;


export type UpdateFeedbackAttributeMutation = { __typename?: 'Mutation', updateAttribute?: { __typename?: 'UpdateAttributePayload', node?: { __typename?: 'Feedback', id: string, attributes: Array<{ __typename?: 'Attribute', key: string, value?: any | null }> } | null } | null };

export type ArchiveFeedbacksMutationVariables = Exact<{
  feedbackIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ArchiveFeedbacksMutation = { __typename?: 'Mutation', archiveFeedbacks?: { __typename?: 'ArchiveFeedbacksPayload', errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type CreateFeedbackMutationVariables = Exact<{
  feedback: CreateFeedbackAttributes;
}>;


export type CreateFeedbackMutation = { __typename?: 'Mutation', createFeedback?: { __typename?: 'CreateFeedbackPayload', errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type OrganizeFeedbacksMutationVariables = Exact<{
  feedbackIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  feedbackableId: Scalars['ID']['input'];
  feedbackableType: Scalars['String']['input'];
}>;


export type OrganizeFeedbacksMutation = { __typename?: 'Mutation', organizeFeedbacks?: { __typename?: 'OrganizeFeedbacksPayload', errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type UnarchiveFeedbacksMutationVariables = Exact<{
  feedbackIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UnarchiveFeedbacksMutation = { __typename?: 'Mutation', unarchiveFeedbacks?: { __typename?: 'UnarchiveFeedbacksPayload', errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type UpdateFeedbackMutationVariables = Exact<{
  feedback: UpdateFeedbackAttributes;
}>;


export type UpdateFeedbackMutation = { __typename?: 'Mutation', updateFeedback?: { __typename?: 'UpdateFeedbackPayload', errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type CreateFeedbackModalQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type CreateFeedbackModalQuery = { __typename?: 'Query', project: { __typename?: 'Project', ideas?: { __typename?: 'IdeaConnection', nodes?: Array<{ __typename?: 'Idea', id: string, name: string } | null> | null } | null, workItems?: { __typename?: 'WorkItemConnection', nodes?: Array<{ __typename?: 'WorkItem', id: string, name: string } | null> | null } | null, announcements?: { __typename?: 'AnnouncementConnection', nodes?: Array<{ __typename?: 'Announcement', id: string, name: string } | null> | null } | null } };

export type OrganizeFeedbackModalQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  feedbackId: Scalars['ID']['input'];
}>;


export type OrganizeFeedbackModalQuery = { __typename?: 'Query', project: { __typename?: 'Project', ideas?: { __typename?: 'IdeaConnection', nodes?: Array<{ __typename?: 'Idea', id: string, name: string } | null> | null } | null, workItems?: { __typename?: 'WorkItemConnection', nodes?: Array<{ __typename?: 'WorkItem', id: string, name: string } | null> | null } | null, announcements?: { __typename?: 'AnnouncementConnection', nodes?: Array<{ __typename?: 'Announcement', id: string, name: string } | null> | null } | null }, feedback: { __typename?: 'Feedback', id: string, content: string, affectedCustomerEmail: string, importance?: Importance | null, reaction?: Reaction | null, notes?: string | null, feedbackable?: { __typename: 'Announcement', id: string, name: string } | { __typename: 'Idea', id: string, name: string } | { __typename: 'WorkItem', id: string, name: string } | null } };

export type UpdateFeedbackModalQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  feedbackId: Scalars['ID']['input'];
}>;


export type UpdateFeedbackModalQuery = { __typename?: 'Query', project: { __typename?: 'Project', ideas?: { __typename?: 'IdeaConnection', nodes?: Array<{ __typename?: 'Idea', id: string, name: string } | null> | null } | null, workItems?: { __typename?: 'WorkItemConnection', nodes?: Array<{ __typename?: 'WorkItem', id: string, name: string } | null> | null } | null, announcements?: { __typename?: 'AnnouncementConnection', nodes?: Array<{ __typename?: 'Announcement', id: string, name: string } | null> | null } | null }, feedback: { __typename?: 'Feedback', id: string, content: string, affectedCustomerEmail: string, importance?: Importance | null, reaction?: Reaction | null, notes?: string | null, feedbackable?: { __typename: 'Announcement', id: string, name: string } | { __typename: 'Idea', id: string, name: string } | { __typename: 'WorkItem', id: string, name: string } | null } };

export type DirectUploadMutationVariables = Exact<{
  input: CreateDirectUploadInput;
}>;


export type DirectUploadMutation = { __typename?: 'Mutation', createDirectUpload?: { __typename?: 'CreateDirectUploadPayload', blob?: { __typename?: 'Blob', id: string, signedId: string, url: string, headers: string, key?: string | null } | null } | null };

export type IdeasTableQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  orderAttr?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OrderBy>;
}>;


export type IdeasTableQuery = { __typename?: 'Query', project: { __typename?: 'Project', ideasEnabled: boolean, cohorts?: { __typename?: 'CohortConnection', nodes?: Array<{ __typename?: 'Cohort', id: string, name: string } | null> | null } | null, ideas?: { __typename?: 'IdeaConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Idea', id: string, name: string, published: boolean, lastFeedback?: any | null, feedbackCount: number, ideaVotesCount: number, updatedAt: any, categories?: { __typename?: 'CategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name: string, color: string } | null> | null } | null } | null> | null } | null, categories?: { __typename?: 'CategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name: string, color: string } | null> | null } | null } };

export type ArchiveIdeasMutationVariables = Exact<{
  ideaIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ArchiveIdeasMutation = { __typename?: 'Mutation', archiveIdeas?: { __typename?: 'ArchiveIdeasPayload', errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type CreateIdeaMutationVariables = Exact<{
  input: CreateIdeaInput;
}>;


export type CreateIdeaMutation = { __typename?: 'Mutation', createIdea?: { __typename?: 'CreateIdeaPayload', idea?: { __typename?: 'Idea', id: string } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type PromoteIdeaMutationVariables = Exact<{
  input: PromoteIdeaInput;
}>;


export type PromoteIdeaMutation = { __typename?: 'Mutation', promoteIdea?: { __typename?: 'PromoteIdeaPayload', workItem?: { __typename?: 'WorkItem', id: string } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type TogglePublishedIdeaMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TogglePublishedIdeaMutation = { __typename?: 'Mutation', togglePublishedIdea?: { __typename?: 'TogglePublishedIdeaPayload', errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type UnarchiveIdeasMutationVariables = Exact<{
  ideaIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UnarchiveIdeasMutation = { __typename?: 'Mutation', unarchiveIdeas?: { __typename?: 'UnarchiveIdeasPayload', errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type UpdateIdeaMutationVariables = Exact<{
  input: UpdateIdeaInput;
}>;


export type UpdateIdeaMutation = { __typename?: 'Mutation', updateIdea?: { __typename?: 'UpdateIdeaPayload', errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type UpdateIdeaModalQueryVariables = Exact<{
  ideaId: Scalars['ID']['input'];
}>;


export type UpdateIdeaModalQuery = { __typename?: 'Query', idea: { __typename?: 'Idea', notes?: string | null, name: string, categories?: { __typename?: 'CategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name: string, color: string } | null> | null } | null } };

export type GetCrmStagesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetCrmStagesQuery = { __typename?: 'Query', project: { __typename?: 'Project', crmStageData: { __typename?: 'CrmStage', crmStageFilters: Array<string>, availableStages?: Array<{ __typename?: 'AvailableCrmStage', id: string, name?: string | null }> | null } } };

export type TableProjectSubscriptionsQueryVariables = Exact<{
  subscribableId: Scalars['ID']['input'];
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type TableProjectSubscriptionsQuery = { __typename?: 'Query', subscribable?: { __typename?: 'Announcement' } | { __typename?: 'AnnouncementDigest' } | { __typename?: 'ApiToken' } | { __typename?: 'ApiUser' } | { __typename?: 'AtlassianApp' } | { __typename?: 'AttributeDefinition' } | { __typename?: 'AudienceDomain' } | { __typename?: 'Category' } | { __typename?: 'ChangeType' } | { __typename?: 'Channel' } | { __typename?: 'Cohort' } | { __typename?: 'ConnectedSource' } | { __typename?: 'ContentGenerator' } | { __typename?: 'EmbedApp' } | { __typename?: 'Event' } | { __typename?: 'EventType' } | { __typename?: 'ExternalContentLink' } | { __typename?: 'Feedback' } | { __typename?: 'HubspotApp' } | { __typename?: 'Idea' } | { __typename?: 'IdeaVote' } | { __typename?: 'JiraApp' } | { __typename?: 'MailAppSetting' } | { __typename?: 'MarketplaceTemplate' } | { __typename?: 'Notification' } | { __typename?: 'OnboardingTasks' } | { __typename?: 'Organization' } | { __typename?: 'OutboundWebhook' } | { __typename?: 'OutboundWebhookEvent' } | { __typename?: 'Project', id: string, __isSubscribable: 'Project', projectSubscriptions?: { __typename?: 'ProjectSubscriptionConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'ProjectSubscriptionEdge', cursor: string, node?: { __typename: 'ProjectSubscription', id: string, createdAt: any, source?: string | null, transportTypes: Array<string>, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string }>, subscriber: { __typename: 'Subscriber', email: string, confirmedAt?: any | null, isProjectSubscriber: boolean, id: string, initials: string } } | null }> | null } | null } | { __typename?: 'ProjectSubscription' } | { __typename?: 'ProjectView' } | { __typename?: 'RoadmapUpdate' } | { __typename?: 'Rollup' } | { __typename?: 'SecureConnectionSettings' } | { __typename?: 'SimpleMailApp' } | { __typename?: 'SimpleMailTransport' } | { __typename?: 'SlackApp' } | { __typename?: 'SlackAppTransport' } | { __typename?: 'SlackCommandApp' } | { __typename?: 'Stage' } | { __typename?: 'Subscriber' } | { __typename?: 'Subscription' } | { __typename?: 'Template' } | { __typename?: 'User' } | { __typename?: 'VideoAsset' } | { __typename?: 'Vote' } | { __typename?: 'WorkItem', id: string, __isSubscribable: 'WorkItem', projectSubscriptions?: { __typename?: 'ProjectSubscriptionConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'ProjectSubscriptionEdge', cursor: string, node?: { __typename: 'ProjectSubscription', id: string, createdAt: any, source?: string | null, transportTypes: Array<string>, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string }>, subscriber: { __typename: 'Subscriber', email: string, confirmedAt?: any | null, isProjectSubscriber: boolean, id: string, initials: string } } | null }> | null } | null } | { __typename?: 'Workspace' } | { __typename?: 'ZapierApp' } | null };

type TableProjectSubscriptions_Project_Fragment = { __typename?: 'Project', id: string, __isSubscribable: 'Project', projectSubscriptions?: { __typename?: 'ProjectSubscriptionConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'ProjectSubscriptionEdge', cursor: string, node?: { __typename: 'ProjectSubscription', id: string, createdAt: any, source?: string | null, transportTypes: Array<string>, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string }>, subscriber: { __typename: 'Subscriber', email: string, confirmedAt?: any | null, isProjectSubscriber: boolean, id: string, initials: string } } | null }> | null } | null };

type TableProjectSubscriptions_WorkItem_Fragment = { __typename?: 'WorkItem', id: string, __isSubscribable: 'WorkItem', projectSubscriptions?: { __typename?: 'ProjectSubscriptionConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'ProjectSubscriptionEdge', cursor: string, node?: { __typename: 'ProjectSubscription', id: string, createdAt: any, source?: string | null, transportTypes: Array<string>, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string }>, subscriber: { __typename: 'Subscriber', email: string, confirmedAt?: any | null, isProjectSubscriber: boolean, id: string, initials: string } } | null }> | null } | null };

export type TableProjectSubscriptionsFragment = TableProjectSubscriptions_Project_Fragment | TableProjectSubscriptions_WorkItem_Fragment;

export type UnsubscribeProjectSubscriptionWorkItemMutationVariables = Exact<{
  projectSubscriptionId: Scalars['ID']['input'];
  workItemId: Scalars['ID']['input'];
}>;


export type UnsubscribeProjectSubscriptionWorkItemMutation = { __typename?: 'Mutation', unsubscribeProjectSubscriptionWorkItem?: { __typename?: 'UnsubscribeProjectSubscriptionWorkItemPayload', projectSubscription?: { __typename?: 'ProjectSubscription', id: string, state: ProjectSubscriptionStateEnum, updatedAt: any, project: { __typename?: 'Project', id: string }, subscriber: { __typename?: 'Subscriber', id: string, email: string }, workItems: Array<{ __typename?: 'WorkItem', id: string, name: string }> } | null } | null };

export type ArchiveProjectMutationVariables = Exact<{
  input: ArchiveProjectInput;
}>;


export type ArchiveProjectMutation = { __typename?: 'Mutation', archiveProject?: { __typename?: 'ArchiveProjectPayload', project?: { __typename?: 'Project', id: string } | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject?: { __typename?: 'CreateProjectPayload', project?: { __typename?: 'Project', id: string } | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type FetchProjectAdminsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type FetchProjectAdminsQuery = { __typename?: 'Query', project: { __typename?: 'Project', projectAdmins: Array<{ __typename?: 'User', name?: string | null, email: string }> } };

export type ArchiveWorkItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveWorkItemMutation = { __typename?: 'Mutation', archiveWorkItem?: { __typename?: 'ArchiveWorkItemPayload', workItem?: { __typename?: 'WorkItem', id: string, feedbacks?: { __typename?: 'FeedbackConnection', edges?: Array<{ __typename?: 'FeedbackEdge', node?: { __typename?: 'Feedback', id: string } | null }> | null } | null } | null } | null };

export type CreateWorkItemMutationVariables = Exact<{
  name: Scalars['String']['input'];
  stageId: Scalars['ID']['input'];
  categories?: InputMaybe<Array<CategoryAttributes> | CategoryAttributes>;
}>;


export type CreateWorkItemMutation = { __typename?: 'Mutation', createWorkItem?: { __typename?: 'CreateWorkItemPayload', workItem?: { __typename?: 'WorkItem', id: string, name: string, stageId: string, stage?: { __typename?: 'Stage', name: string } | null, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string }>, feedbacks?: { __typename?: 'FeedbackConnection', totalCount: number } | null, projectSubscriptions?: { __typename?: 'ProjectSubscriptionConnection', totalCount: number } | null } | null } | null };

export type DuplicateWorkItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DuplicateWorkItemMutation = { __typename?: 'Mutation', duplicateWorkItem?: { __typename?: 'DuplicateWorkItemPayload', workItem?: { __typename?: 'WorkItem', id: string, name: string, stageId: string, stage?: { __typename?: 'Stage', name: string } | null, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string }>, feedbacks?: { __typename?: 'FeedbackConnection', totalCount: number } | null, projectSubscriptions?: { __typename?: 'ProjectSubscriptionConnection', totalCount: number } | null } | null } | null };

export type RepositionWorkItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  targetStageId: Scalars['ID']['input'];
  sourceStageId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RepositionWorkItemMutation = { __typename?: 'Mutation', repositionWorkItem?: { __typename?: 'RepositionWorkItemPayload', workItem?: { __typename?: 'WorkItem', id: string, position: number, stageId: string, events?: { __typename?: 'EventConnection', nodes?: Array<{ __typename?: 'Event', id: string, eventType: string, createdAt: any, data?: any | null } | null> | null } | null } | null, targetStage?: { __typename?: 'Stage', workItems?: { __typename?: 'WorkItemConnection', edges?: Array<{ __typename?: 'WorkItemEdge', node?: { __typename?: 'WorkItem', id: string } | null }> | null } | null } | null, sourceStage?: { __typename?: 'Stage', workItems?: { __typename?: 'WorkItemConnection', edges?: Array<{ __typename?: 'WorkItemEdge', node?: { __typename?: 'WorkItem', id: string } | null }> | null } | null } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type RoadmapEnableMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type RoadmapEnableMutation = { __typename?: 'Mutation', updateProject?: { __typename?: 'UpdateProjectPayload', project?: { __typename?: 'Project', roadmapEnabled: boolean } | null } | null };

export type UnarchiveWorkItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnarchiveWorkItemMutation = { __typename?: 'Mutation', unarchiveWorkItem?: { __typename?: 'UnarchiveWorkItemPayload', workItem?: { __typename?: 'WorkItem', id: string, feedbacks?: { __typename?: 'FeedbackConnection', edges?: Array<{ __typename?: 'FeedbackEdge', node?: { __typename?: 'Feedback', id: string } | null }> | null } | null } | null } | null };

export type WorkItemSelectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type WorkItemSelectQuery = { __typename?: 'Query', viewer: { __typename?: 'ApiUser', project: { __typename?: 'Project', stages?: { __typename?: 'StageConnection', nodes?: Array<{ __typename?: 'Stage', id: string, name: string, position: number, workItems?: { __typename?: 'WorkItemConnection', nodes?: Array<{ __typename?: 'WorkItem', id: string, name: string, position: number, categories: Array<{ __typename?: 'Category', id: string, position: number }> } | null> | null } | null } | null> | null } | null } } };

export type SubscriberDrawerShowQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  id: Scalars['RuleValue']['input'];
}>;


export type SubscriberDrawerShowQuery = { __typename?: 'Query', project: { __typename?: 'Project', subscribers?: { __typename?: 'SubscriberConnection', edges?: Array<{ __typename?: 'SubscriberEdge', createdAt: any, status: SubscriptionStatus, hasSlackTransport: boolean, hasMailTransport: boolean, audienceDomainHostname: string, audienceDomainId: string, categories: Array<{ __typename?: 'Category', id: string, textColor: string, backgroundColor: string, name: string }>, node: { __typename?: 'Subscriber', id: string, email: string, initials: string, isProjectSubscriber: boolean, feedbacks: { __typename?: 'FeedbackConnection', totalCount: number }, ideaVotes: { __typename?: 'IdeaVoteConnection', totalCount: number }, workItems: { __typename?: 'WorkItemConnection', totalCount: number } } }> | null } | null } };

export type SubscriberEventsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  id: Scalars['RuleValue']['input'];
  count: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OrderBy>;
}>;


export type SubscriberEventsQuery = { __typename?: 'Query', project: { __typename?: 'Project', subscribers?: { __typename?: 'SubscriberConnection', nodes?: Array<{ __typename?: 'Subscriber', events: { __typename?: 'EventConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'Event', id: string, createdAt: any, eventType: string, project: { __typename?: 'Project', id: string, name: string }, eventObject?: { __typename: 'Announcement', id: string, name: string, headline?: string | null, privatePermalink: string } | { __typename: 'AnnouncementDigest' } | { __typename: 'ConnectedSource' } | { __typename: 'Feedback', id: string, content: string, importance?: Importance | null, sentimentScore?: number | null, sentimentMagnitude?: number | null, notes?: string | null, feedbackable?: { __typename: 'Announcement', name: string, privatePermalink: string } | { __typename: 'Idea', name: string, privatePermalink: string } | { __typename: 'WorkItem', name: string, privatePermalink: string } | null, reporter?: { __typename?: 'User', id: string, name?: string | null, email: string } | null } | { __typename: 'Idea', id: string, name: string, privatePermalink: string } | { __typename: 'Project' } | { __typename: 'ProjectSubscription', id: string } | { __typename: 'ProjectView' } | { __typename: 'Stage' } | { __typename: 'Subscriber' } | { __typename: 'Template' } | { __typename: 'WorkItem', id: string, name: string, privatePermalink: string } | null, notifications?: { __typename?: 'NotificationConnection', totalCount: number, nodes?: Array<{ __typename?: 'Notification', createdAt: any, sentAt?: any | null, openedAt?: any | null, clickedThroughAt?: any | null, status: NotificationStatus, transport: { __typename: 'SimpleMailTransport' } | { __typename: 'SlackAppTransport' } } | null> | null } | null } | null> | null } } | null> | null } | null } };

export type SubscriberFeedbacksQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  id: Scalars['RuleValue']['input'];
  orderBy?: InputMaybe<OrderBy>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubscriberFeedbacksQuery = { __typename?: 'Query', project: { __typename?: 'Project', subscribers?: { __typename?: 'SubscriberConnection', nodes?: Array<{ __typename?: 'Subscriber', feedbacks: { __typename?: 'FeedbackConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'Feedback', id: string, content: string, createdAt: any, importance?: Importance | null, sentimentScore?: number | null, notes?: string | null, reporter?: { __typename?: 'User', id: string, name?: string | null, email: string } | null, feedbackable?: { __typename: 'Announcement', name: string, privatePermalink: string } | { __typename: 'Idea', name: string, privatePermalink: string } | { __typename: 'WorkItem', name: string, privatePermalink: string } | null } | null> | null } } | null> | null } | null } };

export type SubscriberNotificationsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  id: Scalars['RuleValue']['input'];
}>;


export type SubscriberNotificationsQuery = { __typename?: 'Query', project: { __typename?: 'Project', subscribers?: { __typename?: 'SubscriberConnection', nodes?: Array<{ __typename?: 'Subscriber', notifications: { __typename?: 'NotificationConnection', nodes?: Array<{ __typename?: 'Notification', id: string, status: NotificationStatus, createdAt: any, transport: { __typename?: 'SimpleMailTransport', type: 'SimpleMailTransport' } | { __typename?: 'SlackAppTransport', type: 'SlackAppTransport' }, event: { __typename?: 'Event', eventType: string, eventObject?: { __typename?: 'Announcement', id: string, createdAt: any, headline?: string | null } | { __typename?: 'AnnouncementDigest' } | { __typename?: 'ConnectedSource' } | { __typename?: 'Feedback' } | { __typename?: 'Idea' } | { __typename?: 'Project' } | { __typename?: 'ProjectSubscription' } | { __typename?: 'ProjectView' } | { __typename?: 'Stage' } | { __typename?: 'Subscriber' } | { __typename?: 'Template' } | { __typename?: 'WorkItem' } | null } } | null> | null } } | null> | null } | null } };

export type SubscriberRoadmapQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  id: Scalars['RuleValue']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubscriberRoadmapQuery = { __typename?: 'Query', project: { __typename?: 'Project', subscribers?: { __typename?: 'SubscriberConnection', nodes?: Array<{ __typename?: 'Subscriber', workItems: { __typename?: 'WorkItemConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null }, nodes?: Array<{ __typename?: 'WorkItem', name: string, privatePermalink: string, stage?: { __typename?: 'Stage', name: string } | null } | null> | null } } | null> | null } | null } };

export type SubscriberVotesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  id: Scalars['RuleValue']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OrderBy>;
}>;


export type SubscriberVotesQuery = { __typename?: 'Query', project: { __typename?: 'Project', subscribers?: { __typename?: 'SubscriberConnection', nodes?: Array<{ __typename?: 'Subscriber', ideaVotes: { __typename?: 'IdeaVoteConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null }, nodes?: Array<{ __typename?: 'IdeaVote', id: string, createdAt: any, idea: { __typename?: 'Idea', id: string, name: string, privatePermalink: string, createdAt: any } } | null> | null } } | null> | null } | null } };

export type AddProjectViewAudienceDomainMutationVariables = Exact<{
  input: AddAudienceDomainsInput;
}>;


export type AddProjectViewAudienceDomainMutation = { __typename?: 'Mutation', addProjectViewAudienceDomains?: { __typename?: 'AddAudienceDomainsPayload', projectView?: { __typename?: 'ProjectView', id: string, audienceDomains: { __typename?: 'AudienceDomainConnection', totalCount: number, edges?: Array<{ __typename?: 'AudienceDomainEdge', node?: { __typename?: 'AudienceDomain', id: string } | null }> | null } } | null } | null };

export type AddProjectViewSubscriberMutationVariables = Exact<{
  input: AddSubscribersInput;
}>;


export type AddProjectViewSubscriberMutation = { __typename?: 'Mutation', addProjectViewSubscribers?: { __typename?: 'AddSubscribersPayload', projectView?: { __typename?: 'ProjectView', id: string, subscribers: { __typename?: 'SubscriberConnection', totalCount: number } } | null } | null };

export type CreateViewMutationVariables = Exact<{
  input: CreateProjectViewInput;
}>;


export type CreateViewMutation = { __typename?: 'Mutation', createProjectView?: { __typename?: 'CreateProjectViewPayload', projectView?: { __typename?: 'ProjectView', id: string, name?: string | null, description?: string | null } | null, errors: Array<{ __typename?: 'UserError', message: string }> } | null };

export type ProjectViewDomainsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  projectViewId: Scalars['ID']['input'];
}>;


export type ProjectViewDomainsQuery = { __typename?: 'Query', project: { __typename?: 'Project', projectView?: { __typename?: 'ProjectView', id: string, audienceDomains: { __typename?: 'AudienceDomainConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'AudienceDomainEdge', node?: { __typename?: 'AudienceDomain', id: string, hostname: string } | null }> | null } } | null } };

export type ProjectViewSubscribersQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  projectViewId: Scalars['ID']['input'];
}>;


export type ProjectViewSubscribersQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, projectView?: { __typename?: 'ProjectView', id: string, subscribers: { __typename?: 'SubscriberConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'SubscriberEdge', node: { __typename?: 'Subscriber', id: string, email: string } }> | null } } | null } };

export type RemoveProjectViewDomainsMutationVariables = Exact<{
  input: RemoveAudienceDomainsInput;
}>;


export type RemoveProjectViewDomainsMutation = { __typename?: 'Mutation', removeProjectViewAudienceDomains?: { __typename?: 'RemoveAudienceDomainsPayload', projectView?: { __typename?: 'ProjectView', id: string, audienceDomains: { __typename?: 'AudienceDomainConnection', totalCount: number, edges?: Array<{ __typename?: 'AudienceDomainEdge', node?: { __typename?: 'AudienceDomain', id: string } | null }> | null } } | null } | null };

export type RemoveProjectViewSubscribersMutationVariables = Exact<{
  input: RemoveSubscribersInput;
}>;


export type RemoveProjectViewSubscribersMutation = { __typename?: 'Mutation', removeProjectViewSubscribers?: { __typename?: 'RemoveSubscribersPayload', projectView?: { __typename?: 'ProjectView', id: string, name?: string | null, subscribers: { __typename?: 'SubscriberConnection', totalCount: number } } | null } | null };

export type DeleteVotesMutationVariables = Exact<{
  ideaId: Scalars['ID']['input'];
  voteIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteVotesMutation = { __typename?: 'Mutation', deleteVotes?: { __typename?: 'DeleteVotesPayload', success?: boolean | null } | null };

export type VotesTableQueryVariables = Exact<{
  ideaId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  orderAttr?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
}>;


export type VotesTableQuery = { __typename?: 'Query', idea: { __typename?: 'Idea', votes?: { __typename?: 'VoteConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'VoteEdge', node?: { __typename?: 'Vote', id: string, createdAt: any, subscriber: { __typename: 'Subscriber', id: string, initials: string, email: string, isProjectSubscriber: boolean } } | null }> | null } | null } };

export type UploadFieldImageFragment = { __typename?: 'Image', filename?: string | null, url?: string | null };

export type CheckAtlassianAccountQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type CheckAtlassianAccountQuery = { __typename?: 'Query', session: { __typename?: 'User', atlassianAccount?: { __typename?: 'AtlassianApp', id: string, siteUrl: string } | null } };

export type CheckHubspotInstallQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type CheckHubspotInstallQuery = { __typename?: 'Query', project: { __typename?: 'Project', projectApps?: { __typename?: 'ProjectAppConnection', nodes?: Array<{ __typename: 'AtlassianApp' } | { __typename: 'HubspotApp', id: string, accountId?: string | null, ready: boolean, sendEmailViaHubspot?: boolean | null } | { __typename: 'JiraApp' } | { __typename: 'SimpleMailApp' } | { __typename: 'SlackApp' } | { __typename: 'SlackCommandApp' } | { __typename: 'ZapierApp' } | null> | null } | null } };

export type CreateProjectSubscriptionMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  workItemId?: InputMaybe<Scalars['ID']['input']>;
  categories?: InputMaybe<Array<CategoryAttributes> | CategoryAttributes>;
}>;


export type CreateProjectSubscriptionMutation = { __typename?: 'Mutation', createProjectSubscription?: { __typename?: 'CreateProjectSubscriptionPayload', projectSubscription?: { __typename?: 'ProjectSubscription', id: string, createdAt: any, transportTypes: Array<string>, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string }>, subscriber: { __typename: 'Subscriber', email: string, confirmedAt?: any | null } } | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type CreateUserProjectSubscriptionMutationVariables = Exact<{
  input: CreateProjectSubscriptionInput;
}>;


export type CreateUserProjectSubscriptionMutation = { __typename?: 'Mutation', createProjectSubscription?: { __typename?: 'CreateProjectSubscriptionPayload', projectSubscription?: { __typename?: 'ProjectSubscription', id: string, categories: Array<{ __typename?: 'Category', id: string, name: string }> } | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type GetProjectSettingsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetProjectSettingsQuery = { __typename?: 'Query', project: { __typename?: 'Project', primaryColor: string, secondaryColor: string, primaryTextColor: string, secondaryTextColor: string, whiteColor: string, offWhiteColor: string, grayColor: string } };

export type UnsubscribeProjectSubscriptionMutationVariables = Exact<{
  input: UnsubscribeProjectSubscriptionInput;
}>;


export type UnsubscribeProjectSubscriptionMutation = { __typename?: 'Mutation', unsubscribeProjectSubscription?: { __typename?: 'UnsubscribeProjectSubscriptionPayload', projectSubscription?: { __typename?: 'ProjectSubscription', id: string } | null } | null };

export type GetCategoriesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetCategoriesQuery = { __typename?: 'Query', project: { __typename?: 'Project', categories?: { __typename?: 'CategoryConnection', edges?: Array<{ __typename?: 'CategoryEdge', node?: { __typename?: 'Category', id: string, name: string, color: string } | null }> | null } | null } };

export type GetApiDeckSessionMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetApiDeckSessionMutation = { __typename?: 'Mutation', getConsumerToken?: { __typename?: 'GetConsumerSessionPayload', token?: string | null, sessionUri?: string | null } | null };

export type GetCrmDataLastSyncQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetCrmDataLastSyncQuery = { __typename?: 'Query', project: { __typename?: 'Project', crmDataLastSync?: any | null, crmStageData: { __typename?: 'CrmStage', crmStageFilters: Array<string> } } };

export type GetJiraAppInstallsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetJiraAppInstallsQuery = { __typename?: 'Query', project: { __typename?: 'Project', projectApps?: { __typename?: 'ProjectAppConnection', nodes?: Array<{ __typename: 'AtlassianApp' } | { __typename: 'HubspotApp' } | { __typename: 'JiraApp', id: string, projects: Array<{ __typename?: 'JiraProject', url?: string | null, name?: string | null }> } | { __typename: 'SimpleMailApp' } | { __typename: 'SlackApp' } | { __typename: 'SlackCommandApp' } | { __typename: 'ZapierApp' } | null> | null } | null } };

export type GetVaultConnectionsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetVaultConnectionsQuery = { __typename?: 'Query', project: { __typename?: 'Project', vaultConnections: Array<string> } };

export type RemoveCrmIntegrationMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  unifiedApi: Scalars['String']['input'];
  serviceId: Scalars['ID']['input'];
}>;


export type RemoveCrmIntegrationMutation = { __typename?: 'Mutation', removeCrmIntegration?: { __typename?: 'RemoveCrmIntegrationPayload', valid?: boolean | null, serviceId?: string | null } | null };

export type SyncCrmCompaniesMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type SyncCrmCompaniesMutation = { __typename?: 'Mutation', syncCrmCompanies?: { __typename?: 'SyncCrmCompaniesPayload', projectId?: string | null, valid?: boolean | null } | null };

export type AuditLogIndexQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  eventTypeName?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuditLogIndexQuery = { __typename?: 'Query', project: { __typename?: 'Project', events: { __typename?: 'EventConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'EventEdge', node?: { __typename?: 'Event', id: string, createdAt: any, data?: any | null, userData: any, type: string, user?: { __typename?: 'Subscriber', id: string, initials: string, type: 'Subscriber', email: string } | { __typename?: 'User', id: string, name?: string | null, initials: string, type: 'User', email: string } | null, object?: { __typename?: 'Announcement', id: string, headline?: string | null, state?: AnnouncementStateEnum | null, type: 'Announcement' } | { __typename?: 'AnnouncementDigest' } | { __typename?: 'ConnectedSource' } | { __typename?: 'Feedback', id: string, affectedCustomerEmail: string, type: 'Feedback', feedbackable?: { __typename?: 'Announcement', id: string, type: 'Announcement' } | { __typename?: 'Idea', id: string, type: 'Idea' } | { __typename?: 'WorkItem', id: string, type: 'WorkItem' } | null } | { __typename?: 'Idea', id: string, name: string, type: 'Idea' } | { __typename?: 'Project', id: string, name: string, type: 'Project' } | { __typename?: 'ProjectSubscription' } | { __typename?: 'ProjectView' } | { __typename?: 'Stage', id: string, name: string, type: 'Stage' } | { __typename?: 'Subscriber' } | { __typename?: 'Template', id: string, type: 'Template', templateName?: string | null } | { __typename?: 'WorkItem', id: string, type: 'WorkItem', workItemName: string } | null } | null }> | null }, eventTypes: { __typename?: 'EventTypeConnection', edges?: Array<{ __typename?: 'EventTypeEdge', node?: { __typename?: 'EventType', name: string } | null }> | null } } };

export type CategoriesIndexQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type CategoriesIndexQuery = { __typename?: 'Query', project: { __typename?: 'Project', categories?: { __typename?: 'CategoryConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'CategoryEdge', node?: { __typename?: 'Category', id: string, position: number, name: string, slug: string, description?: string | null, color: string } | null }> | null } | null } };

export type CategoryQueryVariables = Exact<{
  categoryId: Scalars['ID']['input'];
}>;


export type CategoryQuery = { __typename?: 'Query', category?: { __typename?: 'Announcement' } | { __typename?: 'AnnouncementDigest' } | { __typename?: 'ApiToken' } | { __typename?: 'ApiUser' } | { __typename?: 'AtlassianApp' } | { __typename?: 'AttributeDefinition' } | { __typename?: 'AudienceDomain' } | { __typename?: 'Category', id: string, position: number, name: string, slug: string, description?: string | null, color: string } | { __typename?: 'ChangeType' } | { __typename?: 'Channel' } | { __typename?: 'Cohort' } | { __typename?: 'ConnectedSource' } | { __typename?: 'ContentGenerator' } | { __typename?: 'EmbedApp' } | { __typename?: 'Event' } | { __typename?: 'EventType' } | { __typename?: 'ExternalContentLink' } | { __typename?: 'Feedback' } | { __typename?: 'HubspotApp' } | { __typename?: 'Idea' } | { __typename?: 'IdeaVote' } | { __typename?: 'JiraApp' } | { __typename?: 'MailAppSetting' } | { __typename?: 'MarketplaceTemplate' } | { __typename?: 'Notification' } | { __typename?: 'OnboardingTasks' } | { __typename?: 'Organization' } | { __typename?: 'OutboundWebhook' } | { __typename?: 'OutboundWebhookEvent' } | { __typename?: 'Project' } | { __typename?: 'ProjectSubscription' } | { __typename?: 'ProjectView' } | { __typename?: 'RoadmapUpdate' } | { __typename?: 'Rollup' } | { __typename?: 'SecureConnectionSettings' } | { __typename?: 'SimpleMailApp' } | { __typename?: 'SimpleMailTransport' } | { __typename?: 'SlackApp' } | { __typename?: 'SlackAppTransport' } | { __typename?: 'SlackCommandApp' } | { __typename?: 'Stage' } | { __typename?: 'Subscriber' } | { __typename?: 'Subscription' } | { __typename?: 'Template' } | { __typename?: 'User' } | { __typename?: 'VideoAsset' } | { __typename?: 'Vote' } | { __typename?: 'WorkItem' } | { __typename?: 'Workspace' } | { __typename?: 'ZapierApp' } | null };

export type ChangeTypesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ChangeTypesQuery = { __typename?: 'Query', project: { __typename?: 'Project', changeTypes?: { __typename?: 'ChangeTypeConnection', nodes?: Array<{ __typename?: 'ChangeType', id: string, name: string, color: string } | null> | null } | null } };

export type ChangeTypesIndexQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangeTypesIndexQuery = { __typename?: 'Query', project: { __typename?: 'Project', changeTypes?: { __typename?: 'ChangeTypeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'ChangeTypeEdge', node?: { __typename?: 'ChangeType', id: string, name: string, color: string, apiSlug: string } | null }> | null } | null } };

export type CreateCategoryMutationVariables = Exact<{
  category: CreateCategoryAttributes;
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', createCategory?: { __typename?: 'CreateCategoryPayload', category?: { __typename?: 'Category', id: string, name: string, description?: string | null, slug: string, color: string, position: number } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type CreateChangeTypeMutationVariables = Exact<{
  input: CreateChangeInput;
}>;


export type CreateChangeTypeMutation = { __typename?: 'Mutation', createChangeType?: { __typename?: 'CreateChangePayload', changeType?: { __typename?: 'ChangeType', id: string } | null, errors: Array<{ __typename?: 'UserError', message: string }> } | null };

export type RemoveCategoryMutationVariables = Exact<{
  categoryId: Scalars['ID']['input'];
}>;


export type RemoveCategoryMutation = { __typename?: 'Mutation', removeCategory?: { __typename?: 'RemoveCategoryPayload', category?: { __typename?: 'Category', id: string, name: string, description?: string | null } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type RemoveChangeTypeMutationVariables = Exact<{
  input: RemoveChangeInput;
}>;


export type RemoveChangeTypeMutation = { __typename?: 'Mutation', removeChangeType?: { __typename?: 'RemoveChangePayload', changeType?: { __typename?: 'ChangeType', id: string } | null } | null };

export type ReorderCategoryMutationVariables = Exact<{
  input: ReorderCategoryInput;
}>;


export type ReorderCategoryMutation = { __typename?: 'Mutation', reorderCategory?: { __typename?: 'ReorderCategoryPayload', categories?: Array<{ __typename?: 'Category', id: string, position: number }> | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type UpdateCategoryMutationVariables = Exact<{
  input: UpdateCategoryInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory?: { __typename?: 'UpdateCategoryPayload', category?: { __typename?: 'Category', id: string, name: string, slug: string, position: number, color: string, description?: string | null } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type UpdateChangeTypeMutationVariables = Exact<{
  input: UpdateChangeInput;
}>;


export type UpdateChangeTypeMutation = { __typename?: 'Mutation', updateChangeType?: { __typename?: 'UpdateChangePayload', changeType?: { __typename?: 'ChangeType', id: string, name: string, color: string } | null, errors: Array<{ __typename?: 'UserError', message: string }> } | null };

export type EmailBrandSettingsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type EmailBrandSettingsQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, publicPageUrl: string, hideNotificationContent: boolean, defaultNotificationSetting: boolean, autosubscribeNewUsers: boolean, emailSettings: { __typename?: 'MailAppSetting', id: string, customLayout?: string | null, primaryColor?: string | null, logoHeight?: string | null, headingColor?: string | null, superscriptColor?: string | null, textColor?: string | null, digestTextColor?: string | null, digestBackgroundColor?: string | null, bodyBackgroundColor?: string | null, containerBackgroundColor?: string | null, fontFamily?: string | null, announcementButtonCta?: string | null, subscriberConfirmButtonCta?: string | null, categoriesEnabled?: boolean | null, notificationsExcerptOnly: boolean, logo?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } } };

export type EspSettingsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type EspSettingsQuery = { __typename?: 'Query', project: { __typename?: 'Project', publicPageUrl: string, emailSettings: { __typename?: 'MailAppSetting', id: string, activeEsp?: string | null, senderName?: string | null, replyToEmail?: string | null, apiKey?: string | null, domain?: string | null, euDomain: boolean, smtpUser?: string | null, smtpPassword?: string | null, smtpHost?: string | null, smtpSecure?: boolean | null, smtpPort?: string | null } } };

export type NotificationSecuritySettingsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type NotificationSecuritySettingsQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, hideNotificationContent: boolean, defaultNotificationSetting: boolean, autosubscribeNewUsers: boolean } };

export type RemoveEmailLogoMutationVariables = Exact<{
  input: RemoveEmailLogoInput;
}>;


export type RemoveEmailLogoMutation = { __typename?: 'Mutation', removeEmailLogo?: { __typename?: 'RemoveEmailLogoPayload', mailAppSetting?: { __typename?: 'MailAppSetting', id: string, logo?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null } | null };

export type TriggerTestEmailMutationVariables = Exact<{
  input: TriggerTestEmailInput;
}>;


export type TriggerTestEmailMutation = { __typename?: 'Mutation', triggerTestEmail?: { __typename?: 'TriggerTestEmailPayload', errors: string } | null };

export type UpdateMailAppSettingsMutationVariables = Exact<{
  input: UpdateMailAppSettingsInput;
}>;


export type UpdateMailAppSettingsMutation = { __typename?: 'Mutation', updateMailAppSettings?: { __typename?: 'UpdateMailAppSettingsPayload', mailAppSetting?: { __typename?: 'MailAppSetting', id: string, primaryColor?: string | null, logoHeight?: string | null, headingColor?: string | null, superscriptColor?: string | null, textColor?: string | null, digestTextColor?: string | null, digestBackgroundColor?: string | null, bodyBackgroundColor?: string | null, containerBackgroundColor?: string | null, fontFamily?: string | null, categoriesEnabled?: boolean | null, announcementButtonCta?: string | null, subscriberConfirmButtonCta?: string | null, activeEsp?: string | null, senderName?: string | null, replyToEmail?: string | null, apiKey?: string | null, domain?: string | null, smtpUser?: string | null, smtpPassword?: string | null, smtpHost?: string | null, smtpSecure?: boolean | null, smtpPort?: string | null, notificationsExcerptOnly: boolean, logo?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null, errors: Array<{ __typename?: 'UserError', message: string }> } | null };

export type ApiTokenFormQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ApiTokenFormQuery = { __typename?: 'Query', project: { __typename?: 'Project', apiToken?: { __typename?: 'ApiToken', id: string, name?: string | null } | null } };

export type ApiTokenIndexQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ApiTokenIndexQuery = { __typename?: 'Query', project: { __typename?: 'Project', apiTokens?: { __typename?: 'ApiTokenConnection', nodes?: Array<{ __typename?: 'ApiToken', id: string, name?: string | null, token: string, type: string } | null> | null } | null } };

export type CreateApiTokenMutationVariables = Exact<{
  apiToken: CreateApiTokenAttributes;
}>;


export type CreateApiTokenMutation = { __typename?: 'Mutation', createApiToken?: { __typename?: 'CreateApiTokenPayload', errors: Array<string>, apiToken?: { __typename?: 'ApiToken', id: string, name?: string | null, token: string, type: string } | null } | null };

export type CreateEmbedAppMutationVariables = Exact<{
  title: Scalars['String']['input'];
  subtitle: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type CreateEmbedAppMutation = { __typename?: 'Mutation', createEmbedApp?: { __typename?: 'CreateEmbedAppPayload', app: { __typename?: 'EmbedApp', id: string, name: string, subtitle: string, token: string } } | null };

export type FetchEmbedAppsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FetchEmbedAppsQuery = { __typename?: 'Query', project: { __typename?: 'Project', secured: boolean, embedApps: Array<{ __typename?: 'EmbedApp', id: string, name: string, subtitle: string, token: string, enforceToken: boolean }> } };

export type RegenerateEmbedTokenMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RegenerateEmbedTokenMutation = { __typename?: 'Mutation', regenerateEmbedAppToken?: { __typename?: 'RegenerateTokenPayload', token: string, success: boolean } | null };

export type RemoveApiTokenMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveApiTokenMutation = { __typename?: 'Mutation', removeApiToken?: { __typename?: 'RemoveApiTokenPayload', errors?: Array<string> | null } | null };

export type RssFeedSettingsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type RssFeedSettingsQuery = { __typename?: 'Query', project: { __typename?: 'Project', rssFeedEnabled?: boolean | null, rssFeedPrivate?: boolean | null, rssFeedUrl: string, rssSecretKey?: string | null } };

export type ToggleEnforceEmbedTokenMutationVariables = Exact<{
  embedId: Scalars['ID']['input'];
  enforceToken: Scalars['Boolean']['input'];
}>;


export type ToggleEnforceEmbedTokenMutation = { __typename?: 'Mutation', toggleEnforceEmbedToken?: { __typename?: 'ToggleEnforceEmbedTokenPayload', success: boolean } | null };

export type UpdateEmbedAppMutationVariables = Exact<{
  title: Scalars['String']['input'];
  subtitle: Scalars['String']['input'];
  embedAppId: Scalars['ID']['input'];
}>;


export type UpdateEmbedAppMutation = { __typename?: 'Mutation', updateEmbedApp?: { __typename?: 'UpdateEmbedAppPayload', success: boolean } | null };

export type FeedbackSettingsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type FeedbackSettingsQuery = { __typename?: 'Query', project: { __typename?: 'Project', feedbackEnabled: boolean, feedbackForwardEmails: Array<string>, ideasEnabled: boolean, ideasName: string, votingEnabled: boolean, voteCountDisplay: string, ideasDisclaimer?: string | null, ideasDisclaimerEnabled: boolean, attributeDefinitions: { __typename?: 'AttributeDefinitionConnection', edges?: Array<{ __typename?: 'AttributeDefinitionEdge', node?: { __typename?: 'AttributeDefinition', id: string, key: string, name: string, description?: string | null, valueType?: Value | null } | null }> | null } } };

export type AttributeValueTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AttributeValueTypesQuery = { __typename?: 'Query', __type?: { __typename?: '__Type', name?: string | null, enumValues?: Array<{ __typename?: '__EnumValue', name: string }> | null } | null };

export type CreateFeedbackAttributeDefinitionMutationVariables = Exact<{
  project: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  valueType: Value;
}>;


export type CreateFeedbackAttributeDefinitionMutation = { __typename?: 'Mutation', createAttributeDefinition?: { __typename?: 'CreateAttributeDefinitionPayload', attributeDefinition?: { __typename?: 'AttributeDefinition', id: string, name: string, key: string } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type DeleteAttributeDefinitionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAttributeDefinitionMutation = { __typename?: 'Mutation', deleteAttributeDefinition?: { __typename?: 'DeleteAttributeDefinitionPayload', attributeDefinition?: { __typename?: 'AttributeDefinition', id: string } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type HubspotSettingsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type HubspotSettingsQuery = { __typename?: 'Query', project: { __typename?: 'Project', projectApps?: { __typename?: 'ProjectAppConnection', nodes?: Array<{ __typename: 'AtlassianApp' } | { __typename: 'HubspotApp', id: string, accountId?: string | null, name: string, description: string, sendEmailViaHubspot?: boolean | null, emailTemplateId?: string | null, emailTemplateName?: string | null, replyToEmail?: string | null, customReplyToEmail?: string | null, emailSubscriptionId?: string | null, ready: boolean, markedForDeletion: boolean, syncing: boolean, emailSubscriptions?: Array<{ __typename?: 'HubspotEmailSubscription', id?: string | null, name?: string | null }> | null, templates?: Array<{ __typename?: 'HubspotTemplate', id: string, label: string }> | null } | { __typename: 'JiraApp' } | { __typename: 'SimpleMailApp' } | { __typename: 'SlackApp' } | { __typename: 'SlackCommandApp' } | { __typename: 'ZapierApp' } | null> | null } | null } };

export type SendHubspotTestEmailMutationVariables = Exact<{
  input: SendTestEmailInput;
}>;


export type SendHubspotTestEmailMutation = { __typename?: 'Mutation', sendTestEmail?: { __typename?: 'SendTestEmailPayload', errors?: Array<string> | null, success?: boolean | null } | null };

export type SetHubspotEmailSubscriptionMutationVariables = Exact<{
  input: SetEmailSubscriptionInput;
}>;


export type SetHubspotEmailSubscriptionMutation = { __typename?: 'Mutation', setEmailSubscription?: { __typename?: 'SetEmailSubscriptionPayload', errors?: string | null, emailSubscriptionId?: string | null } | null };

export type SetHubspotEmailSettingsMutationVariables = Exact<{
  input: SetEmailSettingsInput;
}>;


export type SetHubspotEmailSettingsMutation = { __typename?: 'Mutation', setEmailSettings?: { __typename?: 'SetEmailSettingsPayload', app?: { __typename?: 'HubspotApp', sendEmailViaHubspot?: boolean | null, emailTemplateId?: string | null, emailTemplateName?: string | null, replyToEmail?: string | null } | null, validation?: { __typename?: 'HubspotSettingsValidationObject', templateId: string, templateName: string, errors?: Array<string> | null } | null } | null };

export type ValidateHubspotTemplatesMutationVariables = Exact<{
  input: ValidateHubspotTemplatesInput;
}>;


export type ValidateHubspotTemplatesMutation = { __typename?: 'Mutation', validateHubspotTemplates?: { __typename?: 'ValidateHubspotTemplatesPayload', errors?: string | null, response?: { __typename?: 'HubspotTemplateValidationObject', templateId: string, templateName: string, errors?: Array<string> | null } | null } | null };

export type AllowedDomainsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type AllowedDomainsQuery = { __typename?: 'Query', project: { __typename?: 'Project', allowedDomains: Array<string> } };

export type InviteProjectUserMutationVariables = Exact<{
  input: InviteProjectUserInput;
}>;


export type InviteProjectUserMutation = { __typename?: 'Mutation', inviteProjectUser?: { __typename?: 'InviteProjectUserPayload', projectUser?: { __typename?: 'User', id: string, email: string, greatestPermission: string, status: string } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type RemoveProjectUserMutationVariables = Exact<{
  input: RemoveProjectUserInput;
}>;


export type RemoveProjectUserMutation = { __typename?: 'Mutation', removeProjectUser?: { __typename?: 'RemoveProjectUserPayload', project?: { __typename?: 'Project', id: string } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type TableProjectUsersQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type TableProjectUsersQuery = { __typename?: 'Query', project: { __typename?: 'Project', maxTeamMembers: number, projectUsers?: { __typename?: 'UserConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'UserEdge', node?: { __typename?: 'User', id: string, email: string, initials: string, name?: string | null, displayName: string, avatarColor: string, greatestPermission: string, permissions: Array<string>, status: string, avatarImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null }> | null } | null } };

export type UpdateProjectRoleMutationVariables = Exact<{
  userID: Scalars['ID']['input'];
  projectID: Scalars['ID']['input'];
  role: ProjectRoleEnum;
}>;


export type UpdateProjectRoleMutation = { __typename?: 'Mutation', updateProjectUserRole?: { __typename?: 'UpdateProjectUserRolePayload', errors: Array<{ __typename?: 'UserError', message: string }> } | null };

export type RoadmapSettingsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type RoadmapSettingsQuery = { __typename?: 'Query', project: { __typename?: 'Project', roadmapName: string, roadmapEnabled: boolean, roadmapDisclaimerEnabled: boolean, roadmapDisclaimer?: string | null, defaultWorkItemsDisplayTimeline: boolean, publicPageUrl: string, roadmapMoveUpdatesEnabled: boolean, roadmapWatchedStages: Array<string>, publicStageDescriptionsEnabled: boolean, stages?: { __typename?: 'StageConnection', nodes?: Array<{ __typename?: 'Stage', id: string, name: string, description?: string | null, position: number, published?: boolean | null, archiveAfterDays?: number | null } | null> | null } | null } };

export type TogglePublicStageDescriptionsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type TogglePublicStageDescriptionsMutation = { __typename?: 'Mutation', togglePublicStageDescriptions?: { __typename?: 'TogglePublicStageDescriptionsPayload', success?: boolean | null } | null };

export type ArchiveStageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveStageMutation = { __typename?: 'Mutation', archiveStage?: { __typename?: 'ArchiveStagePayload', stage?: { __typename?: 'Stage', id: string } | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type CreateStageMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['ID']['input'];
  archiveAfterDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateStageMutation = { __typename?: 'Mutation', createStage?: { __typename?: 'CreateStagePayload', stage?: { __typename?: 'Stage', id: string, name: string, description?: string | null, published?: boolean | null, archiveAfterDays?: number | null } | null } | null };

export type ReorderStageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
}>;


export type ReorderStageMutation = { __typename?: 'Mutation', reorderStage?: { __typename?: 'ReorderStagePayload', stages?: Array<{ __typename?: 'Stage', id: string, name: string, description?: string | null, position: number }> | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type UpdateStageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  archiveAfterDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateStageMutation = { __typename?: 'Mutation', updateStage?: { __typename?: 'UpdateStagePayload', stage?: { __typename?: 'Stage', id: string, name: string, description?: string | null, published?: boolean | null, archiveAfterDays?: number | null } | null } | null };

export type CreateSecureConnectionMutationVariables = Exact<{
  input: CreateSecureConnectionInput;
}>;


export type CreateSecureConnectionMutation = { __typename?: 'Mutation', createSecureConnection?: { __typename?: 'CreateSecureConnectionPayload', errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type RemoveSecureConnectionMutationVariables = Exact<{
  input: RemoveSecureConnectionInput;
}>;


export type RemoveSecureConnectionMutation = { __typename?: 'Mutation', removeSecureConnection?: { __typename?: 'RemoveSecureConnectionPayload', errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type AddSlackChannelsMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  channelNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  categoryIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddSlackChannelsMutation = { __typename?: 'Mutation', createSlackChannels?: { __typename?: 'AddSlackChannelsPayload', success: boolean, missingChannels: Array<string> } | null };

export type DeleteSlackChannelMutationVariables = Exact<{
  channelId: Scalars['ID']['input'];
}>;


export type DeleteSlackChannelMutation = { __typename?: 'Mutation', deleteSlackChannel?: { __typename?: 'DeleteSlackChannelPayload', success: boolean } | null };

export type FetchAddChannelDataQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type FetchAddChannelDataQuery = { __typename?: 'Query', project: { __typename?: 'Project', categories?: { __typename?: 'CategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name: string } | null> | null } | null, slackWorkspaces: Array<{ __typename?: 'Workspace', id: string, name: string, createdAt: any }> } };

export type FetchChannelsForProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type FetchChannelsForProjectQuery = { __typename?: 'Query', project: { __typename?: 'Project', slackWorkspaces: Array<{ __typename?: 'Workspace', id: string, name: string, channels?: Array<{ __typename?: 'Channel', id: string, name: string, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, color: string }> }> | null }> } };

export type ViewSettingsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ViewSettingsQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, slug: string, publicPageUrl: string, privacyPolicyUrl?: string | null, termsAndConditionsUrl?: string | null, roadmapName: string, roadmapDisclaimer?: string | null, ideasName: string, ideasDisclaimer?: string | null, author?: string | null, showToc: boolean } };

export type AdminIndexQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type AdminIndexQuery = { __typename?: 'Query', project: { __typename?: 'Project', secured: boolean } };

export type CustomHtmlcssQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type CustomHtmlcssQuery = { __typename?: 'Query', project: { __typename?: 'Project', publicPageUrl: string, customCss?: string | null, customHead?: string | null, customHeader?: string | null, customFooter?: string | null, customIndexHero?: string | null } };

export type GeneralSettingsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GeneralSettingsQuery = { __typename?: 'Query', project: { __typename?: 'Project', publicPageUrl: string, id: string, name: string, published: boolean, slug: string, heading?: string | null, subheading?: string | null, privacyPolicyUrl?: string | null, termsAndConditionsUrl?: string | null, author?: string | null, showToc: boolean, fiscalYearOffset: number, announcementsName: string } };

export type LookAndFeelQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type LookAndFeelQuery = { __typename?: 'Query', project: { __typename?: 'Project', publicPageUrl: string, density: string, colorTheme: string, primaryColor: string, secondaryColor: string, primaryTextColor: string, secondaryTextColor: string, whiteColor: string, offWhiteColor: string, lightGrayColor: string, grayColor: string, logo?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, favicon?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, emptyFieldImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } };

export type RemoveProjectEmptyFieldImageMutationVariables = Exact<{
  projectID: Scalars['ID']['input'];
}>;


export type RemoveProjectEmptyFieldImageMutation = { __typename?: 'Mutation', removeProjectEmptyFieldImage?: { __typename?: 'RemoveEmptyFieldImagePayload', project?: { __typename?: 'Project', id: string, emptyFieldImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null } | null };

export type RemoveProjectFaviconMutationVariables = Exact<{
  projectID: Scalars['ID']['input'];
}>;


export type RemoveProjectFaviconMutation = { __typename?: 'Mutation', removeProjectFavicon?: { __typename?: 'RemoveFaviconPayload', project?: { __typename?: 'Project', id: string, favicon?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null } | null };

export type RemoveProjectLogoMutationVariables = Exact<{
  projectID: Scalars['ID']['input'];
}>;


export type RemoveProjectLogoMutation = { __typename?: 'Mutation', removeProjectLogo?: { __typename?: 'RemoveLogoPayload', project?: { __typename?: 'Project', id: string, logo?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null } | null };

export type RemoveProjectShareImageMutationVariables = Exact<{
  projectID: Scalars['ID']['input'];
}>;


export type RemoveProjectShareImageMutation = { __typename?: 'Mutation', removeProjectShareImage?: { __typename?: 'RemoveShareImagePayload', project?: { __typename?: 'Project', id: string, shareImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null } | null };

export type SharingAndSearchQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type SharingAndSearchQuery = { __typename?: 'Query', viewer: { __typename?: 'ApiUser', project: { __typename?: 'Project', title?: string | null, description?: string | null, noindex: boolean, twitterUsername?: string | null, shareImageAltText?: string | null, publicPageUrl: string, shareImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } } };

export type UpdateProjectMutationVariables = Exact<{
  input: UpdateProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject?: { __typename?: 'UpdateProjectPayload', project?: { __typename?: 'Project', id: string, hideNotificationContent: boolean, defaultNotificationSetting: boolean, autosubscribeNewUsers: boolean, showToc: boolean, feedbackEnabled: boolean, feedbackForwardEmails: Array<string>, allowedDomains: Array<string>, ideasEnabled: boolean, ideasName: string, votingEnabled: boolean, publicPageUrl: string, name: string, published: boolean, slug: string, heading?: string | null, subheading?: string | null, density: string, colorTheme: string, primaryColor: string, secondaryColor: string, primaryTextColor: string, secondaryTextColor: string, whiteColor: string, offWhiteColor: string, lightGrayColor: string, grayColor: string, customCss?: string | null, customHead?: string | null, customHeader?: string | null, customFooter?: string | null, customIndexHero?: string | null, title?: string | null, description?: string | null, noindex: boolean, author?: string | null, twitterUsername?: string | null, shareImageAltText?: string | null, roadmapName: string, roadmapEnabled: boolean, roadmapDisclaimer?: string | null, roadmapDisclaimerEnabled: boolean, logo?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, favicon?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, emptyFieldImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, shareImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, stages?: { __typename?: 'StageConnection', edges?: Array<{ __typename?: 'StageEdge', node?: { __typename?: 'Stage', id: string, name: string, description?: string | null, position: number, published?: boolean | null, publishedAt?: any | null } | null }> | null } | null } | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type AnnouncementAnalyticsQueryVariables = Exact<{
  announcementId: Scalars['ID']['input'];
  tzOffset: Scalars['Int']['input'];
}>;


export type AnnouncementAnalyticsQuery = { __typename?: 'Query', announcement: { __typename?: 'Announcement', publishedAt?: any | null, shouldNotifyPageSubscribers?: boolean | null, totalSubscriberCounts: number, feedbackHappyCount: number, feedbackMehCount: number, feedbackSadCount: number, slackChannelCount: number, slackChannelClickedCount: number, slackSubscriberClickedCount: number, slackNotificationsCount: number, emailNotificationsCount: number, viewerAnalytics?: { __typename?: 'ViewerAnalyticsObject', totalUniqueAnonymousCount: number, totalUniqueSubscribersCount: number, totalUniqueEmbeddedCount: number, uniqueVisitors: Array<{ __typename?: 'ViewerChartData', date: any, uniqueAnonymousVisitors?: number | null, uniqueSubscribedVisitors?: number | null, uniqueEmbeddedVisitors?: number | null }> } | null, emailAnalytics?: { __typename?: 'EmailAnalyticsObject', sentCount: number, openRate: number, clickRate: number, clickToOpenRate: number, chartData: Array<{ __typename?: 'BarChartData', date: any, sent?: number | null, opened?: number | null, clicked?: number | null }> } | null, feedbacks?: { __typename?: 'FeedbackConnection', totalCount: number } | null } };

export type AnnouncementEmailAnalyticsQueryVariables = Exact<{
  announcementId: Scalars['ID']['input'];
  tzOffset: Scalars['Int']['input'];
}>;


export type AnnouncementEmailAnalyticsQuery = { __typename?: 'Query', announcement: { __typename?: 'Announcement', emailAnalytics?: { __typename?: 'EmailAnalyticsObject', sentCount: number, openRate: number, clickRate: number } | null } };

export type GenerateBernieAnnouncementMutationVariables = Exact<{
  content: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type GenerateBernieAnnouncementMutation = { __typename?: 'Mutation', generateBernieAnnouncement?: { __typename?: 'GenerateBernieAnnouncementPayload', success: boolean, announcementId?: string | null } | null };

export type GenerateLoomAnnouncementMutationVariables = Exact<{
  videoUrl: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  heightRatio: Scalars['String']['input'];
  thumbnailUrl: Scalars['String']['input'];
}>;


export type GenerateLoomAnnouncementMutation = { __typename?: 'Mutation', generateLoomAnnouncement?: { __typename?: 'GenerateLoomAnnouncementPayload', success: boolean, announcementId?: string | null } | null };

export type AnnouncementsByStateQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  state: AnnouncementStateEnum;
  count: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OrderBy>;
}>;


export type AnnouncementsByStateQuery = { __typename?: 'Query', viewer: { __typename?: 'ApiUser', project: { __typename?: 'Project', id: string, announcements?: { __typename?: 'AnnouncementConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'AnnouncementEdge', node?: { __typename?: 'Announcement', id: string, state?: AnnouncementStateEnum | null, headline?: string | null, content?: string | null, updatedAt: any, scheduledAt?: any | null, scheduledAtTimezone?: string | null, publishedAt?: any | null, deactivatedAt?: any | null, shouldNotifyPageSubscribers?: boolean | null, excerptWithFallback?: string | null, inPublishedDigest: boolean, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }>, changeTypes: { __typename?: 'ChangeTypeConnection', nodes?: Array<{ __typename?: 'ChangeType', id: string, name: string } | null> | null } } | null }> | null } | null } } };

export type AnnouncementDashboardQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type AnnouncementDashboardQuery = { __typename?: 'Query', viewer: { __typename?: 'ApiUser', project: { __typename?: 'Project', id: string, announcements?: { __typename?: 'AnnouncementConnection', totalCount: number } | null, draftAnnouncements?: { __typename?: 'AnnouncementConnection', totalCount: number } | null, scheduledAnnouncements?: { __typename?: 'AnnouncementConnection', totalCount: number } | null, publishedAnnouncements?: { __typename?: 'AnnouncementConnection', totalCount: number } | null, archivedAnnouncements?: { __typename?: 'AnnouncementConnection', totalCount: number } | null, templates: { __typename?: 'TemplateConnection', edges?: Array<{ __typename?: 'TemplateEdge', node?: { __typename?: 'Template', id: string, name?: string | null, description?: string | null } | null }> | null } } } };

export type Card_AnnouncementFragment = { __typename?: 'Announcement', id: string, state?: AnnouncementStateEnum | null, headline?: string | null, content?: string | null, excerptWithFallback?: string | null, updatedAt: any, scheduledAt?: any | null, scheduledAtTimezone?: string | null, publishedAt?: any | null, deactivatedAt?: any | null, shouldNotifyPageSubscribers?: boolean | null, inPublishedDigest: boolean };

export type ArchiveDigestMutationVariables = Exact<{
  digestId: Scalars['ID']['input'];
}>;


export type ArchiveDigestMutation = { __typename?: 'Mutation', archiveDigest?: { __typename?: 'ArchiveDigestPayload', success: boolean } | null };

export type CreateDigestMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateDigestMutation = { __typename?: 'Mutation', createDigest?: { __typename?: 'CreateDigestPayload', announcementDigest?: { __typename?: 'AnnouncementDigest', id: string } | null } | null };

export type DuplicateDigestMutationVariables = Exact<{
  digestId: Scalars['ID']['input'];
}>;


export type DuplicateDigestMutation = { __typename?: 'Mutation', duplicateDigest?: { __typename?: 'DuplicateDigestPayload', announcementDigest?: { __typename?: 'AnnouncementDigest', id: string } | null } | null };

export type FetchDigestQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FetchDigestQuery = { __typename?: 'Query', announcementDigest: { __typename?: 'AnnouncementDigest', id: string, title?: string | null, content?: string | null, subjectLine?: string | null, state?: AnnouncementDigestStateEnum | null, publishedAt?: any | null, deactivatedAt?: any | null, sendToAll: boolean, order: Array<string>, emailSubscriberCount: number, slackSubscriberCount: number, slackChannelCount: number, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }>, labels: Array<{ __typename?: 'ChangeType', id: string, name: string }>, announcements?: { __typename?: 'AnnouncementConnection', nodes?: Array<{ __typename?: 'Announcement', id: string, headline?: string | null, publicPermalink: string, excerptWithFallback?: string | null, videoAsset?: { __typename?: 'VideoAsset', embedType: string, videoUrl: string, thumbnailUrl?: string | null, heightRatio?: string | null } | null, heroImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null> | null } | null } };

export type FetchDigestWithAnalyticsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FetchDigestWithAnalyticsQuery = { __typename?: 'Query', announcementDigest: { __typename?: 'AnnouncementDigest', id: string, title?: string | null, content?: string | null, subjectLine?: string | null, state?: AnnouncementDigestStateEnum | null, publishedAt?: any | null, deactivatedAt?: any | null, order: Array<string>, emailSubscriberCount: number, emailSentCount: number, emailOpenedCount: number, emailClickedThroughCount: number, slackSubscriberCount: number, slackSubscriberSentCount: number, slackSubscriberClickedThroughCount: number, slackChannelCount: number, slackChannelSentCount: number, slackChannelClickedThroughCount: number, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }>, labels: Array<{ __typename?: 'ChangeType', id: string, name: string }>, announcements?: { __typename?: 'AnnouncementConnection', nodes?: Array<{ __typename?: 'Announcement', id: string, headline?: string | null, publicPermalink: string, excerptWithFallback?: string | null, videoAsset?: { __typename?: 'VideoAsset', embedType: string, videoUrl: string, thumbnailUrl?: string | null, heightRatio?: string | null } | null, heroImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null> | null } | null } };

export type FetchDigestsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  state: AnnouncementDigestStateEnum;
}>;


export type FetchDigestsQuery = { __typename?: 'Query', project: { __typename?: 'Project', announcementDigests: { __typename?: 'AnnouncementDigestConnection', nodes?: Array<{ __typename?: 'AnnouncementDigest', id: string, title?: string | null, publishedAt?: any | null, deactivatedAt?: any | null, updatedAt: any, contentPlainText?: string | null, state?: AnnouncementDigestStateEnum | null, subjectLine?: string | null, announcements?: { __typename?: 'AnnouncementConnection', nodes?: Array<{ __typename?: 'Announcement', id: string, headline?: string | null, excerptWithFallback?: string | null } | null> | null } | null, categories: Array<{ __typename?: 'Category', name: string, color: string }> } | null> | null } } };

export type PublishDigestMutationVariables = Exact<{
  digestId: Scalars['ID']['input'];
}>;


export type PublishDigestMutation = { __typename?: 'Mutation', publishDigest?: { __typename?: 'PublishDigestPayload', success: boolean } | null };

export type SearchAnnouncementsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  count: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchAnnouncementsQuery = { __typename?: 'Query', project: { __typename?: 'Project', announcements?: { __typename?: 'AnnouncementConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Announcement', id: string, headline?: string | null, excerptWithFallback?: string | null, publishedAt?: any | null, shouldNotifyPageSubscribers?: boolean | null, inPublishedDigest: boolean, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }>, changeTypes: { __typename?: 'ChangeTypeConnection', nodes?: Array<{ __typename?: 'ChangeType', id: string, name: string, color: string } | null> | null } } | null> | null } | null } };

export type ToggleSendToAllMutationVariables = Exact<{
  digestId: Scalars['ID']['input'];
  sendToAll: Scalars['Boolean']['input'];
}>;


export type ToggleSendToAllMutation = { __typename?: 'Mutation', toggleSendToAll?: { __typename?: 'ToggleSendToAllPayload', success: boolean } | null };

export type UpdateDigestMutationVariables = Exact<{
  digestId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  announcements?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  order?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  subjectLine?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDigestMutation = { __typename?: 'Mutation', updateDigest?: { __typename?: 'UpdateDigestPayload', success: boolean } | null };

export type EditorAnnouncementQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  announcementId: Scalars['ID']['input'];
}>;


export type EditorAnnouncementQuery = { __typename?: 'Query', project: { __typename?: 'Project', author?: string | null, id: string, publicPageUrl: string, slackAuthenticationUrl: string, totalConfirmedSubscriptions: number, slackSubscription?: { __typename?: 'Subscription', id: string } | null, slackProjectSubscription?: { __typename?: 'ProjectSubscription', id: string } | null, emailSettings: { __typename?: 'MailAppSetting', primaryColor?: string | null, replyToEmail?: string | null }, categories?: { __typename?: 'CategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string } | null> | null } | null }, announcement: { __typename?: 'Announcement', scheduledAt?: any | null, scheduledAtTimezone?: string | null, archived: boolean, id: string, name: string, shouldNotifyPageSubscribers?: boolean | null, notificationsExcerptOnly?: boolean | null, headline?: string | null, subjectLine?: string | null, slackMessage?: string | null, totalSubscriberCounts: number, slackChannelCounts: number, state?: AnnouncementStateEnum | null, slug?: string | null, publicPermalink: string, content?: string | null, contentType: string, excerpt?: string | null, excerptWithFallback?: string | null, publishedAt?: any | null, title?: string | null, titleWithFallback?: string | null, description?: string | null, descriptionWithFallback?: string | null, author?: string | null, authorWithFallback?: string | null, doNotIndex?: boolean | null, emailSubscriberCounts: number, slackSubscriberCounts: number, slackSubscriberCount: number, emailSubscriberCount: number, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string }>, workItems?: { __typename?: 'WorkItemConnection', nodes?: Array<{ __typename?: 'WorkItem', id: string, name: string } | null> | null, edges?: Array<{ __typename?: 'WorkItemEdge', node?: { __typename?: 'WorkItem', id: string, name: string } | null }> | null } | null, heroImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, changeTypes: { __typename?: 'ChangeTypeConnection', nodes?: Array<{ __typename?: 'ChangeType', id: string, name: string } | null> | null }, shareImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, connectedSources?: { __typename?: 'ConnectedSourceConnection', nodes?: Array<{ __typename?: 'ConnectedSource', id: string, url: string, name?: string | null, providerName: string } | null> | null } | null } };

export type AnnouncementExcerptQueryVariables = Exact<{
  announcementId: Scalars['ID']['input'];
}>;


export type AnnouncementExcerptQuery = { __typename?: 'Query', announcement: { __typename?: 'Announcement', excerpt?: string | null, excerptWithFallback?: string | null, state?: AnnouncementStateEnum | null } };

export type TemplateExcerptQueryVariables = Exact<{
  templateId: Scalars['ID']['input'];
}>;


export type TemplateExcerptQuery = { __typename?: 'Query', template: { __typename?: 'Template', excerpt?: string | null, excerptWithFallback?: string | null } };

export type PublishAnnouncementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PublishAnnouncementMutation = { __typename?: 'Mutation', publishAnnouncement?: { __typename?: 'PublishAnnouncementPayload', announcement?: { __typename?: 'Announcement', id: string, state?: AnnouncementStateEnum | null, publishedAt?: any | null } | null } | null };

export type ScheduleAnnouncementV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  scheduledAt: Scalars['String']['input'];
  scheduledAtTimezone: Scalars['String']['input'];
}>;


export type ScheduleAnnouncementV2Mutation = { __typename?: 'Mutation', scheduleAnnouncement?: { __typename?: 'ScheduleAnnouncementPayload', announcement?: { __typename?: 'Announcement', id: string, state?: AnnouncementStateEnum | null, scheduledAt?: any | null, scheduledAtTimezone?: string | null } | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type SendPreviewSlackMutationVariables = Exact<{
  input: PreviewAnnouncementSlackInput;
}>;


export type SendPreviewSlackMutation = { __typename?: 'Mutation', previewAnnouncementSlack?: { __typename?: 'PreviewAnnouncementSlackPayload', announcement?: { __typename?: 'Announcement', id: string } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type AnnouncementToBeNotifiedQueryVariables = Exact<{
  itemId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AnnouncementToBeNotifiedQuery = { __typename?: 'Query', announcement: { __typename?: 'Announcement', subscribers: { __typename?: 'ProjectSubscriptionConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename?: 'ProjectSubscription', id: string, transportTypes: Array<string>, subscriber: { __typename?: 'Subscriber', id: string, email: string, avatarColor: string, initials: string, workItems: { __typename?: 'WorkItemConnection', totalCount: number, nodes?: Array<{ __typename?: 'WorkItem', id: string, name: string } | null> | null } }, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }> } | null> | null }, slackChannels: { __typename?: 'ChannelConnection', nodes?: Array<{ __typename?: 'Channel', id: string, name: string, workspace: { __typename?: 'Workspace', id: string, name: string } } | null> | null } } };

export type DigestToBeNotifiedQueryVariables = Exact<{
  itemId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type DigestToBeNotifiedQuery = { __typename?: 'Query', announcementDigest: { __typename?: 'AnnouncementDigest', slackChannels: Array<{ __typename?: 'Channel', id: string, name: string, workspace: { __typename?: 'Workspace', id: string, name: string } }>, subscribers: { __typename?: 'ProjectSubscriptionConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename?: 'ProjectSubscription', id: string, transportTypes: Array<string>, subscriber: { __typename?: 'Subscriber', id: string, email: string, avatarColor: string, initials: string, workItems: { __typename?: 'WorkItemConnection', totalCount: number, nodes?: Array<{ __typename?: 'WorkItem', id: string, name: string } | null> | null } }, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }> } | null> | null } } };

export type PublishedAnnouncementContentQueryVariables = Exact<{
  announcementId: Scalars['ID']['input'];
}>;


export type PublishedAnnouncementContentQuery = { __typename?: 'Query', announcement: { __typename?: 'Announcement', id: string, headline?: string | null, content?: string | null, contentType: string, excerpt?: string | null, excerptWithFallback?: string | null, publicPermalink: string, state?: AnnouncementStateEnum | null, publishedAt?: any | null, slug?: string | null, title?: string | null, titleWithFallback?: string | null, description?: string | null, descriptionWithFallback?: string | null, author?: string | null, authorWithFallback?: string | null, doNotIndex?: boolean | null, heroImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string }>, changeTypes: { __typename?: 'ChangeTypeConnection', nodes?: Array<{ __typename?: 'ChangeType', id: string, name: string } | null> | null }, workItems?: { __typename?: 'WorkItemConnection', edges?: Array<{ __typename?: 'WorkItemEdge', node?: { __typename?: 'WorkItem', id: string, name: string } | null }> | null } | null, shareImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, connectedSources?: { __typename?: 'ConnectedSourceConnection', nodes?: Array<{ __typename?: 'ConnectedSource', id: string, url: string, name?: string | null, providerName: string } | null> | null } | null } };

export type PublishedAnnouncementIndexQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  announcementId: Scalars['ID']['input'];
}>;


export type PublishedAnnouncementIndexQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, publicPageUrl: string, slackAuthenticationUrl: string, totalConfirmedSubscriptions: number, slackSubscription?: { __typename?: 'Subscription', id: string } | null, slackProjectSubscription?: { __typename?: 'ProjectSubscription', id: string } | null, emailSettings: { __typename?: 'MailAppSetting', primaryColor?: string | null, replyToEmail?: string | null }, categories?: { __typename?: 'CategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string } | null> | null } | null }, announcement: { __typename?: 'Announcement', id: string, headline?: string | null, publicPermalink: string, shouldNotifyPageSubscribers?: boolean | null, totalSubscriberCounts: number, emailSubscriberCounts: number, slackSubscriberCounts: number } };

export type AnnouncementQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  announcementId: Scalars['ID']['input'];
}>;


export type AnnouncementQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, publicPageUrl: string, author?: string | null, slackAuthenticationUrl: string, totalConfirmedSubscriptions: number, slackSubscription?: { __typename?: 'Subscription', id: string } | null, slackProjectSubscription?: { __typename?: 'ProjectSubscription', id: string } | null, emailSettings: { __typename?: 'MailAppSetting', primaryColor?: string | null, replyToEmail?: string | null }, categories?: { __typename?: 'CategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string } | null> | null } | null }, announcement: { __typename?: 'Announcement', id: string, name: string, author?: string | null, scheduledAt?: any | null, scheduledAtTimezone?: string | null, archived: boolean, shouldNotifyPageSubscribers?: boolean | null, notificationsExcerptOnly?: boolean | null, headline?: string | null, subjectLine?: string | null, slackMessage?: string | null, totalSubscriberCounts: number, slackChannelCounts: number, state?: AnnouncementStateEnum | null, slug?: string | null, privatePermalink: string, content?: string | null, contentType: string, excerpt?: string | null, excerptWithFallback?: string | null, publicPermalink: string, publishedAt?: any | null, title?: string | null, titleWithFallback?: string | null, description?: string | null, descriptionWithFallback?: string | null, authorWithFallback?: string | null, doNotIndex?: boolean | null, emailSubscriberCounts: number, slackSubscriberCounts: number, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string }>, workItems?: { __typename?: 'WorkItemConnection', nodes?: Array<{ __typename?: 'WorkItem', id: string, name: string } | null> | null, edges?: Array<{ __typename?: 'WorkItemEdge', node?: { __typename?: 'WorkItem', id: string, name: string } | null }> | null } | null, changeTypes: { __typename?: 'ChangeTypeConnection', nodes?: Array<{ __typename?: 'ChangeType', id: string, name: string, color: string } | null> | null }, videoAsset?: { __typename?: 'VideoAsset', embedType: string, videoUrl: string, thumbnailUrl?: string | null, heightRatio?: string | null } | null, heroImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, shareImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, externalContentLinks?: Array<{ __typename?: 'ExternalContentLink', id: string, url: string, title: string, imageUrl?: string | null }> | null, connectedSources?: { __typename?: 'ConnectedSourceConnection', nodes?: Array<{ __typename?: 'ConnectedSource', id: string, url: string, name?: string | null, providerName: string } | null> | null } | null } };

export type ArchiveTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveTemplateMutation = { __typename?: 'Mutation', archiveTemplate?: { __typename?: 'ArchiveTemplatePayload', template?: { __typename?: 'Template', id: string } | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type CreateTemplateMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  marketplaceTemplateId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateTemplateMutation = { __typename?: 'Mutation', createTemplate?: { __typename?: 'CreateTemplatePayload', template?: { __typename?: 'Template', id: string, name?: string | null, description?: string | null } | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type RemoveTemplateAttachmentMutationVariables = Exact<{
  templateId: Scalars['ID']['input'];
  attachment: TemplateAttachment;
}>;


export type RemoveTemplateAttachmentMutation = { __typename?: 'Mutation', removeTemplateAttachment?: { __typename?: 'RemoveTemplateAttachmentPayload', template?: { __typename?: 'Template', id: string, heroImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null } | null };

export type TemplateEditorQueryVariables = Exact<{
  templateId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type TemplateEditorQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, publicPageUrl: string, slackAuthenticationUrl: string, totalConfirmedSubscriptions: number, slackSubscription?: { __typename?: 'Subscription', id: string } | null, slackProjectSubscription?: { __typename?: 'ProjectSubscription', id: string } | null, emailSettings: { __typename?: 'MailAppSetting', primaryColor?: string | null, replyToEmail?: string | null }, categories?: { __typename?: 'CategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string } | null> | null } | null }, template: { __typename?: 'Template', id: string, name?: string | null, description?: string | null, content?: string | null, contentType: string, excerpt?: string | null, excerptWithFallback?: string | null, headline?: string | null, heroImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, categories: Array<{ __typename?: 'Category', id: string }>, workItems?: { __typename?: 'WorkItemConnection', edges?: Array<{ __typename?: 'WorkItemEdge', node?: { __typename?: 'WorkItem', id: string, name: string } | null }> | null } | null } };

export type TemplatesIndexQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type TemplatesIndexQuery = { __typename?: 'Query', project: { __typename?: 'Project', templates: { __typename?: 'TemplateConnection', edges?: Array<{ __typename?: 'TemplateEdge', node?: { __typename?: 'Template', id: string, name?: string | null } | null }> | null }, marketplaceTemplates: { __typename?: 'MarketplaceTemplateConnection', edges?: Array<{ __typename?: 'MarketplaceTemplateEdge', node?: { __typename?: 'MarketplaceTemplate', id: string, name?: string | null, category?: string | null, position: number, coverImage?: { __typename?: 'Image', url?: string | null } | null } | null }> | null } } };

export type RqMarketplaceTemplatesModalFragment = { __typename?: 'Project', marketplaceTemplates: { __typename?: 'MarketplaceTemplateConnection', edges?: Array<{ __typename?: 'MarketplaceTemplateEdge', node?: { __typename?: 'MarketplaceTemplate', id: string, name?: string | null, category?: string | null, position: number, coverImage?: { __typename?: 'Image', url?: string | null } | null } | null }> | null } };

export type UpdateTemplateMutationVariables = Exact<{
  template: UpdateTemplateAttributes;
}>;


export type UpdateTemplateMutation = { __typename?: 'Mutation', updateTemplate?: { __typename?: 'UpdateTemplatePayload', template?: { __typename?: 'Template', id: string, name?: string | null, description?: string | null, content?: string | null, contentType: string, excerpt?: string | null, excerptWithFallback?: string | null, headline?: string | null, heroImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, categories: Array<{ __typename?: 'Category', id: string }>, workItems?: { __typename?: 'WorkItemConnection', edges?: Array<{ __typename?: 'WorkItemEdge', node?: { __typename?: 'WorkItem', id: string, name: string } | null }> | null } | null } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type ArchiveAnnouncementMutationVariables = Exact<{
  announcementId: Scalars['ID']['input'];
}>;


export type ArchiveAnnouncementMutation = { __typename?: 'Mutation', archiveAnnouncement?: { __typename?: 'ArchiveAnnouncementPayload', announcement?: { __typename?: 'Announcement', id: string, state?: AnnouncementStateEnum | null, headline?: string | null, content?: string | null, excerptWithFallback?: string | null, updatedAt: any, scheduledAt?: any | null, scheduledAtTimezone?: string | null, publishedAt?: any | null, deactivatedAt?: any | null, shouldNotifyPageSubscribers?: boolean | null, inPublishedDigest: boolean, feedbacks?: { __typename?: 'FeedbackConnection', edges?: Array<{ __typename?: 'FeedbackEdge', node?: { __typename?: 'Feedback', id: string } | null }> | null } | null } | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type CopyAnnouncementToProjectMutationVariables = Exact<{
  announcementId: Scalars['ID']['input'];
  newProjectId: Scalars['ID']['input'];
}>;


export type CopyAnnouncementToProjectMutation = { __typename?: 'Mutation', copyAnnouncementToProject?: { __typename?: 'CopyAnnouncementToProjectPayload', announcement?: { __typename?: 'Announcement', id: string, name: string } | null, targetProject?: { __typename?: 'Project', id: string, name: string } | null, errors: Array<{ __typename?: 'UserError', message: string }> } | null };

export type CreateAnnouncementMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  templateId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateAnnouncementMutation = { __typename?: 'Mutation', createAnnouncement?: { __typename?: 'CreateAnnouncementPayload', announcement?: { __typename?: 'Announcement', id: string, state?: AnnouncementStateEnum | null, headline?: string | null, content?: string | null, excerptWithFallback?: string | null, updatedAt: any, scheduledAt?: any | null, scheduledAtTimezone?: string | null, publishedAt?: any | null, deactivatedAt?: any | null, shouldNotifyPageSubscribers?: boolean | null, inPublishedDigest: boolean, template?: { __typename?: 'Template', id: string, name?: string | null } | null } | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type DuplicateAnnouncementMutationVariables = Exact<{
  announcementId: Scalars['ID']['input'];
}>;


export type DuplicateAnnouncementMutation = { __typename?: 'Mutation', duplicateAnnouncement?: { __typename?: 'DuplicateAnnouncementPayload', announcement?: { __typename?: 'Announcement', id: string, state?: AnnouncementStateEnum | null, headline?: string | null, content?: string | null, excerptWithFallback?: string | null, updatedAt: any, scheduledAt?: any | null, scheduledAtTimezone?: string | null, publishedAt?: any | null, deactivatedAt?: any | null, shouldNotifyPageSubscribers?: boolean | null, inPublishedDigest: boolean, heroImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string }>, workItems?: { __typename?: 'WorkItemConnection', edges?: Array<{ __typename?: 'WorkItemEdge', node?: { __typename?: 'WorkItem', id: string, name: string } | null }> | null } | null } | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type RqPublishAnnouncementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RqPublishAnnouncementMutation = { __typename?: 'Mutation', publishAnnouncement?: { __typename?: 'PublishAnnouncementPayload', announcement?: { __typename?: 'Announcement', id: string, state?: AnnouncementStateEnum | null, publishedAt?: any | null } | null } | null };

export type RemoveAnnouncementWorkItemMutationVariables = Exact<{
  announcementId: Scalars['ID']['input'];
  workItemId: Scalars['ID']['input'];
}>;


export type RemoveAnnouncementWorkItemMutation = { __typename?: 'Mutation', removeAnnouncementWorkItem?: { __typename?: 'RemoveAnnouncementWorkItemPayload', announcement?: { __typename?: 'Announcement', id: string, workItems?: { __typename?: 'WorkItemConnection', edges?: Array<{ __typename?: 'WorkItemEdge', node?: { __typename?: 'WorkItem', id: string } | null }> | null } | null } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type RemoveAttachmentMutationVariables = Exact<{
  announcementId: Scalars['ID']['input'];
  attachment: AnnouncementAttachment;
}>;


export type RemoveAttachmentMutation = { __typename?: 'Mutation', removeAnnouncementAttachment?: { __typename?: 'RemoveAttachmentPayload', announcement?: { __typename?: 'Announcement', id: string, heroImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null } | null };

export type RestoreAnnouncementMutationVariables = Exact<{
  announcementId: Scalars['ID']['input'];
}>;


export type RestoreAnnouncementMutation = { __typename?: 'Mutation', unarchiveAnnouncement?: { __typename?: 'UnarchiveAnnouncementPayload', announcement?: { __typename?: 'Announcement', id: string, state?: AnnouncementStateEnum | null, headline?: string | null, content?: string | null, excerptWithFallback?: string | null, updatedAt: any, scheduledAt?: any | null, scheduledAtTimezone?: string | null, publishedAt?: any | null, deactivatedAt?: any | null, shouldNotifyPageSubscribers?: boolean | null, inPublishedDigest: boolean, feedbacks?: { __typename?: 'FeedbackConnection', edges?: Array<{ __typename?: 'FeedbackEdge', node?: { __typename?: 'Feedback', id: string } | null }> | null } | null } | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type UseScheduleAnnouncementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  scheduledAt: Scalars['String']['input'];
  scheduledAtTimezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type UseScheduleAnnouncementMutation = { __typename?: 'Mutation', scheduleAnnouncement?: { __typename?: 'ScheduleAnnouncementPayload', announcement?: { __typename?: 'Announcement', id: string, state?: AnnouncementStateEnum | null, scheduledAt?: any | null, scheduledAtTimezone?: string | null, headline?: string | null, content?: string | null } | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type UnscheduleAnnouncementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnscheduleAnnouncementMutation = { __typename?: 'Mutation', unscheduleAnnouncement?: { __typename?: 'UnscheduleAnnouncementPayload', announcement?: { __typename?: 'Announcement', id: string, state?: AnnouncementStateEnum | null } | null } | null };

export type UpdateAnnouncementMutationVariables = Exact<{
  announcement: UpdateAnnouncementAttributes;
}>;


export type UpdateAnnouncementMutation = { __typename?: 'Mutation', updateAnnouncement?: { __typename?: 'UpdateAnnouncementPayload', announcement?: { __typename?: 'Announcement', id: string, notificationsExcerptOnly?: boolean | null, headline?: string | null, content?: string | null, contentType: string, excerpt?: string | null, excerptWithFallback?: string | null, publicPermalink: string, state?: AnnouncementStateEnum | null, publishedAt?: any | null, slug?: string | null, title?: string | null, titleWithFallback?: string | null, description?: string | null, descriptionWithFallback?: string | null, author?: string | null, authorWithFallback?: string | null, doNotIndex?: boolean | null, shouldNotifyPageSubscribers?: boolean | null, totalSubscriberCounts: number, emailSubscriberCounts: number, slackSubscriberCounts: number, heroImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string }>, changeTypes: { __typename?: 'ChangeTypeConnection', nodes?: Array<{ __typename?: 'ChangeType', id: string, name: string } | null> | null }, workItems?: { __typename?: 'WorkItemConnection', edges?: Array<{ __typename?: 'WorkItemEdge', node?: { __typename?: 'WorkItem', id: string, name: string } | null }> | null } | null, shareImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, connectedSources?: { __typename?: 'ConnectedSourceConnection', nodes?: Array<{ __typename?: 'ConnectedSource', id: string, url: string, name?: string | null, providerName: string } | null> | null } | null } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type CategoryTagsFragment = { __typename?: 'Project', id: string, publicPageUrl: string, slackAuthenticationUrl: string, totalConfirmedSubscriptions: number, slackSubscription?: { __typename?: 'Subscription', id: string } | null, slackProjectSubscription?: { __typename?: 'ProjectSubscription', id: string } | null, emailSettings: { __typename?: 'MailAppSetting', primaryColor?: string | null, replyToEmail?: string | null }, categories?: { __typename?: 'CategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string } | null> | null } | null };

export type ChannelsFragment = { __typename?: 'Announcement', id: string, name: string, shouldNotifyPageSubscribers?: boolean | null, notificationsExcerptOnly?: boolean | null, headline?: string | null, subjectLine?: string | null, slackMessage?: string | null, totalSubscriberCounts: number, slackChannelCounts: number, state?: AnnouncementStateEnum | null, emailSubscriberCounts: number, slackSubscriberCounts: number, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string }>, workItems?: { __typename?: 'WorkItemConnection', nodes?: Array<{ __typename?: 'WorkItem', id: string, name: string } | null> | null } | null };

export type ContentFragment = { __typename?: 'Announcement', id: string, headline?: string | null, content?: string | null, contentType: string, excerpt?: string | null, excerptWithFallback?: string | null, publicPermalink: string, state?: AnnouncementStateEnum | null, publishedAt?: any | null, slug?: string | null, title?: string | null, titleWithFallback?: string | null, description?: string | null, descriptionWithFallback?: string | null, author?: string | null, authorWithFallback?: string | null, doNotIndex?: boolean | null, heroImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string }>, changeTypes: { __typename?: 'ChangeTypeConnection', nodes?: Array<{ __typename?: 'ChangeType', id: string, name: string } | null> | null }, workItems?: { __typename?: 'WorkItemConnection', edges?: Array<{ __typename?: 'WorkItemEdge', node?: { __typename?: 'WorkItem', id: string, name: string } | null }> | null } | null, shareImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, connectedSources?: { __typename?: 'ConnectedSourceConnection', nodes?: Array<{ __typename?: 'ConnectedSource', id: string, url: string, name?: string | null, providerName: string } | null> | null } | null };

export type PreviewFragment = { __typename?: 'Announcement', id: string, state?: AnnouncementStateEnum | null, slug?: string | null, publicPermalink: string, headline?: string | null, content?: string | null, shouldNotifyPageSubscribers?: boolean | null, totalSubscriberCounts: number, scheduledAtTimezone?: string | null, scheduledAt?: any | null, slackSubscriberCount: number, emailSubscriberCount: number };

export type EditorProjectFragment = { __typename?: 'Project', id: string, primaryColor: string, totalConfirmedSubscriptions: number, slug: string, name: string, secured: boolean, hideNotificationContent: boolean, publicPageUrl: string, slackAuthenticationUrl: string, emailSettings: { __typename?: 'MailAppSetting', replyToEmail?: string | null, primaryColor?: string | null, logo?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null }, slackSubscription?: { __typename?: 'Subscription', id: string } | null, slackProjectSubscription?: { __typename?: 'ProjectSubscription', id: string } | null };

export type PublishedAnnouncementFragment = { __typename?: 'Announcement', id: string, headline?: string | null, publicPermalink: string, shouldNotifyPageSubscribers?: boolean | null, totalSubscriberCounts: number, emailSubscriberCounts: number, slackSubscriberCounts: number };

export type DashboardFragment = { __typename?: 'Announcement', id: string, state?: AnnouncementStateEnum | null, headline?: string | null, content?: string | null, updatedAt: any, scheduledAt?: any | null, scheduledAtTimezone?: string | null, publishedAt?: any | null, deactivatedAt?: any | null, shouldNotifyPageSubscribers?: boolean | null, excerptWithFallback?: string | null, inPublishedDigest: boolean, categories: Array<{ __typename?: 'Category', id: string, name: string, color: string }>, changeTypes: { __typename?: 'ChangeTypeConnection', nodes?: Array<{ __typename?: 'ChangeType', id: string, name: string } | null> | null } };

export type CohortShowQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type CohortShowQuery = { __typename?: 'Query', project: { __typename?: 'Project', cohort?: { __typename?: 'Cohort', id: string, name: string, description?: string | null, subscriberCount: number, feedbackCount: number, voteCount: number, subscribers: { __typename?: 'SubscriberConnection', totalCount: number }, audienceDomains: { __typename?: 'AudienceDomainConnection', totalCount: number } } | null } };

export type AudienceDomainsIndexQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type AudienceDomainsIndexQuery = { __typename?: 'Query', project: { __typename?: 'Project', audienceDomains: { __typename?: 'AudienceDomainConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename?: 'AudienceDomain', id: string, createdAt: any, name?: string | null, hostname: string, subscriberCount: number, feedbackCount: number, voteCount: number, averageFeedbackSentiment?: number | null } | null> | null } } };

export type CohortsIndexQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  orderBy?: InputMaybe<OrderBy>;
  where?: InputMaybe<Where>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type CohortsIndexQuery = { __typename?: 'Query', project: { __typename?: 'Project', cohorts?: { __typename?: 'CohortConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Cohort', id: string, name: string, description?: string | null, subscriberCount: number, feedbackCount: number, voteCount: number } | null> | null } | null } };

export type AuthorizationQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type AuthorizationQuery = { __typename?: 'Query', viewer: { __typename?: 'ApiUser', project: { __typename?: 'Project', secureConnectionSettings?: { __typename?: 'SecureConnectionSettings', id: string, allowedDomains: Array<string> } | null } } };

export type RemoveAllowedDomainMutationVariables = Exact<{
  input: RemoveAllowedDomainInput;
}>;


export type RemoveAllowedDomainMutation = { __typename?: 'Mutation', removeAllowedDomain?: { __typename?: 'RemoveAllowedDomainPayload', secureConnection?: { __typename?: 'SecureConnectionSettings', allowedDomains: Array<string> } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type UpdateSecureConnectionMutationVariables = Exact<{
  input: UpdateSecureConnectionInput;
}>;


export type UpdateSecureConnectionMutation = { __typename?: 'Mutation', updateSecureConnection?: { __typename?: 'UpdateSecureConnectionPayload', secureConnection?: { __typename?: 'SecureConnectionSettings', allowedDomains: Array<string> } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type IdeaEmailPromotionCountQueryVariables = Exact<{
  ideaId: Scalars['ID']['input'];
}>;


export type IdeaEmailPromotionCountQuery = { __typename?: 'Query', idea: { __typename?: 'Idea', emailPromotionCount: number } };

export type IdeaShowQueryVariables = Exact<{
  ideaId: Scalars['ID']['input'];
}>;


export type IdeaShowQuery = { __typename?: 'Query', idea: { __typename?: 'Idea', id: string, name: string, notes?: string | null, published: boolean, feedbackCount: number, ideaVotesCount: number, lastFeedback?: any | null, deactivatedAt?: any | null, createdAt: any, latestWorkItemId?: string | null, categories?: { __typename?: 'CategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name: string, color: string } | null> | null } | null } };

export type IdeasInboxQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type IdeasInboxQuery = { __typename?: 'Query', project: { __typename?: 'Project', ideasEnabled: boolean, hasPublishedIdea: boolean } };

export type ImportFeedbackMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  feedbacks: Array<BatchFeedback> | BatchFeedback;
  skipOptIn?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ImportFeedbackMutation = { __typename?: 'Mutation', importFeedback?: { __typename?: 'ImportFeedbackPayload', status?: string | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type SendPromotionTestEmailMutationVariables = Exact<{
  input: SendPromoteTestInput;
}>;


export type SendPromotionTestEmailMutation = { __typename?: 'Mutation', sendPromoteTest?: { __typename?: 'SendPromoteTestPayload', success: boolean } | null };

export type CreateOrganizationProfileMutationVariables = Exact<{
  name: Scalars['String']['input'];
  creatorId: Scalars['ID']['input'];
  userRole: UserRoleEnum;
  userReferralSource: UserReferralSourceEnum;
}>;


export type CreateOrganizationProfileMutation = { __typename?: 'Mutation', createOrganizationProfile?: { __typename?: 'CreateOrganizationProfilePayload', projectId: string } | null };

export type OnboardingTasksQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type OnboardingTasksQuery = { __typename?: 'Query', viewer: { __typename?: 'ApiUser', project: { __typename?: 'Project', slug: string, onboardingTasks: { __typename?: 'OnboardingTasks', addAnnouncement?: boolean | null, addUser?: boolean | null, addWorkItem?: boolean | null, claimSubdomain?: boolean | null, customizeCategories?: boolean | null, customizeColors?: boolean | null, customizeEmail?: boolean | null, customizeHtmlCss?: boolean | null, customizeRoadmapStages?: boolean | null, enableRoadmap?: boolean | null, uploadLogo?: boolean | null } } } };

export type UpdateOnboardingTasksMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  onboardingTasks: UpdateOnboardingTasksAttributes;
}>;


export type UpdateOnboardingTasksMutation = { __typename?: 'Mutation', updateOnboardingTasks?: { __typename?: 'UpdateOnboardingTasksPayload', errors: Array<{ __typename?: 'UserError', message: string }> } | null };

export type WizardAnnouncementStepFragment = { __typename?: 'Project', id: string, name: string, primaryColor: string, primaryTextColor: string };

export type WizardCategoriesStepFragment = { __typename?: 'Project', id: string, name: string, categories?: { __typename?: 'CategoryConnection', edges?: Array<{ __typename?: 'CategoryEdge', node?: { __typename?: 'Category', id: string, name: string } | null }> | null } | null };

export type WizardCustomizeStepFragment = { __typename?: 'Project', id: string, name: string, primaryColor: string, primaryTextColor: string, supportingPalette?: string | null, emailSettings: { __typename?: 'MailAppSetting', id: string }, logo?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null };

export type WizardInfoStepFragment = { __typename?: 'Project', id: string, name: string, slug: string, referralSource?: string | null, emailSettings: { __typename?: 'MailAppSetting', id: string } };

export type WizardPublicPagePreviewFragment = { __typename?: 'Project', id: string, name: string, slug: string, primaryColor: string, supportingPalette?: string | null, logo?: { __typename?: 'Image', url?: string | null } | null, emailProjectSubscription?: { __typename?: 'ProjectSubscription', id: string } | null, categories?: { __typename?: 'CategoryConnection', edges?: Array<{ __typename?: 'CategoryEdge', node?: { __typename?: 'Category', id: string, name: string } | null }> | null } | null, eventTypes: { __typename?: 'EventTypeConnection', nodes?: Array<{ __typename?: 'EventType', id: string } | null> | null } };

export type WizardQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type WizardQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, name: string, slug: string, referralSource?: string | null, primaryColor: string, primaryTextColor: string, supportingPalette?: string | null, emailProjectSubscription?: { __typename?: 'ProjectSubscription', id: string, categories: Array<{ __typename?: 'Category', id: string, name: string }> } | null, emailSettings: { __typename?: 'MailAppSetting', id: string }, logo?: { __typename?: 'Image', url?: string | null, filename?: string | null } | null, categories?: { __typename?: 'CategoryConnection', edges?: Array<{ __typename?: 'CategoryEdge', node?: { __typename?: 'Category', id: string, name: string } | null }> | null } | null, eventTypes: { __typename?: 'EventTypeConnection', nodes?: Array<{ __typename?: 'EventType', id: string } | null> | null } } };

export type WizardSubscribersStepFragment = { __typename?: 'Project', id: string, name: string, emailProjectSubscription?: { __typename?: 'ProjectSubscription', id: string } | null };

export type UpdateOnboardingProjectMutationVariables = Exact<{
  project: UpdateProjectAttributes;
  mailAppSetting: UpdateMailAppSettingsAttributes;
}>;


export type UpdateOnboardingProjectMutation = { __typename?: 'Mutation', updateProject?: { __typename?: 'UpdateProjectPayload', project?: { __typename?: 'Project', id: string, name: string, slug: string, referralSource?: string | null, primaryColor: string, primaryTextColor: string, supportingPalette?: string | null, emailSettings: { __typename?: 'MailAppSetting', id: string }, logo?: { __typename?: 'Image', url?: string | null, filename?: string | null } | null, categories?: { __typename?: 'CategoryConnection', edges?: Array<{ __typename?: 'CategoryEdge', node?: { __typename?: 'Category', id: string, name: string } | null }> | null } | null, emailProjectSubscription?: { __typename?: 'ProjectSubscription', id: string } | null, eventTypes: { __typename?: 'EventTypeConnection', nodes?: Array<{ __typename?: 'EventType', id: string } | null> | null } } | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null, updateMailAppSettings?: { __typename?: 'UpdateMailAppSettingsPayload', mailAppSetting?: { __typename?: 'MailAppSetting', id: string } | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type WizardCreateCategoryMutationVariables = Exact<{
  category: CreateCategoryAttributes;
}>;


export type WizardCreateCategoryMutation = { __typename?: 'Mutation', createCategory?: { __typename?: 'CreateCategoryPayload', category?: { __typename?: 'Category', id: string, name: string } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type WizardCreateTestAnnouncementMutationVariables = Exact<{
  announcement: CreateAnnouncementAttributes;
}>;


export type WizardCreateTestAnnouncementMutation = { __typename?: 'Mutation', createAnnouncement?: { __typename?: 'CreateAnnouncementPayload', announcement?: { __typename?: 'Announcement', id: string } | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type WizardRemoveCategoryMutationVariables = Exact<{
  categoryId: Scalars['ID']['input'];
}>;


export type WizardRemoveCategoryMutation = { __typename?: 'Mutation', removeCategory?: { __typename?: 'RemoveCategoryPayload', category?: { __typename?: 'Category', id: string, name: string } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type WizardRemoveLogoMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  emailSettingsId: Scalars['ID']['input'];
}>;


export type WizardRemoveLogoMutation = { __typename?: 'Mutation', removeProjectLogo?: { __typename?: 'RemoveLogoPayload', project?: { __typename?: 'Project', id: string, logo?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null, removeEmailLogo?: { __typename?: 'RemoveEmailLogoPayload', errors: string, mailAppSetting?: { __typename?: 'MailAppSetting', id: string, logo?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null } | null };

export type DeleteAtlassianOauthAppMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type DeleteAtlassianOauthAppMutation = { __typename?: 'Mutation', deleteAtlassianApp?: { __typename?: 'DeletePayload', appId: string } | null };

export type UpdateAtlassianAppMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  siteId: Scalars['String']['input'];
}>;


export type UpdateAtlassianAppMutation = { __typename?: 'Mutation', updateAtlassianOauthApp?: { __typename?: 'UpdatePayload', appId: string } | null };

export type NotificationsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type NotificationsQuery = { __typename?: 'Query', viewer: { __typename?: 'ApiUser', project: { __typename?: 'Project', id: string, name: string, publicPageUrl: string, subscriberReportEnabled: boolean, feedbackViaEmailEnabled: boolean, feedbackViaSlackEnabled: boolean, slackAuthenticationUrl: string, slackSubscription?: { __typename?: 'Subscription', id: string } | null, emailSubscription?: { __typename?: 'Subscription', id: string } | null } } };

export type UnsubscribeAllMutationVariables = Exact<{
  input: UnsubscribeAllInput;
}>;


export type UnsubscribeAllMutation = { __typename?: 'Mutation', unsubscribeAll?: { __typename?: 'UnsubscribeAllPayload', projectId?: string | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type ToggleSubscriberReportMutationVariables = Exact<{
  input: ToggleSubscriberReportInput;
}>;


export type ToggleSubscriberReportMutation = { __typename?: 'Mutation', toggleSubscriberReport?: { __typename?: 'ToggleSubscriberReportPayload', errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type UpdateNotificationsMutationVariables = Exact<{
  input: ToggleEventInput;
}>;


export type UpdateNotificationsMutation = { __typename?: 'Mutation', toggleEventType?: { __typename?: 'ToggleEventPayload', subscription?: { __typename?: 'Subscription', id: string, feedbackSubmitted: boolean } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type FetchProjectRollupQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type FetchProjectRollupQuery = { __typename?: 'Query', project: { __typename?: 'Project', rollup?: { __typename?: 'Rollup', id: string, enabled: boolean, onlyMemberItems: boolean, daysOfTheWeek: Array<string>, events: Array<string>, groupedBy: string } | null } };

export type ToggleRollupMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type ToggleRollupMutation = { __typename?: 'Mutation', toggleRollup?: { __typename?: 'ToggleRollupPayload', rollup?: { __typename?: 'Rollup', id: string, enabled: boolean, onlyMemberItems: boolean, daysOfTheWeek: Array<string> } | null } | null };

export type UpsertRollupMutationVariables = Exact<{
  rollupId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  daysOfTheWeek: Array<Scalars['String']['input']> | Scalars['String']['input'];
  events: Array<Scalars['String']['input']> | Scalars['String']['input'];
  onlyMemberItems: Scalars['Boolean']['input'];
  groupedBy: Scalars['String']['input'];
}>;


export type UpsertRollupMutation = { __typename?: 'Mutation', upsertRollup?: { __typename?: 'UpsertRollupPayload', rollup?: { __typename?: 'Rollup', id: string, daysOfTheWeek: Array<string>, onlyMemberItems: boolean } | null } | null };

export type DestroyUserProfileMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type DestroyUserProfileMutation = { __typename?: 'Mutation', destroyUser?: { __typename?: 'DestroyUserAccountPayload', user?: { __typename?: 'User', id: string } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type ProfileUserQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProfileUserQuery = { __typename?: 'Query', session: { __typename?: 'User', id: string, name?: string | null, firstName?: string | null, lastName?: string | null, email: string, avatarColor: string, project: { __typename?: 'Project', id: string, name: string, subscriberReportEnabled: boolean, feedbackViaEmailEnabled: boolean, feedbackViaSlackEnabled: boolean, slackAuthenticationUrl: string, publicPageUrl: string, emailSubscription?: { __typename?: 'Subscription', id: string } | null, slackSubscription?: { __typename?: 'Subscription', id: string } | null }, avatarImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, defaultProject?: { __typename?: 'Project', id: string, name: string, organization: { __typename?: 'Organization', name?: string | null } } | null, projects: { __typename?: 'ProjectConnection', nodes?: Array<{ __typename?: 'Project', id: string, name: string, organization: { __typename?: 'Organization', name?: string | null } } | null> | null } } };

export type RqProfileFragmentFragment = { __typename?: 'User', id: string, name?: string | null, firstName?: string | null, lastName?: string | null, email: string, avatarColor: string, avatarImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, defaultProject?: { __typename?: 'Project', id: string, name: string, organization: { __typename?: 'Organization', name?: string | null } } | null, projects: { __typename?: 'ProjectConnection', nodes?: Array<{ __typename?: 'Project', id: string, name: string, organization: { __typename?: 'Organization', name?: string | null } } | null> | null } };

export type RqNotificationsFragmentFragment = { __typename?: 'Project', id: string, name: string, subscriberReportEnabled: boolean, feedbackViaEmailEnabled: boolean, feedbackViaSlackEnabled: boolean, slackAuthenticationUrl: string, publicPageUrl: string, emailSubscription?: { __typename?: 'Subscription', id: string } | null, slackSubscription?: { __typename?: 'Subscription', id: string } | null };

export type RemoveUserAvatarImageMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type RemoveUserAvatarImageMutation = { __typename?: 'Mutation', removeUserAvatarImage?: { __typename?: 'RemoveAvatarImagePayload', user?: { __typename?: 'User', id: string } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type UpdateUserProfileMutationVariables = Exact<{
  user: UpdateUserAttributes;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserPayload', user?: { __typename?: 'User', id: string, name?: string | null, firstName?: string | null, lastName?: string | null, email: string, avatarColor: string, avatarImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, defaultProject?: { __typename?: 'Project', id: string, name: string, organization: { __typename?: 'Organization', name?: string | null } } | null, projects: { __typename?: 'ProjectConnection', nodes?: Array<{ __typename?: 'Project', id: string, name: string, organization: { __typename?: 'Organization', name?: string | null } } | null> | null } } | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type RoadmapBoardQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type RoadmapBoardQuery = { __typename?: 'Query', project: { __typename?: 'Project', publicPageUrl: string, roadmapEnabled: boolean, roadmapMoveUpdatesEnabled: boolean, roadmapWatchedStages: Array<string>, categories?: { __typename?: 'CategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string } | null> | null } | null, projectUsers?: { __typename?: 'UserConnection', edges?: Array<{ __typename?: 'UserEdge', node?: { __typename?: 'User', id: string, displayName: string, initials: string, avatarColor: string, avatarImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null }> | null } | null, stages?: { __typename?: 'StageConnection', edges?: Array<{ __typename?: 'StageEdge', node?: { __typename?: 'Stage', id: string, description?: string | null, position: number, published?: boolean | null, title: string, cards?: { __typename?: 'WorkItemConnection', nodes?: Array<{ __typename?: 'WorkItem', id: string, name: string, position: number, laneId: string, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string }>, changeTypes: { __typename?: 'ChangeTypeConnection', nodes?: Array<{ __typename?: 'ChangeType', id: string, name: string, color: string } | null> | null }, owner?: { __typename?: 'User', id: string, displayName: string, initials: string, avatarColor: string, avatarImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null, members: Array<{ __typename?: 'User', id: string, displayName: string, initials: string, avatarColor: string, avatarImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null }> } | null> | null } | null } | null }> | null } | null } };

export type RoadmapViewQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  viewId: Scalars['ID']['input'];
}>;


export type RoadmapViewQuery = { __typename?: 'Query', project: { __typename?: 'Project', projectView?: { __typename?: 'ProjectView', id: string, security: ProjectViewSecurityEnum, publicPermalink: string, restricted: boolean, categories: Array<{ __typename?: 'Category', id: string, name: string }>, stages: Array<{ __typename?: 'Stage', id: string, name: string }>, owners: Array<{ __typename?: 'User', id: string, displayName: string }>, members: Array<{ __typename?: 'User', id: string, displayName: string }> } | null } };

export type RoadmapViewsBoardQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type RoadmapViewsBoardQuery = { __typename?: 'Query', project: { __typename?: 'Project', name: string, heading?: string | null, publicPageUrl: string, roadmapEnabled: boolean, roadmapMoveUpdatesEnabled: boolean, roadmapWatchedStages: Array<string>, secured: boolean, categories?: { __typename?: 'CategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string } | null> | null } | null, projectUsers?: { __typename?: 'UserConnection', edges?: Array<{ __typename?: 'UserEdge', node?: { __typename?: 'User', id: string, displayName: string, initials: string, avatarColor: string, avatarImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null }> | null } | null, projectViews?: { __typename?: 'ProjectViewConnection', edges?: Array<{ __typename?: 'ProjectViewEdge', node?: { __typename?: 'ProjectView', id: string, name?: string | null, security: ProjectViewSecurityEnum } | null }> | null } | null, stages?: { __typename?: 'StageConnection', edges?: Array<{ __typename?: 'StageEdge', node?: { __typename?: 'Stage', id: string, name: string, description?: string | null, position: number, published?: boolean | null, restricted: boolean, cards?: { __typename?: 'WorkItemConnection', nodes?: Array<{ __typename?: 'WorkItem', id: string, name: string, position: number, laneId: string, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string }>, owner?: { __typename?: 'User', id: string, displayName: string, initials: string, avatarColor: string, avatarImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null, members: Array<{ __typename?: 'User', id: string, displayName: string, initials: string, avatarColor: string, avatarImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null }> } | null> | null } | null } | null }> | null } | null } };

export type ArchivedWorkItemsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArchivedWorkItemsQuery = { __typename?: 'Query', project: { __typename?: 'Project', archivedWorkItemsCount?: { __typename?: 'WorkItemConnection', totalCount: number } | null, archivedWorkItems?: { __typename?: 'WorkItemConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'WorkItemEdge', node?: { __typename?: 'WorkItem', id: string, name: string, deactivatedAt?: any | null, stage?: { __typename?: 'Stage', id: string, name: string } | null, feedbacks?: { __typename?: 'FeedbackConnection', totalCount: number } | null, projectSubscriptions?: { __typename?: 'ProjectSubscriptionConnection', totalCount: number } | null } | null }> | null } | null } };

export type ImportSubscribersMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  subscribers: Array<BatchSubscriber> | BatchSubscriber;
}>;


export type ImportSubscribersMutation = { __typename?: 'Mutation', createBatchEmailSubscriptions?: { __typename?: 'CreateBatchEmailSubscriptionsPayload', status?: string | null, errors: Array<{ __typename?: 'UserError', path?: Array<string> | null, message: string }> } | null };

export type RemoveSubscribersMutationVariables = Exact<{
  subscriberIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type RemoveSubscribersMutation = { __typename?: 'Mutation', removeProjectSubscribers?: { __typename?: 'RemoveFromProjectPayload', subscriberIds: Array<string> } | null };

export type SubscribersIndexQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  where?: InputMaybe<Where>;
  orderBy?: InputMaybe<OrderBy>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<SubscriptionStatus> | SubscriptionStatus>;
  cohortId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SubscribersIndexQuery = { __typename?: 'Query', project: { __typename?: 'Project', name: string, cohorts?: { __typename?: 'CohortConnection', nodes?: Array<{ __typename?: 'Cohort', id: string, name: string } | null> | null } | null, allSubscribers?: { __typename?: 'SubscriberConnection', totalCount: number } | null, subscribers?: { __typename?: 'SubscriberConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'SubscriberEdge', hasMailTransport: boolean, hasSlackTransport: boolean, audienceDomainId: string, audienceDomainHostname: string, status: SubscriptionStatus, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string }>, node: { __typename?: 'Subscriber', id: string, initials: string, avatarColor: string, email: string, createdAt: any, confirmedAt?: any | null, isProjectSubscriber: boolean } }> | null } | null } };

export type ExportSubscribersQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ExportSubscribersQuery = { __typename?: 'Query', project: { __typename?: 'Project', exportSubscribers?: { __typename?: 'SubscriberConnection', edges?: Array<{ __typename?: 'SubscriberEdge', hasMailTransport: boolean, hasSlackTransport: boolean, status: SubscriptionStatus, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string }>, node: { __typename?: 'Subscriber', id: string, email: string, createdAt: any, confirmedAt?: any | null } }> | null } | null } };

export type SubscriberIndexStatsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type SubscriberIndexStatsQuery = { __typename?: 'Query', project: { __typename?: 'Project', newSubscriptionsThisMonth: number, totalConfirmedSubscriptions: number } };

export type ConfirmSubscribersMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  subscriberIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ConfirmSubscribersMutation = { __typename?: 'Mutation', confirmSubscribers?: { __typename?: 'ConfirmSubscribersPayload', errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type UnsubscribeFromProjectMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  subscriberIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UnsubscribeFromProjectMutation = { __typename?: 'Mutation', unsubscribeFromProject?: { __typename?: 'UnsubscribeFromProjectPayload', errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type ResubscribeToProjectMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  subscriberIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ResubscribeToProjectMutation = { __typename?: 'Mutation', resubscribeToProject?: { __typename?: 'ResubscribeToProjectPayload', errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type AllProjectViewsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type AllProjectViewsQuery = { __typename?: 'Query', project: { __typename?: 'Project', name: string, heading?: string | null, publicPageUrl: string, secured: boolean, restricted: boolean, editable: boolean, projectViews?: { __typename?: 'ProjectViewConnection', edges?: Array<{ __typename?: 'ProjectViewEdge', node?: { __typename?: 'ProjectView', id: string, name?: string | null, description?: string | null, slug: string, publicPermalink: string, security: ProjectViewSecurityEnum, restricted: boolean, editable: boolean, archived: boolean, archivedAt?: any | null, categories: Array<{ __typename?: 'Category', id: string }>, stages: Array<{ __typename?: 'Stage', id: string }> } | null }> | null } | null } };

export type ArchiveProjectViewMutationVariables = Exact<{
  input: DeactivateProjectViewInput;
}>;


export type ArchiveProjectViewMutation = { __typename?: 'Mutation', deactivateProjectView?: { __typename?: 'DeactivateProjectViewPayload', projectView?: { __typename?: 'ProjectView', id: string } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type ArchivedProjectViewsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ArchivedProjectViewsQuery = { __typename?: 'Query', project: { __typename?: 'Project', projectViews?: { __typename?: 'ProjectViewConnection', edges?: Array<{ __typename?: 'ProjectViewEdge', node?: { __typename?: 'ProjectView', id: string, name?: string | null, description?: string | null, slug: string, publicPermalink: string, security: ProjectViewSecurityEnum, restricted: boolean, editable: boolean, archived: boolean, archivedAt?: any | null, categories: Array<{ __typename?: 'Category', id: string }>, stages: Array<{ __typename?: 'Stage', id: string }> } | null }> | null } | null } };

export type DuplicateProjectViewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DuplicateProjectViewMutation = { __typename?: 'Mutation', duplicateProjectView?: { __typename?: 'DuplicateProjectViewPayload', projectView?: { __typename?: 'ProjectView', id: string } | null } | null };

export type ProjectViewItemFragment = { __typename?: 'ProjectView', id: string, name?: string | null, description?: string | null, slug: string, publicPermalink: string, security: ProjectViewSecurityEnum, restricted: boolean, editable: boolean, archived: boolean, archivedAt?: any | null, categories: Array<{ __typename?: 'Category', id: string }>, stages: Array<{ __typename?: 'Stage', id: string }> };

export type ShowDefaultProjectViewQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ShowDefaultProjectViewQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, name: string, heading?: string | null, subheading?: string | null, publicPageUrl: string, secured: boolean, roadmapEnabled: boolean, ideasEnabled: boolean, votingEnabled: boolean, voteCountDisplay: string, feedbackEnabled: boolean, feedbackForwardEmails: Array<string>, restricted: boolean, editable: boolean, published: boolean, stages?: { __typename?: 'StageConnection', edges?: Array<{ __typename?: 'StageEdge', node?: { __typename?: 'Stage', id: string, name: string, published?: boolean | null } | null }> | null } | null, categories?: { __typename?: 'CategoryConnection', edges?: Array<{ __typename?: 'CategoryEdge', node?: { __typename?: 'Category', id: string, name: string } | null }> | null } | null } };

export type ShowProjectViewQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  viewId: Scalars['ID']['input'];
}>;


export type ShowProjectViewQuery = { __typename?: 'Query', project: { __typename?: 'Project', publicPageUrl: string, projectView?: { __typename?: 'ProjectView', id: string, archived: boolean, archivedAt?: any | null, name?: string | null, description?: string | null, slug: string, publicPermalink: string, security: ProjectViewSecurityEnum, restricted: boolean, editable: boolean, heading?: string | null, subheading?: string | null, stages: Array<{ __typename?: 'Stage', id: string }>, categories: Array<{ __typename?: 'Category', id: string }>, audienceDomains: { __typename?: 'AudienceDomainConnection', totalCount: number }, owners: Array<{ __typename?: 'User', id: string }>, members: Array<{ __typename?: 'User', id: string }>, subscribers: { __typename?: 'SubscriberConnection', totalCount: number } } | null, stages?: { __typename?: 'StageConnection', edges?: Array<{ __typename?: 'StageEdge', node?: { __typename?: 'Stage', id: string, name: string } | null }> | null } | null, projectUsers?: { __typename?: 'UserConnection', edges?: Array<{ __typename?: 'UserEdge', node?: { __typename?: 'User', id: string, initials: string, displayName: string, avatarColor: string, avatarImage?: { __typename?: 'Image', url?: string | null } | null } | null }> | null } | null, categories?: { __typename?: 'CategoryConnection', edges?: Array<{ __typename?: 'CategoryEdge', node?: { __typename?: 'Category', id: string, name: string } | null }> | null } | null } };

export type UnarchiveProjectViewMutationVariables = Exact<{
  input: ActivateProjectViewInput;
}>;


export type UnarchiveProjectViewMutation = { __typename?: 'Mutation', activateProjectView?: { __typename?: 'ActivateProjectViewPayload', projectView?: { __typename?: 'ProjectView', id: string, archived: boolean } | null } | null };

export type UpdateProjectViewMutationVariables = Exact<{
  input: UpdateProjectViewInput;
}>;


export type UpdateProjectViewMutation = { __typename?: 'Mutation', updateProjectView?: { __typename?: 'UpdateProjectViewPayload', projectView?: { __typename?: 'ProjectView', id: string } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type CreateWebhookMutationVariables = Exact<{
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  owner: Scalars['ID']['input'];
  eventTypes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateWebhookMutation = { __typename?: 'Mutation', createOutboundWebhook?: { __typename?: 'CreateOutboundWebhookPayload', outboundWebhook?: { __typename?: 'OutboundWebhook', id: string } | null } | null };

export type DeleteWebhookMutationVariables = Exact<{
  webhookId: Scalars['ID']['input'];
}>;


export type DeleteWebhookMutation = { __typename?: 'Mutation', deleteOutboundWebhook?: { __typename?: 'DeleteOutboundWebhookPayload', success: boolean } | null };

export type FetchEventTypesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type FetchEventTypesQuery = { __typename?: 'Query', project: { __typename?: 'Project', eventTypes: { __typename?: 'EventTypeConnection', nodes?: Array<{ __typename?: 'EventType', id: string, name: string } | null> | null } } };

export type FetchWebhookEventsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  webhookId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchWebhookEventsQuery = { __typename?: 'Query', project: { __typename?: 'Project', outboundWebhooks: Array<{ __typename?: 'OutboundWebhook', events: { __typename?: 'OutboundWebhookEventConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename?: 'OutboundWebhookEvent', id: string, status: OutboundWebhookEventStatus, payload: any, createdAt: any, eventType: { __typename?: 'EventType', id: string, name: string } } | null> | null } }> } };

export type FetchWebhookInfoQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  webhookId: Scalars['ID']['input'];
}>;


export type FetchWebhookInfoQuery = { __typename?: 'Query', project: { __typename?: 'Project', outboundWebhooks: Array<{ __typename?: 'OutboundWebhook', id: string, name: string, url: string, status: OutboundWebhookStatus, enabled: boolean, username?: string | null, password?: string | null, managed?: boolean | null, owner: { __typename: 'Organization' } | { __typename: 'Project' }, eventTypes: Array<{ __typename?: 'EventType', id: string, name: string }> }> } };

export type FetchWebhooksListQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type FetchWebhooksListQuery = { __typename?: 'Query', project: { __typename?: 'Project', outboundWebhooks: Array<{ __typename?: 'OutboundWebhook', id: string, name: string, url: string, enabled: boolean, status: OutboundWebhookStatus, eventTypes: Array<{ __typename?: 'EventType', name: string }>, owner: { __typename: 'Organization', organizationName?: string | null } | { __typename: 'Project', name: string } }> } };

export type RetryWebhookEventMutationVariables = Exact<{
  webhookEventId: Scalars['ID']['input'];
}>;


export type RetryWebhookEventMutation = { __typename?: 'Mutation', retryWebhookEvent?: { __typename?: 'RetryWebhookEventPayload', success: boolean } | null };

export type SendWebhookTestEventMutationVariables = Exact<{
  webhookId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
}>;


export type SendWebhookTestEventMutation = { __typename?: 'Mutation', sendWebhookTestEvent?: { __typename?: 'SendWebhookTestEventPayload', success: boolean } | null };

export type ToggleWebhookEnabledMutationVariables = Exact<{
  webhookId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type ToggleWebhookEnabledMutation = { __typename?: 'Mutation', toggleOutboundWebhookEnabled?: { __typename?: 'ToggleOutboundWebhookEnabledPayload', success: boolean } | null };

export type UpdateWebhookMutationVariables = Exact<{
  webhookId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  eventTypes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UpdateWebhookMutation = { __typename?: 'Mutation', updateOutboundWebhook?: { __typename?: 'UpdateOutboundWebhookPayload', success: boolean } | null };

export type VerifyWebhookMutationVariables = Exact<{
  webhookId: Scalars['ID']['input'];
}>;


export type VerifyWebhookMutation = { __typename?: 'Mutation', verifyOutboundWebhook?: { __typename?: 'VerifyOutboundWebhookPayload', success?: boolean | null } | null };

export type CopyWorkItemToProjectMutationVariables = Exact<{
  input: CopyToProjectInput;
}>;


export type CopyWorkItemToProjectMutation = { __typename?: 'Mutation', copyWorkItemToProject?: { __typename?: 'CopyToProjectPayload', workItem?: { __typename?: 'WorkItem', id: string, name: string } | null, targetProject?: { __typename?: 'Project', id: string, name: string } | null, targetStage?: { __typename?: 'Stage', id: string, name: string } | null, errors?: Array<{ __typename?: 'UserError', message: string }> | null } | null };

export type CreateRoadmapUpdateMutationVariables = Exact<{
  title: Scalars['String']['input'];
  content: Scalars['String']['input'];
  workItemId: Scalars['ID']['input'];
  newStageId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateRoadmapUpdateMutation = { __typename?: 'Mutation', createRoadmapUpdate?: { __typename?: 'CreateRoadmapUpdatePayload', roadmapUpdate?: { __typename?: 'RoadmapUpdate', id: string } | null } | null };

export type CreateWorkItemMovedMutationVariables = Exact<{
  workItemId: Scalars['ID']['input'];
}>;


export type CreateWorkItemMovedMutation = { __typename?: 'Mutation', createWorkItemMovedUpdate?: { __typename?: 'CreateWorkItemMovedUpdatePayload', success?: boolean | null } | null };

export type EditorWorkItemQueryVariables = Exact<{
  workItemId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type EditorWorkItemQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, fiscalYearOffset: number, stages?: { __typename?: 'StageConnection', edges?: Array<{ __typename?: 'StageEdge', cursor: string, node?: { __typename?: 'Stage', id: string, name: string, published?: boolean | null, restricted: boolean } | null }> | null } | null, projectUsers?: { __typename?: 'UserConnection', edges?: Array<{ __typename?: 'UserEdge', node?: { __typename?: 'User', id: string, displayName: string, initials: string, avatarColor: string, avatarImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null }> | null } | null }, workItem: { __typename?: 'WorkItem', id: string, name: string, publishedAt?: any | null, content?: string | null, contentType: string, stageId: string, projectedAt?: string | null, projectedAtFormat: string, heroImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string }>, changeTypes: { __typename?: 'ChangeTypeConnection', nodes?: Array<{ __typename?: 'ChangeType', id: string, name: string, color: string } | null> | null }, stage?: { __typename?: 'Stage', published?: boolean | null, restricted: boolean } | null, owner?: { __typename?: 'User', id: string, displayName: string, initials: string, avatarColor: string, avatarImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null, members: Array<{ __typename?: 'User', id: string, displayName: string, initials: string, avatarColor: string, avatarImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null }>, externalContentLinks?: Array<{ __typename?: 'ExternalContentLink', id: string, url: string, title: string, imageUrl?: string | null }> | null } };

export type FeedbackQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  feedbackableIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  count: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  organizedState?: InputMaybe<Scalars['String']['input']>;
  reaction?: InputMaybe<Reaction>;
  importance?: InputMaybe<Importance>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Where>;
}>;


export type FeedbackQuery = { __typename?: 'Query', project: { __typename?: 'Project', feedbacks?: { __typename?: 'FeedbackConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'FeedbackEdge', cursor: string, node?: { __typename?: 'Feedback', id: string, archived: boolean, createdAt: any, content: string, notes?: string | null, reaction?: Reaction | null, importance?: Importance | null, affectedCustomerEmail: string, affectedCustomer: { __typename?: 'Subscriber', id: string, email: string, initials: string, isProjectSubscriber: boolean }, reporter?: { __typename?: 'User', id: string, name?: string | null, email: string } | null, feedbackable?: { __typename: 'Announcement', id: string, archived: boolean, name: string, privatePermalink: string } | { __typename: 'Idea', id: string, archived: boolean, name: string, privatePermalink: string } | { __typename: 'WorkItem', id: string, archived: boolean, name: string, privatePermalink: string } | null } | null }> | null } | null } };

export type GetAllProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProjectsQuery = { __typename?: 'Query', viewer: { __typename?: 'ApiUser', projects: { __typename?: 'ProjectConnection', nodes?: Array<{ __typename?: 'Project', id: string, name: string } | null> | null } } };

export type WorkItemMemberCountsQueryVariables = Exact<{
  workItemId: Scalars['ID']['input'];
}>;


export type WorkItemMemberCountsQuery = { __typename?: 'Query', workItem: { __typename?: 'WorkItem', members: Array<{ __typename?: 'User', id: string }>, owner?: { __typename?: 'User', id: string } | null, projectSubscriptions?: { __typename?: 'ProjectSubscriptionConnection', totalCount: number } | null } };

export type ProjectStagesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectStagesQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, stages?: { __typename?: 'StageConnection', nodes?: Array<{ __typename?: 'Stage', id: string, name: string, description?: string | null, published?: boolean | null } | null> | null } | null } };

export type RemoveHeroImageMutationVariables = Exact<{
  workItemId: Scalars['ID']['input'];
  attachment: WorkItemHeroImage;
}>;


export type RemoveHeroImageMutation = { __typename?: 'Mutation', removeWorkItemHeroImage?: { __typename?: 'RemoveHeroImagePayload', workItem?: { __typename?: 'WorkItem', id: string, heroImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null } | null };

export type RemoveOwnerMutationVariables = Exact<{
  workItemId: Scalars['ID']['input'];
}>;


export type RemoveOwnerMutation = { __typename?: 'Mutation', removeWorkItemOwner?: { __typename?: 'RemoveOwnerPayload', workItem?: { __typename?: 'WorkItem', id: string } | null } | null };

export type SendRoadmapUpdateTestEmailMutationVariables = Exact<{
  title: Scalars['String']['input'];
  content: Scalars['String']['input'];
  workItemId: Scalars['ID']['input'];
  newStageId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SendRoadmapUpdateTestEmailMutation = { __typename?: 'Mutation', sendRoadmapUpdateTestEmail?: { __typename?: 'SendRoadmapUpdateTestEmailPayload', success: boolean } | null };

export type SendWorkItemMovedTestEmailMutationVariables = Exact<{
  workItemId: Scalars['ID']['input'];
}>;


export type SendWorkItemMovedTestEmailMutation = { __typename?: 'Mutation', createWorkItemMovedUpdate?: { __typename?: 'CreateWorkItemMovedUpdatePayload', success?: boolean | null } | null };

export type UpdateWorkItemMutationVariables = Exact<{
  workItem: UpdateWorkItemAttributes;
}>;


export type UpdateWorkItemMutation = { __typename?: 'Mutation', updateWorkItem?: { __typename?: 'UpdateWorkItemPayload', workItem?: { __typename?: 'WorkItem', id: string, name: string, content?: string | null, projectedAt?: string | null, projectedAtFormat: string, displayTimeline: boolean, heroImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null, categories: Array<{ __typename?: 'Category', id: string, name: string, backgroundColor: string, textColor: string }>, owner?: { __typename?: 'User', id: string, displayName: string, initials: string, avatarImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null } | null, members: Array<{ __typename?: 'User', id: string, displayName: string, initials: string, avatarImage?: { __typename?: 'Image', filename?: string | null, url?: string | null } | null }> } | null, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> | null }> } | null };

export type UpdatesWorkItemQueryVariables = Exact<{
  workItemId: Scalars['ID']['input'];
}>;


export type UpdatesWorkItemQuery = { __typename?: 'Query', workItem: { __typename?: 'WorkItem', id: string, roadmapUpdates: Array<{ __typename?: 'RoadmapUpdate', id: string, title: string, content: string, createdAt: any, author: { __typename?: 'User', id: string, name?: string | null, email: string } }> } };

export type WorkItemIdeasQueryVariables = Exact<{
  workItemId: Scalars['ID']['input'];
}>;


export type WorkItemIdeasQuery = { __typename?: 'Query', workItem?: { __typename?: 'Announcement' } | { __typename?: 'AnnouncementDigest' } | { __typename?: 'ApiToken' } | { __typename?: 'ApiUser' } | { __typename?: 'AtlassianApp' } | { __typename?: 'AttributeDefinition' } | { __typename?: 'AudienceDomain' } | { __typename?: 'Category' } | { __typename?: 'ChangeType' } | { __typename?: 'Channel' } | { __typename?: 'Cohort' } | { __typename?: 'ConnectedSource' } | { __typename?: 'ContentGenerator' } | { __typename?: 'EmbedApp' } | { __typename?: 'Event' } | { __typename?: 'EventType' } | { __typename?: 'ExternalContentLink' } | { __typename?: 'Feedback' } | { __typename?: 'HubspotApp' } | { __typename?: 'Idea' } | { __typename?: 'IdeaVote' } | { __typename?: 'JiraApp' } | { __typename?: 'MailAppSetting' } | { __typename?: 'MarketplaceTemplate' } | { __typename?: 'Notification' } | { __typename?: 'OnboardingTasks' } | { __typename?: 'Organization' } | { __typename?: 'OutboundWebhook' } | { __typename?: 'OutboundWebhookEvent' } | { __typename?: 'Project' } | { __typename?: 'ProjectSubscription' } | { __typename?: 'ProjectView' } | { __typename?: 'RoadmapUpdate' } | { __typename?: 'Rollup' } | { __typename?: 'SecureConnectionSettings' } | { __typename?: 'SimpleMailApp' } | { __typename?: 'SimpleMailTransport' } | { __typename?: 'SlackApp' } | { __typename?: 'SlackAppTransport' } | { __typename?: 'SlackCommandApp' } | { __typename?: 'Stage' } | { __typename?: 'Subscriber' } | { __typename?: 'Subscription' } | { __typename?: 'Template' } | { __typename?: 'User' } | { __typename?: 'VideoAsset' } | { __typename?: 'Vote' } | { __typename?: 'WorkItem', ideas: Array<{ __typename?: 'Idea', id: string, name: string }> } | { __typename?: 'Workspace' } | { __typename?: 'ZapierApp' } | null };

export type WorkItemShowQueryVariables = Exact<{
  workItemId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type WorkItemShowQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, roadmapMoveUpdatesEnabled: boolean, roadmapWatchedStages: Array<string>, stages?: { __typename?: 'StageConnection', nodes?: Array<{ __typename?: 'Stage', id: string, name: string } | null> | null } | null }, workItem: { __typename?: 'WorkItem', id: string, name: string, displayTimeline: boolean, events?: { __typename?: 'EventConnection', nodes?: Array<{ __typename?: 'Event', id: string, eventType: string, createdAt: any, internalOnly: boolean, data?: any | null } | null> | null } | null, stage?: { __typename?: 'Stage', id: string, published?: boolean | null, showOnPublicRoadmap: boolean } | null, ideas: Array<{ __typename?: 'Idea', id: string, privatePermalink: string, name: string }> } };

export type PublishWorkItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PublishWorkItemMutation = { __typename?: 'Mutation', publishWorkItem?: { __typename?: 'PublishWorkItemPayload', workItem?: { __typename?: 'WorkItem', id: string, state: WorkItemStateEnum, publishedAt?: any | null } | null } | null };

export type UnpublishWorkItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnpublishWorkItemMutation = { __typename?: 'Mutation', unpublishWorkItem?: { __typename?: 'UnpublishWorkItemPayload', workItem?: { __typename?: 'WorkItem', id: string, state: WorkItemStateEnum, publishedAt?: any | null } | null } | null };


export const TableProjectSubscriptionsFragmentDoc = `
    fragment TableProjectSubscriptions on Subscribable {
  __isSubscribable: __typename
  projectSubscriptions(first: $count, confirmed: $confirmed, after: $cursor) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        createdAt
        source
        categories {
          id
          name
          backgroundColor
          textColor
        }
        subscriber {
          email
          confirmedAt
          isProjectSubscriber
          __typename
          id
          initials
        }
        transportTypes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  id
}
    `;
export const Card_AnnouncementFragmentDoc = `
    fragment Card_announcement on Announcement {
  id
  state
  headline
  content
  excerptWithFallback
  updatedAt
  scheduledAt
  scheduledAtTimezone
  publishedAt
  deactivatedAt
  shouldNotifyPageSubscribers
  inPublishedDigest
}
    `;
export const RqMarketplaceTemplatesModalFragmentDoc = `
    fragment RqMarketplaceTemplatesModal on Project {
  marketplaceTemplates {
    edges {
      node {
        id
        name
        category
        coverImage {
          url
        }
        position
      }
    }
  }
}
    `;
export const CategoryTagsFragmentDoc = `
    fragment CategoryTags on Project {
  id
  publicPageUrl
  slackAuthenticationUrl
  totalConfirmedSubscriptions
  slackSubscription {
    id
  }
  slackProjectSubscription {
    id
  }
  emailSettings {
    primaryColor
    replyToEmail
  }
  categories {
    nodes {
      id
      name
      backgroundColor
      textColor
    }
  }
}
    `;
export const ChannelsFragmentDoc = `
    fragment Channels on Announcement {
  id
  name
  shouldNotifyPageSubscribers
  notificationsExcerptOnly
  headline
  subjectLine
  slackMessage
  emailSubscriberCounts: subscriberCounts(transport: SimpleMailTransport)
  slackSubscriberCounts: subscriberCounts(transport: SlackAppTransport)
  totalSubscriberCounts
  slackChannelCounts
  state
  categories {
    id
    name
    backgroundColor
    textColor
  }
  workItems {
    nodes {
      id
      name
    }
  }
}
    `;
export const UploadFieldImageFragmentDoc = `
    fragment UploadFieldImage on Image {
  filename
  url
}
    `;
export const ContentFragmentDoc = `
    fragment Content on Announcement {
  id
  heroImage {
    ...UploadFieldImage
  }
  categories {
    id
    name
    backgroundColor
  }
  changeTypes {
    nodes {
      id
      name
    }
  }
  workItems {
    edges {
      node {
        id
        name
      }
    }
  }
  headline
  content
  contentType
  excerpt
  excerptWithFallback
  publicPermalink
  state
  publishedAt
  slug
  title
  titleWithFallback
  description
  descriptionWithFallback
  author
  authorWithFallback
  shareImage {
    ...UploadFieldImage
  }
  doNotIndex
  connectedSources {
    nodes {
      id
      url
      name
      providerName
    }
  }
}
    `;
export const PreviewFragmentDoc = `
    fragment Preview on Announcement {
  id
  state
  slug
  publicPermalink
  headline
  content
  shouldNotifyPageSubscribers
  slackSubscriberCount: subscriberCounts(transport: SlackAppTransport)
  emailSubscriberCount: subscriberCounts(transport: SimpleMailTransport)
  totalSubscriberCounts
  scheduledAtTimezone
  scheduledAt
}
    `;
export const EditorProjectFragmentDoc = `
    fragment EditorProject on Project {
  id
  primaryColor
  emailSettings {
    replyToEmail
  }
  totalConfirmedSubscriptions
  slug
  name
  secured
  hideNotificationContent
  publicPageUrl
  slackAuthenticationUrl
  slackSubscription {
    id
  }
  slackProjectSubscription {
    id
  }
  emailSettings {
    primaryColor
    logo {
      ...UploadFieldImage
    }
  }
}
    `;
export const PublishedAnnouncementFragmentDoc = `
    fragment PublishedAnnouncement on Announcement {
  id
  headline
  publicPermalink
  shouldNotifyPageSubscribers
  emailSubscriberCounts: subscriberCounts(transport: SimpleMailTransport)
  slackSubscriberCounts: subscriberCounts(transport: SlackAppTransport)
  totalSubscriberCounts
}
    `;
export const DashboardFragmentDoc = `
    fragment Dashboard on Announcement {
  id
  state
  headline
  content
  updatedAt
  scheduledAt
  scheduledAtTimezone
  publishedAt
  deactivatedAt
  shouldNotifyPageSubscribers
  excerptWithFallback
  inPublishedDigest
  categories {
    id
    name
    color
  }
  changeTypes {
    nodes {
      id
      name
    }
  }
}
    `;
export const WizardAnnouncementStepFragmentDoc = `
    fragment WizardAnnouncementStep on Project {
  id
  name
  primaryColor
  primaryTextColor
}
    `;
export const WizardCategoriesStepFragmentDoc = `
    fragment WizardCategoriesStep on Project {
  id
  name
  categories(first: 100) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;
export const WizardCustomizeStepFragmentDoc = `
    fragment WizardCustomizeStep on Project {
  id
  emailSettings {
    id
  }
  name
  primaryColor
  primaryTextColor
  supportingPalette
  logo {
    ...UploadFieldImage
  }
}
    `;
export const WizardInfoStepFragmentDoc = `
    fragment WizardInfoStep on Project {
  id
  emailSettings {
    id
  }
  name
  slug
  referralSource
}
    `;
export const WizardPublicPagePreviewFragmentDoc = `
    fragment WizardPublicPagePreview on Project {
  id
  name
  slug
  primaryColor
  supportingPalette
  logo {
    url
  }
  emailProjectSubscription {
    id
  }
  categories(first: 100) {
    edges {
      node {
        id
        name
      }
    }
  }
  eventTypes {
    nodes {
      id
    }
  }
}
    `;
export const WizardSubscribersStepFragmentDoc = `
    fragment WizardSubscribersStep on Project {
  id
  name
  emailProjectSubscription {
    id
  }
}
    `;
export const RqProfileFragmentFragmentDoc = `
    fragment RqProfileFragment on User {
  id
  name
  firstName
  lastName
  email
  avatarColor
  avatarImage {
    ...UploadFieldImage
  }
  defaultProject {
    id
    name
    organization {
      name
    }
  }
  projects {
    nodes {
      id
      name
      organization {
        name
      }
    }
  }
}
    `;
export const RqNotificationsFragmentFragmentDoc = `
    fragment RqNotificationsFragment on Project {
  id
  name
  emailSubscription {
    id
  }
  slackSubscription {
    id
  }
  subscriberReportEnabled
  feedbackViaEmailEnabled
  feedbackViaSlackEnabled
  slackAuthenticationUrl
  publicPageUrl
}
    `;
export const ProjectViewItemFragmentDoc = `
    fragment ProjectViewItem on ProjectView {
  id
  name
  description
  slug
  publicPermalink
  security
  restricted
  editable
  archived
  archivedAt
  categories {
    id
  }
  stages {
    id
  }
}
    `;
export const AnalyticsCardEmailDocument = `
    query AnalyticsCardEmail($projectId: ID!, $startDate: ISO8601DateTime!, $endDate: ISO8601DateTime!) {
  analytics {
    announcementAnalytics(projectId: $projectId) {
      emailEngagement(tzOffset: null, startDate: $startDate, endDate: $endDate) {
        sentCount
        openRate
        clickToOpenRate
        clickRate
      }
    }
  }
}
    `;

export const useAnalyticsCardEmailQuery = <
      TData = AnalyticsCardEmailQuery,
      TError = unknown
    >(
      variables: AnalyticsCardEmailQueryVariables,
      options?: Omit<UseQueryOptions<AnalyticsCardEmailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnalyticsCardEmailQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnalyticsCardEmailQuery, TError, TData>(
      {
    queryKey: ['AnalyticsCardEmail', variables],
    queryFn: useFetchData<AnalyticsCardEmailQuery, AnalyticsCardEmailQueryVariables>(AnalyticsCardEmailDocument).bind(null, variables),
    ...options
  }
    )};

useAnalyticsCardEmailQuery.getKey = (variables: AnalyticsCardEmailQueryVariables) => ['AnalyticsCardEmail', variables];

export const useInfiniteAnalyticsCardEmailQuery = <
      TData = InfiniteData<AnalyticsCardEmailQuery>,
      TError = unknown
    >(
      variables: AnalyticsCardEmailQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AnalyticsCardEmailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AnalyticsCardEmailQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AnalyticsCardEmailQuery, AnalyticsCardEmailQueryVariables>(AnalyticsCardEmailDocument)
    return useInfiniteQuery<AnalyticsCardEmailQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AnalyticsCardEmail.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAnalyticsCardEmailQuery.getKey = (variables: AnalyticsCardEmailQueryVariables) => ['AnalyticsCardEmail.infinite', variables];

export const AnalyticsCardSubscriberDocument = `
    query AnalyticsCardSubscriber($projectId: ID!, $startDate: ISO8601DateTime!, $endDate: ISO8601DateTime!) {
  analytics {
    announcementAnalytics(projectId: $projectId) {
      newSubscribers(startDate: $startDate, endDate: $endDate)
      pageViews(startDate: $startDate, endDate: $endDate)
      showPageViewsDeprecated
      pageViewsDeprecated(startDate: $startDate, endDate: $endDate)
    }
  }
}
    `;

export const useAnalyticsCardSubscriberQuery = <
      TData = AnalyticsCardSubscriberQuery,
      TError = unknown
    >(
      variables: AnalyticsCardSubscriberQueryVariables,
      options?: Omit<UseQueryOptions<AnalyticsCardSubscriberQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnalyticsCardSubscriberQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnalyticsCardSubscriberQuery, TError, TData>(
      {
    queryKey: ['AnalyticsCardSubscriber', variables],
    queryFn: useFetchData<AnalyticsCardSubscriberQuery, AnalyticsCardSubscriberQueryVariables>(AnalyticsCardSubscriberDocument).bind(null, variables),
    ...options
  }
    )};

useAnalyticsCardSubscriberQuery.getKey = (variables: AnalyticsCardSubscriberQueryVariables) => ['AnalyticsCardSubscriber', variables];

export const useInfiniteAnalyticsCardSubscriberQuery = <
      TData = InfiniteData<AnalyticsCardSubscriberQuery>,
      TError = unknown
    >(
      variables: AnalyticsCardSubscriberQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AnalyticsCardSubscriberQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AnalyticsCardSubscriberQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AnalyticsCardSubscriberQuery, AnalyticsCardSubscriberQueryVariables>(AnalyticsCardSubscriberDocument)
    return useInfiniteQuery<AnalyticsCardSubscriberQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AnalyticsCardSubscriber.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAnalyticsCardSubscriberQuery.getKey = (variables: AnalyticsCardSubscriberQueryVariables) => ['AnalyticsCardSubscriber.infinite', variables];

export const AnalyticsCardVotesAndFeedbackDocument = `
    query AnalyticsCardVotesAndFeedback($projectId: ID!, $startDate: ISO8601DateTime!, $endDate: ISO8601DateTime!) {
  analytics {
    feedbackAnalytics(projectId: $projectId) {
      newVotes(startDate: $startDate, endDate: $endDate)
      newFeedbackCount(startDate: $startDate, endDate: $endDate)
    }
  }
}
    `;

export const useAnalyticsCardVotesAndFeedbackQuery = <
      TData = AnalyticsCardVotesAndFeedbackQuery,
      TError = unknown
    >(
      variables: AnalyticsCardVotesAndFeedbackQueryVariables,
      options?: Omit<UseQueryOptions<AnalyticsCardVotesAndFeedbackQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnalyticsCardVotesAndFeedbackQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnalyticsCardVotesAndFeedbackQuery, TError, TData>(
      {
    queryKey: ['AnalyticsCardVotesAndFeedback', variables],
    queryFn: useFetchData<AnalyticsCardVotesAndFeedbackQuery, AnalyticsCardVotesAndFeedbackQueryVariables>(AnalyticsCardVotesAndFeedbackDocument).bind(null, variables),
    ...options
  }
    )};

useAnalyticsCardVotesAndFeedbackQuery.getKey = (variables: AnalyticsCardVotesAndFeedbackQueryVariables) => ['AnalyticsCardVotesAndFeedback', variables];

export const useInfiniteAnalyticsCardVotesAndFeedbackQuery = <
      TData = InfiniteData<AnalyticsCardVotesAndFeedbackQuery>,
      TError = unknown
    >(
      variables: AnalyticsCardVotesAndFeedbackQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AnalyticsCardVotesAndFeedbackQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AnalyticsCardVotesAndFeedbackQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AnalyticsCardVotesAndFeedbackQuery, AnalyticsCardVotesAndFeedbackQueryVariables>(AnalyticsCardVotesAndFeedbackDocument)
    return useInfiniteQuery<AnalyticsCardVotesAndFeedbackQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AnalyticsCardVotesAndFeedback.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAnalyticsCardVotesAndFeedbackQuery.getKey = (variables: AnalyticsCardVotesAndFeedbackQueryVariables) => ['AnalyticsCardVotesAndFeedback.infinite', variables];

export const NotificationsPerformanceDocument = `
    query NotificationsPerformance($projectId: ID!, $startDate: ISO8601DateTime!, $endDate: ISO8601DateTime!) {
  analytics {
    announcementAnalytics(projectId: $projectId) {
      notificationPerformance(startDate: $startDate, endDate: $endDate) {
        announcement: x
        value: y
        type
      }
      notificationPerformanceTable(startDate: $startDate, endDate: $endDate) {
        xValue
        yValue
        metaValues
      }
    }
  }
}
    `;

export const useNotificationsPerformanceQuery = <
      TData = NotificationsPerformanceQuery,
      TError = unknown
    >(
      variables: NotificationsPerformanceQueryVariables,
      options?: Omit<UseQueryOptions<NotificationsPerformanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<NotificationsPerformanceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<NotificationsPerformanceQuery, TError, TData>(
      {
    queryKey: ['NotificationsPerformance', variables],
    queryFn: useFetchData<NotificationsPerformanceQuery, NotificationsPerformanceQueryVariables>(NotificationsPerformanceDocument).bind(null, variables),
    ...options
  }
    )};

useNotificationsPerformanceQuery.getKey = (variables: NotificationsPerformanceQueryVariables) => ['NotificationsPerformance', variables];

export const useInfiniteNotificationsPerformanceQuery = <
      TData = InfiniteData<NotificationsPerformanceQuery>,
      TError = unknown
    >(
      variables: NotificationsPerformanceQueryVariables,
      options: Omit<UseInfiniteQueryOptions<NotificationsPerformanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<NotificationsPerformanceQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<NotificationsPerformanceQuery, NotificationsPerformanceQueryVariables>(NotificationsPerformanceDocument)
    return useInfiniteQuery<NotificationsPerformanceQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['NotificationsPerformance.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteNotificationsPerformanceQuery.getKey = (variables: NotificationsPerformanceQueryVariables) => ['NotificationsPerformance.infinite', variables];

export const NotificationsRatePerformanceDocument = `
    query NotificationsRatePerformance($projectId: ID!, $startDate: ISO8601DateTime!, $endDate: ISO8601DateTime!) {
  analytics {
    announcementAnalytics(projectId: $projectId) {
      notificationRatePerformance(startDate: $startDate, endDate: $endDate) {
        announcement: x
        rate: y
        type
      }
      notificationRatePerformanceTable(startDate: $startDate, endDate: $endDate) {
        xValue
        yValue
        metaValues
      }
    }
  }
}
    `;

export const useNotificationsRatePerformanceQuery = <
      TData = NotificationsRatePerformanceQuery,
      TError = unknown
    >(
      variables: NotificationsRatePerformanceQueryVariables,
      options?: Omit<UseQueryOptions<NotificationsRatePerformanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<NotificationsRatePerformanceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<NotificationsRatePerformanceQuery, TError, TData>(
      {
    queryKey: ['NotificationsRatePerformance', variables],
    queryFn: useFetchData<NotificationsRatePerformanceQuery, NotificationsRatePerformanceQueryVariables>(NotificationsRatePerformanceDocument).bind(null, variables),
    ...options
  }
    )};

useNotificationsRatePerformanceQuery.getKey = (variables: NotificationsRatePerformanceQueryVariables) => ['NotificationsRatePerformance', variables];

export const useInfiniteNotificationsRatePerformanceQuery = <
      TData = InfiniteData<NotificationsRatePerformanceQuery>,
      TError = unknown
    >(
      variables: NotificationsRatePerformanceQueryVariables,
      options: Omit<UseInfiniteQueryOptions<NotificationsRatePerformanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<NotificationsRatePerformanceQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<NotificationsRatePerformanceQuery, NotificationsRatePerformanceQueryVariables>(NotificationsRatePerformanceDocument)
    return useInfiniteQuery<NotificationsRatePerformanceQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['NotificationsRatePerformance.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteNotificationsRatePerformanceQuery.getKey = (variables: NotificationsRatePerformanceQueryVariables) => ['NotificationsRatePerformance.infinite', variables];

export const AnalyticsOpenRatesByDayDocument = `
    query AnalyticsOpenRatesByDay($projectId: ID!, $startDate: ISO8601DateTime!, $endDate: ISO8601DateTime!) {
  analytics {
    announcementAnalytics(projectId: $projectId) {
      openRatesByDayOfWeek(startDate: $startDate, endDate: $endDate) {
        day: x
        rate: y
      }
    }
  }
}
    `;

export const useAnalyticsOpenRatesByDayQuery = <
      TData = AnalyticsOpenRatesByDayQuery,
      TError = unknown
    >(
      variables: AnalyticsOpenRatesByDayQueryVariables,
      options?: Omit<UseQueryOptions<AnalyticsOpenRatesByDayQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnalyticsOpenRatesByDayQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnalyticsOpenRatesByDayQuery, TError, TData>(
      {
    queryKey: ['AnalyticsOpenRatesByDay', variables],
    queryFn: useFetchData<AnalyticsOpenRatesByDayQuery, AnalyticsOpenRatesByDayQueryVariables>(AnalyticsOpenRatesByDayDocument).bind(null, variables),
    ...options
  }
    )};

useAnalyticsOpenRatesByDayQuery.getKey = (variables: AnalyticsOpenRatesByDayQueryVariables) => ['AnalyticsOpenRatesByDay', variables];

export const useInfiniteAnalyticsOpenRatesByDayQuery = <
      TData = InfiniteData<AnalyticsOpenRatesByDayQuery>,
      TError = unknown
    >(
      variables: AnalyticsOpenRatesByDayQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AnalyticsOpenRatesByDayQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AnalyticsOpenRatesByDayQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AnalyticsOpenRatesByDayQuery, AnalyticsOpenRatesByDayQueryVariables>(AnalyticsOpenRatesByDayDocument)
    return useInfiniteQuery<AnalyticsOpenRatesByDayQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AnalyticsOpenRatesByDay.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAnalyticsOpenRatesByDayQuery.getKey = (variables: AnalyticsOpenRatesByDayQueryVariables) => ['AnalyticsOpenRatesByDay.infinite', variables];

export const AvgFeedbackSentimentDocument = `
    query AvgFeedbackSentiment($projectId: ID!, $startDate: ISO8601DateTime!, $endDate: ISO8601DateTime!) {
  analytics {
    feedbackAnalytics(projectId: $projectId) {
      avgFeedbackSentiment(startDate: $startDate, endDate: $endDate) {
        date: x
        score: y
      }
    }
  }
}
    `;

export const useAvgFeedbackSentimentQuery = <
      TData = AvgFeedbackSentimentQuery,
      TError = unknown
    >(
      variables: AvgFeedbackSentimentQueryVariables,
      options?: Omit<UseQueryOptions<AvgFeedbackSentimentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AvgFeedbackSentimentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AvgFeedbackSentimentQuery, TError, TData>(
      {
    queryKey: ['AvgFeedbackSentiment', variables],
    queryFn: useFetchData<AvgFeedbackSentimentQuery, AvgFeedbackSentimentQueryVariables>(AvgFeedbackSentimentDocument).bind(null, variables),
    ...options
  }
    )};

useAvgFeedbackSentimentQuery.getKey = (variables: AvgFeedbackSentimentQueryVariables) => ['AvgFeedbackSentiment', variables];

export const useInfiniteAvgFeedbackSentimentQuery = <
      TData = InfiniteData<AvgFeedbackSentimentQuery>,
      TError = unknown
    >(
      variables: AvgFeedbackSentimentQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AvgFeedbackSentimentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AvgFeedbackSentimentQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AvgFeedbackSentimentQuery, AvgFeedbackSentimentQueryVariables>(AvgFeedbackSentimentDocument)
    return useInfiniteQuery<AvgFeedbackSentimentQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AvgFeedbackSentiment.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAvgFeedbackSentimentQuery.getKey = (variables: AvgFeedbackSentimentQueryVariables) => ['AvgFeedbackSentiment.infinite', variables];

export const FeedbackBySentimentDocument = `
    query FeedbackBySentiment($projectId: ID!, $startDate: ISO8601DateTime!, $endDate: ISO8601DateTime!) {
  analytics {
    feedbackAnalytics(projectId: $projectId) {
      feedbacksBySentiment(startDate: $startDate, endDate: $endDate) {
        date: x
        y
        type
      }
    }
  }
}
    `;

export const useFeedbackBySentimentQuery = <
      TData = FeedbackBySentimentQuery,
      TError = unknown
    >(
      variables: FeedbackBySentimentQueryVariables,
      options?: Omit<UseQueryOptions<FeedbackBySentimentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FeedbackBySentimentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FeedbackBySentimentQuery, TError, TData>(
      {
    queryKey: ['FeedbackBySentiment', variables],
    queryFn: useFetchData<FeedbackBySentimentQuery, FeedbackBySentimentQueryVariables>(FeedbackBySentimentDocument).bind(null, variables),
    ...options
  }
    )};

useFeedbackBySentimentQuery.getKey = (variables: FeedbackBySentimentQueryVariables) => ['FeedbackBySentiment', variables];

export const useInfiniteFeedbackBySentimentQuery = <
      TData = InfiniteData<FeedbackBySentimentQuery>,
      TError = unknown
    >(
      variables: FeedbackBySentimentQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FeedbackBySentimentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FeedbackBySentimentQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<FeedbackBySentimentQuery, FeedbackBySentimentQueryVariables>(FeedbackBySentimentDocument)
    return useInfiniteQuery<FeedbackBySentimentQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FeedbackBySentiment.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteFeedbackBySentimentQuery.getKey = (variables: FeedbackBySentimentQueryVariables) => ['FeedbackBySentiment.infinite', variables];

export const FeedbackWordStatsDocument = `
    query FeedbackWordStats($projectId: ID!, $startDate: ISO8601DateTime!, $endDate: ISO8601DateTime!) {
  analytics {
    feedbackAnalytics(projectId: $projectId) {
      feedbackWordStats(startDate: $startDate, endDate: $endDate) {
        xValue
        yValue
      }
    }
  }
}
    `;

export const useFeedbackWordStatsQuery = <
      TData = FeedbackWordStatsQuery,
      TError = unknown
    >(
      variables: FeedbackWordStatsQueryVariables,
      options?: Omit<UseQueryOptions<FeedbackWordStatsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FeedbackWordStatsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FeedbackWordStatsQuery, TError, TData>(
      {
    queryKey: ['FeedbackWordStats', variables],
    queryFn: useFetchData<FeedbackWordStatsQuery, FeedbackWordStatsQueryVariables>(FeedbackWordStatsDocument).bind(null, variables),
    ...options
  }
    )};

useFeedbackWordStatsQuery.getKey = (variables: FeedbackWordStatsQueryVariables) => ['FeedbackWordStats', variables];

export const useInfiniteFeedbackWordStatsQuery = <
      TData = InfiniteData<FeedbackWordStatsQuery>,
      TError = unknown
    >(
      variables: FeedbackWordStatsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FeedbackWordStatsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FeedbackWordStatsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<FeedbackWordStatsQuery, FeedbackWordStatsQueryVariables>(FeedbackWordStatsDocument)
    return useInfiniteQuery<FeedbackWordStatsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FeedbackWordStats.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteFeedbackWordStatsQuery.getKey = (variables: FeedbackWordStatsQueryVariables) => ['FeedbackWordStats.infinite', variables];

export const RecentlySubscribedDomainsDocument = `
    query RecentlySubscribedDomains($projectId: ID!, $startDate: ISO8601DateTime!, $endDate: ISO8601DateTime!) {
  analytics {
    subscriberAnalytics(projectId: $projectId) {
      recentlySubscribedDomains(startDate: $startDate, endDate: $endDate) {
        yValue
        xValue
        metaValues
      }
    }
  }
}
    `;

export const useRecentlySubscribedDomainsQuery = <
      TData = RecentlySubscribedDomainsQuery,
      TError = unknown
    >(
      variables: RecentlySubscribedDomainsQueryVariables,
      options?: Omit<UseQueryOptions<RecentlySubscribedDomainsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<RecentlySubscribedDomainsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<RecentlySubscribedDomainsQuery, TError, TData>(
      {
    queryKey: ['RecentlySubscribedDomains', variables],
    queryFn: useFetchData<RecentlySubscribedDomainsQuery, RecentlySubscribedDomainsQueryVariables>(RecentlySubscribedDomainsDocument).bind(null, variables),
    ...options
  }
    )};

useRecentlySubscribedDomainsQuery.getKey = (variables: RecentlySubscribedDomainsQueryVariables) => ['RecentlySubscribedDomains', variables];

export const useInfiniteRecentlySubscribedDomainsQuery = <
      TData = InfiniteData<RecentlySubscribedDomainsQuery>,
      TError = unknown
    >(
      variables: RecentlySubscribedDomainsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<RecentlySubscribedDomainsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<RecentlySubscribedDomainsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<RecentlySubscribedDomainsQuery, RecentlySubscribedDomainsQueryVariables>(RecentlySubscribedDomainsDocument)
    return useInfiniteQuery<RecentlySubscribedDomainsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['RecentlySubscribedDomains.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteRecentlySubscribedDomainsQuery.getKey = (variables: RecentlySubscribedDomainsQueryVariables) => ['RecentlySubscribedDomains.infinite', variables];

export const TopCategoriesBySubscribersDocument = `
    query TopCategoriesBySubscribers($projectId: ID!, $startDate: ISO8601DateTime!, $endDate: ISO8601DateTime!) {
  analytics {
    subscriberAnalytics(projectId: $projectId) {
      subscribersByCategory(startDate: $startDate, endDate: $endDate) {
        xValue
        yValue
      }
    }
  }
}
    `;

export const useTopCategoriesBySubscribersQuery = <
      TData = TopCategoriesBySubscribersQuery,
      TError = unknown
    >(
      variables: TopCategoriesBySubscribersQueryVariables,
      options?: Omit<UseQueryOptions<TopCategoriesBySubscribersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TopCategoriesBySubscribersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TopCategoriesBySubscribersQuery, TError, TData>(
      {
    queryKey: ['TopCategoriesBySubscribers', variables],
    queryFn: useFetchData<TopCategoriesBySubscribersQuery, TopCategoriesBySubscribersQueryVariables>(TopCategoriesBySubscribersDocument).bind(null, variables),
    ...options
  }
    )};

useTopCategoriesBySubscribersQuery.getKey = (variables: TopCategoriesBySubscribersQueryVariables) => ['TopCategoriesBySubscribers', variables];

export const useInfiniteTopCategoriesBySubscribersQuery = <
      TData = InfiniteData<TopCategoriesBySubscribersQuery>,
      TError = unknown
    >(
      variables: TopCategoriesBySubscribersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<TopCategoriesBySubscribersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<TopCategoriesBySubscribersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<TopCategoriesBySubscribersQuery, TopCategoriesBySubscribersQueryVariables>(TopCategoriesBySubscribersDocument)
    return useInfiniteQuery<TopCategoriesBySubscribersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['TopCategoriesBySubscribers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteTopCategoriesBySubscribersQuery.getKey = (variables: TopCategoriesBySubscribersQueryVariables) => ['TopCategoriesBySubscribers.infinite', variables];

export const AnalyticsOpenRatesByHourDocument = `
    query AnalyticsOpenRatesByHour($projectId: ID!, $startDate: ISO8601DateTime!, $endDate: ISO8601DateTime!) {
  analytics {
    announcementAnalytics(projectId: $projectId) {
      openRatesByHourOfDay(startDate: $startDate, endDate: $endDate) {
        hour: x
        rate: y
      }
    }
  }
}
    `;

export const useAnalyticsOpenRatesByHourQuery = <
      TData = AnalyticsOpenRatesByHourQuery,
      TError = unknown
    >(
      variables: AnalyticsOpenRatesByHourQueryVariables,
      options?: Omit<UseQueryOptions<AnalyticsOpenRatesByHourQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnalyticsOpenRatesByHourQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnalyticsOpenRatesByHourQuery, TError, TData>(
      {
    queryKey: ['AnalyticsOpenRatesByHour', variables],
    queryFn: useFetchData<AnalyticsOpenRatesByHourQuery, AnalyticsOpenRatesByHourQueryVariables>(AnalyticsOpenRatesByHourDocument).bind(null, variables),
    ...options
  }
    )};

useAnalyticsOpenRatesByHourQuery.getKey = (variables: AnalyticsOpenRatesByHourQueryVariables) => ['AnalyticsOpenRatesByHour', variables];

export const useInfiniteAnalyticsOpenRatesByHourQuery = <
      TData = InfiniteData<AnalyticsOpenRatesByHourQuery>,
      TError = unknown
    >(
      variables: AnalyticsOpenRatesByHourQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AnalyticsOpenRatesByHourQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AnalyticsOpenRatesByHourQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AnalyticsOpenRatesByHourQuery, AnalyticsOpenRatesByHourQueryVariables>(AnalyticsOpenRatesByHourDocument)
    return useInfiniteQuery<AnalyticsOpenRatesByHourQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AnalyticsOpenRatesByHour.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAnalyticsOpenRatesByHourQuery.getKey = (variables: AnalyticsOpenRatesByHourQueryVariables) => ['AnalyticsOpenRatesByHour.infinite', variables];

export const ViewsByWorkItemDocument = `
    query ViewsByWorkItem($projectId: ID!, $startDate: ISO8601DateTime!, $endDate: ISO8601DateTime!) {
  analytics {
    workItemAnalytics(projectId: $projectId) {
      viewsByWorkItem(startDate: $startDate, endDate: $endDate) {
        xValue
        yValue
        metaValues
      }
    }
  }
}
    `;

export const useViewsByWorkItemQuery = <
      TData = ViewsByWorkItemQuery,
      TError = unknown
    >(
      variables: ViewsByWorkItemQueryVariables,
      options?: Omit<UseQueryOptions<ViewsByWorkItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ViewsByWorkItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ViewsByWorkItemQuery, TError, TData>(
      {
    queryKey: ['ViewsByWorkItem', variables],
    queryFn: useFetchData<ViewsByWorkItemQuery, ViewsByWorkItemQueryVariables>(ViewsByWorkItemDocument).bind(null, variables),
    ...options
  }
    )};

useViewsByWorkItemQuery.getKey = (variables: ViewsByWorkItemQueryVariables) => ['ViewsByWorkItem', variables];

export const useInfiniteViewsByWorkItemQuery = <
      TData = InfiniteData<ViewsByWorkItemQuery>,
      TError = unknown
    >(
      variables: ViewsByWorkItemQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ViewsByWorkItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ViewsByWorkItemQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ViewsByWorkItemQuery, ViewsByWorkItemQueryVariables>(ViewsByWorkItemDocument)
    return useInfiniteQuery<ViewsByWorkItemQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ViewsByWorkItem.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteViewsByWorkItemQuery.getKey = (variables: ViewsByWorkItemQueryVariables) => ['ViewsByWorkItem.infinite', variables];

export const ViewsByAnnouncementDocument = `
    query ViewsByAnnouncement($projectId: ID!, $startDate: ISO8601DateTime!, $endDate: ISO8601DateTime!) {
  analytics {
    announcementAnalytics(projectId: $projectId) {
      viewsByAnnouncement(startDate: $startDate, endDate: $endDate) {
        xValue
        yValue
        metaValues
      }
    }
  }
}
    `;

export const useViewsByAnnouncementQuery = <
      TData = ViewsByAnnouncementQuery,
      TError = unknown
    >(
      variables: ViewsByAnnouncementQueryVariables,
      options?: Omit<UseQueryOptions<ViewsByAnnouncementQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ViewsByAnnouncementQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ViewsByAnnouncementQuery, TError, TData>(
      {
    queryKey: ['ViewsByAnnouncement', variables],
    queryFn: useFetchData<ViewsByAnnouncementQuery, ViewsByAnnouncementQueryVariables>(ViewsByAnnouncementDocument).bind(null, variables),
    ...options
  }
    )};

useViewsByAnnouncementQuery.getKey = (variables: ViewsByAnnouncementQueryVariables) => ['ViewsByAnnouncement', variables];

export const useInfiniteViewsByAnnouncementQuery = <
      TData = InfiniteData<ViewsByAnnouncementQuery>,
      TError = unknown
    >(
      variables: ViewsByAnnouncementQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ViewsByAnnouncementQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ViewsByAnnouncementQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ViewsByAnnouncementQuery, ViewsByAnnouncementQueryVariables>(ViewsByAnnouncementDocument)
    return useInfiniteQuery<ViewsByAnnouncementQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ViewsByAnnouncement.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteViewsByAnnouncementQuery.getKey = (variables: ViewsByAnnouncementQueryVariables) => ['ViewsByAnnouncement.infinite', variables];

export const EmbedViewsDocument = `
    query EmbedViews($projectId: ID!, $startDate: ISO8601DateTime!, $endDate: ISO8601DateTime!) {
  analytics {
    announcementAnalytics(projectId: $projectId) {
      embedAnnouncementViews(startDate: $startDate, endDate: $endDate) {
        x
        y
      }
    }
  }
}
    `;

export const useEmbedViewsQuery = <
      TData = EmbedViewsQuery,
      TError = unknown
    >(
      variables: EmbedViewsQueryVariables,
      options?: Omit<UseQueryOptions<EmbedViewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<EmbedViewsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<EmbedViewsQuery, TError, TData>(
      {
    queryKey: ['EmbedViews', variables],
    queryFn: useFetchData<EmbedViewsQuery, EmbedViewsQueryVariables>(EmbedViewsDocument).bind(null, variables),
    ...options
  }
    )};

useEmbedViewsQuery.getKey = (variables: EmbedViewsQueryVariables) => ['EmbedViews', variables];

export const useInfiniteEmbedViewsQuery = <
      TData = InfiniteData<EmbedViewsQuery>,
      TError = unknown
    >(
      variables: EmbedViewsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<EmbedViewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<EmbedViewsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<EmbedViewsQuery, EmbedViewsQueryVariables>(EmbedViewsDocument)
    return useInfiniteQuery<EmbedViewsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['EmbedViews.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteEmbedViewsQuery.getKey = (variables: EmbedViewsQueryVariables) => ['EmbedViews.infinite', variables];

export const StaleWorkItemsDocument = `
    query StaleWorkItems($projectId: ID!) {
  analytics {
    workItemAnalytics(projectId: $projectId) {
      staleWorkItems {
        xValue
        yValue
        metaValues
      }
    }
  }
}
    `;

export const useStaleWorkItemsQuery = <
      TData = StaleWorkItemsQuery,
      TError = unknown
    >(
      variables: StaleWorkItemsQueryVariables,
      options?: Omit<UseQueryOptions<StaleWorkItemsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<StaleWorkItemsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<StaleWorkItemsQuery, TError, TData>(
      {
    queryKey: ['StaleWorkItems', variables],
    queryFn: useFetchData<StaleWorkItemsQuery, StaleWorkItemsQueryVariables>(StaleWorkItemsDocument).bind(null, variables),
    ...options
  }
    )};

useStaleWorkItemsQuery.getKey = (variables: StaleWorkItemsQueryVariables) => ['StaleWorkItems', variables];

export const useInfiniteStaleWorkItemsQuery = <
      TData = InfiniteData<StaleWorkItemsQuery>,
      TError = unknown
    >(
      variables: StaleWorkItemsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<StaleWorkItemsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<StaleWorkItemsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<StaleWorkItemsQuery, StaleWorkItemsQueryVariables>(StaleWorkItemsDocument)
    return useInfiniteQuery<StaleWorkItemsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['StaleWorkItems.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteStaleWorkItemsQuery.getKey = (variables: StaleWorkItemsQueryVariables) => ['StaleWorkItems.infinite', variables];

export const AddCohortAudienceDomainDocument = `
    mutation AddCohortAudienceDomain($input: AddCohortAudienceDomainsInput!) {
  addCohortAudienceDomains(input: $input) {
    cohort {
      id
      audienceDomains {
        totalCount
        edges {
          node {
            id
          }
        }
      }
    }
  }
}
    `;

export const useAddCohortAudienceDomainMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddCohortAudienceDomainMutation, TError, AddCohortAudienceDomainMutationVariables, TContext>) => {
    
    return useMutation<AddCohortAudienceDomainMutation, TError, AddCohortAudienceDomainMutationVariables, TContext>(
      {
    mutationKey: ['AddCohortAudienceDomain'],
    mutationFn: useFetchData<AddCohortAudienceDomainMutation, AddCohortAudienceDomainMutationVariables>(AddCohortAudienceDomainDocument),
    ...options
  }
    )};

useAddCohortAudienceDomainMutation.getKey = () => ['AddCohortAudienceDomain'];

export const AddCohortSubscriberDocument = `
    mutation AddCohortSubscriber($input: AddCohortSubscribersInput!) {
  addCohortSubscribers(input: $input) {
    cohort {
      id
      subscribers {
        totalCount
      }
    }
  }
}
    `;

export const useAddCohortSubscriberMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddCohortSubscriberMutation, TError, AddCohortSubscriberMutationVariables, TContext>) => {
    
    return useMutation<AddCohortSubscriberMutation, TError, AddCohortSubscriberMutationVariables, TContext>(
      {
    mutationKey: ['AddCohortSubscriber'],
    mutationFn: useFetchData<AddCohortSubscriberMutation, AddCohortSubscriberMutationVariables>(AddCohortSubscriberDocument),
    ...options
  }
    )};

useAddCohortSubscriberMutation.getKey = () => ['AddCohortSubscriber'];

export const CohortDomainsDocument = `
    query CohortDomains($projectId: ID!, $cohortId: ID!) {
  project(id: $projectId) {
    cohort(id: $cohortId) {
      id
      audienceDomains {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          node {
            id
            hostname
          }
        }
      }
    }
  }
}
    `;

export const useCohortDomainsQuery = <
      TData = CohortDomainsQuery,
      TError = unknown
    >(
      variables: CohortDomainsQueryVariables,
      options?: Omit<UseQueryOptions<CohortDomainsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CohortDomainsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CohortDomainsQuery, TError, TData>(
      {
    queryKey: ['CohortDomains', variables],
    queryFn: useFetchData<CohortDomainsQuery, CohortDomainsQueryVariables>(CohortDomainsDocument).bind(null, variables),
    ...options
  }
    )};

useCohortDomainsQuery.getKey = (variables: CohortDomainsQueryVariables) => ['CohortDomains', variables];

export const useInfiniteCohortDomainsQuery = <
      TData = InfiniteData<CohortDomainsQuery>,
      TError = unknown
    >(
      variables: CohortDomainsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CohortDomainsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CohortDomainsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CohortDomainsQuery, CohortDomainsQueryVariables>(CohortDomainsDocument)
    return useInfiniteQuery<CohortDomainsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CohortDomains.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCohortDomainsQuery.getKey = (variables: CohortDomainsQueryVariables) => ['CohortDomains.infinite', variables];

export const CohortSubscribersDocument = `
    query CohortSubscribers($projectId: ID!, $cohortId: ID!) {
  project(id: $projectId) {
    id
    cohort(id: $cohortId) {
      id
      subscribers {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          node {
            id
            email
          }
        }
      }
    }
  }
}
    `;

export const useCohortSubscribersQuery = <
      TData = CohortSubscribersQuery,
      TError = unknown
    >(
      variables: CohortSubscribersQueryVariables,
      options?: Omit<UseQueryOptions<CohortSubscribersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CohortSubscribersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CohortSubscribersQuery, TError, TData>(
      {
    queryKey: ['CohortSubscribers', variables],
    queryFn: useFetchData<CohortSubscribersQuery, CohortSubscribersQueryVariables>(CohortSubscribersDocument).bind(null, variables),
    ...options
  }
    )};

useCohortSubscribersQuery.getKey = (variables: CohortSubscribersQueryVariables) => ['CohortSubscribers', variables];

export const useInfiniteCohortSubscribersQuery = <
      TData = InfiniteData<CohortSubscribersQuery>,
      TError = unknown
    >(
      variables: CohortSubscribersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CohortSubscribersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CohortSubscribersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CohortSubscribersQuery, CohortSubscribersQueryVariables>(CohortSubscribersDocument)
    return useInfiniteQuery<CohortSubscribersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CohortSubscribers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCohortSubscribersQuery.getKey = (variables: CohortSubscribersQueryVariables) => ['CohortSubscribers.infinite', variables];

export const CreateCohortDocument = `
    mutation CreateCohort($input: CreateCohortInput!) {
  createCohort(input: $input) {
    cohort {
      id
      name
      description
    }
    errors {
      message
    }
  }
}
    `;

export const useCreateCohortMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCohortMutation, TError, CreateCohortMutationVariables, TContext>) => {
    
    return useMutation<CreateCohortMutation, TError, CreateCohortMutationVariables, TContext>(
      {
    mutationKey: ['CreateCohort'],
    mutationFn: useFetchData<CreateCohortMutation, CreateCohortMutationVariables>(CreateCohortDocument),
    ...options
  }
    )};

useCreateCohortMutation.getKey = () => ['CreateCohort'];

export const RemoveCohortDomainsDocument = `
    mutation RemoveCohortDomains($input: RemoveCohortAudienceDomainsInput!) {
  removeCohortAudienceDomains(input: $input) {
    cohort {
      id
      audienceDomains {
        totalCount
        edges {
          node {
            id
          }
        }
      }
    }
  }
}
    `;

export const useRemoveCohortDomainsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveCohortDomainsMutation, TError, RemoveCohortDomainsMutationVariables, TContext>) => {
    
    return useMutation<RemoveCohortDomainsMutation, TError, RemoveCohortDomainsMutationVariables, TContext>(
      {
    mutationKey: ['RemoveCohortDomains'],
    mutationFn: useFetchData<RemoveCohortDomainsMutation, RemoveCohortDomainsMutationVariables>(RemoveCohortDomainsDocument),
    ...options
  }
    )};

useRemoveCohortDomainsMutation.getKey = () => ['RemoveCohortDomains'];

export const RemoveCohortSubscribersDocument = `
    mutation RemoveCohortSubscribers($input: RemoveCohortSubscribersInput!) {
  removeCohortSubscribers(input: $input) {
    cohort {
      id
      name
      subscribers {
        totalCount
      }
    }
  }
}
    `;

export const useRemoveCohortSubscribersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveCohortSubscribersMutation, TError, RemoveCohortSubscribersMutationVariables, TContext>) => {
    
    return useMutation<RemoveCohortSubscribersMutation, TError, RemoveCohortSubscribersMutationVariables, TContext>(
      {
    mutationKey: ['RemoveCohortSubscribers'],
    mutationFn: useFetchData<RemoveCohortSubscribersMutation, RemoveCohortSubscribersMutationVariables>(RemoveCohortSubscribersDocument),
    ...options
  }
    )};

useRemoveCohortSubscribersMutation.getKey = () => ['RemoveCohortSubscribers'];

export const SearchInProjectDocument = `
    query searchInProject($projectId: ID!, $term: String!) {
  results: projectSearch(projectId: $projectId, searchTerm: $term) {
    type: __typename
    ... on Announcement {
      id
      headline
      privatePermalink
      publishedAt
    }
    ... on WorkItem {
      id
      name
      privatePermalink
    }
    ... on Subscriber {
      id
      email
    }
    ... on Idea {
      id
      name
      privatePermalink
    }
    ... on AudienceDomain {
      id
      hostname
    }
  }
}
    `;

export const useSearchInProjectQuery = <
      TData = SearchInProjectQuery,
      TError = unknown
    >(
      variables: SearchInProjectQueryVariables,
      options?: Omit<UseQueryOptions<SearchInProjectQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchInProjectQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchInProjectQuery, TError, TData>(
      {
    queryKey: ['searchInProject', variables],
    queryFn: useFetchData<SearchInProjectQuery, SearchInProjectQueryVariables>(SearchInProjectDocument).bind(null, variables),
    ...options
  }
    )};

useSearchInProjectQuery.getKey = (variables: SearchInProjectQueryVariables) => ['searchInProject', variables];

export const useInfiniteSearchInProjectQuery = <
      TData = InfiniteData<SearchInProjectQuery>,
      TError = unknown
    >(
      variables: SearchInProjectQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SearchInProjectQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SearchInProjectQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SearchInProjectQuery, SearchInProjectQueryVariables>(SearchInProjectDocument)
    return useInfiniteQuery<SearchInProjectQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['searchInProject.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSearchInProjectQuery.getKey = (variables: SearchInProjectQueryVariables) => ['searchInProject.infinite', variables];

export const GetConnectedJiraProjectsDocument = `
    query getConnectedJiraProjects($projectId: ID!) {
  project(id: $projectId) {
    connectedJiraProjects
  }
}
    `;

export const useGetConnectedJiraProjectsQuery = <
      TData = GetConnectedJiraProjectsQuery,
      TError = unknown
    >(
      variables: GetConnectedJiraProjectsQueryVariables,
      options?: Omit<UseQueryOptions<GetConnectedJiraProjectsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetConnectedJiraProjectsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetConnectedJiraProjectsQuery, TError, TData>(
      {
    queryKey: ['getConnectedJiraProjects', variables],
    queryFn: useFetchData<GetConnectedJiraProjectsQuery, GetConnectedJiraProjectsQueryVariables>(GetConnectedJiraProjectsDocument).bind(null, variables),
    ...options
  }
    )};

useGetConnectedJiraProjectsQuery.getKey = (variables: GetConnectedJiraProjectsQueryVariables) => ['getConnectedJiraProjects', variables];

export const useInfiniteGetConnectedJiraProjectsQuery = <
      TData = InfiniteData<GetConnectedJiraProjectsQuery>,
      TError = unknown
    >(
      variables: GetConnectedJiraProjectsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetConnectedJiraProjectsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetConnectedJiraProjectsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetConnectedJiraProjectsQuery, GetConnectedJiraProjectsQueryVariables>(GetConnectedJiraProjectsDocument)
    return useInfiniteQuery<GetConnectedJiraProjectsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getConnectedJiraProjects.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetConnectedJiraProjectsQuery.getKey = (variables: GetConnectedJiraProjectsQueryVariables) => ['getConnectedJiraProjects.infinite', variables];

export const CreateSourceDocument = `
    mutation createSource($workItemId: ID, $announcementId: ID, $issueUrl: String!, $providerName: String!, $name: String!, $externalId: String!, $metadata: JSON!) {
  createConnectedSource(
    input: {workItemId: $workItemId, announcementId: $announcementId, url: $issueUrl, providerName: $providerName, name: $name, externalId: $externalId, metadata: $metadata}
  ) {
    connectedSource {
      id
    }
  }
}
    `;

export const useCreateSourceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSourceMutation, TError, CreateSourceMutationVariables, TContext>) => {
    
    return useMutation<CreateSourceMutation, TError, CreateSourceMutationVariables, TContext>(
      {
    mutationKey: ['createSource'],
    mutationFn: useFetchData<CreateSourceMutation, CreateSourceMutationVariables>(CreateSourceDocument),
    ...options
  }
    )};

useCreateSourceMutation.getKey = () => ['createSource'];

export const GetConnectedSourcesForWorkItemDocument = `
    query getConnectedSourcesForWorkItem($workItemId: ID!) {
  workItem(id: $workItemId) {
    connectedSources {
      nodes {
        id
        name
        providerName
        url
        externalId
        contextId
        metadata
      }
    }
  }
}
    `;

export const useGetConnectedSourcesForWorkItemQuery = <
      TData = GetConnectedSourcesForWorkItemQuery,
      TError = unknown
    >(
      variables: GetConnectedSourcesForWorkItemQueryVariables,
      options?: Omit<UseQueryOptions<GetConnectedSourcesForWorkItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetConnectedSourcesForWorkItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetConnectedSourcesForWorkItemQuery, TError, TData>(
      {
    queryKey: ['getConnectedSourcesForWorkItem', variables],
    queryFn: useFetchData<GetConnectedSourcesForWorkItemQuery, GetConnectedSourcesForWorkItemQueryVariables>(GetConnectedSourcesForWorkItemDocument).bind(null, variables),
    ...options
  }
    )};

useGetConnectedSourcesForWorkItemQuery.getKey = (variables: GetConnectedSourcesForWorkItemQueryVariables) => ['getConnectedSourcesForWorkItem', variables];

export const useInfiniteGetConnectedSourcesForWorkItemQuery = <
      TData = InfiniteData<GetConnectedSourcesForWorkItemQuery>,
      TError = unknown
    >(
      variables: GetConnectedSourcesForWorkItemQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetConnectedSourcesForWorkItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetConnectedSourcesForWorkItemQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetConnectedSourcesForWorkItemQuery, GetConnectedSourcesForWorkItemQueryVariables>(GetConnectedSourcesForWorkItemDocument)
    return useInfiniteQuery<GetConnectedSourcesForWorkItemQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getConnectedSourcesForWorkItem.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetConnectedSourcesForWorkItemQuery.getKey = (variables: GetConnectedSourcesForWorkItemQueryVariables) => ['getConnectedSourcesForWorkItem.infinite', variables];

export const GetConnectedSourcesForAnnouncementDocument = `
    query getConnectedSourcesForAnnouncement($announcementId: ID!) {
  announcement(id: $announcementId) {
    connectedSources {
      nodes {
        id
        name
        providerName
        url
        externalId
        contextId
        metadata
      }
    }
  }
}
    `;

export const useGetConnectedSourcesForAnnouncementQuery = <
      TData = GetConnectedSourcesForAnnouncementQuery,
      TError = unknown
    >(
      variables: GetConnectedSourcesForAnnouncementQueryVariables,
      options?: Omit<UseQueryOptions<GetConnectedSourcesForAnnouncementQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetConnectedSourcesForAnnouncementQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetConnectedSourcesForAnnouncementQuery, TError, TData>(
      {
    queryKey: ['getConnectedSourcesForAnnouncement', variables],
    queryFn: useFetchData<GetConnectedSourcesForAnnouncementQuery, GetConnectedSourcesForAnnouncementQueryVariables>(GetConnectedSourcesForAnnouncementDocument).bind(null, variables),
    ...options
  }
    )};

useGetConnectedSourcesForAnnouncementQuery.getKey = (variables: GetConnectedSourcesForAnnouncementQueryVariables) => ['getConnectedSourcesForAnnouncement', variables];

export const useInfiniteGetConnectedSourcesForAnnouncementQuery = <
      TData = InfiniteData<GetConnectedSourcesForAnnouncementQuery>,
      TError = unknown
    >(
      variables: GetConnectedSourcesForAnnouncementQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetConnectedSourcesForAnnouncementQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetConnectedSourcesForAnnouncementQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetConnectedSourcesForAnnouncementQuery, GetConnectedSourcesForAnnouncementQueryVariables>(GetConnectedSourcesForAnnouncementDocument)
    return useInfiniteQuery<GetConnectedSourcesForAnnouncementQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getConnectedSourcesForAnnouncement.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetConnectedSourcesForAnnouncementQuery.getKey = (variables: GetConnectedSourcesForAnnouncementQueryVariables) => ['getConnectedSourcesForAnnouncement.infinite', variables];

export const RemoveConnectedSourceDocument = `
    mutation RemoveConnectedSource($sourceId: ID!, $contextId: String!) {
  removeConnectedSource(input: {id: $sourceId, contextId: $contextId}) {
    deletedId
    errors {
      message
    }
  }
}
    `;

export const useRemoveConnectedSourceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveConnectedSourceMutation, TError, RemoveConnectedSourceMutationVariables, TContext>) => {
    
    return useMutation<RemoveConnectedSourceMutation, TError, RemoveConnectedSourceMutationVariables, TContext>(
      {
    mutationKey: ['RemoveConnectedSource'],
    mutationFn: useFetchData<RemoveConnectedSourceMutation, RemoveConnectedSourceMutationVariables>(RemoveConnectedSourceDocument),
    ...options
  }
    )};

useRemoveConnectedSourceMutation.getKey = () => ['RemoveConnectedSource'];

export const AudienceDomainShowDocument = `
    query audienceDomainShow($projectId: ID!, $id: ID!) {
  project(id: $projectId) {
    audienceDomain(id: $id) {
      hostname
      firstSeen
      subscriberCount
      feedbackCount
      voteCount
      averageFeedbackSentiment
    }
  }
}
    `;

export const useAudienceDomainShowQuery = <
      TData = AudienceDomainShowQuery,
      TError = unknown
    >(
      variables: AudienceDomainShowQueryVariables,
      options?: Omit<UseQueryOptions<AudienceDomainShowQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AudienceDomainShowQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AudienceDomainShowQuery, TError, TData>(
      {
    queryKey: ['audienceDomainShow', variables],
    queryFn: useFetchData<AudienceDomainShowQuery, AudienceDomainShowQueryVariables>(AudienceDomainShowDocument).bind(null, variables),
    ...options
  }
    )};

useAudienceDomainShowQuery.getKey = (variables: AudienceDomainShowQueryVariables) => ['audienceDomainShow', variables];

export const useInfiniteAudienceDomainShowQuery = <
      TData = InfiniteData<AudienceDomainShowQuery>,
      TError = unknown
    >(
      variables: AudienceDomainShowQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AudienceDomainShowQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AudienceDomainShowQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AudienceDomainShowQuery, AudienceDomainShowQueryVariables>(AudienceDomainShowDocument)
    return useInfiniteQuery<AudienceDomainShowQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['audienceDomainShow.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAudienceDomainShowQuery.getKey = (variables: AudienceDomainShowQueryVariables) => ['audienceDomainShow.infinite', variables];

export const AudienceDomainFeedbackDocument = `
    query audienceDomainFeedback($projectId: ID!, $id: ID!, $orderBy: OrderBy, $first: Int, $after: String, $before: String) {
  project(id: $projectId) {
    audienceDomain(id: $id) {
      feedbacks(first: $first, after: $after, before: $before, orderBy: $orderBy) {
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        nodes {
          id
          createdAt
          sentimentScore
          importance
          content
          notes
          affectedCustomerEmail
          affectedCustomer {
            id
            email
            isProjectSubscriber
          }
          reporter {
            id
            name
            email
          }
          feedbackable {
            id
            name
            privatePermalink
          }
        }
      }
    }
  }
}
    `;

export const useAudienceDomainFeedbackQuery = <
      TData = AudienceDomainFeedbackQuery,
      TError = unknown
    >(
      variables: AudienceDomainFeedbackQueryVariables,
      options?: Omit<UseQueryOptions<AudienceDomainFeedbackQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AudienceDomainFeedbackQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AudienceDomainFeedbackQuery, TError, TData>(
      {
    queryKey: ['audienceDomainFeedback', variables],
    queryFn: useFetchData<AudienceDomainFeedbackQuery, AudienceDomainFeedbackQueryVariables>(AudienceDomainFeedbackDocument).bind(null, variables),
    ...options
  }
    )};

useAudienceDomainFeedbackQuery.getKey = (variables: AudienceDomainFeedbackQueryVariables) => ['audienceDomainFeedback', variables];

export const useInfiniteAudienceDomainFeedbackQuery = <
      TData = InfiniteData<AudienceDomainFeedbackQuery>,
      TError = unknown
    >(
      variables: AudienceDomainFeedbackQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AudienceDomainFeedbackQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AudienceDomainFeedbackQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AudienceDomainFeedbackQuery, AudienceDomainFeedbackQueryVariables>(AudienceDomainFeedbackDocument)
    return useInfiniteQuery<AudienceDomainFeedbackQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['audienceDomainFeedback.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAudienceDomainFeedbackQuery.getKey = (variables: AudienceDomainFeedbackQueryVariables) => ['audienceDomainFeedback.infinite', variables];

export const AudienceDomainSubscribersDocument = `
    query audienceDomainSubscribers($projectId: ID!, $id: ID!, $orderBy: OrderBy, $first: Int, $after: String, $before: String) {
  project(id: $projectId) {
    audienceDomain(id: $id) {
      subscribers(first: $first, after: $after, before: $before, orderBy: $orderBy) {
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          createdAt
          node {
            id
            email
            isProjectSubscriber
            voteCount
            feedbackCount
          }
        }
      }
    }
  }
}
    `;

export const useAudienceDomainSubscribersQuery = <
      TData = AudienceDomainSubscribersQuery,
      TError = unknown
    >(
      variables: AudienceDomainSubscribersQueryVariables,
      options?: Omit<UseQueryOptions<AudienceDomainSubscribersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AudienceDomainSubscribersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AudienceDomainSubscribersQuery, TError, TData>(
      {
    queryKey: ['audienceDomainSubscribers', variables],
    queryFn: useFetchData<AudienceDomainSubscribersQuery, AudienceDomainSubscribersQueryVariables>(AudienceDomainSubscribersDocument).bind(null, variables),
    ...options
  }
    )};

useAudienceDomainSubscribersQuery.getKey = (variables: AudienceDomainSubscribersQueryVariables) => ['audienceDomainSubscribers', variables];

export const useInfiniteAudienceDomainSubscribersQuery = <
      TData = InfiniteData<AudienceDomainSubscribersQuery>,
      TError = unknown
    >(
      variables: AudienceDomainSubscribersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AudienceDomainSubscribersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AudienceDomainSubscribersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AudienceDomainSubscribersQuery, AudienceDomainSubscribersQueryVariables>(AudienceDomainSubscribersDocument)
    return useInfiniteQuery<AudienceDomainSubscribersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['audienceDomainSubscribers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAudienceDomainSubscribersQuery.getKey = (variables: AudienceDomainSubscribersQueryVariables) => ['audienceDomainSubscribers.infinite', variables];

export const AudienceDomainVotesDocument = `
    query audienceDomainVotes($projectId: ID!, $id: ID!, $orderBy: OrderBy, $first: Int, $after: String, $before: String) {
  project(id: $projectId) {
    audienceDomain(id: $id) {
      votes(first: $first, after: $after, before: $before, orderBy: $orderBy) {
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        nodes {
          id
          createdAt
          idea {
            id
            name
            privatePermalink
          }
          subscriber {
            id
            email
            isProjectSubscriber
          }
        }
      }
    }
  }
}
    `;

export const useAudienceDomainVotesQuery = <
      TData = AudienceDomainVotesQuery,
      TError = unknown
    >(
      variables: AudienceDomainVotesQueryVariables,
      options?: Omit<UseQueryOptions<AudienceDomainVotesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AudienceDomainVotesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AudienceDomainVotesQuery, TError, TData>(
      {
    queryKey: ['audienceDomainVotes', variables],
    queryFn: useFetchData<AudienceDomainVotesQuery, AudienceDomainVotesQueryVariables>(AudienceDomainVotesDocument).bind(null, variables),
    ...options
  }
    )};

useAudienceDomainVotesQuery.getKey = (variables: AudienceDomainVotesQueryVariables) => ['audienceDomainVotes', variables];

export const useInfiniteAudienceDomainVotesQuery = <
      TData = InfiniteData<AudienceDomainVotesQuery>,
      TError = unknown
    >(
      variables: AudienceDomainVotesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AudienceDomainVotesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AudienceDomainVotesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AudienceDomainVotesQuery, AudienceDomainVotesQueryVariables>(AudienceDomainVotesDocument)
    return useInfiniteQuery<AudienceDomainVotesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['audienceDomainVotes.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAudienceDomainVotesQuery.getKey = (variables: AudienceDomainVotesQueryVariables) => ['audienceDomainVotes.infinite', variables];

export const CreateExternalContentLinkDocument = `
    mutation createExternalContentLink($externalContentLink: CreateLinkAttributes!) {
  createExternalContentLink(input: {externalContentLink: $externalContentLink}) {
    errors {
      message
      path
    }
  }
}
    `;

export const useCreateExternalContentLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateExternalContentLinkMutation, TError, CreateExternalContentLinkMutationVariables, TContext>) => {
    
    return useMutation<CreateExternalContentLinkMutation, TError, CreateExternalContentLinkMutationVariables, TContext>(
      {
    mutationKey: ['createExternalContentLink'],
    mutationFn: useFetchData<CreateExternalContentLinkMutation, CreateExternalContentLinkMutationVariables>(CreateExternalContentLinkDocument),
    ...options
  }
    )};

useCreateExternalContentLinkMutation.getKey = () => ['createExternalContentLink'];

export const DeleteExternalContentLinkDocument = `
    mutation deleteExternalContentLink($id: ID!) {
  deleteExternalContentLink(input: {id: $id}) {
    errors {
      path
      message
    }
  }
}
    `;

export const useDeleteExternalContentLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteExternalContentLinkMutation, TError, DeleteExternalContentLinkMutationVariables, TContext>) => {
    
    return useMutation<DeleteExternalContentLinkMutation, TError, DeleteExternalContentLinkMutationVariables, TContext>(
      {
    mutationKey: ['deleteExternalContentLink'],
    mutationFn: useFetchData<DeleteExternalContentLinkMutation, DeleteExternalContentLinkMutationVariables>(DeleteExternalContentLinkDocument),
    ...options
  }
    )};

useDeleteExternalContentLinkMutation.getKey = () => ['deleteExternalContentLink'];

export const ReorderExternalContentLinksDocument = `
    mutation reorderExternalContentLinks($ownerId: ID!, $orderMap: [OrderMap!]!) {
  reorderExternalContentLinks(input: {ownerId: $ownerId, orderMap: $orderMap}) {
    errors {
      message
      path
    }
  }
}
    `;

export const useReorderExternalContentLinksMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReorderExternalContentLinksMutation, TError, ReorderExternalContentLinksMutationVariables, TContext>) => {
    
    return useMutation<ReorderExternalContentLinksMutation, TError, ReorderExternalContentLinksMutationVariables, TContext>(
      {
    mutationKey: ['reorderExternalContentLinks'],
    mutationFn: useFetchData<ReorderExternalContentLinksMutation, ReorderExternalContentLinksMutationVariables>(ReorderExternalContentLinksDocument),
    ...options
  }
    )};

useReorderExternalContentLinksMutation.getKey = () => ['reorderExternalContentLinks'];

export const UpdateExternalContentLinkDocument = `
    mutation updateExternalContentLink($externalContentLink: UpdateLinkAttributes!) {
  updateExternalContentLink(input: {externalContentLink: $externalContentLink}) {
    errors {
      message
      path
    }
  }
}
    `;

export const useUpdateExternalContentLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateExternalContentLinkMutation, TError, UpdateExternalContentLinkMutationVariables, TContext>) => {
    
    return useMutation<UpdateExternalContentLinkMutation, TError, UpdateExternalContentLinkMutationVariables, TContext>(
      {
    mutationKey: ['updateExternalContentLink'],
    mutationFn: useFetchData<UpdateExternalContentLinkMutation, UpdateExternalContentLinkMutationVariables>(UpdateExternalContentLinkDocument),
    ...options
  }
    )};

useUpdateExternalContentLinkMutation.getKey = () => ['updateExternalContentLink'];

export const ExportFeedbackDocument = `
    query ExportFeedback($feedbackableId: ID!) {
  node(id: $feedbackableId) {
    ... on HasFeedbacks {
      exportFeedbacks {
        id
        affectedCustomerEmail
        createdAt
        content
        reaction
        importance
        archived
      }
    }
  }
}
    `;

export const useExportFeedbackQuery = <
      TData = ExportFeedbackQuery,
      TError = unknown
    >(
      variables: ExportFeedbackQueryVariables,
      options?: Omit<UseQueryOptions<ExportFeedbackQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ExportFeedbackQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ExportFeedbackQuery, TError, TData>(
      {
    queryKey: ['ExportFeedback', variables],
    queryFn: useFetchData<ExportFeedbackQuery, ExportFeedbackQueryVariables>(ExportFeedbackDocument).bind(null, variables),
    ...options
  }
    )};

useExportFeedbackQuery.getKey = (variables: ExportFeedbackQueryVariables) => ['ExportFeedback', variables];

export const useInfiniteExportFeedbackQuery = <
      TData = InfiniteData<ExportFeedbackQuery>,
      TError = unknown
    >(
      variables: ExportFeedbackQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ExportFeedbackQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ExportFeedbackQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ExportFeedbackQuery, ExportFeedbackQueryVariables>(ExportFeedbackDocument)
    return useInfiniteQuery<ExportFeedbackQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ExportFeedback.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteExportFeedbackQuery.getKey = (variables: ExportFeedbackQueryVariables) => ['ExportFeedback.infinite', variables];

export const FeedbackTableDocument = `
    query FeedbackTable($feedbackableId: ID!, $count: Int!, $before: String, $cursor: String, $archived: Boolean, $organizedState: String, $reaction: Reaction, $importance: Importance, $cohortId: ID, $starred: Boolean, $searchTerm: String, $orderBy: OrderBy, $where: Where) {
  feedbackable: node(id: $feedbackableId) {
    ... on HasFeedbacks {
      __typename
      hasFeedback: feedbacks {
        totalCount
      }
      feedbacks(
        first: $count
        after: $cursor
        before: $before
        archived: $archived
        organizedState: $organizedState
        reaction: $reaction
        importance: $importance
        cohortId: $cohortId
        starred: $starred
        searchTerm: $searchTerm
        orderBy: $orderBy
        where: $where
      ) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
          startCursor
        }
        edges {
          node {
            id
            archived
            createdAt
            content
            notes
            reaction
            importance
            affectedCustomerEmail
            affectedCustomer {
              id
              avatarColor
              email
              initials
              isProjectSubscriber
            }
            reporter {
              id
              name
              email
            }
            feedbackable {
              id
              archived
              name
              privatePermalink
              __typename
            }
            attributes {
              key
              value
            }
          }
        }
      }
    }
  }
}
    `;

export const useFeedbackTableQuery = <
      TData = FeedbackTableQuery,
      TError = unknown
    >(
      variables: FeedbackTableQueryVariables,
      options?: Omit<UseQueryOptions<FeedbackTableQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FeedbackTableQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FeedbackTableQuery, TError, TData>(
      {
    queryKey: ['FeedbackTable', variables],
    queryFn: useFetchData<FeedbackTableQuery, FeedbackTableQueryVariables>(FeedbackTableDocument).bind(null, variables),
    ...options
  }
    )};

useFeedbackTableQuery.getKey = (variables: FeedbackTableQueryVariables) => ['FeedbackTable', variables];

export const useInfiniteFeedbackTableQuery = <
      TData = InfiniteData<FeedbackTableQuery>,
      TError = unknown
    >(
      variables: FeedbackTableQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FeedbackTableQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FeedbackTableQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<FeedbackTableQuery, FeedbackTableQueryVariables>(FeedbackTableDocument)
    return useInfiniteQuery<FeedbackTableQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FeedbackTable.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteFeedbackTableQuery.getKey = (variables: FeedbackTableQueryVariables) => ['FeedbackTable.infinite', variables];

export const FeedbackAttributeDefinitionsDocument = `
    query feedbackAttributeDefinitions($project: ID!) {
  project(id: $project) {
    attributeDefinitions(
      where: {rules: [{field: "type", expression: eq, value: "FeedbackAttributeDefinition"}]}
    ) {
      nodes {
        key
        name
        valueType
        description
      }
    }
  }
}
    `;

export const useFeedbackAttributeDefinitionsQuery = <
      TData = FeedbackAttributeDefinitionsQuery,
      TError = unknown
    >(
      variables: FeedbackAttributeDefinitionsQueryVariables,
      options?: Omit<UseQueryOptions<FeedbackAttributeDefinitionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FeedbackAttributeDefinitionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FeedbackAttributeDefinitionsQuery, TError, TData>(
      {
    queryKey: ['feedbackAttributeDefinitions', variables],
    queryFn: useFetchData<FeedbackAttributeDefinitionsQuery, FeedbackAttributeDefinitionsQueryVariables>(FeedbackAttributeDefinitionsDocument).bind(null, variables),
    ...options
  }
    )};

useFeedbackAttributeDefinitionsQuery.getKey = (variables: FeedbackAttributeDefinitionsQueryVariables) => ['feedbackAttributeDefinitions', variables];

export const useInfiniteFeedbackAttributeDefinitionsQuery = <
      TData = InfiniteData<FeedbackAttributeDefinitionsQuery>,
      TError = unknown
    >(
      variables: FeedbackAttributeDefinitionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FeedbackAttributeDefinitionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FeedbackAttributeDefinitionsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<FeedbackAttributeDefinitionsQuery, FeedbackAttributeDefinitionsQueryVariables>(FeedbackAttributeDefinitionsDocument)
    return useInfiniteQuery<FeedbackAttributeDefinitionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['feedbackAttributeDefinitions.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteFeedbackAttributeDefinitionsQuery.getKey = (variables: FeedbackAttributeDefinitionsQueryVariables) => ['feedbackAttributeDefinitions.infinite', variables];

export const UpdateFeedbackAttributeDocument = `
    mutation updateFeedbackAttribute($feedback: ID!, $key: String!, $value: AttributeValue) {
  updateAttribute(input: {key: $key, id: $feedback, value: $value}) {
    node {
      id
      attributes {
        key
        value
      }
    }
  }
}
    `;

export const useUpdateFeedbackAttributeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateFeedbackAttributeMutation, TError, UpdateFeedbackAttributeMutationVariables, TContext>) => {
    
    return useMutation<UpdateFeedbackAttributeMutation, TError, UpdateFeedbackAttributeMutationVariables, TContext>(
      {
    mutationKey: ['updateFeedbackAttribute'],
    mutationFn: useFetchData<UpdateFeedbackAttributeMutation, UpdateFeedbackAttributeMutationVariables>(UpdateFeedbackAttributeDocument),
    ...options
  }
    )};

useUpdateFeedbackAttributeMutation.getKey = () => ['updateFeedbackAttribute'];

export const ArchiveFeedbacksDocument = `
    mutation archiveFeedbacks($feedbackIds: [ID!]!) {
  archiveFeedbacks(input: {feedbackIds: $feedbackIds}) {
    errors {
      message
      path
    }
  }
}
    `;

export const useArchiveFeedbacksMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ArchiveFeedbacksMutation, TError, ArchiveFeedbacksMutationVariables, TContext>) => {
    
    return useMutation<ArchiveFeedbacksMutation, TError, ArchiveFeedbacksMutationVariables, TContext>(
      {
    mutationKey: ['archiveFeedbacks'],
    mutationFn: useFetchData<ArchiveFeedbacksMutation, ArchiveFeedbacksMutationVariables>(ArchiveFeedbacksDocument),
    ...options
  }
    )};

useArchiveFeedbacksMutation.getKey = () => ['archiveFeedbacks'];

export const CreateFeedbackDocument = `
    mutation createFeedback($feedback: CreateFeedbackAttributes!) {
  createFeedback(input: {feedback: $feedback}) {
    errors {
      message
      path
    }
  }
}
    `;

export const useCreateFeedbackMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateFeedbackMutation, TError, CreateFeedbackMutationVariables, TContext>) => {
    
    return useMutation<CreateFeedbackMutation, TError, CreateFeedbackMutationVariables, TContext>(
      {
    mutationKey: ['createFeedback'],
    mutationFn: useFetchData<CreateFeedbackMutation, CreateFeedbackMutationVariables>(CreateFeedbackDocument),
    ...options
  }
    )};

useCreateFeedbackMutation.getKey = () => ['createFeedback'];

export const OrganizeFeedbacksDocument = `
    mutation organizeFeedbacks($feedbackIds: [ID!]!, $feedbackableId: ID!, $feedbackableType: String!) {
  organizeFeedbacks(
    input: {feedbackIds: $feedbackIds, feedbackableId: $feedbackableId, feedbackableType: $feedbackableType}
  ) {
    errors {
      message
      path
    }
  }
}
    `;

export const useOrganizeFeedbacksMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OrganizeFeedbacksMutation, TError, OrganizeFeedbacksMutationVariables, TContext>) => {
    
    return useMutation<OrganizeFeedbacksMutation, TError, OrganizeFeedbacksMutationVariables, TContext>(
      {
    mutationKey: ['organizeFeedbacks'],
    mutationFn: useFetchData<OrganizeFeedbacksMutation, OrganizeFeedbacksMutationVariables>(OrganizeFeedbacksDocument),
    ...options
  }
    )};

useOrganizeFeedbacksMutation.getKey = () => ['organizeFeedbacks'];

export const UnarchiveFeedbacksDocument = `
    mutation unarchiveFeedbacks($feedbackIds: [ID!]!) {
  unarchiveFeedbacks(input: {feedbackIds: $feedbackIds}) {
    errors {
      message
      path
    }
  }
}
    `;

export const useUnarchiveFeedbacksMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnarchiveFeedbacksMutation, TError, UnarchiveFeedbacksMutationVariables, TContext>) => {
    
    return useMutation<UnarchiveFeedbacksMutation, TError, UnarchiveFeedbacksMutationVariables, TContext>(
      {
    mutationKey: ['unarchiveFeedbacks'],
    mutationFn: useFetchData<UnarchiveFeedbacksMutation, UnarchiveFeedbacksMutationVariables>(UnarchiveFeedbacksDocument),
    ...options
  }
    )};

useUnarchiveFeedbacksMutation.getKey = () => ['unarchiveFeedbacks'];

export const UpdateFeedbackDocument = `
    mutation updateFeedback($feedback: UpdateFeedbackAttributes!) {
  updateFeedback(input: {feedback: $feedback}) {
    errors {
      message
      path
    }
  }
}
    `;

export const useUpdateFeedbackMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateFeedbackMutation, TError, UpdateFeedbackMutationVariables, TContext>) => {
    
    return useMutation<UpdateFeedbackMutation, TError, UpdateFeedbackMutationVariables, TContext>(
      {
    mutationKey: ['updateFeedback'],
    mutationFn: useFetchData<UpdateFeedbackMutation, UpdateFeedbackMutationVariables>(UpdateFeedbackDocument),
    ...options
  }
    )};

useUpdateFeedbackMutation.getKey = () => ['updateFeedback'];

export const CreateFeedbackModalDocument = `
    query CreateFeedbackModal($projectId: ID!) {
  project(id: $projectId) {
    ideas {
      nodes {
        id
        name
      }
    }
    workItems {
      nodes {
        id
        name
      }
    }
    announcements {
      nodes {
        id
        name
      }
    }
  }
}
    `;

export const useCreateFeedbackModalQuery = <
      TData = CreateFeedbackModalQuery,
      TError = unknown
    >(
      variables: CreateFeedbackModalQueryVariables,
      options?: Omit<UseQueryOptions<CreateFeedbackModalQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CreateFeedbackModalQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CreateFeedbackModalQuery, TError, TData>(
      {
    queryKey: ['CreateFeedbackModal', variables],
    queryFn: useFetchData<CreateFeedbackModalQuery, CreateFeedbackModalQueryVariables>(CreateFeedbackModalDocument).bind(null, variables),
    ...options
  }
    )};

useCreateFeedbackModalQuery.getKey = (variables: CreateFeedbackModalQueryVariables) => ['CreateFeedbackModal', variables];

export const useInfiniteCreateFeedbackModalQuery = <
      TData = InfiniteData<CreateFeedbackModalQuery>,
      TError = unknown
    >(
      variables: CreateFeedbackModalQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CreateFeedbackModalQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CreateFeedbackModalQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CreateFeedbackModalQuery, CreateFeedbackModalQueryVariables>(CreateFeedbackModalDocument)
    return useInfiniteQuery<CreateFeedbackModalQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CreateFeedbackModal.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCreateFeedbackModalQuery.getKey = (variables: CreateFeedbackModalQueryVariables) => ['CreateFeedbackModal.infinite', variables];

export const OrganizeFeedbackModalDocument = `
    query OrganizeFeedbackModal($projectId: ID!, $feedbackId: ID!) {
  project(id: $projectId) {
    ideas {
      nodes {
        id
        name
      }
    }
    workItems {
      nodes {
        id
        name
      }
    }
    announcements {
      nodes {
        id
        name
      }
    }
  }
  feedback(id: $feedbackId) {
    id
    content
    affectedCustomerEmail
    importance
    reaction
    notes
    feedbackable {
      __typename
      id
      name
    }
  }
}
    `;

export const useOrganizeFeedbackModalQuery = <
      TData = OrganizeFeedbackModalQuery,
      TError = unknown
    >(
      variables: OrganizeFeedbackModalQueryVariables,
      options?: Omit<UseQueryOptions<OrganizeFeedbackModalQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrganizeFeedbackModalQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrganizeFeedbackModalQuery, TError, TData>(
      {
    queryKey: ['OrganizeFeedbackModal', variables],
    queryFn: useFetchData<OrganizeFeedbackModalQuery, OrganizeFeedbackModalQueryVariables>(OrganizeFeedbackModalDocument).bind(null, variables),
    ...options
  }
    )};

useOrganizeFeedbackModalQuery.getKey = (variables: OrganizeFeedbackModalQueryVariables) => ['OrganizeFeedbackModal', variables];

export const useInfiniteOrganizeFeedbackModalQuery = <
      TData = InfiniteData<OrganizeFeedbackModalQuery>,
      TError = unknown
    >(
      variables: OrganizeFeedbackModalQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrganizeFeedbackModalQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrganizeFeedbackModalQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OrganizeFeedbackModalQuery, OrganizeFeedbackModalQueryVariables>(OrganizeFeedbackModalDocument)
    return useInfiniteQuery<OrganizeFeedbackModalQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['OrganizeFeedbackModal.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOrganizeFeedbackModalQuery.getKey = (variables: OrganizeFeedbackModalQueryVariables) => ['OrganizeFeedbackModal.infinite', variables];

export const UpdateFeedbackModalDocument = `
    query UpdateFeedbackModal($projectId: ID!, $feedbackId: ID!) {
  project(id: $projectId) {
    ideas {
      nodes {
        id
        name
      }
    }
    workItems {
      nodes {
        id
        name
      }
    }
    announcements {
      nodes {
        id
        name
      }
    }
  }
  feedback(id: $feedbackId) {
    id
    content
    affectedCustomerEmail
    importance
    reaction
    notes
    feedbackable {
      __typename
      id
      name
    }
  }
}
    `;

export const useUpdateFeedbackModalQuery = <
      TData = UpdateFeedbackModalQuery,
      TError = unknown
    >(
      variables: UpdateFeedbackModalQueryVariables,
      options?: Omit<UseQueryOptions<UpdateFeedbackModalQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UpdateFeedbackModalQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UpdateFeedbackModalQuery, TError, TData>(
      {
    queryKey: ['UpdateFeedbackModal', variables],
    queryFn: useFetchData<UpdateFeedbackModalQuery, UpdateFeedbackModalQueryVariables>(UpdateFeedbackModalDocument).bind(null, variables),
    ...options
  }
    )};

useUpdateFeedbackModalQuery.getKey = (variables: UpdateFeedbackModalQueryVariables) => ['UpdateFeedbackModal', variables];

export const useInfiniteUpdateFeedbackModalQuery = <
      TData = InfiniteData<UpdateFeedbackModalQuery>,
      TError = unknown
    >(
      variables: UpdateFeedbackModalQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UpdateFeedbackModalQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UpdateFeedbackModalQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<UpdateFeedbackModalQuery, UpdateFeedbackModalQueryVariables>(UpdateFeedbackModalDocument)
    return useInfiniteQuery<UpdateFeedbackModalQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['UpdateFeedbackModal.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteUpdateFeedbackModalQuery.getKey = (variables: UpdateFeedbackModalQueryVariables) => ['UpdateFeedbackModal.infinite', variables];

export const DirectUploadDocument = `
    mutation directUpload($input: CreateDirectUploadInput!) {
  createDirectUpload(input: $input) {
    blob {
      id
      signedId
      url
      headers
      key
    }
  }
}
    `;

export const useDirectUploadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DirectUploadMutation, TError, DirectUploadMutationVariables, TContext>) => {
    
    return useMutation<DirectUploadMutation, TError, DirectUploadMutationVariables, TContext>(
      {
    mutationKey: ['directUpload'],
    mutationFn: useFetchData<DirectUploadMutation, DirectUploadMutationVariables>(DirectUploadDocument),
    ...options
  }
    )};

useDirectUploadMutation.getKey = () => ['directUpload'];

export const IdeasTableDocument = `
    query IdeasTable($projectId: ID!, $count: Int!, $cursor: String, $archived: Boolean, $published: Boolean, $categoryId: String, $cohortId: ID, $searchTerm: String, $orderAttr: String, $orderDirection: String, $orderBy: OrderBy) {
  project(id: $projectId) {
    ideasEnabled
    cohorts {
      nodes {
        id
        name
      }
    }
    ideas(
      first: $count
      after: $cursor
      archived: $archived
      published: $published
      categoryId: $categoryId
      cohortId: $cohortId
      searchTerm: $searchTerm
      orderAttr: $orderAttr
      orderDirection: $orderDirection
      orderBy: $orderBy
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        name
        published
        lastFeedback
        feedbackCount
        ideaVotesCount
        updatedAt
        categories {
          nodes {
            id
            name
            color
          }
        }
      }
    }
    categories {
      nodes {
        id
        name
        color
      }
    }
  }
}
    `;

export const useIdeasTableQuery = <
      TData = IdeasTableQuery,
      TError = unknown
    >(
      variables: IdeasTableQueryVariables,
      options?: Omit<UseQueryOptions<IdeasTableQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<IdeasTableQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<IdeasTableQuery, TError, TData>(
      {
    queryKey: ['IdeasTable', variables],
    queryFn: useFetchData<IdeasTableQuery, IdeasTableQueryVariables>(IdeasTableDocument).bind(null, variables),
    ...options
  }
    )};

useIdeasTableQuery.getKey = (variables: IdeasTableQueryVariables) => ['IdeasTable', variables];

export const useInfiniteIdeasTableQuery = <
      TData = InfiniteData<IdeasTableQuery>,
      TError = unknown
    >(
      variables: IdeasTableQueryVariables,
      options: Omit<UseInfiniteQueryOptions<IdeasTableQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<IdeasTableQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<IdeasTableQuery, IdeasTableQueryVariables>(IdeasTableDocument)
    return useInfiniteQuery<IdeasTableQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['IdeasTable.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteIdeasTableQuery.getKey = (variables: IdeasTableQueryVariables) => ['IdeasTable.infinite', variables];

export const ArchiveIdeasDocument = `
    mutation ArchiveIdeas($ideaIds: [ID!]!) {
  archiveIdeas(input: {ideaIds: $ideaIds}) {
    errors {
      message
      path
    }
  }
}
    `;

export const useArchiveIdeasMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ArchiveIdeasMutation, TError, ArchiveIdeasMutationVariables, TContext>) => {
    
    return useMutation<ArchiveIdeasMutation, TError, ArchiveIdeasMutationVariables, TContext>(
      {
    mutationKey: ['ArchiveIdeas'],
    mutationFn: useFetchData<ArchiveIdeasMutation, ArchiveIdeasMutationVariables>(ArchiveIdeasDocument),
    ...options
  }
    )};

useArchiveIdeasMutation.getKey = () => ['ArchiveIdeas'];

export const CreateIdeaDocument = `
    mutation CreateIdea($input: CreateIdeaInput!) {
  createIdea(input: $input) {
    idea {
      id
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useCreateIdeaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateIdeaMutation, TError, CreateIdeaMutationVariables, TContext>) => {
    
    return useMutation<CreateIdeaMutation, TError, CreateIdeaMutationVariables, TContext>(
      {
    mutationKey: ['CreateIdea'],
    mutationFn: useFetchData<CreateIdeaMutation, CreateIdeaMutationVariables>(CreateIdeaDocument),
    ...options
  }
    )};

useCreateIdeaMutation.getKey = () => ['CreateIdea'];

export const PromoteIdeaDocument = `
    mutation PromoteIdea($input: PromoteIdeaInput!) {
  promoteIdea(input: $input) {
    workItem {
      id
    }
    errors {
      message
      path
    }
  }
}
    `;

export const usePromoteIdeaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PromoteIdeaMutation, TError, PromoteIdeaMutationVariables, TContext>) => {
    
    return useMutation<PromoteIdeaMutation, TError, PromoteIdeaMutationVariables, TContext>(
      {
    mutationKey: ['PromoteIdea'],
    mutationFn: useFetchData<PromoteIdeaMutation, PromoteIdeaMutationVariables>(PromoteIdeaDocument),
    ...options
  }
    )};

usePromoteIdeaMutation.getKey = () => ['PromoteIdea'];

export const TogglePublishedIdeaDocument = `
    mutation TogglePublishedIdea($id: ID!) {
  togglePublishedIdea(input: {id: $id}) {
    errors {
      message
      path
    }
  }
}
    `;

export const useTogglePublishedIdeaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TogglePublishedIdeaMutation, TError, TogglePublishedIdeaMutationVariables, TContext>) => {
    
    return useMutation<TogglePublishedIdeaMutation, TError, TogglePublishedIdeaMutationVariables, TContext>(
      {
    mutationKey: ['TogglePublishedIdea'],
    mutationFn: useFetchData<TogglePublishedIdeaMutation, TogglePublishedIdeaMutationVariables>(TogglePublishedIdeaDocument),
    ...options
  }
    )};

useTogglePublishedIdeaMutation.getKey = () => ['TogglePublishedIdea'];

export const UnarchiveIdeasDocument = `
    mutation UnarchiveIdeas($ideaIds: [ID!]!) {
  unarchiveIdeas(input: {ideaIds: $ideaIds}) {
    errors {
      message
      path
    }
  }
}
    `;

export const useUnarchiveIdeasMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnarchiveIdeasMutation, TError, UnarchiveIdeasMutationVariables, TContext>) => {
    
    return useMutation<UnarchiveIdeasMutation, TError, UnarchiveIdeasMutationVariables, TContext>(
      {
    mutationKey: ['UnarchiveIdeas'],
    mutationFn: useFetchData<UnarchiveIdeasMutation, UnarchiveIdeasMutationVariables>(UnarchiveIdeasDocument),
    ...options
  }
    )};

useUnarchiveIdeasMutation.getKey = () => ['UnarchiveIdeas'];

export const UpdateIdeaDocument = `
    mutation UpdateIdea($input: UpdateIdeaInput!) {
  updateIdea(input: $input) {
    errors {
      message
      path
    }
  }
}
    `;

export const useUpdateIdeaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateIdeaMutation, TError, UpdateIdeaMutationVariables, TContext>) => {
    
    return useMutation<UpdateIdeaMutation, TError, UpdateIdeaMutationVariables, TContext>(
      {
    mutationKey: ['UpdateIdea'],
    mutationFn: useFetchData<UpdateIdeaMutation, UpdateIdeaMutationVariables>(UpdateIdeaDocument),
    ...options
  }
    )};

useUpdateIdeaMutation.getKey = () => ['UpdateIdea'];

export const UpdateIdeaModalDocument = `
    query UpdateIdeaModal($ideaId: ID!) {
  idea(id: $ideaId) {
    categories {
      nodes {
        id
        name
        color
      }
    }
    notes
    name
  }
}
    `;

export const useUpdateIdeaModalQuery = <
      TData = UpdateIdeaModalQuery,
      TError = unknown
    >(
      variables: UpdateIdeaModalQueryVariables,
      options?: Omit<UseQueryOptions<UpdateIdeaModalQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UpdateIdeaModalQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UpdateIdeaModalQuery, TError, TData>(
      {
    queryKey: ['UpdateIdeaModal', variables],
    queryFn: useFetchData<UpdateIdeaModalQuery, UpdateIdeaModalQueryVariables>(UpdateIdeaModalDocument).bind(null, variables),
    ...options
  }
    )};

useUpdateIdeaModalQuery.getKey = (variables: UpdateIdeaModalQueryVariables) => ['UpdateIdeaModal', variables];

export const useInfiniteUpdateIdeaModalQuery = <
      TData = InfiniteData<UpdateIdeaModalQuery>,
      TError = unknown
    >(
      variables: UpdateIdeaModalQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UpdateIdeaModalQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UpdateIdeaModalQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<UpdateIdeaModalQuery, UpdateIdeaModalQueryVariables>(UpdateIdeaModalDocument)
    return useInfiniteQuery<UpdateIdeaModalQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['UpdateIdeaModal.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteUpdateIdeaModalQuery.getKey = (variables: UpdateIdeaModalQueryVariables) => ['UpdateIdeaModal.infinite', variables];

export const GetCrmStagesDocument = `
    query GetCrmStages($projectId: ID!) {
  project(id: $projectId) {
    crmStageData {
      crmStageFilters
      availableStages {
        id
        name
      }
    }
  }
}
    `;

export const useGetCrmStagesQuery = <
      TData = GetCrmStagesQuery,
      TError = unknown
    >(
      variables: GetCrmStagesQueryVariables,
      options?: Omit<UseQueryOptions<GetCrmStagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCrmStagesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCrmStagesQuery, TError, TData>(
      {
    queryKey: ['GetCrmStages', variables],
    queryFn: useFetchData<GetCrmStagesQuery, GetCrmStagesQueryVariables>(GetCrmStagesDocument).bind(null, variables),
    ...options
  }
    )};

useGetCrmStagesQuery.getKey = (variables: GetCrmStagesQueryVariables) => ['GetCrmStages', variables];

export const useInfiniteGetCrmStagesQuery = <
      TData = InfiniteData<GetCrmStagesQuery>,
      TError = unknown
    >(
      variables: GetCrmStagesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetCrmStagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetCrmStagesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetCrmStagesQuery, GetCrmStagesQueryVariables>(GetCrmStagesDocument)
    return useInfiniteQuery<GetCrmStagesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetCrmStages.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetCrmStagesQuery.getKey = (variables: GetCrmStagesQueryVariables) => ['GetCrmStages.infinite', variables];

export const TableProjectSubscriptionsDocument = `
    query TableProjectSubscriptions($subscribableId: ID!, $confirmed: Boolean, $count: Int, $cursor: String) {
  subscribable: node(id: $subscribableId) {
    ...TableProjectSubscriptions
  }
}
    ${TableProjectSubscriptionsFragmentDoc}`;

export const useTableProjectSubscriptionsQuery = <
      TData = TableProjectSubscriptionsQuery,
      TError = unknown
    >(
      variables: TableProjectSubscriptionsQueryVariables,
      options?: Omit<UseQueryOptions<TableProjectSubscriptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TableProjectSubscriptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TableProjectSubscriptionsQuery, TError, TData>(
      {
    queryKey: ['TableProjectSubscriptions', variables],
    queryFn: useFetchData<TableProjectSubscriptionsQuery, TableProjectSubscriptionsQueryVariables>(TableProjectSubscriptionsDocument).bind(null, variables),
    ...options
  }
    )};

useTableProjectSubscriptionsQuery.getKey = (variables: TableProjectSubscriptionsQueryVariables) => ['TableProjectSubscriptions', variables];

export const useInfiniteTableProjectSubscriptionsQuery = <
      TData = InfiniteData<TableProjectSubscriptionsQuery>,
      TError = unknown
    >(
      variables: TableProjectSubscriptionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<TableProjectSubscriptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<TableProjectSubscriptionsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<TableProjectSubscriptionsQuery, TableProjectSubscriptionsQueryVariables>(TableProjectSubscriptionsDocument)
    return useInfiniteQuery<TableProjectSubscriptionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['TableProjectSubscriptions.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteTableProjectSubscriptionsQuery.getKey = (variables: TableProjectSubscriptionsQueryVariables) => ['TableProjectSubscriptions.infinite', variables];

export const UnsubscribeProjectSubscriptionWorkItemDocument = `
    mutation UnsubscribeProjectSubscriptionWorkItem($projectSubscriptionId: ID!, $workItemId: ID!) {
  unsubscribeProjectSubscriptionWorkItem(
    input: {projectSubscription: {id: $projectSubscriptionId}, workItemId: $workItemId}
  ) {
    projectSubscription {
      id
      state
      project {
        id
      }
      subscriber {
        id
        email
      }
      workItems {
        id
        name
      }
      updatedAt
    }
  }
}
    `;

export const useUnsubscribeProjectSubscriptionWorkItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnsubscribeProjectSubscriptionWorkItemMutation, TError, UnsubscribeProjectSubscriptionWorkItemMutationVariables, TContext>) => {
    
    return useMutation<UnsubscribeProjectSubscriptionWorkItemMutation, TError, UnsubscribeProjectSubscriptionWorkItemMutationVariables, TContext>(
      {
    mutationKey: ['UnsubscribeProjectSubscriptionWorkItem'],
    mutationFn: useFetchData<UnsubscribeProjectSubscriptionWorkItemMutation, UnsubscribeProjectSubscriptionWorkItemMutationVariables>(UnsubscribeProjectSubscriptionWorkItemDocument),
    ...options
  }
    )};

useUnsubscribeProjectSubscriptionWorkItemMutation.getKey = () => ['UnsubscribeProjectSubscriptionWorkItem'];

export const ArchiveProjectDocument = `
    mutation archiveProject($input: ArchiveProjectInput!) {
  archiveProject(input: $input) {
    project {
      id
    }
    errors {
      path
      message
    }
  }
}
    `;

export const useArchiveProjectMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ArchiveProjectMutation, TError, ArchiveProjectMutationVariables, TContext>) => {
    
    return useMutation<ArchiveProjectMutation, TError, ArchiveProjectMutationVariables, TContext>(
      {
    mutationKey: ['archiveProject'],
    mutationFn: useFetchData<ArchiveProjectMutation, ArchiveProjectMutationVariables>(ArchiveProjectDocument),
    ...options
  }
    )};

useArchiveProjectMutation.getKey = () => ['archiveProject'];

export const CreateProjectDocument = `
    mutation createProject($input: CreateProjectInput!) {
  createProject(input: $input) {
    project {
      id
    }
    errors {
      path
      message
    }
  }
}
    `;

export const useCreateProjectMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateProjectMutation, TError, CreateProjectMutationVariables, TContext>) => {
    
    return useMutation<CreateProjectMutation, TError, CreateProjectMutationVariables, TContext>(
      {
    mutationKey: ['createProject'],
    mutationFn: useFetchData<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument),
    ...options
  }
    )};

useCreateProjectMutation.getKey = () => ['createProject'];

export const FetchProjectAdminsDocument = `
    query FetchProjectAdmins($projectId: ID!) {
  project(id: $projectId) {
    projectAdmins {
      name
      email
    }
  }
}
    `;

export const useFetchProjectAdminsQuery = <
      TData = FetchProjectAdminsQuery,
      TError = unknown
    >(
      variables: FetchProjectAdminsQueryVariables,
      options?: Omit<UseQueryOptions<FetchProjectAdminsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FetchProjectAdminsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FetchProjectAdminsQuery, TError, TData>(
      {
    queryKey: ['FetchProjectAdmins', variables],
    queryFn: useFetchData<FetchProjectAdminsQuery, FetchProjectAdminsQueryVariables>(FetchProjectAdminsDocument).bind(null, variables),
    ...options
  }
    )};

useFetchProjectAdminsQuery.getKey = (variables: FetchProjectAdminsQueryVariables) => ['FetchProjectAdmins', variables];

export const useInfiniteFetchProjectAdminsQuery = <
      TData = InfiniteData<FetchProjectAdminsQuery>,
      TError = unknown
    >(
      variables: FetchProjectAdminsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FetchProjectAdminsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FetchProjectAdminsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<FetchProjectAdminsQuery, FetchProjectAdminsQueryVariables>(FetchProjectAdminsDocument)
    return useInfiniteQuery<FetchProjectAdminsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FetchProjectAdmins.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteFetchProjectAdminsQuery.getKey = (variables: FetchProjectAdminsQueryVariables) => ['FetchProjectAdmins.infinite', variables];

export const ArchiveWorkItemDocument = `
    mutation archiveWorkItem($id: ID!) {
  archiveWorkItem(input: {id: $id}) {
    workItem {
      id
      feedbacks {
        edges {
          node {
            id
          }
        }
      }
    }
  }
}
    `;

export const useArchiveWorkItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ArchiveWorkItemMutation, TError, ArchiveWorkItemMutationVariables, TContext>) => {
    
    return useMutation<ArchiveWorkItemMutation, TError, ArchiveWorkItemMutationVariables, TContext>(
      {
    mutationKey: ['archiveWorkItem'],
    mutationFn: useFetchData<ArchiveWorkItemMutation, ArchiveWorkItemMutationVariables>(ArchiveWorkItemDocument),
    ...options
  }
    )};

useArchiveWorkItemMutation.getKey = () => ['archiveWorkItem'];

export const CreateWorkItemDocument = `
    mutation CreateWorkItem($name: String!, $stageId: ID!, $categories: [CategoryAttributes!]) {
  createWorkItem(
    input: {workItem: {name: $name, stageId: $stageId, categories: $categories}}
  ) {
    workItem {
      id
      name
      stageId
      stage {
        name
      }
      categories {
        id
        name
        backgroundColor
        textColor
      }
      feedbacks {
        totalCount
      }
      projectSubscriptions {
        totalCount
      }
    }
  }
}
    `;

export const useCreateWorkItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateWorkItemMutation, TError, CreateWorkItemMutationVariables, TContext>) => {
    
    return useMutation<CreateWorkItemMutation, TError, CreateWorkItemMutationVariables, TContext>(
      {
    mutationKey: ['CreateWorkItem'],
    mutationFn: useFetchData<CreateWorkItemMutation, CreateWorkItemMutationVariables>(CreateWorkItemDocument),
    ...options
  }
    )};

useCreateWorkItemMutation.getKey = () => ['CreateWorkItem'];

export const DuplicateWorkItemDocument = `
    mutation duplicateWorkItem($id: ID!) {
  duplicateWorkItem(input: {id: $id}) {
    workItem {
      id
      name
      stageId
      stage {
        name
      }
      categories {
        id
        name
        backgroundColor
        textColor
      }
      feedbacks {
        totalCount
      }
      projectSubscriptions {
        totalCount
      }
    }
  }
}
    `;

export const useDuplicateWorkItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DuplicateWorkItemMutation, TError, DuplicateWorkItemMutationVariables, TContext>) => {
    
    return useMutation<DuplicateWorkItemMutation, TError, DuplicateWorkItemMutationVariables, TContext>(
      {
    mutationKey: ['duplicateWorkItem'],
    mutationFn: useFetchData<DuplicateWorkItemMutation, DuplicateWorkItemMutationVariables>(DuplicateWorkItemDocument),
    ...options
  }
    )};

useDuplicateWorkItemMutation.getKey = () => ['duplicateWorkItem'];

export const RepositionWorkItemDocument = `
    mutation RepositionWorkItem($id: ID!, $position: Int, $targetStageId: ID!, $sourceStageId: ID) {
  repositionWorkItem(
    input: {workItem: {id: $id, position: $position, targetStageId: $targetStageId, sourceStageId: $sourceStageId}}
  ) {
    workItem {
      id
      position
      stageId
      events {
        nodes {
          id
          eventType
          createdAt
          data
        }
      }
    }
    targetStage {
      workItems {
        edges {
          node {
            id
          }
        }
      }
    }
    sourceStage {
      workItems {
        edges {
          node {
            id
          }
        }
      }
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useRepositionWorkItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RepositionWorkItemMutation, TError, RepositionWorkItemMutationVariables, TContext>) => {
    
    return useMutation<RepositionWorkItemMutation, TError, RepositionWorkItemMutationVariables, TContext>(
      {
    mutationKey: ['RepositionWorkItem'],
    mutationFn: useFetchData<RepositionWorkItemMutation, RepositionWorkItemMutationVariables>(RepositionWorkItemDocument),
    ...options
  }
    )};

useRepositionWorkItemMutation.getKey = () => ['RepositionWorkItem'];

export const RoadmapEnableDocument = `
    mutation RoadmapEnable($projectId: ID!) {
  updateProject(input: {project: {id: $projectId, roadmapEnabled: true}}) {
    project {
      roadmapEnabled
    }
  }
}
    `;

export const useRoadmapEnableMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RoadmapEnableMutation, TError, RoadmapEnableMutationVariables, TContext>) => {
    
    return useMutation<RoadmapEnableMutation, TError, RoadmapEnableMutationVariables, TContext>(
      {
    mutationKey: ['RoadmapEnable'],
    mutationFn: useFetchData<RoadmapEnableMutation, RoadmapEnableMutationVariables>(RoadmapEnableDocument),
    ...options
  }
    )};

useRoadmapEnableMutation.getKey = () => ['RoadmapEnable'];

export const UnarchiveWorkItemDocument = `
    mutation UnarchiveWorkItem($id: ID!) {
  unarchiveWorkItem(input: {id: $id}) {
    workItem {
      id
      feedbacks {
        edges {
          node {
            id
          }
        }
      }
    }
  }
}
    `;

export const useUnarchiveWorkItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnarchiveWorkItemMutation, TError, UnarchiveWorkItemMutationVariables, TContext>) => {
    
    return useMutation<UnarchiveWorkItemMutation, TError, UnarchiveWorkItemMutationVariables, TContext>(
      {
    mutationKey: ['UnarchiveWorkItem'],
    mutationFn: useFetchData<UnarchiveWorkItemMutation, UnarchiveWorkItemMutationVariables>(UnarchiveWorkItemDocument),
    ...options
  }
    )};

useUnarchiveWorkItemMutation.getKey = () => ['UnarchiveWorkItem'];

export const WorkItemSelectDocument = `
    query WorkItemSelect($projectId: ID!) {
  viewer {
    project(id: $projectId) {
      stages {
        nodes {
          id
          name
          position
          workItems {
            nodes {
              id
              name
              position
              categories {
                id
                position
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useWorkItemSelectQuery = <
      TData = WorkItemSelectQuery,
      TError = unknown
    >(
      variables: WorkItemSelectQueryVariables,
      options?: Omit<UseQueryOptions<WorkItemSelectQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<WorkItemSelectQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<WorkItemSelectQuery, TError, TData>(
      {
    queryKey: ['WorkItemSelect', variables],
    queryFn: useFetchData<WorkItemSelectQuery, WorkItemSelectQueryVariables>(WorkItemSelectDocument).bind(null, variables),
    ...options
  }
    )};

useWorkItemSelectQuery.getKey = (variables: WorkItemSelectQueryVariables) => ['WorkItemSelect', variables];

export const useInfiniteWorkItemSelectQuery = <
      TData = InfiniteData<WorkItemSelectQuery>,
      TError = unknown
    >(
      variables: WorkItemSelectQueryVariables,
      options: Omit<UseInfiniteQueryOptions<WorkItemSelectQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<WorkItemSelectQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<WorkItemSelectQuery, WorkItemSelectQueryVariables>(WorkItemSelectDocument)
    return useInfiniteQuery<WorkItemSelectQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['WorkItemSelect.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteWorkItemSelectQuery.getKey = (variables: WorkItemSelectQueryVariables) => ['WorkItemSelect.infinite', variables];

export const SubscriberDrawerShowDocument = `
    query subscriberDrawerShow($projectId: ID!, $id: RuleValue!) {
  project(id: $projectId) {
    subscribers(where: {rules: [{field: "id", expression: eq, value: $id}]}) {
      edges {
        createdAt
        status
        hasSlackTransport
        hasMailTransport
        audienceDomainHostname
        audienceDomainId
        categories {
          id
          textColor
          backgroundColor
          name
        }
        node {
          id
          email
          initials
          isProjectSubscriber
          feedbacks {
            totalCount
          }
          ideaVotes {
            totalCount
          }
          workItems {
            totalCount
          }
        }
      }
    }
  }
}
    `;

export const useSubscriberDrawerShowQuery = <
      TData = SubscriberDrawerShowQuery,
      TError = unknown
    >(
      variables: SubscriberDrawerShowQueryVariables,
      options?: Omit<UseQueryOptions<SubscriberDrawerShowQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SubscriberDrawerShowQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SubscriberDrawerShowQuery, TError, TData>(
      {
    queryKey: ['subscriberDrawerShow', variables],
    queryFn: useFetchData<SubscriberDrawerShowQuery, SubscriberDrawerShowQueryVariables>(SubscriberDrawerShowDocument).bind(null, variables),
    ...options
  }
    )};

useSubscriberDrawerShowQuery.getKey = (variables: SubscriberDrawerShowQueryVariables) => ['subscriberDrawerShow', variables];

export const useInfiniteSubscriberDrawerShowQuery = <
      TData = InfiniteData<SubscriberDrawerShowQuery>,
      TError = unknown
    >(
      variables: SubscriberDrawerShowQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SubscriberDrawerShowQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SubscriberDrawerShowQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SubscriberDrawerShowQuery, SubscriberDrawerShowQueryVariables>(SubscriberDrawerShowDocument)
    return useInfiniteQuery<SubscriberDrawerShowQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['subscriberDrawerShow.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSubscriberDrawerShowQuery.getKey = (variables: SubscriberDrawerShowQueryVariables) => ['subscriberDrawerShow.infinite', variables];

export const SubscriberEventsDocument = `
    query subscriberEvents($projectId: ID!, $id: RuleValue!, $count: Int!, $cursor: String, $orderBy: OrderBy) {
  project(id: $projectId) {
    subscribers(where: {rules: [{field: "id", expression: eq, value: $id}]}) {
      nodes {
        events(first: $count, after: $cursor, orderBy: $orderBy) {
          pageInfo {
            startCursor
            endCursor
            hasNextPage
          }
          nodes {
            id
            createdAt
            project {
              id
              name
            }
            eventType
            eventObject {
              __typename
              ... on Announcement {
                id
                name
                headline
                privatePermalink
              }
              ... on Idea {
                id
                name
                privatePermalink
              }
              ... on Feedback {
                id
                content
                importance
                sentimentScore
                sentimentMagnitude
                notes
                feedbackable {
                  __typename
                  name
                  privatePermalink
                }
                reporter {
                  id
                  name
                  email
                }
              }
              ... on ProjectSubscription {
                id
              }
              ... on WorkItem {
                id
                name
                privatePermalink
              }
            }
            notifications(
              where: {rules: [{field: "recipient_id", expression: eq, value: $id}]}
            ) {
              totalCount
              nodes {
                createdAt
                sentAt
                openedAt
                clickedThroughAt
                transport {
                  __typename
                }
                status
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useSubscriberEventsQuery = <
      TData = SubscriberEventsQuery,
      TError = unknown
    >(
      variables: SubscriberEventsQueryVariables,
      options?: Omit<UseQueryOptions<SubscriberEventsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SubscriberEventsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SubscriberEventsQuery, TError, TData>(
      {
    queryKey: ['subscriberEvents', variables],
    queryFn: useFetchData<SubscriberEventsQuery, SubscriberEventsQueryVariables>(SubscriberEventsDocument).bind(null, variables),
    ...options
  }
    )};

useSubscriberEventsQuery.getKey = (variables: SubscriberEventsQueryVariables) => ['subscriberEvents', variables];

export const useInfiniteSubscriberEventsQuery = <
      TData = InfiniteData<SubscriberEventsQuery>,
      TError = unknown
    >(
      variables: SubscriberEventsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SubscriberEventsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SubscriberEventsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SubscriberEventsQuery, SubscriberEventsQueryVariables>(SubscriberEventsDocument)
    return useInfiniteQuery<SubscriberEventsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['subscriberEvents.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSubscriberEventsQuery.getKey = (variables: SubscriberEventsQueryVariables) => ['subscriberEvents.infinite', variables];

export const SubscriberFeedbacksDocument = `
    query subscriberFeedbacks($projectId: ID!, $id: RuleValue!, $orderBy: OrderBy, $first: Int, $after: String, $before: String) {
  project(id: $projectId) {
    subscribers(where: {rules: [{field: "id", expression: eq, value: $id}]}) {
      nodes {
        feedbacks(first: $first, after: $after, before: $before, orderBy: $orderBy) {
          pageInfo {
            startCursor
            endCursor
            hasPreviousPage
            hasNextPage
          }
          totalCount
          nodes {
            id
            content
            createdAt
            importance
            sentimentScore
            notes
            reporter {
              id
              name
              email
            }
            feedbackable {
              name
              privatePermalink
              __typename
            }
          }
        }
      }
    }
  }
}
    `;

export const useSubscriberFeedbacksQuery = <
      TData = SubscriberFeedbacksQuery,
      TError = unknown
    >(
      variables: SubscriberFeedbacksQueryVariables,
      options?: Omit<UseQueryOptions<SubscriberFeedbacksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SubscriberFeedbacksQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SubscriberFeedbacksQuery, TError, TData>(
      {
    queryKey: ['subscriberFeedbacks', variables],
    queryFn: useFetchData<SubscriberFeedbacksQuery, SubscriberFeedbacksQueryVariables>(SubscriberFeedbacksDocument).bind(null, variables),
    ...options
  }
    )};

useSubscriberFeedbacksQuery.getKey = (variables: SubscriberFeedbacksQueryVariables) => ['subscriberFeedbacks', variables];

export const useInfiniteSubscriberFeedbacksQuery = <
      TData = InfiniteData<SubscriberFeedbacksQuery>,
      TError = unknown
    >(
      variables: SubscriberFeedbacksQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SubscriberFeedbacksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SubscriberFeedbacksQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SubscriberFeedbacksQuery, SubscriberFeedbacksQueryVariables>(SubscriberFeedbacksDocument)
    return useInfiniteQuery<SubscriberFeedbacksQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['subscriberFeedbacks.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSubscriberFeedbacksQuery.getKey = (variables: SubscriberFeedbacksQueryVariables) => ['subscriberFeedbacks.infinite', variables];

export const SubscriberNotificationsDocument = `
    query subscriberNotifications($projectId: ID!, $id: RuleValue!) {
  project(id: $projectId) {
    subscribers(where: {rules: [{field: "id", expression: eq, value: $id}]}) {
      nodes {
        notifications {
          nodes {
            id
            status
            createdAt
            transport {
              type: __typename
            }
            event {
              eventType
              eventObject {
                ... on Announcement {
                  id
                  createdAt
                  headline
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useSubscriberNotificationsQuery = <
      TData = SubscriberNotificationsQuery,
      TError = unknown
    >(
      variables: SubscriberNotificationsQueryVariables,
      options?: Omit<UseQueryOptions<SubscriberNotificationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SubscriberNotificationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SubscriberNotificationsQuery, TError, TData>(
      {
    queryKey: ['subscriberNotifications', variables],
    queryFn: useFetchData<SubscriberNotificationsQuery, SubscriberNotificationsQueryVariables>(SubscriberNotificationsDocument).bind(null, variables),
    ...options
  }
    )};

useSubscriberNotificationsQuery.getKey = (variables: SubscriberNotificationsQueryVariables) => ['subscriberNotifications', variables];

export const useInfiniteSubscriberNotificationsQuery = <
      TData = InfiniteData<SubscriberNotificationsQuery>,
      TError = unknown
    >(
      variables: SubscriberNotificationsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SubscriberNotificationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SubscriberNotificationsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SubscriberNotificationsQuery, SubscriberNotificationsQueryVariables>(SubscriberNotificationsDocument)
    return useInfiniteQuery<SubscriberNotificationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['subscriberNotifications.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSubscriberNotificationsQuery.getKey = (variables: SubscriberNotificationsQueryVariables) => ['subscriberNotifications.infinite', variables];

export const SubscriberRoadmapDocument = `
    query SubscriberRoadmap($projectId: ID!, $id: RuleValue!, $first: Int, $after: String, $before: String) {
  project(id: $projectId) {
    subscribers(where: {rules: [{field: "id", expression: eq, value: $id}]}) {
      nodes {
        workItems(
          first: $first
          after: $after
          before: $before
          orderBy: {field: "createdAt", sort: DESC}
        ) {
          pageInfo {
            hasNextPage
            hasPreviousPage
            endCursor
            startCursor
          }
          totalCount
          nodes {
            name
            stage {
              name
            }
            privatePermalink
          }
        }
      }
    }
  }
}
    `;

export const useSubscriberRoadmapQuery = <
      TData = SubscriberRoadmapQuery,
      TError = unknown
    >(
      variables: SubscriberRoadmapQueryVariables,
      options?: Omit<UseQueryOptions<SubscriberRoadmapQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SubscriberRoadmapQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SubscriberRoadmapQuery, TError, TData>(
      {
    queryKey: ['SubscriberRoadmap', variables],
    queryFn: useFetchData<SubscriberRoadmapQuery, SubscriberRoadmapQueryVariables>(SubscriberRoadmapDocument).bind(null, variables),
    ...options
  }
    )};

useSubscriberRoadmapQuery.getKey = (variables: SubscriberRoadmapQueryVariables) => ['SubscriberRoadmap', variables];

export const useInfiniteSubscriberRoadmapQuery = <
      TData = InfiniteData<SubscriberRoadmapQuery>,
      TError = unknown
    >(
      variables: SubscriberRoadmapQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SubscriberRoadmapQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SubscriberRoadmapQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SubscriberRoadmapQuery, SubscriberRoadmapQueryVariables>(SubscriberRoadmapDocument)
    return useInfiniteQuery<SubscriberRoadmapQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['SubscriberRoadmap.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSubscriberRoadmapQuery.getKey = (variables: SubscriberRoadmapQueryVariables) => ['SubscriberRoadmap.infinite', variables];

export const SubscriberVotesDocument = `
    query subscriberVotes($projectId: ID!, $id: RuleValue!, $first: Int, $after: String, $before: String, $orderBy: OrderBy) {
  project(id: $projectId) {
    subscribers(where: {rules: [{field: "id", expression: eq, value: $id}]}) {
      nodes {
        ideaVotes(first: $first, after: $after, before: $before, orderBy: $orderBy) {
          pageInfo {
            hasNextPage
            hasPreviousPage
            endCursor
            startCursor
          }
          totalCount
          nodes {
            id
            createdAt
            idea {
              id
              name
              privatePermalink
              createdAt
            }
          }
        }
      }
    }
  }
}
    `;

export const useSubscriberVotesQuery = <
      TData = SubscriberVotesQuery,
      TError = unknown
    >(
      variables: SubscriberVotesQueryVariables,
      options?: Omit<UseQueryOptions<SubscriberVotesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SubscriberVotesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SubscriberVotesQuery, TError, TData>(
      {
    queryKey: ['subscriberVotes', variables],
    queryFn: useFetchData<SubscriberVotesQuery, SubscriberVotesQueryVariables>(SubscriberVotesDocument).bind(null, variables),
    ...options
  }
    )};

useSubscriberVotesQuery.getKey = (variables: SubscriberVotesQueryVariables) => ['subscriberVotes', variables];

export const useInfiniteSubscriberVotesQuery = <
      TData = InfiniteData<SubscriberVotesQuery>,
      TError = unknown
    >(
      variables: SubscriberVotesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SubscriberVotesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SubscriberVotesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SubscriberVotesQuery, SubscriberVotesQueryVariables>(SubscriberVotesDocument)
    return useInfiniteQuery<SubscriberVotesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['subscriberVotes.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSubscriberVotesQuery.getKey = (variables: SubscriberVotesQueryVariables) => ['subscriberVotes.infinite', variables];

export const AddProjectViewAudienceDomainDocument = `
    mutation AddProjectViewAudienceDomain($input: AddAudienceDomainsInput!) {
  addProjectViewAudienceDomains(input: $input) {
    projectView {
      id
      audienceDomains {
        totalCount
        edges {
          node {
            id
          }
        }
      }
    }
  }
}
    `;

export const useAddProjectViewAudienceDomainMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddProjectViewAudienceDomainMutation, TError, AddProjectViewAudienceDomainMutationVariables, TContext>) => {
    
    return useMutation<AddProjectViewAudienceDomainMutation, TError, AddProjectViewAudienceDomainMutationVariables, TContext>(
      {
    mutationKey: ['AddProjectViewAudienceDomain'],
    mutationFn: useFetchData<AddProjectViewAudienceDomainMutation, AddProjectViewAudienceDomainMutationVariables>(AddProjectViewAudienceDomainDocument),
    ...options
  }
    )};

useAddProjectViewAudienceDomainMutation.getKey = () => ['AddProjectViewAudienceDomain'];

export const AddProjectViewSubscriberDocument = `
    mutation AddProjectViewSubscriber($input: AddSubscribersInput!) {
  addProjectViewSubscribers(input: $input) {
    projectView {
      id
      subscribers {
        totalCount
      }
    }
  }
}
    `;

export const useAddProjectViewSubscriberMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddProjectViewSubscriberMutation, TError, AddProjectViewSubscriberMutationVariables, TContext>) => {
    
    return useMutation<AddProjectViewSubscriberMutation, TError, AddProjectViewSubscriberMutationVariables, TContext>(
      {
    mutationKey: ['AddProjectViewSubscriber'],
    mutationFn: useFetchData<AddProjectViewSubscriberMutation, AddProjectViewSubscriberMutationVariables>(AddProjectViewSubscriberDocument),
    ...options
  }
    )};

useAddProjectViewSubscriberMutation.getKey = () => ['AddProjectViewSubscriber'];

export const CreateViewDocument = `
    mutation CreateView($input: CreateProjectViewInput!) {
  createProjectView(input: $input) {
    projectView {
      id
      name
      description
    }
    errors {
      message
    }
  }
}
    `;

export const useCreateViewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateViewMutation, TError, CreateViewMutationVariables, TContext>) => {
    
    return useMutation<CreateViewMutation, TError, CreateViewMutationVariables, TContext>(
      {
    mutationKey: ['CreateView'],
    mutationFn: useFetchData<CreateViewMutation, CreateViewMutationVariables>(CreateViewDocument),
    ...options
  }
    )};

useCreateViewMutation.getKey = () => ['CreateView'];

export const ProjectViewDomainsDocument = `
    query ProjectViewDomains($projectId: ID!, $projectViewId: ID!) {
  project(id: $projectId) {
    projectView(id: $projectViewId) {
      id
      audienceDomains {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          node {
            id
            hostname
          }
        }
      }
    }
  }
}
    `;

export const useProjectViewDomainsQuery = <
      TData = ProjectViewDomainsQuery,
      TError = unknown
    >(
      variables: ProjectViewDomainsQueryVariables,
      options?: Omit<UseQueryOptions<ProjectViewDomainsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectViewDomainsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectViewDomainsQuery, TError, TData>(
      {
    queryKey: ['ProjectViewDomains', variables],
    queryFn: useFetchData<ProjectViewDomainsQuery, ProjectViewDomainsQueryVariables>(ProjectViewDomainsDocument).bind(null, variables),
    ...options
  }
    )};

useProjectViewDomainsQuery.getKey = (variables: ProjectViewDomainsQueryVariables) => ['ProjectViewDomains', variables];

export const useInfiniteProjectViewDomainsQuery = <
      TData = InfiniteData<ProjectViewDomainsQuery>,
      TError = unknown
    >(
      variables: ProjectViewDomainsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProjectViewDomainsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProjectViewDomainsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ProjectViewDomainsQuery, ProjectViewDomainsQueryVariables>(ProjectViewDomainsDocument)
    return useInfiniteQuery<ProjectViewDomainsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProjectViewDomains.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteProjectViewDomainsQuery.getKey = (variables: ProjectViewDomainsQueryVariables) => ['ProjectViewDomains.infinite', variables];

export const ProjectViewSubscribersDocument = `
    query ProjectViewSubscribers($projectId: ID!, $projectViewId: ID!) {
  project(id: $projectId) {
    id
    projectView(id: $projectViewId) {
      id
      subscribers {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          node {
            id
            email
          }
        }
      }
    }
  }
}
    `;

export const useProjectViewSubscribersQuery = <
      TData = ProjectViewSubscribersQuery,
      TError = unknown
    >(
      variables: ProjectViewSubscribersQueryVariables,
      options?: Omit<UseQueryOptions<ProjectViewSubscribersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectViewSubscribersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectViewSubscribersQuery, TError, TData>(
      {
    queryKey: ['ProjectViewSubscribers', variables],
    queryFn: useFetchData<ProjectViewSubscribersQuery, ProjectViewSubscribersQueryVariables>(ProjectViewSubscribersDocument).bind(null, variables),
    ...options
  }
    )};

useProjectViewSubscribersQuery.getKey = (variables: ProjectViewSubscribersQueryVariables) => ['ProjectViewSubscribers', variables];

export const useInfiniteProjectViewSubscribersQuery = <
      TData = InfiniteData<ProjectViewSubscribersQuery>,
      TError = unknown
    >(
      variables: ProjectViewSubscribersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProjectViewSubscribersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProjectViewSubscribersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ProjectViewSubscribersQuery, ProjectViewSubscribersQueryVariables>(ProjectViewSubscribersDocument)
    return useInfiniteQuery<ProjectViewSubscribersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProjectViewSubscribers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteProjectViewSubscribersQuery.getKey = (variables: ProjectViewSubscribersQueryVariables) => ['ProjectViewSubscribers.infinite', variables];

export const RemoveProjectViewDomainsDocument = `
    mutation RemoveProjectViewDomains($input: RemoveAudienceDomainsInput!) {
  removeProjectViewAudienceDomains(input: $input) {
    projectView {
      id
      audienceDomains {
        totalCount
        edges {
          node {
            id
          }
        }
      }
    }
  }
}
    `;

export const useRemoveProjectViewDomainsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveProjectViewDomainsMutation, TError, RemoveProjectViewDomainsMutationVariables, TContext>) => {
    
    return useMutation<RemoveProjectViewDomainsMutation, TError, RemoveProjectViewDomainsMutationVariables, TContext>(
      {
    mutationKey: ['RemoveProjectViewDomains'],
    mutationFn: useFetchData<RemoveProjectViewDomainsMutation, RemoveProjectViewDomainsMutationVariables>(RemoveProjectViewDomainsDocument),
    ...options
  }
    )};

useRemoveProjectViewDomainsMutation.getKey = () => ['RemoveProjectViewDomains'];

export const RemoveProjectViewSubscribersDocument = `
    mutation RemoveProjectViewSubscribers($input: RemoveSubscribersInput!) {
  removeProjectViewSubscribers(input: $input) {
    projectView {
      id
      name
      subscribers {
        totalCount
      }
    }
  }
}
    `;

export const useRemoveProjectViewSubscribersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveProjectViewSubscribersMutation, TError, RemoveProjectViewSubscribersMutationVariables, TContext>) => {
    
    return useMutation<RemoveProjectViewSubscribersMutation, TError, RemoveProjectViewSubscribersMutationVariables, TContext>(
      {
    mutationKey: ['RemoveProjectViewSubscribers'],
    mutationFn: useFetchData<RemoveProjectViewSubscribersMutation, RemoveProjectViewSubscribersMutationVariables>(RemoveProjectViewSubscribersDocument),
    ...options
  }
    )};

useRemoveProjectViewSubscribersMutation.getKey = () => ['RemoveProjectViewSubscribers'];

export const DeleteVotesDocument = `
    mutation DeleteVotes($ideaId: ID!, $voteIds: [ID!]!) {
  deleteVotes(input: {ideaId: $ideaId, voteIds: $voteIds}) {
    success
  }
}
    `;

export const useDeleteVotesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteVotesMutation, TError, DeleteVotesMutationVariables, TContext>) => {
    
    return useMutation<DeleteVotesMutation, TError, DeleteVotesMutationVariables, TContext>(
      {
    mutationKey: ['DeleteVotes'],
    mutationFn: useFetchData<DeleteVotesMutation, DeleteVotesMutationVariables>(DeleteVotesDocument),
    ...options
  }
    )};

useDeleteVotesMutation.getKey = () => ['DeleteVotes'];

export const VotesTableDocument = `
    query VotesTable($ideaId: ID!, $count: Int!, $cursor: String, $searchTerm: String, $orderAttr: String, $orderDirection: String) {
  idea(id: $ideaId) {
    votes(
      first: $count
      after: $cursor
      searchTerm: $searchTerm
      orderAttr: $orderAttr
      orderDirection: $orderDirection
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          subscriber {
            id
            initials
            email
            isProjectSubscriber
            __typename
          }
          createdAt
        }
      }
    }
  }
}
    `;

export const useVotesTableQuery = <
      TData = VotesTableQuery,
      TError = unknown
    >(
      variables: VotesTableQueryVariables,
      options?: Omit<UseQueryOptions<VotesTableQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<VotesTableQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<VotesTableQuery, TError, TData>(
      {
    queryKey: ['VotesTable', variables],
    queryFn: useFetchData<VotesTableQuery, VotesTableQueryVariables>(VotesTableDocument).bind(null, variables),
    ...options
  }
    )};

useVotesTableQuery.getKey = (variables: VotesTableQueryVariables) => ['VotesTable', variables];

export const useInfiniteVotesTableQuery = <
      TData = InfiniteData<VotesTableQuery>,
      TError = unknown
    >(
      variables: VotesTableQueryVariables,
      options: Omit<UseInfiniteQueryOptions<VotesTableQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<VotesTableQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<VotesTableQuery, VotesTableQueryVariables>(VotesTableDocument)
    return useInfiniteQuery<VotesTableQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['VotesTable.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteVotesTableQuery.getKey = (variables: VotesTableQueryVariables) => ['VotesTable.infinite', variables];

export const CheckAtlassianAccountDocument = `
    query CheckAtlassianAccount($projectId: ID!) {
  session {
    atlassianAccount(projectId: $projectId) {
      id
      siteUrl
    }
  }
}
    `;

export const useCheckAtlassianAccountQuery = <
      TData = CheckAtlassianAccountQuery,
      TError = unknown
    >(
      variables: CheckAtlassianAccountQueryVariables,
      options?: Omit<UseQueryOptions<CheckAtlassianAccountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CheckAtlassianAccountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CheckAtlassianAccountQuery, TError, TData>(
      {
    queryKey: ['CheckAtlassianAccount', variables],
    queryFn: useFetchData<CheckAtlassianAccountQuery, CheckAtlassianAccountQueryVariables>(CheckAtlassianAccountDocument).bind(null, variables),
    ...options
  }
    )};

useCheckAtlassianAccountQuery.getKey = (variables: CheckAtlassianAccountQueryVariables) => ['CheckAtlassianAccount', variables];

export const useInfiniteCheckAtlassianAccountQuery = <
      TData = InfiniteData<CheckAtlassianAccountQuery>,
      TError = unknown
    >(
      variables: CheckAtlassianAccountQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CheckAtlassianAccountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CheckAtlassianAccountQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CheckAtlassianAccountQuery, CheckAtlassianAccountQueryVariables>(CheckAtlassianAccountDocument)
    return useInfiniteQuery<CheckAtlassianAccountQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CheckAtlassianAccount.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCheckAtlassianAccountQuery.getKey = (variables: CheckAtlassianAccountQueryVariables) => ['CheckAtlassianAccount.infinite', variables];

export const CheckHubspotInstallDocument = `
    query CheckHubspotInstall($projectId: ID!) {
  project(id: $projectId) {
    projectApps {
      nodes {
        __typename
        ... on HubspotApp {
          id
          accountId
          ready
          sendEmailViaHubspot
        }
      }
    }
  }
}
    `;

export const useCheckHubspotInstallQuery = <
      TData = CheckHubspotInstallQuery,
      TError = unknown
    >(
      variables: CheckHubspotInstallQueryVariables,
      options?: Omit<UseQueryOptions<CheckHubspotInstallQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CheckHubspotInstallQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CheckHubspotInstallQuery, TError, TData>(
      {
    queryKey: ['CheckHubspotInstall', variables],
    queryFn: useFetchData<CheckHubspotInstallQuery, CheckHubspotInstallQueryVariables>(CheckHubspotInstallDocument).bind(null, variables),
    ...options
  }
    )};

useCheckHubspotInstallQuery.getKey = (variables: CheckHubspotInstallQueryVariables) => ['CheckHubspotInstall', variables];

export const useInfiniteCheckHubspotInstallQuery = <
      TData = InfiniteData<CheckHubspotInstallQuery>,
      TError = unknown
    >(
      variables: CheckHubspotInstallQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CheckHubspotInstallQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CheckHubspotInstallQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CheckHubspotInstallQuery, CheckHubspotInstallQueryVariables>(CheckHubspotInstallDocument)
    return useInfiniteQuery<CheckHubspotInstallQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CheckHubspotInstall.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCheckHubspotInstallQuery.getKey = (variables: CheckHubspotInstallQueryVariables) => ['CheckHubspotInstall.infinite', variables];

export const CreateProjectSubscriptionDocument = `
    mutation CreateProjectSubscription($projectId: ID!, $email: String!, $workItemId: ID, $categories: [CategoryAttributes!]) {
  createProjectSubscription(
    input: {projectSubscription: {projectId: $projectId, subscriber: {email: $email, type: SUBSCRIBER}, workItems: [{id: $workItemId}], categories: $categories}}
  ) {
    projectSubscription {
      id
      createdAt
      categories {
        id
        name
        backgroundColor
        textColor
      }
      subscriber {
        email
        confirmedAt
        __typename
      }
      transportTypes
    }
    errors {
      path
      message
    }
  }
}
    `;

export const useCreateProjectSubscriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateProjectSubscriptionMutation, TError, CreateProjectSubscriptionMutationVariables, TContext>) => {
    
    return useMutation<CreateProjectSubscriptionMutation, TError, CreateProjectSubscriptionMutationVariables, TContext>(
      {
    mutationKey: ['CreateProjectSubscription'],
    mutationFn: useFetchData<CreateProjectSubscriptionMutation, CreateProjectSubscriptionMutationVariables>(CreateProjectSubscriptionDocument),
    ...options
  }
    )};

useCreateProjectSubscriptionMutation.getKey = () => ['CreateProjectSubscription'];

export const CreateUserProjectSubscriptionDocument = `
    mutation CreateUserProjectSubscription($input: CreateProjectSubscriptionInput!) {
  createProjectSubscription(input: $input) {
    projectSubscription {
      id
      categories {
        id
        name
      }
    }
    errors {
      path
      message
    }
  }
}
    `;

export const useCreateUserProjectSubscriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateUserProjectSubscriptionMutation, TError, CreateUserProjectSubscriptionMutationVariables, TContext>) => {
    
    return useMutation<CreateUserProjectSubscriptionMutation, TError, CreateUserProjectSubscriptionMutationVariables, TContext>(
      {
    mutationKey: ['CreateUserProjectSubscription'],
    mutationFn: useFetchData<CreateUserProjectSubscriptionMutation, CreateUserProjectSubscriptionMutationVariables>(CreateUserProjectSubscriptionDocument),
    ...options
  }
    )};

useCreateUserProjectSubscriptionMutation.getKey = () => ['CreateUserProjectSubscription'];

export const GetProjectSettingsDocument = `
    query GetProjectSettings($projectId: ID!) {
  project(id: $projectId) {
    primaryColor
    secondaryColor
    primaryTextColor
    secondaryTextColor
    whiteColor
    offWhiteColor
    grayColor
  }
}
    `;

export const useGetProjectSettingsQuery = <
      TData = GetProjectSettingsQuery,
      TError = unknown
    >(
      variables: GetProjectSettingsQueryVariables,
      options?: Omit<UseQueryOptions<GetProjectSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProjectSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProjectSettingsQuery, TError, TData>(
      {
    queryKey: ['GetProjectSettings', variables],
    queryFn: useFetchData<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>(GetProjectSettingsDocument).bind(null, variables),
    ...options
  }
    )};

useGetProjectSettingsQuery.getKey = (variables: GetProjectSettingsQueryVariables) => ['GetProjectSettings', variables];

export const useInfiniteGetProjectSettingsQuery = <
      TData = InfiniteData<GetProjectSettingsQuery>,
      TError = unknown
    >(
      variables: GetProjectSettingsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetProjectSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetProjectSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>(GetProjectSettingsDocument)
    return useInfiniteQuery<GetProjectSettingsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetProjectSettings.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetProjectSettingsQuery.getKey = (variables: GetProjectSettingsQueryVariables) => ['GetProjectSettings.infinite', variables];

export const UnsubscribeProjectSubscriptionDocument = `
    mutation unsubscribeProjectSubscription($input: UnsubscribeProjectSubscriptionInput!) {
  unsubscribeProjectSubscription(input: $input) {
    projectSubscription {
      id
    }
  }
}
    `;

export const useUnsubscribeProjectSubscriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnsubscribeProjectSubscriptionMutation, TError, UnsubscribeProjectSubscriptionMutationVariables, TContext>) => {
    
    return useMutation<UnsubscribeProjectSubscriptionMutation, TError, UnsubscribeProjectSubscriptionMutationVariables, TContext>(
      {
    mutationKey: ['unsubscribeProjectSubscription'],
    mutationFn: useFetchData<UnsubscribeProjectSubscriptionMutation, UnsubscribeProjectSubscriptionMutationVariables>(UnsubscribeProjectSubscriptionDocument),
    ...options
  }
    )};

useUnsubscribeProjectSubscriptionMutation.getKey = () => ['unsubscribeProjectSubscription'];

export const GetCategoriesDocument = `
    query getCategories($projectId: ID!) {
  project(id: $projectId) {
    categories {
      edges {
        node {
          id
          name
          color
        }
      }
    }
  }
}
    `;

export const useGetCategoriesQuery = <
      TData = GetCategoriesQuery,
      TError = unknown
    >(
      variables: GetCategoriesQueryVariables,
      options?: Omit<UseQueryOptions<GetCategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCategoriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCategoriesQuery, TError, TData>(
      {
    queryKey: ['getCategories', variables],
    queryFn: useFetchData<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument).bind(null, variables),
    ...options
  }
    )};

useGetCategoriesQuery.getKey = (variables: GetCategoriesQueryVariables) => ['getCategories', variables];

export const useInfiniteGetCategoriesQuery = <
      TData = InfiniteData<GetCategoriesQuery>,
      TError = unknown
    >(
      variables: GetCategoriesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetCategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetCategoriesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument)
    return useInfiniteQuery<GetCategoriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getCategories.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetCategoriesQuery.getKey = (variables: GetCategoriesQueryVariables) => ['getCategories.infinite', variables];

export const GetApiDeckSessionDocument = `
    mutation GetApiDeckSession($projectId: ID!) {
  getConsumerToken(input: {projectId: $projectId}) {
    token
    sessionUri
  }
}
    `;

export const useGetApiDeckSessionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GetApiDeckSessionMutation, TError, GetApiDeckSessionMutationVariables, TContext>) => {
    
    return useMutation<GetApiDeckSessionMutation, TError, GetApiDeckSessionMutationVariables, TContext>(
      {
    mutationKey: ['GetApiDeckSession'],
    mutationFn: useFetchData<GetApiDeckSessionMutation, GetApiDeckSessionMutationVariables>(GetApiDeckSessionDocument),
    ...options
  }
    )};

useGetApiDeckSessionMutation.getKey = () => ['GetApiDeckSession'];

export const GetCrmDataLastSyncDocument = `
    query GetCrmDataLastSync($projectId: ID!) {
  project(id: $projectId) {
    crmDataLastSync
    crmStageData {
      crmStageFilters
    }
  }
}
    `;

export const useGetCrmDataLastSyncQuery = <
      TData = GetCrmDataLastSyncQuery,
      TError = unknown
    >(
      variables: GetCrmDataLastSyncQueryVariables,
      options?: Omit<UseQueryOptions<GetCrmDataLastSyncQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCrmDataLastSyncQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCrmDataLastSyncQuery, TError, TData>(
      {
    queryKey: ['GetCrmDataLastSync', variables],
    queryFn: useFetchData<GetCrmDataLastSyncQuery, GetCrmDataLastSyncQueryVariables>(GetCrmDataLastSyncDocument).bind(null, variables),
    ...options
  }
    )};

useGetCrmDataLastSyncQuery.getKey = (variables: GetCrmDataLastSyncQueryVariables) => ['GetCrmDataLastSync', variables];

export const useInfiniteGetCrmDataLastSyncQuery = <
      TData = InfiniteData<GetCrmDataLastSyncQuery>,
      TError = unknown
    >(
      variables: GetCrmDataLastSyncQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetCrmDataLastSyncQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetCrmDataLastSyncQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetCrmDataLastSyncQuery, GetCrmDataLastSyncQueryVariables>(GetCrmDataLastSyncDocument)
    return useInfiniteQuery<GetCrmDataLastSyncQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetCrmDataLastSync.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetCrmDataLastSyncQuery.getKey = (variables: GetCrmDataLastSyncQueryVariables) => ['GetCrmDataLastSync.infinite', variables];

export const GetJiraAppInstallsDocument = `
    query GetJiraAppInstalls($projectId: ID!) {
  project(id: $projectId) {
    projectApps {
      nodes {
        __typename
        ... on JiraApp {
          id
          projects {
            url
            name
          }
        }
      }
    }
  }
}
    `;

export const useGetJiraAppInstallsQuery = <
      TData = GetJiraAppInstallsQuery,
      TError = unknown
    >(
      variables: GetJiraAppInstallsQueryVariables,
      options?: Omit<UseQueryOptions<GetJiraAppInstallsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetJiraAppInstallsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetJiraAppInstallsQuery, TError, TData>(
      {
    queryKey: ['GetJiraAppInstalls', variables],
    queryFn: useFetchData<GetJiraAppInstallsQuery, GetJiraAppInstallsQueryVariables>(GetJiraAppInstallsDocument).bind(null, variables),
    ...options
  }
    )};

useGetJiraAppInstallsQuery.getKey = (variables: GetJiraAppInstallsQueryVariables) => ['GetJiraAppInstalls', variables];

export const useInfiniteGetJiraAppInstallsQuery = <
      TData = InfiniteData<GetJiraAppInstallsQuery>,
      TError = unknown
    >(
      variables: GetJiraAppInstallsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetJiraAppInstallsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetJiraAppInstallsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetJiraAppInstallsQuery, GetJiraAppInstallsQueryVariables>(GetJiraAppInstallsDocument)
    return useInfiniteQuery<GetJiraAppInstallsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetJiraAppInstalls.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetJiraAppInstallsQuery.getKey = (variables: GetJiraAppInstallsQueryVariables) => ['GetJiraAppInstalls.infinite', variables];

export const GetVaultConnectionsDocument = `
    query GetVaultConnections($projectId: ID!) {
  project(id: $projectId) {
    vaultConnections
  }
}
    `;

export const useGetVaultConnectionsQuery = <
      TData = GetVaultConnectionsQuery,
      TError = unknown
    >(
      variables: GetVaultConnectionsQueryVariables,
      options?: Omit<UseQueryOptions<GetVaultConnectionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetVaultConnectionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetVaultConnectionsQuery, TError, TData>(
      {
    queryKey: ['GetVaultConnections', variables],
    queryFn: useFetchData<GetVaultConnectionsQuery, GetVaultConnectionsQueryVariables>(GetVaultConnectionsDocument).bind(null, variables),
    ...options
  }
    )};

useGetVaultConnectionsQuery.getKey = (variables: GetVaultConnectionsQueryVariables) => ['GetVaultConnections', variables];

export const useInfiniteGetVaultConnectionsQuery = <
      TData = InfiniteData<GetVaultConnectionsQuery>,
      TError = unknown
    >(
      variables: GetVaultConnectionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetVaultConnectionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetVaultConnectionsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetVaultConnectionsQuery, GetVaultConnectionsQueryVariables>(GetVaultConnectionsDocument)
    return useInfiniteQuery<GetVaultConnectionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetVaultConnections.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetVaultConnectionsQuery.getKey = (variables: GetVaultConnectionsQueryVariables) => ['GetVaultConnections.infinite', variables];

export const RemoveCrmIntegrationDocument = `
    mutation RemoveCrmIntegration($projectId: ID!, $unifiedApi: String!, $serviceId: ID!) {
  removeCrmIntegration(
    input: {projectId: $projectId, unifiedApi: $unifiedApi, serviceId: $serviceId}
  ) {
    valid
    serviceId
  }
}
    `;

export const useRemoveCrmIntegrationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveCrmIntegrationMutation, TError, RemoveCrmIntegrationMutationVariables, TContext>) => {
    
    return useMutation<RemoveCrmIntegrationMutation, TError, RemoveCrmIntegrationMutationVariables, TContext>(
      {
    mutationKey: ['RemoveCrmIntegration'],
    mutationFn: useFetchData<RemoveCrmIntegrationMutation, RemoveCrmIntegrationMutationVariables>(RemoveCrmIntegrationDocument),
    ...options
  }
    )};

useRemoveCrmIntegrationMutation.getKey = () => ['RemoveCrmIntegration'];

export const SyncCrmCompaniesDocument = `
    mutation SyncCrmCompanies($projectId: ID!) {
  syncCrmCompanies(input: {projectId: $projectId}) {
    projectId
    valid
  }
}
    `;

export const useSyncCrmCompaniesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SyncCrmCompaniesMutation, TError, SyncCrmCompaniesMutationVariables, TContext>) => {
    
    return useMutation<SyncCrmCompaniesMutation, TError, SyncCrmCompaniesMutationVariables, TContext>(
      {
    mutationKey: ['SyncCrmCompanies'],
    mutationFn: useFetchData<SyncCrmCompaniesMutation, SyncCrmCompaniesMutationVariables>(SyncCrmCompaniesDocument),
    ...options
  }
    )};

useSyncCrmCompaniesMutation.getKey = () => ['SyncCrmCompanies'];

export const AuditLogIndexDocument = `
    query AuditLogIndex($projectId: ID!, $count: Int!, $cursor: String, $eventTypeName: String, $searchTerm: String) {
  project(id: $projectId) {
    ... on Project {
      events(
        first: $count
        after: $cursor
        eventTypeName: $eventTypeName
        searchTerm: $searchTerm
      ) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            createdAt
            type: eventType
            data
            userData
            user {
              ... on User {
                type: __typename
                id
                email: email
                name
                initials
              }
              ... on Subscriber {
                type: __typename
                id
                email: email
                initials
              }
            }
            object: eventObject {
              ... on Announcement {
                id
                type: __typename
                headline
                state
              }
              ... on WorkItem {
                id
                type: __typename
                workItemName: name
              }
              ... on Template {
                id
                type: __typename
                templateName: name
              }
              ... on Idea {
                id
                type: __typename
                name
              }
              ... on Feedback {
                id
                type: __typename
                affectedCustomerEmail
                feedbackable {
                  type: __typename
                  id
                }
              }
              ... on Project {
                type: __typename
                id
                name
              }
              ... on Stage {
                type: __typename
                id
                name
              }
            }
          }
        }
      }
      eventTypes {
        edges {
          node {
            name
          }
        }
      }
    }
  }
}
    `;

export const useAuditLogIndexQuery = <
      TData = AuditLogIndexQuery,
      TError = unknown
    >(
      variables: AuditLogIndexQueryVariables,
      options?: Omit<UseQueryOptions<AuditLogIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AuditLogIndexQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AuditLogIndexQuery, TError, TData>(
      {
    queryKey: ['AuditLogIndex', variables],
    queryFn: useFetchData<AuditLogIndexQuery, AuditLogIndexQueryVariables>(AuditLogIndexDocument).bind(null, variables),
    ...options
  }
    )};

useAuditLogIndexQuery.getKey = (variables: AuditLogIndexQueryVariables) => ['AuditLogIndex', variables];

export const useInfiniteAuditLogIndexQuery = <
      TData = InfiniteData<AuditLogIndexQuery>,
      TError = unknown
    >(
      variables: AuditLogIndexQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AuditLogIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AuditLogIndexQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AuditLogIndexQuery, AuditLogIndexQueryVariables>(AuditLogIndexDocument)
    return useInfiniteQuery<AuditLogIndexQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AuditLogIndex.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAuditLogIndexQuery.getKey = (variables: AuditLogIndexQueryVariables) => ['AuditLogIndex.infinite', variables];

export const CategoriesIndexDocument = `
    query CategoriesIndex($projectId: ID!, $count: Int!, $cursor: String) {
  project(id: $projectId) {
    categories(first: $count, after: $cursor) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          position
          name
          slug
          description
          color
        }
      }
    }
  }
}
    `;

export const useCategoriesIndexQuery = <
      TData = CategoriesIndexQuery,
      TError = unknown
    >(
      variables: CategoriesIndexQueryVariables,
      options?: Omit<UseQueryOptions<CategoriesIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CategoriesIndexQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CategoriesIndexQuery, TError, TData>(
      {
    queryKey: ['CategoriesIndex', variables],
    queryFn: useFetchData<CategoriesIndexQuery, CategoriesIndexQueryVariables>(CategoriesIndexDocument).bind(null, variables),
    ...options
  }
    )};

useCategoriesIndexQuery.getKey = (variables: CategoriesIndexQueryVariables) => ['CategoriesIndex', variables];

export const useInfiniteCategoriesIndexQuery = <
      TData = InfiniteData<CategoriesIndexQuery>,
      TError = unknown
    >(
      variables: CategoriesIndexQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CategoriesIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CategoriesIndexQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CategoriesIndexQuery, CategoriesIndexQueryVariables>(CategoriesIndexDocument)
    return useInfiniteQuery<CategoriesIndexQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CategoriesIndex.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCategoriesIndexQuery.getKey = (variables: CategoriesIndexQueryVariables) => ['CategoriesIndex.infinite', variables];

export const CategoryDocument = `
    query Category($categoryId: ID!) {
  category: node(id: $categoryId) {
    ... on Category {
      id
      position
      name
      slug
      description
      color
    }
  }
}
    `;

export const useCategoryQuery = <
      TData = CategoryQuery,
      TError = unknown
    >(
      variables: CategoryQueryVariables,
      options?: Omit<UseQueryOptions<CategoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CategoryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CategoryQuery, TError, TData>(
      {
    queryKey: ['Category', variables],
    queryFn: useFetchData<CategoryQuery, CategoryQueryVariables>(CategoryDocument).bind(null, variables),
    ...options
  }
    )};

useCategoryQuery.getKey = (variables: CategoryQueryVariables) => ['Category', variables];

export const useInfiniteCategoryQuery = <
      TData = InfiniteData<CategoryQuery>,
      TError = unknown
    >(
      variables: CategoryQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CategoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CategoryQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CategoryQuery, CategoryQueryVariables>(CategoryDocument)
    return useInfiniteQuery<CategoryQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Category.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCategoryQuery.getKey = (variables: CategoryQueryVariables) => ['Category.infinite', variables];

export const ChangeTypesDocument = `
    query ChangeTypes($projectId: ID!) {
  project(id: $projectId) {
    changeTypes {
      nodes {
        id
        name
        color
      }
    }
  }
}
    `;

export const useChangeTypesQuery = <
      TData = ChangeTypesQuery,
      TError = unknown
    >(
      variables: ChangeTypesQueryVariables,
      options?: Omit<UseQueryOptions<ChangeTypesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ChangeTypesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ChangeTypesQuery, TError, TData>(
      {
    queryKey: ['ChangeTypes', variables],
    queryFn: useFetchData<ChangeTypesQuery, ChangeTypesQueryVariables>(ChangeTypesDocument).bind(null, variables),
    ...options
  }
    )};

useChangeTypesQuery.getKey = (variables: ChangeTypesQueryVariables) => ['ChangeTypes', variables];

export const useInfiniteChangeTypesQuery = <
      TData = InfiniteData<ChangeTypesQuery>,
      TError = unknown
    >(
      variables: ChangeTypesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ChangeTypesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ChangeTypesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ChangeTypesQuery, ChangeTypesQueryVariables>(ChangeTypesDocument)
    return useInfiniteQuery<ChangeTypesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ChangeTypes.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteChangeTypesQuery.getKey = (variables: ChangeTypesQueryVariables) => ['ChangeTypes.infinite', variables];

export const ChangeTypesIndexDocument = `
    query ChangeTypesIndex($projectId: ID!, $count: Int!, $cursor: String) {
  project(id: $projectId) {
    changeTypes(first: $count, after: $cursor) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
          color
          apiSlug
        }
      }
    }
  }
}
    `;

export const useChangeTypesIndexQuery = <
      TData = ChangeTypesIndexQuery,
      TError = unknown
    >(
      variables: ChangeTypesIndexQueryVariables,
      options?: Omit<UseQueryOptions<ChangeTypesIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ChangeTypesIndexQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ChangeTypesIndexQuery, TError, TData>(
      {
    queryKey: ['ChangeTypesIndex', variables],
    queryFn: useFetchData<ChangeTypesIndexQuery, ChangeTypesIndexQueryVariables>(ChangeTypesIndexDocument).bind(null, variables),
    ...options
  }
    )};

useChangeTypesIndexQuery.getKey = (variables: ChangeTypesIndexQueryVariables) => ['ChangeTypesIndex', variables];

export const useInfiniteChangeTypesIndexQuery = <
      TData = InfiniteData<ChangeTypesIndexQuery>,
      TError = unknown
    >(
      variables: ChangeTypesIndexQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ChangeTypesIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ChangeTypesIndexQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ChangeTypesIndexQuery, ChangeTypesIndexQueryVariables>(ChangeTypesIndexDocument)
    return useInfiniteQuery<ChangeTypesIndexQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ChangeTypesIndex.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteChangeTypesIndexQuery.getKey = (variables: ChangeTypesIndexQueryVariables) => ['ChangeTypesIndex.infinite', variables];

export const CreateCategoryDocument = `
    mutation CreateCategory($category: CreateCategoryAttributes!) {
  createCategory(input: {category: $category}) {
    category {
      id
      name
      description
      slug
      color
      position
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useCreateCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCategoryMutation, TError, CreateCategoryMutationVariables, TContext>) => {
    
    return useMutation<CreateCategoryMutation, TError, CreateCategoryMutationVariables, TContext>(
      {
    mutationKey: ['CreateCategory'],
    mutationFn: useFetchData<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument),
    ...options
  }
    )};

useCreateCategoryMutation.getKey = () => ['CreateCategory'];

export const CreateChangeTypeDocument = `
    mutation CreateChangeType($input: CreateChangeInput!) {
  createChangeType(input: $input) {
    changeType {
      id
    }
    errors {
      message
    }
  }
}
    `;

export const useCreateChangeTypeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateChangeTypeMutation, TError, CreateChangeTypeMutationVariables, TContext>) => {
    
    return useMutation<CreateChangeTypeMutation, TError, CreateChangeTypeMutationVariables, TContext>(
      {
    mutationKey: ['CreateChangeType'],
    mutationFn: useFetchData<CreateChangeTypeMutation, CreateChangeTypeMutationVariables>(CreateChangeTypeDocument),
    ...options
  }
    )};

useCreateChangeTypeMutation.getKey = () => ['CreateChangeType'];

export const RemoveCategoryDocument = `
    mutation RemoveCategory($categoryId: ID!) {
  removeCategory(input: {id: $categoryId}) {
    category {
      id
      name
      description
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useRemoveCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveCategoryMutation, TError, RemoveCategoryMutationVariables, TContext>) => {
    
    return useMutation<RemoveCategoryMutation, TError, RemoveCategoryMutationVariables, TContext>(
      {
    mutationKey: ['RemoveCategory'],
    mutationFn: useFetchData<RemoveCategoryMutation, RemoveCategoryMutationVariables>(RemoveCategoryDocument),
    ...options
  }
    )};

useRemoveCategoryMutation.getKey = () => ['RemoveCategory'];

export const RemoveChangeTypeDocument = `
    mutation RemoveChangeType($input: RemoveChangeInput!) {
  removeChangeType(input: $input) {
    changeType {
      id
    }
  }
}
    `;

export const useRemoveChangeTypeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveChangeTypeMutation, TError, RemoveChangeTypeMutationVariables, TContext>) => {
    
    return useMutation<RemoveChangeTypeMutation, TError, RemoveChangeTypeMutationVariables, TContext>(
      {
    mutationKey: ['RemoveChangeType'],
    mutationFn: useFetchData<RemoveChangeTypeMutation, RemoveChangeTypeMutationVariables>(RemoveChangeTypeDocument),
    ...options
  }
    )};

useRemoveChangeTypeMutation.getKey = () => ['RemoveChangeType'];

export const ReorderCategoryDocument = `
    mutation ReorderCategory($input: ReorderCategoryInput!) {
  reorderCategory(input: $input) {
    categories {
      id
      position
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useReorderCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReorderCategoryMutation, TError, ReorderCategoryMutationVariables, TContext>) => {
    
    return useMutation<ReorderCategoryMutation, TError, ReorderCategoryMutationVariables, TContext>(
      {
    mutationKey: ['ReorderCategory'],
    mutationFn: useFetchData<ReorderCategoryMutation, ReorderCategoryMutationVariables>(ReorderCategoryDocument),
    ...options
  }
    )};

useReorderCategoryMutation.getKey = () => ['ReorderCategory'];

export const UpdateCategoryDocument = `
    mutation UpdateCategory($input: UpdateCategoryInput!) {
  updateCategory(input: $input) {
    category {
      id
      name
      slug
      position
      color
      description
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useUpdateCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCategoryMutation, TError, UpdateCategoryMutationVariables, TContext>) => {
    
    return useMutation<UpdateCategoryMutation, TError, UpdateCategoryMutationVariables, TContext>(
      {
    mutationKey: ['UpdateCategory'],
    mutationFn: useFetchData<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument),
    ...options
  }
    )};

useUpdateCategoryMutation.getKey = () => ['UpdateCategory'];

export const UpdateChangeTypeDocument = `
    mutation UpdateChangeType($input: UpdateChangeInput!) {
  updateChangeType(input: $input) {
    changeType {
      id
      name
      color
    }
    errors {
      message
    }
  }
}
    `;

export const useUpdateChangeTypeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateChangeTypeMutation, TError, UpdateChangeTypeMutationVariables, TContext>) => {
    
    return useMutation<UpdateChangeTypeMutation, TError, UpdateChangeTypeMutationVariables, TContext>(
      {
    mutationKey: ['UpdateChangeType'],
    mutationFn: useFetchData<UpdateChangeTypeMutation, UpdateChangeTypeMutationVariables>(UpdateChangeTypeDocument),
    ...options
  }
    )};

useUpdateChangeTypeMutation.getKey = () => ['UpdateChangeType'];

export const EmailBrandSettingsDocument = `
    query EmailBrandSettings($projectId: ID!) {
  project(id: $projectId) {
    id
    publicPageUrl
    emailSettings {
      id
      customLayout
      primaryColor
      logoHeight
      headingColor
      superscriptColor
      textColor
      digestTextColor
      digestBackgroundColor
      bodyBackgroundColor
      containerBackgroundColor
      fontFamily
      announcementButtonCta
      subscriberConfirmButtonCta
      categoriesEnabled
      notificationsExcerptOnly
      logo {
        ...UploadFieldImage
      }
    }
    hideNotificationContent
    defaultNotificationSetting
    autosubscribeNewUsers
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useEmailBrandSettingsQuery = <
      TData = EmailBrandSettingsQuery,
      TError = unknown
    >(
      variables: EmailBrandSettingsQueryVariables,
      options?: Omit<UseQueryOptions<EmailBrandSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<EmailBrandSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<EmailBrandSettingsQuery, TError, TData>(
      {
    queryKey: ['EmailBrandSettings', variables],
    queryFn: useFetchData<EmailBrandSettingsQuery, EmailBrandSettingsQueryVariables>(EmailBrandSettingsDocument).bind(null, variables),
    ...options
  }
    )};

useEmailBrandSettingsQuery.getKey = (variables: EmailBrandSettingsQueryVariables) => ['EmailBrandSettings', variables];

export const useInfiniteEmailBrandSettingsQuery = <
      TData = InfiniteData<EmailBrandSettingsQuery>,
      TError = unknown
    >(
      variables: EmailBrandSettingsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<EmailBrandSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<EmailBrandSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<EmailBrandSettingsQuery, EmailBrandSettingsQueryVariables>(EmailBrandSettingsDocument)
    return useInfiniteQuery<EmailBrandSettingsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['EmailBrandSettings.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteEmailBrandSettingsQuery.getKey = (variables: EmailBrandSettingsQueryVariables) => ['EmailBrandSettings.infinite', variables];

export const EspSettingsDocument = `
    query EspSettings($projectId: ID!) {
  project(id: $projectId) {
    publicPageUrl
    emailSettings {
      id
      activeEsp
      senderName
      replyToEmail
      apiKey
      domain
      euDomain
      smtpUser
      smtpPassword
      smtpHost
      smtpSecure
      smtpPort
    }
  }
}
    `;

export const useEspSettingsQuery = <
      TData = EspSettingsQuery,
      TError = unknown
    >(
      variables: EspSettingsQueryVariables,
      options?: Omit<UseQueryOptions<EspSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<EspSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<EspSettingsQuery, TError, TData>(
      {
    queryKey: ['EspSettings', variables],
    queryFn: useFetchData<EspSettingsQuery, EspSettingsQueryVariables>(EspSettingsDocument).bind(null, variables),
    ...options
  }
    )};

useEspSettingsQuery.getKey = (variables: EspSettingsQueryVariables) => ['EspSettings', variables];

export const useInfiniteEspSettingsQuery = <
      TData = InfiniteData<EspSettingsQuery>,
      TError = unknown
    >(
      variables: EspSettingsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<EspSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<EspSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<EspSettingsQuery, EspSettingsQueryVariables>(EspSettingsDocument)
    return useInfiniteQuery<EspSettingsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['EspSettings.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteEspSettingsQuery.getKey = (variables: EspSettingsQueryVariables) => ['EspSettings.infinite', variables];

export const NotificationSecuritySettingsDocument = `
    query NotificationSecuritySettings($projectId: ID!) {
  project(id: $projectId) {
    id
    hideNotificationContent
    defaultNotificationSetting
    autosubscribeNewUsers
  }
}
    `;

export const useNotificationSecuritySettingsQuery = <
      TData = NotificationSecuritySettingsQuery,
      TError = unknown
    >(
      variables: NotificationSecuritySettingsQueryVariables,
      options?: Omit<UseQueryOptions<NotificationSecuritySettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<NotificationSecuritySettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<NotificationSecuritySettingsQuery, TError, TData>(
      {
    queryKey: ['NotificationSecuritySettings', variables],
    queryFn: useFetchData<NotificationSecuritySettingsQuery, NotificationSecuritySettingsQueryVariables>(NotificationSecuritySettingsDocument).bind(null, variables),
    ...options
  }
    )};

useNotificationSecuritySettingsQuery.getKey = (variables: NotificationSecuritySettingsQueryVariables) => ['NotificationSecuritySettings', variables];

export const useInfiniteNotificationSecuritySettingsQuery = <
      TData = InfiniteData<NotificationSecuritySettingsQuery>,
      TError = unknown
    >(
      variables: NotificationSecuritySettingsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<NotificationSecuritySettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<NotificationSecuritySettingsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<NotificationSecuritySettingsQuery, NotificationSecuritySettingsQueryVariables>(NotificationSecuritySettingsDocument)
    return useInfiniteQuery<NotificationSecuritySettingsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['NotificationSecuritySettings.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteNotificationSecuritySettingsQuery.getKey = (variables: NotificationSecuritySettingsQueryVariables) => ['NotificationSecuritySettings.infinite', variables];

export const RemoveEmailLogoDocument = `
    mutation RemoveEmailLogo($input: RemoveEmailLogoInput!) {
  removeEmailLogo(input: $input) {
    mailAppSetting {
      id
      logo {
        ...UploadFieldImage
      }
    }
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useRemoveEmailLogoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveEmailLogoMutation, TError, RemoveEmailLogoMutationVariables, TContext>) => {
    
    return useMutation<RemoveEmailLogoMutation, TError, RemoveEmailLogoMutationVariables, TContext>(
      {
    mutationKey: ['RemoveEmailLogo'],
    mutationFn: useFetchData<RemoveEmailLogoMutation, RemoveEmailLogoMutationVariables>(RemoveEmailLogoDocument),
    ...options
  }
    )};

useRemoveEmailLogoMutation.getKey = () => ['RemoveEmailLogo'];

export const TriggerTestEmailDocument = `
    mutation TriggerTestEmail($input: TriggerTestEmailInput!) {
  triggerTestEmail(input: $input) {
    errors
  }
}
    `;

export const useTriggerTestEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TriggerTestEmailMutation, TError, TriggerTestEmailMutationVariables, TContext>) => {
    
    return useMutation<TriggerTestEmailMutation, TError, TriggerTestEmailMutationVariables, TContext>(
      {
    mutationKey: ['TriggerTestEmail'],
    mutationFn: useFetchData<TriggerTestEmailMutation, TriggerTestEmailMutationVariables>(TriggerTestEmailDocument),
    ...options
  }
    )};

useTriggerTestEmailMutation.getKey = () => ['TriggerTestEmail'];

export const UpdateMailAppSettingsDocument = `
    mutation UpdateMailAppSettings($input: UpdateMailAppSettingsInput!) {
  updateMailAppSettings(input: $input) {
    mailAppSetting {
      id
      primaryColor
      logoHeight
      headingColor
      superscriptColor
      textColor
      digestTextColor
      digestBackgroundColor
      bodyBackgroundColor
      containerBackgroundColor
      fontFamily
      categoriesEnabled
      announcementButtonCta
      subscriberConfirmButtonCta
      logo {
        ...UploadFieldImage
      }
      activeEsp
      senderName
      replyToEmail
      apiKey
      domain
      smtpUser
      smtpPassword
      smtpHost
      smtpSecure
      smtpPort
      notificationsExcerptOnly
    }
    errors {
      message
    }
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useUpdateMailAppSettingsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMailAppSettingsMutation, TError, UpdateMailAppSettingsMutationVariables, TContext>) => {
    
    return useMutation<UpdateMailAppSettingsMutation, TError, UpdateMailAppSettingsMutationVariables, TContext>(
      {
    mutationKey: ['UpdateMailAppSettings'],
    mutationFn: useFetchData<UpdateMailAppSettingsMutation, UpdateMailAppSettingsMutationVariables>(UpdateMailAppSettingsDocument),
    ...options
  }
    )};

useUpdateMailAppSettingsMutation.getKey = () => ['UpdateMailAppSettings'];

export const ApiTokenFormDocument = `
    query ApiTokenForm($projectId: ID!, $id: ID) {
  project(id: $projectId) {
    apiToken(id: $id) {
      id
      name
    }
  }
}
    `;

export const useApiTokenFormQuery = <
      TData = ApiTokenFormQuery,
      TError = unknown
    >(
      variables: ApiTokenFormQueryVariables,
      options?: Omit<UseQueryOptions<ApiTokenFormQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiTokenFormQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiTokenFormQuery, TError, TData>(
      {
    queryKey: ['ApiTokenForm', variables],
    queryFn: useFetchData<ApiTokenFormQuery, ApiTokenFormQueryVariables>(ApiTokenFormDocument).bind(null, variables),
    ...options
  }
    )};

useApiTokenFormQuery.getKey = (variables: ApiTokenFormQueryVariables) => ['ApiTokenForm', variables];

export const useInfiniteApiTokenFormQuery = <
      TData = InfiniteData<ApiTokenFormQuery>,
      TError = unknown
    >(
      variables: ApiTokenFormQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ApiTokenFormQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiTokenFormQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ApiTokenFormQuery, ApiTokenFormQueryVariables>(ApiTokenFormDocument)
    return useInfiniteQuery<ApiTokenFormQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ApiTokenForm.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteApiTokenFormQuery.getKey = (variables: ApiTokenFormQueryVariables) => ['ApiTokenForm.infinite', variables];

export const ApiTokenIndexDocument = `
    query ApiTokenIndex($projectId: ID!) {
  project(id: $projectId) {
    apiTokens {
      nodes {
        id
        name
        token
        type
      }
    }
  }
}
    `;

export const useApiTokenIndexQuery = <
      TData = ApiTokenIndexQuery,
      TError = unknown
    >(
      variables: ApiTokenIndexQueryVariables,
      options?: Omit<UseQueryOptions<ApiTokenIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiTokenIndexQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiTokenIndexQuery, TError, TData>(
      {
    queryKey: ['ApiTokenIndex', variables],
    queryFn: useFetchData<ApiTokenIndexQuery, ApiTokenIndexQueryVariables>(ApiTokenIndexDocument).bind(null, variables),
    ...options
  }
    )};

useApiTokenIndexQuery.getKey = (variables: ApiTokenIndexQueryVariables) => ['ApiTokenIndex', variables];

export const useInfiniteApiTokenIndexQuery = <
      TData = InfiniteData<ApiTokenIndexQuery>,
      TError = unknown
    >(
      variables: ApiTokenIndexQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ApiTokenIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiTokenIndexQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ApiTokenIndexQuery, ApiTokenIndexQueryVariables>(ApiTokenIndexDocument)
    return useInfiniteQuery<ApiTokenIndexQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ApiTokenIndex.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteApiTokenIndexQuery.getKey = (variables: ApiTokenIndexQueryVariables) => ['ApiTokenIndex.infinite', variables];

export const CreateApiTokenDocument = `
    mutation CreateApiToken($apiToken: CreateApiTokenAttributes!) {
  createApiToken(input: {apiToken: $apiToken}) {
    apiToken {
      id
      name
      token
      type
    }
    errors
  }
}
    `;

export const useCreateApiTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateApiTokenMutation, TError, CreateApiTokenMutationVariables, TContext>) => {
    
    return useMutation<CreateApiTokenMutation, TError, CreateApiTokenMutationVariables, TContext>(
      {
    mutationKey: ['CreateApiToken'],
    mutationFn: useFetchData<CreateApiTokenMutation, CreateApiTokenMutationVariables>(CreateApiTokenDocument),
    ...options
  }
    )};

useCreateApiTokenMutation.getKey = () => ['CreateApiToken'];

export const CreateEmbedAppDocument = `
    mutation CreateEmbedApp($title: String!, $subtitle: String!, $projectId: ID!) {
  createEmbedApp(
    input: {title: $title, subtitle: $subtitle, projectId: $projectId}
  ) {
    app {
      id
      name
      subtitle
      token
    }
  }
}
    `;

export const useCreateEmbedAppMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateEmbedAppMutation, TError, CreateEmbedAppMutationVariables, TContext>) => {
    
    return useMutation<CreateEmbedAppMutation, TError, CreateEmbedAppMutationVariables, TContext>(
      {
    mutationKey: ['CreateEmbedApp'],
    mutationFn: useFetchData<CreateEmbedAppMutation, CreateEmbedAppMutationVariables>(CreateEmbedAppDocument),
    ...options
  }
    )};

useCreateEmbedAppMutation.getKey = () => ['CreateEmbedApp'];

export const FetchEmbedAppsDocument = `
    query FetchEmbedApps($id: ID!) {
  project(id: $id) {
    secured
    embedApps {
      id
      name
      subtitle
      token
      enforceToken
    }
  }
}
    `;

export const useFetchEmbedAppsQuery = <
      TData = FetchEmbedAppsQuery,
      TError = unknown
    >(
      variables: FetchEmbedAppsQueryVariables,
      options?: Omit<UseQueryOptions<FetchEmbedAppsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FetchEmbedAppsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FetchEmbedAppsQuery, TError, TData>(
      {
    queryKey: ['FetchEmbedApps', variables],
    queryFn: useFetchData<FetchEmbedAppsQuery, FetchEmbedAppsQueryVariables>(FetchEmbedAppsDocument).bind(null, variables),
    ...options
  }
    )};

useFetchEmbedAppsQuery.getKey = (variables: FetchEmbedAppsQueryVariables) => ['FetchEmbedApps', variables];

export const useInfiniteFetchEmbedAppsQuery = <
      TData = InfiniteData<FetchEmbedAppsQuery>,
      TError = unknown
    >(
      variables: FetchEmbedAppsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FetchEmbedAppsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FetchEmbedAppsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<FetchEmbedAppsQuery, FetchEmbedAppsQueryVariables>(FetchEmbedAppsDocument)
    return useInfiniteQuery<FetchEmbedAppsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FetchEmbedApps.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteFetchEmbedAppsQuery.getKey = (variables: FetchEmbedAppsQueryVariables) => ['FetchEmbedApps.infinite', variables];

export const RegenerateEmbedTokenDocument = `
    mutation RegenerateEmbedToken($id: ID!) {
  regenerateEmbedAppToken(input: {embedAppId: $id}) {
    token
    success
  }
}
    `;

export const useRegenerateEmbedTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RegenerateEmbedTokenMutation, TError, RegenerateEmbedTokenMutationVariables, TContext>) => {
    
    return useMutation<RegenerateEmbedTokenMutation, TError, RegenerateEmbedTokenMutationVariables, TContext>(
      {
    mutationKey: ['RegenerateEmbedToken'],
    mutationFn: useFetchData<RegenerateEmbedTokenMutation, RegenerateEmbedTokenMutationVariables>(RegenerateEmbedTokenDocument),
    ...options
  }
    )};

useRegenerateEmbedTokenMutation.getKey = () => ['RegenerateEmbedToken'];

export const RemoveApiTokenDocument = `
    mutation RemoveApiToken($id: ID!) {
  removeApiToken(input: {id: $id}) {
    errors
  }
}
    `;

export const useRemoveApiTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveApiTokenMutation, TError, RemoveApiTokenMutationVariables, TContext>) => {
    
    return useMutation<RemoveApiTokenMutation, TError, RemoveApiTokenMutationVariables, TContext>(
      {
    mutationKey: ['RemoveApiToken'],
    mutationFn: useFetchData<RemoveApiTokenMutation, RemoveApiTokenMutationVariables>(RemoveApiTokenDocument),
    ...options
  }
    )};

useRemoveApiTokenMutation.getKey = () => ['RemoveApiToken'];

export const RssFeedSettingsDocument = `
    query RssFeedSettings($projectId: ID!) {
  project(id: $projectId) {
    rssFeedEnabled
    rssFeedPrivate
    rssFeedUrl
    rssSecretKey
  }
}
    `;

export const useRssFeedSettingsQuery = <
      TData = RssFeedSettingsQuery,
      TError = unknown
    >(
      variables: RssFeedSettingsQueryVariables,
      options?: Omit<UseQueryOptions<RssFeedSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<RssFeedSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<RssFeedSettingsQuery, TError, TData>(
      {
    queryKey: ['RssFeedSettings', variables],
    queryFn: useFetchData<RssFeedSettingsQuery, RssFeedSettingsQueryVariables>(RssFeedSettingsDocument).bind(null, variables),
    ...options
  }
    )};

useRssFeedSettingsQuery.getKey = (variables: RssFeedSettingsQueryVariables) => ['RssFeedSettings', variables];

export const useInfiniteRssFeedSettingsQuery = <
      TData = InfiniteData<RssFeedSettingsQuery>,
      TError = unknown
    >(
      variables: RssFeedSettingsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<RssFeedSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<RssFeedSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<RssFeedSettingsQuery, RssFeedSettingsQueryVariables>(RssFeedSettingsDocument)
    return useInfiniteQuery<RssFeedSettingsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['RssFeedSettings.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteRssFeedSettingsQuery.getKey = (variables: RssFeedSettingsQueryVariables) => ['RssFeedSettings.infinite', variables];

export const ToggleEnforceEmbedTokenDocument = `
    mutation ToggleEnforceEmbedToken($embedId: ID!, $enforceToken: Boolean!) {
  toggleEnforceEmbedToken(input: {embedId: $embedId, enforceToken: $enforceToken}) {
    success
  }
}
    `;

export const useToggleEnforceEmbedTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ToggleEnforceEmbedTokenMutation, TError, ToggleEnforceEmbedTokenMutationVariables, TContext>) => {
    
    return useMutation<ToggleEnforceEmbedTokenMutation, TError, ToggleEnforceEmbedTokenMutationVariables, TContext>(
      {
    mutationKey: ['ToggleEnforceEmbedToken'],
    mutationFn: useFetchData<ToggleEnforceEmbedTokenMutation, ToggleEnforceEmbedTokenMutationVariables>(ToggleEnforceEmbedTokenDocument),
    ...options
  }
    )};

useToggleEnforceEmbedTokenMutation.getKey = () => ['ToggleEnforceEmbedToken'];

export const UpdateEmbedAppDocument = `
    mutation UpdateEmbedApp($title: String!, $subtitle: String!, $embedAppId: ID!) {
  updateEmbedApp(
    input: {title: $title, subtitle: $subtitle, embedAppId: $embedAppId}
  ) {
    success
  }
}
    `;

export const useUpdateEmbedAppMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateEmbedAppMutation, TError, UpdateEmbedAppMutationVariables, TContext>) => {
    
    return useMutation<UpdateEmbedAppMutation, TError, UpdateEmbedAppMutationVariables, TContext>(
      {
    mutationKey: ['UpdateEmbedApp'],
    mutationFn: useFetchData<UpdateEmbedAppMutation, UpdateEmbedAppMutationVariables>(UpdateEmbedAppDocument),
    ...options
  }
    )};

useUpdateEmbedAppMutation.getKey = () => ['UpdateEmbedApp'];

export const FeedbackSettingsDocument = `
    query FeedbackSettings($projectId: ID!) {
  project(id: $projectId) {
    feedbackEnabled
    feedbackForwardEmails
    ideasEnabled
    ideasName
    votingEnabled
    voteCountDisplay
    ideasDisclaimer
    ideasDisclaimerEnabled
    attributeDefinitions(
      where: {rules: [{field: "type", expression: eq, value: "FeedbackAttributeDefinition"}]}
    ) {
      edges {
        node {
          id
          key
          name
          description
          valueType
        }
      }
    }
  }
}
    `;

export const useFeedbackSettingsQuery = <
      TData = FeedbackSettingsQuery,
      TError = unknown
    >(
      variables: FeedbackSettingsQueryVariables,
      options?: Omit<UseQueryOptions<FeedbackSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FeedbackSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FeedbackSettingsQuery, TError, TData>(
      {
    queryKey: ['FeedbackSettings', variables],
    queryFn: useFetchData<FeedbackSettingsQuery, FeedbackSettingsQueryVariables>(FeedbackSettingsDocument).bind(null, variables),
    ...options
  }
    )};

useFeedbackSettingsQuery.getKey = (variables: FeedbackSettingsQueryVariables) => ['FeedbackSettings', variables];

export const useInfiniteFeedbackSettingsQuery = <
      TData = InfiniteData<FeedbackSettingsQuery>,
      TError = unknown
    >(
      variables: FeedbackSettingsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FeedbackSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FeedbackSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<FeedbackSettingsQuery, FeedbackSettingsQueryVariables>(FeedbackSettingsDocument)
    return useInfiniteQuery<FeedbackSettingsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FeedbackSettings.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteFeedbackSettingsQuery.getKey = (variables: FeedbackSettingsQueryVariables) => ['FeedbackSettings.infinite', variables];

export const AttributeValueTypesDocument = `
    query attributeValueTypes {
  __type(name: "Value") {
    name
    enumValues {
      name
    }
  }
}
    `;

export const useAttributeValueTypesQuery = <
      TData = AttributeValueTypesQuery,
      TError = unknown
    >(
      variables?: AttributeValueTypesQueryVariables,
      options?: Omit<UseQueryOptions<AttributeValueTypesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AttributeValueTypesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AttributeValueTypesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['attributeValueTypes'] : ['attributeValueTypes', variables],
    queryFn: useFetchData<AttributeValueTypesQuery, AttributeValueTypesQueryVariables>(AttributeValueTypesDocument).bind(null, variables),
    ...options
  }
    )};

useAttributeValueTypesQuery.getKey = (variables?: AttributeValueTypesQueryVariables) => variables === undefined ? ['attributeValueTypes'] : ['attributeValueTypes', variables];

export const useInfiniteAttributeValueTypesQuery = <
      TData = InfiniteData<AttributeValueTypesQuery>,
      TError = unknown
    >(
      variables: AttributeValueTypesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AttributeValueTypesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AttributeValueTypesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AttributeValueTypesQuery, AttributeValueTypesQueryVariables>(AttributeValueTypesDocument)
    return useInfiniteQuery<AttributeValueTypesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['attributeValueTypes.infinite'] : ['attributeValueTypes.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAttributeValueTypesQuery.getKey = (variables?: AttributeValueTypesQueryVariables) => variables === undefined ? ['attributeValueTypes.infinite'] : ['attributeValueTypes.infinite', variables];

export const CreateFeedbackAttributeDefinitionDocument = `
    mutation createFeedbackAttributeDefinition($project: ID!, $name: String!, $description: String, $key: String!, $valueType: Value!) {
  createAttributeDefinition(
    input: {attributeDefinition: {projectId: $project, name: $name, description: $description, key: $key, valueType: $valueType, typeClass: feedback}}
  ) {
    attributeDefinition {
      id
      name
      key
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useCreateFeedbackAttributeDefinitionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateFeedbackAttributeDefinitionMutation, TError, CreateFeedbackAttributeDefinitionMutationVariables, TContext>) => {
    
    return useMutation<CreateFeedbackAttributeDefinitionMutation, TError, CreateFeedbackAttributeDefinitionMutationVariables, TContext>(
      {
    mutationKey: ['createFeedbackAttributeDefinition'],
    mutationFn: useFetchData<CreateFeedbackAttributeDefinitionMutation, CreateFeedbackAttributeDefinitionMutationVariables>(CreateFeedbackAttributeDefinitionDocument),
    ...options
  }
    )};

useCreateFeedbackAttributeDefinitionMutation.getKey = () => ['createFeedbackAttributeDefinition'];

export const DeleteAttributeDefinitionDocument = `
    mutation deleteAttributeDefinition($id: ID!) {
  deleteAttributeDefinition(input: {id: $id}) {
    attributeDefinition {
      id
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useDeleteAttributeDefinitionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteAttributeDefinitionMutation, TError, DeleteAttributeDefinitionMutationVariables, TContext>) => {
    
    return useMutation<DeleteAttributeDefinitionMutation, TError, DeleteAttributeDefinitionMutationVariables, TContext>(
      {
    mutationKey: ['deleteAttributeDefinition'],
    mutationFn: useFetchData<DeleteAttributeDefinitionMutation, DeleteAttributeDefinitionMutationVariables>(DeleteAttributeDefinitionDocument),
    ...options
  }
    )};

useDeleteAttributeDefinitionMutation.getKey = () => ['deleteAttributeDefinition'];

export const HubspotSettingsDocument = `
    query HubspotSettings($projectId: ID!) {
  project(id: $projectId) {
    projectApps {
      nodes {
        __typename
        ... on HubspotApp {
          id
          accountId
          name
          description
          emailSubscriptions {
            id
            name
          }
          sendEmailViaHubspot
          emailTemplateId
          emailTemplateName
          replyToEmail
          customReplyToEmail
          templates {
            id
            label
          }
          emailSubscriptionId
          ready
          markedForDeletion
          syncing
        }
      }
    }
  }
}
    `;

export const useHubspotSettingsQuery = <
      TData = HubspotSettingsQuery,
      TError = unknown
    >(
      variables: HubspotSettingsQueryVariables,
      options?: Omit<UseQueryOptions<HubspotSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<HubspotSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<HubspotSettingsQuery, TError, TData>(
      {
    queryKey: ['HubspotSettings', variables],
    queryFn: useFetchData<HubspotSettingsQuery, HubspotSettingsQueryVariables>(HubspotSettingsDocument).bind(null, variables),
    ...options
  }
    )};

useHubspotSettingsQuery.getKey = (variables: HubspotSettingsQueryVariables) => ['HubspotSettings', variables];

export const useInfiniteHubspotSettingsQuery = <
      TData = InfiniteData<HubspotSettingsQuery>,
      TError = unknown
    >(
      variables: HubspotSettingsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<HubspotSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<HubspotSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<HubspotSettingsQuery, HubspotSettingsQueryVariables>(HubspotSettingsDocument)
    return useInfiniteQuery<HubspotSettingsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['HubspotSettings.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteHubspotSettingsQuery.getKey = (variables: HubspotSettingsQueryVariables) => ['HubspotSettings.infinite', variables];

export const SendHubspotTestEmailDocument = `
    mutation SendHubspotTestEmail($input: SendTestEmailInput!) {
  sendTestEmail(input: $input) {
    errors
    success
  }
}
    `;

export const useSendHubspotTestEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendHubspotTestEmailMutation, TError, SendHubspotTestEmailMutationVariables, TContext>) => {
    
    return useMutation<SendHubspotTestEmailMutation, TError, SendHubspotTestEmailMutationVariables, TContext>(
      {
    mutationKey: ['SendHubspotTestEmail'],
    mutationFn: useFetchData<SendHubspotTestEmailMutation, SendHubspotTestEmailMutationVariables>(SendHubspotTestEmailDocument),
    ...options
  }
    )};

useSendHubspotTestEmailMutation.getKey = () => ['SendHubspotTestEmail'];

export const SetHubspotEmailSubscriptionDocument = `
    mutation SetHubspotEmailSubscription($input: SetEmailSubscriptionInput!) {
  setEmailSubscription(input: $input) {
    errors
    emailSubscriptionId
  }
}
    `;

export const useSetHubspotEmailSubscriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetHubspotEmailSubscriptionMutation, TError, SetHubspotEmailSubscriptionMutationVariables, TContext>) => {
    
    return useMutation<SetHubspotEmailSubscriptionMutation, TError, SetHubspotEmailSubscriptionMutationVariables, TContext>(
      {
    mutationKey: ['SetHubspotEmailSubscription'],
    mutationFn: useFetchData<SetHubspotEmailSubscriptionMutation, SetHubspotEmailSubscriptionMutationVariables>(SetHubspotEmailSubscriptionDocument),
    ...options
  }
    )};

useSetHubspotEmailSubscriptionMutation.getKey = () => ['SetHubspotEmailSubscription'];

export const SetHubspotEmailSettingsDocument = `
    mutation SetHubspotEmailSettings($input: SetEmailSettingsInput!) {
  setEmailSettings(input: $input) {
    app {
      sendEmailViaHubspot
      emailTemplateId
      emailTemplateName
      replyToEmail
    }
    validation {
      templateId
      templateName
      errors
    }
  }
}
    `;

export const useSetHubspotEmailSettingsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetHubspotEmailSettingsMutation, TError, SetHubspotEmailSettingsMutationVariables, TContext>) => {
    
    return useMutation<SetHubspotEmailSettingsMutation, TError, SetHubspotEmailSettingsMutationVariables, TContext>(
      {
    mutationKey: ['SetHubspotEmailSettings'],
    mutationFn: useFetchData<SetHubspotEmailSettingsMutation, SetHubspotEmailSettingsMutationVariables>(SetHubspotEmailSettingsDocument),
    ...options
  }
    )};

useSetHubspotEmailSettingsMutation.getKey = () => ['SetHubspotEmailSettings'];

export const ValidateHubspotTemplatesDocument = `
    mutation ValidateHubspotTemplates($input: ValidateHubspotTemplatesInput!) {
  validateHubspotTemplates(input: $input) {
    response {
      templateId
      templateName
      errors
    }
    errors
  }
}
    `;

export const useValidateHubspotTemplatesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ValidateHubspotTemplatesMutation, TError, ValidateHubspotTemplatesMutationVariables, TContext>) => {
    
    return useMutation<ValidateHubspotTemplatesMutation, TError, ValidateHubspotTemplatesMutationVariables, TContext>(
      {
    mutationKey: ['ValidateHubspotTemplates'],
    mutationFn: useFetchData<ValidateHubspotTemplatesMutation, ValidateHubspotTemplatesMutationVariables>(ValidateHubspotTemplatesDocument),
    ...options
  }
    )};

useValidateHubspotTemplatesMutation.getKey = () => ['ValidateHubspotTemplates'];

export const AllowedDomainsDocument = `
    query AllowedDomains($projectId: ID!) {
  project(id: $projectId) {
    allowedDomains
  }
}
    `;

export const useAllowedDomainsQuery = <
      TData = AllowedDomainsQuery,
      TError = unknown
    >(
      variables: AllowedDomainsQueryVariables,
      options?: Omit<UseQueryOptions<AllowedDomainsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AllowedDomainsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AllowedDomainsQuery, TError, TData>(
      {
    queryKey: ['AllowedDomains', variables],
    queryFn: useFetchData<AllowedDomainsQuery, AllowedDomainsQueryVariables>(AllowedDomainsDocument).bind(null, variables),
    ...options
  }
    )};

useAllowedDomainsQuery.getKey = (variables: AllowedDomainsQueryVariables) => ['AllowedDomains', variables];

export const useInfiniteAllowedDomainsQuery = <
      TData = InfiniteData<AllowedDomainsQuery>,
      TError = unknown
    >(
      variables: AllowedDomainsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AllowedDomainsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AllowedDomainsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AllowedDomainsQuery, AllowedDomainsQueryVariables>(AllowedDomainsDocument)
    return useInfiniteQuery<AllowedDomainsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AllowedDomains.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAllowedDomainsQuery.getKey = (variables: AllowedDomainsQueryVariables) => ['AllowedDomains.infinite', variables];

export const InviteProjectUserDocument = `
    mutation InviteProjectUser($input: InviteProjectUserInput!) {
  inviteProjectUser(input: $input) {
    projectUser {
      id
      email
      greatestPermission
      status
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useInviteProjectUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<InviteProjectUserMutation, TError, InviteProjectUserMutationVariables, TContext>) => {
    
    return useMutation<InviteProjectUserMutation, TError, InviteProjectUserMutationVariables, TContext>(
      {
    mutationKey: ['InviteProjectUser'],
    mutationFn: useFetchData<InviteProjectUserMutation, InviteProjectUserMutationVariables>(InviteProjectUserDocument),
    ...options
  }
    )};

useInviteProjectUserMutation.getKey = () => ['InviteProjectUser'];

export const RemoveProjectUserDocument = `
    mutation RemoveProjectUser($input: RemoveProjectUserInput!) {
  removeProjectUser(input: $input) {
    project {
      id
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useRemoveProjectUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveProjectUserMutation, TError, RemoveProjectUserMutationVariables, TContext>) => {
    
    return useMutation<RemoveProjectUserMutation, TError, RemoveProjectUserMutationVariables, TContext>(
      {
    mutationKey: ['RemoveProjectUser'],
    mutationFn: useFetchData<RemoveProjectUserMutation, RemoveProjectUserMutationVariables>(RemoveProjectUserDocument),
    ...options
  }
    )};

useRemoveProjectUserMutation.getKey = () => ['RemoveProjectUser'];

export const TableProjectUsersDocument = `
    query TableProjectUsers($projectId: ID!, $count: Int!, $cursor: String) {
  project(id: $projectId) {
    maxTeamMembers
    projectUsers(first: $count, after: $cursor) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          email
          initials
          name
          displayName
          avatarColor
          avatarImage {
            ...UploadFieldImage
          }
          greatestPermission(projectId: $projectId)
          permissions(projectId: $projectId)
          status
        }
      }
    }
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useTableProjectUsersQuery = <
      TData = TableProjectUsersQuery,
      TError = unknown
    >(
      variables: TableProjectUsersQueryVariables,
      options?: Omit<UseQueryOptions<TableProjectUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TableProjectUsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TableProjectUsersQuery, TError, TData>(
      {
    queryKey: ['TableProjectUsers', variables],
    queryFn: useFetchData<TableProjectUsersQuery, TableProjectUsersQueryVariables>(TableProjectUsersDocument).bind(null, variables),
    ...options
  }
    )};

useTableProjectUsersQuery.getKey = (variables: TableProjectUsersQueryVariables) => ['TableProjectUsers', variables];

export const useInfiniteTableProjectUsersQuery = <
      TData = InfiniteData<TableProjectUsersQuery>,
      TError = unknown
    >(
      variables: TableProjectUsersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<TableProjectUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<TableProjectUsersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<TableProjectUsersQuery, TableProjectUsersQueryVariables>(TableProjectUsersDocument)
    return useInfiniteQuery<TableProjectUsersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['TableProjectUsers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteTableProjectUsersQuery.getKey = (variables: TableProjectUsersQueryVariables) => ['TableProjectUsers.infinite', variables];

export const UpdateProjectRoleDocument = `
    mutation updateProjectRole($userID: ID!, $projectID: ID!, $role: ProjectRoleEnum!) {
  updateProjectUserRole(
    input: {userId: $userID, projectId: $projectID, role: $role}
  ) {
    errors {
      message
    }
  }
}
    `;

export const useUpdateProjectRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProjectRoleMutation, TError, UpdateProjectRoleMutationVariables, TContext>) => {
    
    return useMutation<UpdateProjectRoleMutation, TError, UpdateProjectRoleMutationVariables, TContext>(
      {
    mutationKey: ['updateProjectRole'],
    mutationFn: useFetchData<UpdateProjectRoleMutation, UpdateProjectRoleMutationVariables>(UpdateProjectRoleDocument),
    ...options
  }
    )};

useUpdateProjectRoleMutation.getKey = () => ['updateProjectRole'];

export const RoadmapSettingsDocument = `
    query RoadmapSettings($projectId: ID!) {
  project(id: $projectId) {
    roadmapName
    roadmapEnabled
    roadmapDisclaimerEnabled
    roadmapDisclaimer
    defaultWorkItemsDisplayTimeline
    publicPageUrl
    roadmapMoveUpdatesEnabled
    roadmapWatchedStages
    publicStageDescriptionsEnabled
    stages {
      nodes {
        id
        name
        description
        position
        published
        archiveAfterDays
      }
    }
  }
}
    `;

export const useRoadmapSettingsQuery = <
      TData = RoadmapSettingsQuery,
      TError = unknown
    >(
      variables: RoadmapSettingsQueryVariables,
      options?: Omit<UseQueryOptions<RoadmapSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<RoadmapSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<RoadmapSettingsQuery, TError, TData>(
      {
    queryKey: ['RoadmapSettings', variables],
    queryFn: useFetchData<RoadmapSettingsQuery, RoadmapSettingsQueryVariables>(RoadmapSettingsDocument).bind(null, variables),
    ...options
  }
    )};

useRoadmapSettingsQuery.getKey = (variables: RoadmapSettingsQueryVariables) => ['RoadmapSettings', variables];

export const useInfiniteRoadmapSettingsQuery = <
      TData = InfiniteData<RoadmapSettingsQuery>,
      TError = unknown
    >(
      variables: RoadmapSettingsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<RoadmapSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<RoadmapSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<RoadmapSettingsQuery, RoadmapSettingsQueryVariables>(RoadmapSettingsDocument)
    return useInfiniteQuery<RoadmapSettingsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['RoadmapSettings.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteRoadmapSettingsQuery.getKey = (variables: RoadmapSettingsQueryVariables) => ['RoadmapSettings.infinite', variables];

export const TogglePublicStageDescriptionsDocument = `
    mutation TogglePublicStageDescriptions($projectId: ID!, $enabled: Boolean!) {
  togglePublicStageDescriptions(input: {projectId: $projectId, enabled: $enabled}) {
    success
  }
}
    `;

export const useTogglePublicStageDescriptionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TogglePublicStageDescriptionsMutation, TError, TogglePublicStageDescriptionsMutationVariables, TContext>) => {
    
    return useMutation<TogglePublicStageDescriptionsMutation, TError, TogglePublicStageDescriptionsMutationVariables, TContext>(
      {
    mutationKey: ['TogglePublicStageDescriptions'],
    mutationFn: useFetchData<TogglePublicStageDescriptionsMutation, TogglePublicStageDescriptionsMutationVariables>(TogglePublicStageDescriptionsDocument),
    ...options
  }
    )};

useTogglePublicStageDescriptionsMutation.getKey = () => ['TogglePublicStageDescriptions'];

export const ArchiveStageDocument = `
    mutation archiveStage($id: ID!) {
  archiveStage(input: {id: $id}) {
    stage {
      id
    }
    errors {
      path
      message
    }
  }
}
    `;

export const useArchiveStageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ArchiveStageMutation, TError, ArchiveStageMutationVariables, TContext>) => {
    
    return useMutation<ArchiveStageMutation, TError, ArchiveStageMutationVariables, TContext>(
      {
    mutationKey: ['archiveStage'],
    mutationFn: useFetchData<ArchiveStageMutation, ArchiveStageMutationVariables>(ArchiveStageDocument),
    ...options
  }
    )};

useArchiveStageMutation.getKey = () => ['archiveStage'];

export const CreateStageDocument = `
    mutation createStage($name: String!, $description: String, $published: Boolean, $projectId: ID!, $archiveAfterDays: Int) {
  createStage(
    input: {stage: {name: $name, description: $description, published: $published, projectId: $projectId, archiveAfterDays: $archiveAfterDays}}
  ) {
    stage {
      id
      name
      description
      published
      archiveAfterDays
    }
  }
}
    `;

export const useCreateStageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateStageMutation, TError, CreateStageMutationVariables, TContext>) => {
    
    return useMutation<CreateStageMutation, TError, CreateStageMutationVariables, TContext>(
      {
    mutationKey: ['createStage'],
    mutationFn: useFetchData<CreateStageMutation, CreateStageMutationVariables>(CreateStageDocument),
    ...options
  }
    )};

useCreateStageMutation.getKey = () => ['createStage'];

export const ReorderStageDocument = `
    mutation reorderStage($id: ID!, $position: Int!) {
  reorderStage(input: {stage: {id: $id, position: $position}}) {
    stages {
      id
      name
      description
      position
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useReorderStageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReorderStageMutation, TError, ReorderStageMutationVariables, TContext>) => {
    
    return useMutation<ReorderStageMutation, TError, ReorderStageMutationVariables, TContext>(
      {
    mutationKey: ['reorderStage'],
    mutationFn: useFetchData<ReorderStageMutation, ReorderStageMutationVariables>(ReorderStageDocument),
    ...options
  }
    )};

useReorderStageMutation.getKey = () => ['reorderStage'];

export const UpdateStageDocument = `
    mutation updateStage($id: ID!, $name: String, $description: String, $published: Boolean, $archiveAfterDays: Int) {
  updateStage(
    input: {stage: {id: $id, name: $name, description: $description, published: $published, archiveAfterDays: $archiveAfterDays}}
  ) {
    stage {
      id
      name
      description
      published
      archiveAfterDays
    }
  }
}
    `;

export const useUpdateStageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateStageMutation, TError, UpdateStageMutationVariables, TContext>) => {
    
    return useMutation<UpdateStageMutation, TError, UpdateStageMutationVariables, TContext>(
      {
    mutationKey: ['updateStage'],
    mutationFn: useFetchData<UpdateStageMutation, UpdateStageMutationVariables>(UpdateStageDocument),
    ...options
  }
    )};

useUpdateStageMutation.getKey = () => ['updateStage'];

export const CreateSecureConnectionDocument = `
    mutation createSecureConnection($input: CreateSecureConnectionInput!) {
  createSecureConnection(input: $input) {
    errors {
      path
      message
    }
  }
}
    `;

export const useCreateSecureConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSecureConnectionMutation, TError, CreateSecureConnectionMutationVariables, TContext>) => {
    
    return useMutation<CreateSecureConnectionMutation, TError, CreateSecureConnectionMutationVariables, TContext>(
      {
    mutationKey: ['createSecureConnection'],
    mutationFn: useFetchData<CreateSecureConnectionMutation, CreateSecureConnectionMutationVariables>(CreateSecureConnectionDocument),
    ...options
  }
    )};

useCreateSecureConnectionMutation.getKey = () => ['createSecureConnection'];

export const RemoveSecureConnectionDocument = `
    mutation removeSecureConnection($input: RemoveSecureConnectionInput!) {
  removeSecureConnection(input: $input) {
    errors {
      path
      message
    }
  }
}
    `;

export const useRemoveSecureConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveSecureConnectionMutation, TError, RemoveSecureConnectionMutationVariables, TContext>) => {
    
    return useMutation<RemoveSecureConnectionMutation, TError, RemoveSecureConnectionMutationVariables, TContext>(
      {
    mutationKey: ['removeSecureConnection'],
    mutationFn: useFetchData<RemoveSecureConnectionMutation, RemoveSecureConnectionMutationVariables>(RemoveSecureConnectionDocument),
    ...options
  }
    )};

useRemoveSecureConnectionMutation.getKey = () => ['removeSecureConnection'];

export const AddSlackChannelsDocument = `
    mutation AddSlackChannels($workspaceId: ID!, $channelNames: [String!]!, $categoryIds: [ID!]!) {
  createSlackChannels(
    input: {workspaceId: $workspaceId, channels: $channelNames, categories: $categoryIds}
  ) {
    success
    missingChannels
  }
}
    `;

export const useAddSlackChannelsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddSlackChannelsMutation, TError, AddSlackChannelsMutationVariables, TContext>) => {
    
    return useMutation<AddSlackChannelsMutation, TError, AddSlackChannelsMutationVariables, TContext>(
      {
    mutationKey: ['AddSlackChannels'],
    mutationFn: useFetchData<AddSlackChannelsMutation, AddSlackChannelsMutationVariables>(AddSlackChannelsDocument),
    ...options
  }
    )};

useAddSlackChannelsMutation.getKey = () => ['AddSlackChannels'];

export const DeleteSlackChannelDocument = `
    mutation DeleteSlackChannel($channelId: ID!) {
  deleteSlackChannel(input: {channelId: $channelId}) {
    success
  }
}
    `;

export const useDeleteSlackChannelMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSlackChannelMutation, TError, DeleteSlackChannelMutationVariables, TContext>) => {
    
    return useMutation<DeleteSlackChannelMutation, TError, DeleteSlackChannelMutationVariables, TContext>(
      {
    mutationKey: ['DeleteSlackChannel'],
    mutationFn: useFetchData<DeleteSlackChannelMutation, DeleteSlackChannelMutationVariables>(DeleteSlackChannelDocument),
    ...options
  }
    )};

useDeleteSlackChannelMutation.getKey = () => ['DeleteSlackChannel'];

export const FetchAddChannelDataDocument = `
    query FetchAddChannelData($projectId: ID!) {
  project(id: $projectId) {
    categories {
      nodes {
        id
        name
      }
    }
    slackWorkspaces {
      id
      name
      createdAt
    }
  }
}
    `;

export const useFetchAddChannelDataQuery = <
      TData = FetchAddChannelDataQuery,
      TError = unknown
    >(
      variables: FetchAddChannelDataQueryVariables,
      options?: Omit<UseQueryOptions<FetchAddChannelDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FetchAddChannelDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FetchAddChannelDataQuery, TError, TData>(
      {
    queryKey: ['FetchAddChannelData', variables],
    queryFn: useFetchData<FetchAddChannelDataQuery, FetchAddChannelDataQueryVariables>(FetchAddChannelDataDocument).bind(null, variables),
    ...options
  }
    )};

useFetchAddChannelDataQuery.getKey = (variables: FetchAddChannelDataQueryVariables) => ['FetchAddChannelData', variables];

export const useInfiniteFetchAddChannelDataQuery = <
      TData = InfiniteData<FetchAddChannelDataQuery>,
      TError = unknown
    >(
      variables: FetchAddChannelDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FetchAddChannelDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FetchAddChannelDataQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<FetchAddChannelDataQuery, FetchAddChannelDataQueryVariables>(FetchAddChannelDataDocument)
    return useInfiniteQuery<FetchAddChannelDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FetchAddChannelData.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteFetchAddChannelDataQuery.getKey = (variables: FetchAddChannelDataQueryVariables) => ['FetchAddChannelData.infinite', variables];

export const FetchChannelsForProjectDocument = `
    query FetchChannelsForProject($projectId: ID!) {
  project(id: $projectId) {
    slackWorkspaces {
      id
      name
      channels {
        id
        name
        categories {
          id
          name
          backgroundColor
          color
        }
      }
    }
  }
}
    `;

export const useFetchChannelsForProjectQuery = <
      TData = FetchChannelsForProjectQuery,
      TError = unknown
    >(
      variables: FetchChannelsForProjectQueryVariables,
      options?: Omit<UseQueryOptions<FetchChannelsForProjectQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FetchChannelsForProjectQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FetchChannelsForProjectQuery, TError, TData>(
      {
    queryKey: ['FetchChannelsForProject', variables],
    queryFn: useFetchData<FetchChannelsForProjectQuery, FetchChannelsForProjectQueryVariables>(FetchChannelsForProjectDocument).bind(null, variables),
    ...options
  }
    )};

useFetchChannelsForProjectQuery.getKey = (variables: FetchChannelsForProjectQueryVariables) => ['FetchChannelsForProject', variables];

export const useInfiniteFetchChannelsForProjectQuery = <
      TData = InfiniteData<FetchChannelsForProjectQuery>,
      TError = unknown
    >(
      variables: FetchChannelsForProjectQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FetchChannelsForProjectQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FetchChannelsForProjectQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<FetchChannelsForProjectQuery, FetchChannelsForProjectQueryVariables>(FetchChannelsForProjectDocument)
    return useInfiniteQuery<FetchChannelsForProjectQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FetchChannelsForProject.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteFetchChannelsForProjectQuery.getKey = (variables: FetchChannelsForProjectQueryVariables) => ['FetchChannelsForProject.infinite', variables];

export const ViewSettingsDocument = `
    query ViewSettings($projectId: ID!) {
  project(id: $projectId) {
    id
    slug
    publicPageUrl
    privacyPolicyUrl
    termsAndConditionsUrl
    roadmapName
    roadmapDisclaimer
    ideasName
    ideasDisclaimer
    author
    showToc
  }
}
    `;

export const useViewSettingsQuery = <
      TData = ViewSettingsQuery,
      TError = unknown
    >(
      variables: ViewSettingsQueryVariables,
      options?: Omit<UseQueryOptions<ViewSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ViewSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ViewSettingsQuery, TError, TData>(
      {
    queryKey: ['ViewSettings', variables],
    queryFn: useFetchData<ViewSettingsQuery, ViewSettingsQueryVariables>(ViewSettingsDocument).bind(null, variables),
    ...options
  }
    )};

useViewSettingsQuery.getKey = (variables: ViewSettingsQueryVariables) => ['ViewSettings', variables];

export const useInfiniteViewSettingsQuery = <
      TData = InfiniteData<ViewSettingsQuery>,
      TError = unknown
    >(
      variables: ViewSettingsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ViewSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ViewSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ViewSettingsQuery, ViewSettingsQueryVariables>(ViewSettingsDocument)
    return useInfiniteQuery<ViewSettingsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ViewSettings.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteViewSettingsQuery.getKey = (variables: ViewSettingsQueryVariables) => ['ViewSettings.infinite', variables];

export const AdminIndexDocument = `
    query AdminIndex($projectId: ID!) {
  project(id: $projectId) {
    secured
  }
}
    `;

export const useAdminIndexQuery = <
      TData = AdminIndexQuery,
      TError = unknown
    >(
      variables: AdminIndexQueryVariables,
      options?: Omit<UseQueryOptions<AdminIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AdminIndexQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AdminIndexQuery, TError, TData>(
      {
    queryKey: ['AdminIndex', variables],
    queryFn: useFetchData<AdminIndexQuery, AdminIndexQueryVariables>(AdminIndexDocument).bind(null, variables),
    ...options
  }
    )};

useAdminIndexQuery.getKey = (variables: AdminIndexQueryVariables) => ['AdminIndex', variables];

export const useInfiniteAdminIndexQuery = <
      TData = InfiniteData<AdminIndexQuery>,
      TError = unknown
    >(
      variables: AdminIndexQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AdminIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AdminIndexQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AdminIndexQuery, AdminIndexQueryVariables>(AdminIndexDocument)
    return useInfiniteQuery<AdminIndexQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AdminIndex.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAdminIndexQuery.getKey = (variables: AdminIndexQueryVariables) => ['AdminIndex.infinite', variables];

export const CustomHtmlcssDocument = `
    query CustomHTMLCSS($projectId: ID!) {
  project(id: $projectId) {
    publicPageUrl
    customCss
    customHead
    customHeader
    customFooter
    customIndexHero
  }
}
    `;

export const useCustomHtmlcssQuery = <
      TData = CustomHtmlcssQuery,
      TError = unknown
    >(
      variables: CustomHtmlcssQueryVariables,
      options?: Omit<UseQueryOptions<CustomHtmlcssQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomHtmlcssQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomHtmlcssQuery, TError, TData>(
      {
    queryKey: ['CustomHTMLCSS', variables],
    queryFn: useFetchData<CustomHtmlcssQuery, CustomHtmlcssQueryVariables>(CustomHtmlcssDocument).bind(null, variables),
    ...options
  }
    )};

useCustomHtmlcssQuery.getKey = (variables: CustomHtmlcssQueryVariables) => ['CustomHTMLCSS', variables];

export const useInfiniteCustomHtmlcssQuery = <
      TData = InfiniteData<CustomHtmlcssQuery>,
      TError = unknown
    >(
      variables: CustomHtmlcssQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomHtmlcssQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomHtmlcssQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CustomHtmlcssQuery, CustomHtmlcssQueryVariables>(CustomHtmlcssDocument)
    return useInfiniteQuery<CustomHtmlcssQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CustomHTMLCSS.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomHtmlcssQuery.getKey = (variables: CustomHtmlcssQueryVariables) => ['CustomHTMLCSS.infinite', variables];

export const GeneralSettingsDocument = `
    query GeneralSettings($projectId: ID!) {
  project(id: $projectId) {
    publicPageUrl
    id
    name
    published
    slug
    heading
    subheading
    privacyPolicyUrl
    termsAndConditionsUrl
    author
    showToc
    fiscalYearOffset
    announcementsName
  }
}
    `;

export const useGeneralSettingsQuery = <
      TData = GeneralSettingsQuery,
      TError = unknown
    >(
      variables: GeneralSettingsQueryVariables,
      options?: Omit<UseQueryOptions<GeneralSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GeneralSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GeneralSettingsQuery, TError, TData>(
      {
    queryKey: ['GeneralSettings', variables],
    queryFn: useFetchData<GeneralSettingsQuery, GeneralSettingsQueryVariables>(GeneralSettingsDocument).bind(null, variables),
    ...options
  }
    )};

useGeneralSettingsQuery.getKey = (variables: GeneralSettingsQueryVariables) => ['GeneralSettings', variables];

export const useInfiniteGeneralSettingsQuery = <
      TData = InfiniteData<GeneralSettingsQuery>,
      TError = unknown
    >(
      variables: GeneralSettingsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GeneralSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GeneralSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GeneralSettingsQuery, GeneralSettingsQueryVariables>(GeneralSettingsDocument)
    return useInfiniteQuery<GeneralSettingsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GeneralSettings.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGeneralSettingsQuery.getKey = (variables: GeneralSettingsQueryVariables) => ['GeneralSettings.infinite', variables];

export const LookAndFeelDocument = `
    query LookAndFeel($projectId: ID!) {
  project(id: $projectId) {
    publicPageUrl
    logo {
      ...UploadFieldImage
    }
    favicon {
      ...UploadFieldImage
    }
    emptyFieldImage {
      ...UploadFieldImage
    }
    density
    colorTheme
    primaryColor
    secondaryColor
    primaryTextColor
    secondaryTextColor
    whiteColor
    offWhiteColor
    lightGrayColor
    grayColor
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useLookAndFeelQuery = <
      TData = LookAndFeelQuery,
      TError = unknown
    >(
      variables: LookAndFeelQueryVariables,
      options?: Omit<UseQueryOptions<LookAndFeelQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LookAndFeelQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LookAndFeelQuery, TError, TData>(
      {
    queryKey: ['LookAndFeel', variables],
    queryFn: useFetchData<LookAndFeelQuery, LookAndFeelQueryVariables>(LookAndFeelDocument).bind(null, variables),
    ...options
  }
    )};

useLookAndFeelQuery.getKey = (variables: LookAndFeelQueryVariables) => ['LookAndFeel', variables];

export const useInfiniteLookAndFeelQuery = <
      TData = InfiniteData<LookAndFeelQuery>,
      TError = unknown
    >(
      variables: LookAndFeelQueryVariables,
      options: Omit<UseInfiniteQueryOptions<LookAndFeelQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<LookAndFeelQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<LookAndFeelQuery, LookAndFeelQueryVariables>(LookAndFeelDocument)
    return useInfiniteQuery<LookAndFeelQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['LookAndFeel.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteLookAndFeelQuery.getKey = (variables: LookAndFeelQueryVariables) => ['LookAndFeel.infinite', variables];

export const RemoveProjectEmptyFieldImageDocument = `
    mutation RemoveProjectEmptyFieldImage($projectID: ID!) {
  removeProjectEmptyFieldImage(input: {id: $projectID}) {
    project {
      id
      emptyFieldImage {
        ...UploadFieldImage
      }
    }
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useRemoveProjectEmptyFieldImageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveProjectEmptyFieldImageMutation, TError, RemoveProjectEmptyFieldImageMutationVariables, TContext>) => {
    
    return useMutation<RemoveProjectEmptyFieldImageMutation, TError, RemoveProjectEmptyFieldImageMutationVariables, TContext>(
      {
    mutationKey: ['RemoveProjectEmptyFieldImage'],
    mutationFn: useFetchData<RemoveProjectEmptyFieldImageMutation, RemoveProjectEmptyFieldImageMutationVariables>(RemoveProjectEmptyFieldImageDocument),
    ...options
  }
    )};

useRemoveProjectEmptyFieldImageMutation.getKey = () => ['RemoveProjectEmptyFieldImage'];

export const RemoveProjectFaviconDocument = `
    mutation RemoveProjectFavicon($projectID: ID!) {
  removeProjectFavicon(input: {id: $projectID}) {
    project {
      id
      favicon {
        ...UploadFieldImage
      }
    }
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useRemoveProjectFaviconMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveProjectFaviconMutation, TError, RemoveProjectFaviconMutationVariables, TContext>) => {
    
    return useMutation<RemoveProjectFaviconMutation, TError, RemoveProjectFaviconMutationVariables, TContext>(
      {
    mutationKey: ['RemoveProjectFavicon'],
    mutationFn: useFetchData<RemoveProjectFaviconMutation, RemoveProjectFaviconMutationVariables>(RemoveProjectFaviconDocument),
    ...options
  }
    )};

useRemoveProjectFaviconMutation.getKey = () => ['RemoveProjectFavicon'];

export const RemoveProjectLogoDocument = `
    mutation RemoveProjectLogo($projectID: ID!) {
  removeProjectLogo(input: {id: $projectID}) {
    project {
      id
      logo {
        ...UploadFieldImage
      }
    }
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useRemoveProjectLogoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveProjectLogoMutation, TError, RemoveProjectLogoMutationVariables, TContext>) => {
    
    return useMutation<RemoveProjectLogoMutation, TError, RemoveProjectLogoMutationVariables, TContext>(
      {
    mutationKey: ['RemoveProjectLogo'],
    mutationFn: useFetchData<RemoveProjectLogoMutation, RemoveProjectLogoMutationVariables>(RemoveProjectLogoDocument),
    ...options
  }
    )};

useRemoveProjectLogoMutation.getKey = () => ['RemoveProjectLogo'];

export const RemoveProjectShareImageDocument = `
    mutation RemoveProjectShareImage($projectID: ID!) {
  removeProjectShareImage(input: {id: $projectID}) {
    project {
      id
      shareImage {
        ...UploadFieldImage
      }
    }
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useRemoveProjectShareImageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveProjectShareImageMutation, TError, RemoveProjectShareImageMutationVariables, TContext>) => {
    
    return useMutation<RemoveProjectShareImageMutation, TError, RemoveProjectShareImageMutationVariables, TContext>(
      {
    mutationKey: ['RemoveProjectShareImage'],
    mutationFn: useFetchData<RemoveProjectShareImageMutation, RemoveProjectShareImageMutationVariables>(RemoveProjectShareImageDocument),
    ...options
  }
    )};

useRemoveProjectShareImageMutation.getKey = () => ['RemoveProjectShareImage'];

export const SharingAndSearchDocument = `
    query SharingAndSearch($projectId: ID!) {
  viewer {
    project(id: $projectId) {
      title
      description
      noindex
      twitterUsername
      shareImage {
        ...UploadFieldImage
      }
      shareImageAltText
      publicPageUrl
    }
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useSharingAndSearchQuery = <
      TData = SharingAndSearchQuery,
      TError = unknown
    >(
      variables: SharingAndSearchQueryVariables,
      options?: Omit<UseQueryOptions<SharingAndSearchQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SharingAndSearchQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SharingAndSearchQuery, TError, TData>(
      {
    queryKey: ['SharingAndSearch', variables],
    queryFn: useFetchData<SharingAndSearchQuery, SharingAndSearchQueryVariables>(SharingAndSearchDocument).bind(null, variables),
    ...options
  }
    )};

useSharingAndSearchQuery.getKey = (variables: SharingAndSearchQueryVariables) => ['SharingAndSearch', variables];

export const useInfiniteSharingAndSearchQuery = <
      TData = InfiniteData<SharingAndSearchQuery>,
      TError = unknown
    >(
      variables: SharingAndSearchQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SharingAndSearchQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SharingAndSearchQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SharingAndSearchQuery, SharingAndSearchQueryVariables>(SharingAndSearchDocument)
    return useInfiniteQuery<SharingAndSearchQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['SharingAndSearch.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSharingAndSearchQuery.getKey = (variables: SharingAndSearchQueryVariables) => ['SharingAndSearch.infinite', variables];

export const UpdateProjectDocument = `
    mutation UpdateProject($input: UpdateProjectInput!) {
  updateProject(input: $input) {
    project {
      id
      hideNotificationContent
      defaultNotificationSetting
      autosubscribeNewUsers
      showToc
      feedbackEnabled
      feedbackForwardEmails
      allowedDomains
      ideasEnabled
      ideasName
      votingEnabled
      publicPageUrl
      name
      published
      slug
      heading
      subheading
      logo {
        ...UploadFieldImage
      }
      favicon {
        ...UploadFieldImage
      }
      emptyFieldImage {
        ...UploadFieldImage
      }
      density
      colorTheme
      primaryColor
      secondaryColor
      primaryTextColor
      secondaryTextColor
      whiteColor
      offWhiteColor
      lightGrayColor
      grayColor
      publicPageUrl
      customCss
      customHead
      customHeader
      customFooter
      customIndexHero
      title
      description
      noindex
      author
      twitterUsername
      shareImage {
        ...UploadFieldImage
      }
      shareImageAltText
      roadmapName
      roadmapEnabled
      roadmapDisclaimer
      roadmapDisclaimerEnabled
      stages {
        edges {
          node {
            id
            name
            description
            position
            published
            publishedAt
          }
        }
      }
    }
    errors {
      path
      message
    }
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useUpdateProjectMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProjectMutation, TError, UpdateProjectMutationVariables, TContext>) => {
    
    return useMutation<UpdateProjectMutation, TError, UpdateProjectMutationVariables, TContext>(
      {
    mutationKey: ['UpdateProject'],
    mutationFn: useFetchData<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument),
    ...options
  }
    )};

useUpdateProjectMutation.getKey = () => ['UpdateProject'];

export const AnnouncementAnalyticsDocument = `
    query AnnouncementAnalytics($announcementId: ID!, $tzOffset: Int!) {
  announcement(id: $announcementId) {
    publishedAt
    shouldNotifyPageSubscribers
    totalSubscriberCounts
    slackNotificationsCount: notificationsSent(transportType: SlackAppTransport)
    emailNotificationsCount: notificationsSent(transportType: SimpleMailTransport)
    viewerAnalytics: viewerAnalytics(tzOffset: $tzOffset) {
      totalUniqueAnonymousCount
      totalUniqueSubscribersCount
      totalUniqueEmbeddedCount
      uniqueVisitors {
        date
        uniqueAnonymousVisitors
        uniqueSubscribedVisitors
        uniqueEmbeddedVisitors
      }
    }
    emailAnalytics: emailAnalytics(tzOffset: $tzOffset) {
      chartData {
        date
        sent
        opened
        clicked
      }
      sentCount
      openRate
      clickRate
      clickToOpenRate
    }
    feedbacks {
      totalCount
    }
    feedbackHappyCount
    feedbackMehCount
    feedbackSadCount
    slackChannelCount
    slackChannelClickedCount
    slackSubscriberClickedCount
  }
}
    `;

export const useAnnouncementAnalyticsQuery = <
      TData = AnnouncementAnalyticsQuery,
      TError = unknown
    >(
      variables: AnnouncementAnalyticsQueryVariables,
      options?: Omit<UseQueryOptions<AnnouncementAnalyticsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnnouncementAnalyticsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnnouncementAnalyticsQuery, TError, TData>(
      {
    queryKey: ['AnnouncementAnalytics', variables],
    queryFn: useFetchData<AnnouncementAnalyticsQuery, AnnouncementAnalyticsQueryVariables>(AnnouncementAnalyticsDocument).bind(null, variables),
    ...options
  }
    )};

useAnnouncementAnalyticsQuery.getKey = (variables: AnnouncementAnalyticsQueryVariables) => ['AnnouncementAnalytics', variables];

export const useInfiniteAnnouncementAnalyticsQuery = <
      TData = InfiniteData<AnnouncementAnalyticsQuery>,
      TError = unknown
    >(
      variables: AnnouncementAnalyticsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AnnouncementAnalyticsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AnnouncementAnalyticsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AnnouncementAnalyticsQuery, AnnouncementAnalyticsQueryVariables>(AnnouncementAnalyticsDocument)
    return useInfiniteQuery<AnnouncementAnalyticsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AnnouncementAnalytics.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAnnouncementAnalyticsQuery.getKey = (variables: AnnouncementAnalyticsQueryVariables) => ['AnnouncementAnalytics.infinite', variables];

export const AnnouncementEmailAnalyticsDocument = `
    query AnnouncementEmailAnalytics($announcementId: ID!, $tzOffset: Int!) {
  announcement(id: $announcementId) {
    emailAnalytics: emailAnalytics(tzOffset: $tzOffset) {
      sentCount
      openRate
      clickRate
    }
  }
}
    `;

export const useAnnouncementEmailAnalyticsQuery = <
      TData = AnnouncementEmailAnalyticsQuery,
      TError = unknown
    >(
      variables: AnnouncementEmailAnalyticsQueryVariables,
      options?: Omit<UseQueryOptions<AnnouncementEmailAnalyticsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnnouncementEmailAnalyticsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnnouncementEmailAnalyticsQuery, TError, TData>(
      {
    queryKey: ['AnnouncementEmailAnalytics', variables],
    queryFn: useFetchData<AnnouncementEmailAnalyticsQuery, AnnouncementEmailAnalyticsQueryVariables>(AnnouncementEmailAnalyticsDocument).bind(null, variables),
    ...options
  }
    )};

useAnnouncementEmailAnalyticsQuery.getKey = (variables: AnnouncementEmailAnalyticsQueryVariables) => ['AnnouncementEmailAnalytics', variables];

export const useInfiniteAnnouncementEmailAnalyticsQuery = <
      TData = InfiniteData<AnnouncementEmailAnalyticsQuery>,
      TError = unknown
    >(
      variables: AnnouncementEmailAnalyticsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AnnouncementEmailAnalyticsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AnnouncementEmailAnalyticsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AnnouncementEmailAnalyticsQuery, AnnouncementEmailAnalyticsQueryVariables>(AnnouncementEmailAnalyticsDocument)
    return useInfiniteQuery<AnnouncementEmailAnalyticsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AnnouncementEmailAnalytics.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAnnouncementEmailAnalyticsQuery.getKey = (variables: AnnouncementEmailAnalyticsQueryVariables) => ['AnnouncementEmailAnalytics.infinite', variables];

export const GenerateBernieAnnouncementDocument = `
    mutation GenerateBernieAnnouncement($content: String!, $projectId: ID!) {
  generateBernieAnnouncement(input: {content: $content, projectId: $projectId}) {
    success
    announcementId
  }
}
    `;

export const useGenerateBernieAnnouncementMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateBernieAnnouncementMutation, TError, GenerateBernieAnnouncementMutationVariables, TContext>) => {
    
    return useMutation<GenerateBernieAnnouncementMutation, TError, GenerateBernieAnnouncementMutationVariables, TContext>(
      {
    mutationKey: ['GenerateBernieAnnouncement'],
    mutationFn: useFetchData<GenerateBernieAnnouncementMutation, GenerateBernieAnnouncementMutationVariables>(GenerateBernieAnnouncementDocument),
    ...options
  }
    )};

useGenerateBernieAnnouncementMutation.getKey = () => ['GenerateBernieAnnouncement'];

export const GenerateLoomAnnouncementDocument = `
    mutation GenerateLoomAnnouncement($videoUrl: String!, $projectId: ID!, $heightRatio: String!, $thumbnailUrl: String!) {
  generateLoomAnnouncement(
    input: {videoUrl: $videoUrl, projectId: $projectId, heightRatio: $heightRatio, thumbnailUrl: $thumbnailUrl}
  ) {
    success
    announcementId
  }
}
    `;

export const useGenerateLoomAnnouncementMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateLoomAnnouncementMutation, TError, GenerateLoomAnnouncementMutationVariables, TContext>) => {
    
    return useMutation<GenerateLoomAnnouncementMutation, TError, GenerateLoomAnnouncementMutationVariables, TContext>(
      {
    mutationKey: ['GenerateLoomAnnouncement'],
    mutationFn: useFetchData<GenerateLoomAnnouncementMutation, GenerateLoomAnnouncementMutationVariables>(GenerateLoomAnnouncementDocument),
    ...options
  }
    )};

useGenerateLoomAnnouncementMutation.getKey = () => ['GenerateLoomAnnouncement'];

export const AnnouncementsByStateDocument = `
    query AnnouncementsByState($projectId: ID!, $state: AnnouncementStateEnum!, $count: Int!, $cursor: String, $orderBy: OrderBy) {
  viewer {
    project(id: $projectId) {
      id
      announcements(state: $state, first: $count, after: $cursor, orderBy: $orderBy) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...Dashboard
          }
        }
      }
    }
  }
}
    ${DashboardFragmentDoc}`;

export const useAnnouncementsByStateQuery = <
      TData = AnnouncementsByStateQuery,
      TError = unknown
    >(
      variables: AnnouncementsByStateQueryVariables,
      options?: Omit<UseQueryOptions<AnnouncementsByStateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnnouncementsByStateQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnnouncementsByStateQuery, TError, TData>(
      {
    queryKey: ['AnnouncementsByState', variables],
    queryFn: useFetchData<AnnouncementsByStateQuery, AnnouncementsByStateQueryVariables>(AnnouncementsByStateDocument).bind(null, variables),
    ...options
  }
    )};

useAnnouncementsByStateQuery.getKey = (variables: AnnouncementsByStateQueryVariables) => ['AnnouncementsByState', variables];

export const useInfiniteAnnouncementsByStateQuery = <
      TData = InfiniteData<AnnouncementsByStateQuery>,
      TError = unknown
    >(
      variables: AnnouncementsByStateQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AnnouncementsByStateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AnnouncementsByStateQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AnnouncementsByStateQuery, AnnouncementsByStateQueryVariables>(AnnouncementsByStateDocument)
    return useInfiniteQuery<AnnouncementsByStateQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AnnouncementsByState.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAnnouncementsByStateQuery.getKey = (variables: AnnouncementsByStateQueryVariables) => ['AnnouncementsByState.infinite', variables];

export const AnnouncementDashboardDocument = `
    query AnnouncementDashboard($projectId: ID!) {
  viewer {
    project(id: $projectId) {
      id
      announcements {
        totalCount
      }
      draftAnnouncements: announcements(state: draft) {
        totalCount
      }
      scheduledAnnouncements: announcements(state: scheduled) {
        totalCount
      }
      publishedAnnouncements: announcements(state: published) {
        totalCount
      }
      archivedAnnouncements: announcements(state: archived) {
        totalCount
      }
      templates(first: 100) {
        edges {
          node {
            id
            name
            description
          }
        }
      }
    }
  }
}
    `;

export const useAnnouncementDashboardQuery = <
      TData = AnnouncementDashboardQuery,
      TError = unknown
    >(
      variables: AnnouncementDashboardQueryVariables,
      options?: Omit<UseQueryOptions<AnnouncementDashboardQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnnouncementDashboardQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnnouncementDashboardQuery, TError, TData>(
      {
    queryKey: ['AnnouncementDashboard', variables],
    queryFn: useFetchData<AnnouncementDashboardQuery, AnnouncementDashboardQueryVariables>(AnnouncementDashboardDocument).bind(null, variables),
    ...options
  }
    )};

useAnnouncementDashboardQuery.getKey = (variables: AnnouncementDashboardQueryVariables) => ['AnnouncementDashboard', variables];

export const useInfiniteAnnouncementDashboardQuery = <
      TData = InfiniteData<AnnouncementDashboardQuery>,
      TError = unknown
    >(
      variables: AnnouncementDashboardQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AnnouncementDashboardQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AnnouncementDashboardQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AnnouncementDashboardQuery, AnnouncementDashboardQueryVariables>(AnnouncementDashboardDocument)
    return useInfiniteQuery<AnnouncementDashboardQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AnnouncementDashboard.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAnnouncementDashboardQuery.getKey = (variables: AnnouncementDashboardQueryVariables) => ['AnnouncementDashboard.infinite', variables];

export const ArchiveDigestDocument = `
    mutation ArchiveDigest($digestId: ID!) {
  archiveDigest(input: {digestId: $digestId}) {
    success
  }
}
    `;

export const useArchiveDigestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ArchiveDigestMutation, TError, ArchiveDigestMutationVariables, TContext>) => {
    
    return useMutation<ArchiveDigestMutation, TError, ArchiveDigestMutationVariables, TContext>(
      {
    mutationKey: ['ArchiveDigest'],
    mutationFn: useFetchData<ArchiveDigestMutation, ArchiveDigestMutationVariables>(ArchiveDigestDocument),
    ...options
  }
    )};

useArchiveDigestMutation.getKey = () => ['ArchiveDigest'];

export const CreateDigestDocument = `
    mutation CreateDigest($projectId: ID!, $title: String) {
  createDigest(input: {projectId: $projectId, title: $title}) {
    announcementDigest {
      id
    }
  }
}
    `;

export const useCreateDigestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateDigestMutation, TError, CreateDigestMutationVariables, TContext>) => {
    
    return useMutation<CreateDigestMutation, TError, CreateDigestMutationVariables, TContext>(
      {
    mutationKey: ['CreateDigest'],
    mutationFn: useFetchData<CreateDigestMutation, CreateDigestMutationVariables>(CreateDigestDocument),
    ...options
  }
    )};

useCreateDigestMutation.getKey = () => ['CreateDigest'];

export const DuplicateDigestDocument = `
    mutation DuplicateDigest($digestId: ID!) {
  duplicateDigest(input: {digestId: $digestId}) {
    announcementDigest {
      id
    }
  }
}
    `;

export const useDuplicateDigestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DuplicateDigestMutation, TError, DuplicateDigestMutationVariables, TContext>) => {
    
    return useMutation<DuplicateDigestMutation, TError, DuplicateDigestMutationVariables, TContext>(
      {
    mutationKey: ['DuplicateDigest'],
    mutationFn: useFetchData<DuplicateDigestMutation, DuplicateDigestMutationVariables>(DuplicateDigestDocument),
    ...options
  }
    )};

useDuplicateDigestMutation.getKey = () => ['DuplicateDigest'];

export const FetchDigestDocument = `
    query FetchDigest($id: ID!) {
  announcementDigest(id: $id) {
    id
    title
    content
    subjectLine
    state
    publishedAt
    deactivatedAt
    sendToAll
    categories {
      id
      name
      color
    }
    labels {
      id
      name
    }
    order
    announcements {
      nodes {
        id
        headline
        publicPermalink
        excerptWithFallback
        videoAsset {
          embedType
          videoUrl
          thumbnailUrl
          heightRatio
        }
        heroImage {
          ...UploadFieldImage
        }
      }
    }
    emailSubscriberCount
    slackSubscriberCount
    slackChannelCount
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useFetchDigestQuery = <
      TData = FetchDigestQuery,
      TError = unknown
    >(
      variables: FetchDigestQueryVariables,
      options?: Omit<UseQueryOptions<FetchDigestQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FetchDigestQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FetchDigestQuery, TError, TData>(
      {
    queryKey: ['FetchDigest', variables],
    queryFn: useFetchData<FetchDigestQuery, FetchDigestQueryVariables>(FetchDigestDocument).bind(null, variables),
    ...options
  }
    )};

useFetchDigestQuery.getKey = (variables: FetchDigestQueryVariables) => ['FetchDigest', variables];

export const useInfiniteFetchDigestQuery = <
      TData = InfiniteData<FetchDigestQuery>,
      TError = unknown
    >(
      variables: FetchDigestQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FetchDigestQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FetchDigestQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<FetchDigestQuery, FetchDigestQueryVariables>(FetchDigestDocument)
    return useInfiniteQuery<FetchDigestQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FetchDigest.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteFetchDigestQuery.getKey = (variables: FetchDigestQueryVariables) => ['FetchDigest.infinite', variables];

export const FetchDigestWithAnalyticsDocument = `
    query FetchDigestWithAnalytics($id: ID!) {
  announcementDigest(id: $id) {
    id
    title
    content
    subjectLine
    state
    publishedAt
    deactivatedAt
    categories {
      id
      name
      color
    }
    labels {
      id
      name
    }
    order
    announcements {
      nodes {
        id
        headline
        publicPermalink
        excerptWithFallback
        videoAsset {
          embedType
          videoUrl
          thumbnailUrl
          heightRatio
        }
        heroImage {
          ...UploadFieldImage
        }
      }
    }
    emailSubscriberCount
    emailSentCount
    emailOpenedCount
    emailClickedThroughCount
    slackSubscriberCount
    slackSubscriberSentCount
    slackSubscriberClickedThroughCount
    slackChannelCount
    slackChannelSentCount
    slackChannelClickedThroughCount
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useFetchDigestWithAnalyticsQuery = <
      TData = FetchDigestWithAnalyticsQuery,
      TError = unknown
    >(
      variables: FetchDigestWithAnalyticsQueryVariables,
      options?: Omit<UseQueryOptions<FetchDigestWithAnalyticsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FetchDigestWithAnalyticsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FetchDigestWithAnalyticsQuery, TError, TData>(
      {
    queryKey: ['FetchDigestWithAnalytics', variables],
    queryFn: useFetchData<FetchDigestWithAnalyticsQuery, FetchDigestWithAnalyticsQueryVariables>(FetchDigestWithAnalyticsDocument).bind(null, variables),
    ...options
  }
    )};

useFetchDigestWithAnalyticsQuery.getKey = (variables: FetchDigestWithAnalyticsQueryVariables) => ['FetchDigestWithAnalytics', variables];

export const useInfiniteFetchDigestWithAnalyticsQuery = <
      TData = InfiniteData<FetchDigestWithAnalyticsQuery>,
      TError = unknown
    >(
      variables: FetchDigestWithAnalyticsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FetchDigestWithAnalyticsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FetchDigestWithAnalyticsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<FetchDigestWithAnalyticsQuery, FetchDigestWithAnalyticsQueryVariables>(FetchDigestWithAnalyticsDocument)
    return useInfiniteQuery<FetchDigestWithAnalyticsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FetchDigestWithAnalytics.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteFetchDigestWithAnalyticsQuery.getKey = (variables: FetchDigestWithAnalyticsQueryVariables) => ['FetchDigestWithAnalytics.infinite', variables];

export const FetchDigestsDocument = `
    query FetchDigests($projectId: ID!, $state: AnnouncementDigestStateEnum!) {
  project(id: $projectId) {
    announcementDigests(state: $state) {
      nodes {
        id
        title
        publishedAt
        deactivatedAt
        updatedAt
        contentPlainText
        state
        subjectLine
        announcements {
          nodes {
            id
            headline
            excerptWithFallback
          }
        }
        categories {
          name
          color
        }
      }
    }
  }
}
    `;

export const useFetchDigestsQuery = <
      TData = FetchDigestsQuery,
      TError = unknown
    >(
      variables: FetchDigestsQueryVariables,
      options?: Omit<UseQueryOptions<FetchDigestsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FetchDigestsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FetchDigestsQuery, TError, TData>(
      {
    queryKey: ['FetchDigests', variables],
    queryFn: useFetchData<FetchDigestsQuery, FetchDigestsQueryVariables>(FetchDigestsDocument).bind(null, variables),
    ...options
  }
    )};

useFetchDigestsQuery.getKey = (variables: FetchDigestsQueryVariables) => ['FetchDigests', variables];

export const useInfiniteFetchDigestsQuery = <
      TData = InfiniteData<FetchDigestsQuery>,
      TError = unknown
    >(
      variables: FetchDigestsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FetchDigestsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FetchDigestsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<FetchDigestsQuery, FetchDigestsQueryVariables>(FetchDigestsDocument)
    return useInfiniteQuery<FetchDigestsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FetchDigests.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteFetchDigestsQuery.getKey = (variables: FetchDigestsQueryVariables) => ['FetchDigests.infinite', variables];

export const PublishDigestDocument = `
    mutation PublishDigest($digestId: ID!) {
  publishDigest(input: {digestId: $digestId}) {
    success
  }
}
    `;

export const usePublishDigestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PublishDigestMutation, TError, PublishDigestMutationVariables, TContext>) => {
    
    return useMutation<PublishDigestMutation, TError, PublishDigestMutationVariables, TContext>(
      {
    mutationKey: ['PublishDigest'],
    mutationFn: useFetchData<PublishDigestMutation, PublishDigestMutationVariables>(PublishDigestDocument),
    ...options
  }
    )};

usePublishDigestMutation.getKey = () => ['PublishDigest'];

export const SearchAnnouncementsDocument = `
    query SearchAnnouncements($projectId: ID!, $search: String, $count: Int!, $cursor: String) {
  project(id: $projectId) {
    announcements(
      state: published
      search: $search
      first: $count
      after: $cursor
      orderBy: {field: "publishedAt", sort: DESC}
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        headline
        excerptWithFallback
        publishedAt
        shouldNotifyPageSubscribers
        inPublishedDigest
        categories {
          id
          name
          color
        }
        changeTypes {
          nodes {
            id
            name
            color
          }
        }
      }
    }
  }
}
    `;

export const useSearchAnnouncementsQuery = <
      TData = SearchAnnouncementsQuery,
      TError = unknown
    >(
      variables: SearchAnnouncementsQueryVariables,
      options?: Omit<UseQueryOptions<SearchAnnouncementsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchAnnouncementsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchAnnouncementsQuery, TError, TData>(
      {
    queryKey: ['SearchAnnouncements', variables],
    queryFn: useFetchData<SearchAnnouncementsQuery, SearchAnnouncementsQueryVariables>(SearchAnnouncementsDocument).bind(null, variables),
    ...options
  }
    )};

useSearchAnnouncementsQuery.getKey = (variables: SearchAnnouncementsQueryVariables) => ['SearchAnnouncements', variables];

export const useInfiniteSearchAnnouncementsQuery = <
      TData = InfiniteData<SearchAnnouncementsQuery>,
      TError = unknown
    >(
      variables: SearchAnnouncementsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SearchAnnouncementsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SearchAnnouncementsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SearchAnnouncementsQuery, SearchAnnouncementsQueryVariables>(SearchAnnouncementsDocument)
    return useInfiniteQuery<SearchAnnouncementsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['SearchAnnouncements.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSearchAnnouncementsQuery.getKey = (variables: SearchAnnouncementsQueryVariables) => ['SearchAnnouncements.infinite', variables];

export const ToggleSendToAllDocument = `
    mutation ToggleSendToAll($digestId: ID!, $sendToAll: Boolean!) {
  toggleSendToAll(input: {digestId: $digestId, sendToAll: $sendToAll}) {
    success
  }
}
    `;

export const useToggleSendToAllMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ToggleSendToAllMutation, TError, ToggleSendToAllMutationVariables, TContext>) => {
    
    return useMutation<ToggleSendToAllMutation, TError, ToggleSendToAllMutationVariables, TContext>(
      {
    mutationKey: ['ToggleSendToAll'],
    mutationFn: useFetchData<ToggleSendToAllMutation, ToggleSendToAllMutationVariables>(ToggleSendToAllDocument),
    ...options
  }
    )};

useToggleSendToAllMutation.getKey = () => ['ToggleSendToAll'];

export const UpdateDigestDocument = `
    mutation UpdateDigest($digestId: ID!, $title: String, $content: String, $announcements: [ID!], $order: [ID!], $subjectLine: String) {
  updateDigest(
    input: {digestId: $digestId, title: $title, content: $content, subjectLine: $subjectLine, announcements: $announcements, order: $order}
  ) {
    success
  }
}
    `;

export const useUpdateDigestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateDigestMutation, TError, UpdateDigestMutationVariables, TContext>) => {
    
    return useMutation<UpdateDigestMutation, TError, UpdateDigestMutationVariables, TContext>(
      {
    mutationKey: ['UpdateDigest'],
    mutationFn: useFetchData<UpdateDigestMutation, UpdateDigestMutationVariables>(UpdateDigestDocument),
    ...options
  }
    )};

useUpdateDigestMutation.getKey = () => ['UpdateDigest'];

export const EditorAnnouncementDocument = `
    query EditorAnnouncement($projectId: ID!, $announcementId: ID!) {
  project(id: $projectId) {
    ...CategoryTags
    author
  }
  announcement(id: $announcementId) {
    scheduledAt
    scheduledAtTimezone
    archived
    ...Channels
    ...Preview
    ...Content
  }
}
    ${CategoryTagsFragmentDoc}
${ChannelsFragmentDoc}
${PreviewFragmentDoc}
${ContentFragmentDoc}
${UploadFieldImageFragmentDoc}`;

export const useEditorAnnouncementQuery = <
      TData = EditorAnnouncementQuery,
      TError = unknown
    >(
      variables: EditorAnnouncementQueryVariables,
      options?: Omit<UseQueryOptions<EditorAnnouncementQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<EditorAnnouncementQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<EditorAnnouncementQuery, TError, TData>(
      {
    queryKey: ['EditorAnnouncement', variables],
    queryFn: useFetchData<EditorAnnouncementQuery, EditorAnnouncementQueryVariables>(EditorAnnouncementDocument).bind(null, variables),
    ...options
  }
    )};

useEditorAnnouncementQuery.getKey = (variables: EditorAnnouncementQueryVariables) => ['EditorAnnouncement', variables];

export const useInfiniteEditorAnnouncementQuery = <
      TData = InfiniteData<EditorAnnouncementQuery>,
      TError = unknown
    >(
      variables: EditorAnnouncementQueryVariables,
      options: Omit<UseInfiniteQueryOptions<EditorAnnouncementQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<EditorAnnouncementQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<EditorAnnouncementQuery, EditorAnnouncementQueryVariables>(EditorAnnouncementDocument)
    return useInfiniteQuery<EditorAnnouncementQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['EditorAnnouncement.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteEditorAnnouncementQuery.getKey = (variables: EditorAnnouncementQueryVariables) => ['EditorAnnouncement.infinite', variables];

export const AnnouncementExcerptDocument = `
    query AnnouncementExcerpt($announcementId: ID!) {
  announcement(id: $announcementId) {
    excerpt
    excerptWithFallback
    state
  }
}
    `;

export const useAnnouncementExcerptQuery = <
      TData = AnnouncementExcerptQuery,
      TError = unknown
    >(
      variables: AnnouncementExcerptQueryVariables,
      options?: Omit<UseQueryOptions<AnnouncementExcerptQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnnouncementExcerptQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnnouncementExcerptQuery, TError, TData>(
      {
    queryKey: ['AnnouncementExcerpt', variables],
    queryFn: useFetchData<AnnouncementExcerptQuery, AnnouncementExcerptQueryVariables>(AnnouncementExcerptDocument).bind(null, variables),
    ...options
  }
    )};

useAnnouncementExcerptQuery.getKey = (variables: AnnouncementExcerptQueryVariables) => ['AnnouncementExcerpt', variables];

export const useInfiniteAnnouncementExcerptQuery = <
      TData = InfiniteData<AnnouncementExcerptQuery>,
      TError = unknown
    >(
      variables: AnnouncementExcerptQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AnnouncementExcerptQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AnnouncementExcerptQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AnnouncementExcerptQuery, AnnouncementExcerptQueryVariables>(AnnouncementExcerptDocument)
    return useInfiniteQuery<AnnouncementExcerptQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AnnouncementExcerpt.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAnnouncementExcerptQuery.getKey = (variables: AnnouncementExcerptQueryVariables) => ['AnnouncementExcerpt.infinite', variables];

export const TemplateExcerptDocument = `
    query TemplateExcerpt($templateId: ID!) {
  template(id: $templateId) {
    excerpt
    excerptWithFallback
  }
}
    `;

export const useTemplateExcerptQuery = <
      TData = TemplateExcerptQuery,
      TError = unknown
    >(
      variables: TemplateExcerptQueryVariables,
      options?: Omit<UseQueryOptions<TemplateExcerptQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TemplateExcerptQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TemplateExcerptQuery, TError, TData>(
      {
    queryKey: ['TemplateExcerpt', variables],
    queryFn: useFetchData<TemplateExcerptQuery, TemplateExcerptQueryVariables>(TemplateExcerptDocument).bind(null, variables),
    ...options
  }
    )};

useTemplateExcerptQuery.getKey = (variables: TemplateExcerptQueryVariables) => ['TemplateExcerpt', variables];

export const useInfiniteTemplateExcerptQuery = <
      TData = InfiniteData<TemplateExcerptQuery>,
      TError = unknown
    >(
      variables: TemplateExcerptQueryVariables,
      options: Omit<UseInfiniteQueryOptions<TemplateExcerptQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<TemplateExcerptQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<TemplateExcerptQuery, TemplateExcerptQueryVariables>(TemplateExcerptDocument)
    return useInfiniteQuery<TemplateExcerptQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['TemplateExcerpt.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteTemplateExcerptQuery.getKey = (variables: TemplateExcerptQueryVariables) => ['TemplateExcerpt.infinite', variables];

export const PublishAnnouncementDocument = `
    mutation PublishAnnouncement($id: ID!) {
  publishAnnouncement(input: {announcementId: $id}) {
    announcement {
      id
      state
      publishedAt
    }
  }
}
    `;

export const usePublishAnnouncementMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PublishAnnouncementMutation, TError, PublishAnnouncementMutationVariables, TContext>) => {
    
    return useMutation<PublishAnnouncementMutation, TError, PublishAnnouncementMutationVariables, TContext>(
      {
    mutationKey: ['PublishAnnouncement'],
    mutationFn: useFetchData<PublishAnnouncementMutation, PublishAnnouncementMutationVariables>(PublishAnnouncementDocument),
    ...options
  }
    )};

usePublishAnnouncementMutation.getKey = () => ['PublishAnnouncement'];

export const ScheduleAnnouncementV2Document = `
    mutation ScheduleAnnouncementV2($id: ID!, $scheduledAt: String!, $scheduledAtTimezone: String!) {
  scheduleAnnouncement(
    input: {announcementId: $id, scheduledAt: $scheduledAt, scheduledAtTimezone: $scheduledAtTimezone}
  ) {
    announcement {
      id
      state
      scheduledAt
      scheduledAtTimezone
    }
    errors {
      path
      message
    }
  }
}
    `;

export const useScheduleAnnouncementV2Mutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ScheduleAnnouncementV2Mutation, TError, ScheduleAnnouncementV2MutationVariables, TContext>) => {
    
    return useMutation<ScheduleAnnouncementV2Mutation, TError, ScheduleAnnouncementV2MutationVariables, TContext>(
      {
    mutationKey: ['ScheduleAnnouncementV2'],
    mutationFn: useFetchData<ScheduleAnnouncementV2Mutation, ScheduleAnnouncementV2MutationVariables>(ScheduleAnnouncementV2Document),
    ...options
  }
    )};

useScheduleAnnouncementV2Mutation.getKey = () => ['ScheduleAnnouncementV2'];

export const SendPreviewSlackDocument = `
    mutation SendPreviewSlack($input: PreviewAnnouncementSlackInput!) {
  previewAnnouncementSlack(input: $input) {
    announcement {
      id
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useSendPreviewSlackMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendPreviewSlackMutation, TError, SendPreviewSlackMutationVariables, TContext>) => {
    
    return useMutation<SendPreviewSlackMutation, TError, SendPreviewSlackMutationVariables, TContext>(
      {
    mutationKey: ['SendPreviewSlack'],
    mutationFn: useFetchData<SendPreviewSlackMutation, SendPreviewSlackMutationVariables>(SendPreviewSlackDocument),
    ...options
  }
    )};

useSendPreviewSlackMutation.getKey = () => ['SendPreviewSlack'];

export const AnnouncementToBeNotifiedDocument = `
    query AnnouncementToBeNotified($itemId: ID!, $count: Int!, $after: String, $before: String, $search: String) {
  announcement(id: $itemId) {
    subscribers(
      first: $count
      after: $after
      before: $before
      search: $search
      orderBy: {field: "createdAt", sort: DESC}
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        subscriber {
          id
          email
          avatarColor
          initials
          workItems {
            totalCount
            nodes {
              id
              name
            }
          }
        }
        categories {
          id
          name
          color
        }
        transportTypes
      }
    }
    slackChannels {
      nodes {
        id
        name
        workspace {
          id
          name
        }
      }
    }
  }
}
    `;

export const useAnnouncementToBeNotifiedQuery = <
      TData = AnnouncementToBeNotifiedQuery,
      TError = unknown
    >(
      variables: AnnouncementToBeNotifiedQueryVariables,
      options?: Omit<UseQueryOptions<AnnouncementToBeNotifiedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnnouncementToBeNotifiedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnnouncementToBeNotifiedQuery, TError, TData>(
      {
    queryKey: ['AnnouncementToBeNotified', variables],
    queryFn: useFetchData<AnnouncementToBeNotifiedQuery, AnnouncementToBeNotifiedQueryVariables>(AnnouncementToBeNotifiedDocument).bind(null, variables),
    ...options
  }
    )};

useAnnouncementToBeNotifiedQuery.getKey = (variables: AnnouncementToBeNotifiedQueryVariables) => ['AnnouncementToBeNotified', variables];

export const useInfiniteAnnouncementToBeNotifiedQuery = <
      TData = InfiniteData<AnnouncementToBeNotifiedQuery>,
      TError = unknown
    >(
      variables: AnnouncementToBeNotifiedQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AnnouncementToBeNotifiedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AnnouncementToBeNotifiedQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AnnouncementToBeNotifiedQuery, AnnouncementToBeNotifiedQueryVariables>(AnnouncementToBeNotifiedDocument)
    return useInfiniteQuery<AnnouncementToBeNotifiedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AnnouncementToBeNotified.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAnnouncementToBeNotifiedQuery.getKey = (variables: AnnouncementToBeNotifiedQueryVariables) => ['AnnouncementToBeNotified.infinite', variables];

export const DigestToBeNotifiedDocument = `
    query DigestToBeNotified($itemId: ID!, $count: Int!, $after: String, $before: String, $search: String) {
  announcementDigest(id: $itemId) {
    slackChannels {
      id
      name
      workspace {
        id
        name
      }
    }
    subscribers(
      first: $count
      after: $after
      before: $before
      search: $search
      orderBy: {field: "createdAt", sort: DESC}
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        subscriber {
          id
          email
          avatarColor
          initials
          workItems {
            totalCount
            nodes {
              id
              name
            }
          }
        }
        categories {
          id
          name
          color
        }
        transportTypes
      }
    }
  }
}
    `;

export const useDigestToBeNotifiedQuery = <
      TData = DigestToBeNotifiedQuery,
      TError = unknown
    >(
      variables: DigestToBeNotifiedQueryVariables,
      options?: Omit<UseQueryOptions<DigestToBeNotifiedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DigestToBeNotifiedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DigestToBeNotifiedQuery, TError, TData>(
      {
    queryKey: ['DigestToBeNotified', variables],
    queryFn: useFetchData<DigestToBeNotifiedQuery, DigestToBeNotifiedQueryVariables>(DigestToBeNotifiedDocument).bind(null, variables),
    ...options
  }
    )};

useDigestToBeNotifiedQuery.getKey = (variables: DigestToBeNotifiedQueryVariables) => ['DigestToBeNotified', variables];

export const useInfiniteDigestToBeNotifiedQuery = <
      TData = InfiniteData<DigestToBeNotifiedQuery>,
      TError = unknown
    >(
      variables: DigestToBeNotifiedQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DigestToBeNotifiedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DigestToBeNotifiedQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<DigestToBeNotifiedQuery, DigestToBeNotifiedQueryVariables>(DigestToBeNotifiedDocument)
    return useInfiniteQuery<DigestToBeNotifiedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['DigestToBeNotified.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteDigestToBeNotifiedQuery.getKey = (variables: DigestToBeNotifiedQueryVariables) => ['DigestToBeNotified.infinite', variables];

export const PublishedAnnouncementContentDocument = `
    query PublishedAnnouncementContent($announcementId: ID!) {
  announcement(id: $announcementId) {
    ...Content
  }
}
    ${ContentFragmentDoc}
${UploadFieldImageFragmentDoc}`;

export const usePublishedAnnouncementContentQuery = <
      TData = PublishedAnnouncementContentQuery,
      TError = unknown
    >(
      variables: PublishedAnnouncementContentQueryVariables,
      options?: Omit<UseQueryOptions<PublishedAnnouncementContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PublishedAnnouncementContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PublishedAnnouncementContentQuery, TError, TData>(
      {
    queryKey: ['PublishedAnnouncementContent', variables],
    queryFn: useFetchData<PublishedAnnouncementContentQuery, PublishedAnnouncementContentQueryVariables>(PublishedAnnouncementContentDocument).bind(null, variables),
    ...options
  }
    )};

usePublishedAnnouncementContentQuery.getKey = (variables: PublishedAnnouncementContentQueryVariables) => ['PublishedAnnouncementContent', variables];

export const useInfinitePublishedAnnouncementContentQuery = <
      TData = InfiniteData<PublishedAnnouncementContentQuery>,
      TError = unknown
    >(
      variables: PublishedAnnouncementContentQueryVariables,
      options: Omit<UseInfiniteQueryOptions<PublishedAnnouncementContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<PublishedAnnouncementContentQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<PublishedAnnouncementContentQuery, PublishedAnnouncementContentQueryVariables>(PublishedAnnouncementContentDocument)
    return useInfiniteQuery<PublishedAnnouncementContentQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['PublishedAnnouncementContent.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfinitePublishedAnnouncementContentQuery.getKey = (variables: PublishedAnnouncementContentQueryVariables) => ['PublishedAnnouncementContent.infinite', variables];

export const PublishedAnnouncementIndexDocument = `
    query PublishedAnnouncementIndex($projectId: ID!, $announcementId: ID!) {
  project(id: $projectId) {
    id
    ...CategoryTags
  }
  announcement(id: $announcementId) {
    ...PublishedAnnouncement
  }
}
    ${CategoryTagsFragmentDoc}
${PublishedAnnouncementFragmentDoc}`;

export const usePublishedAnnouncementIndexQuery = <
      TData = PublishedAnnouncementIndexQuery,
      TError = unknown
    >(
      variables: PublishedAnnouncementIndexQueryVariables,
      options?: Omit<UseQueryOptions<PublishedAnnouncementIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PublishedAnnouncementIndexQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PublishedAnnouncementIndexQuery, TError, TData>(
      {
    queryKey: ['PublishedAnnouncementIndex', variables],
    queryFn: useFetchData<PublishedAnnouncementIndexQuery, PublishedAnnouncementIndexQueryVariables>(PublishedAnnouncementIndexDocument).bind(null, variables),
    ...options
  }
    )};

usePublishedAnnouncementIndexQuery.getKey = (variables: PublishedAnnouncementIndexQueryVariables) => ['PublishedAnnouncementIndex', variables];

export const useInfinitePublishedAnnouncementIndexQuery = <
      TData = InfiniteData<PublishedAnnouncementIndexQuery>,
      TError = unknown
    >(
      variables: PublishedAnnouncementIndexQueryVariables,
      options: Omit<UseInfiniteQueryOptions<PublishedAnnouncementIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<PublishedAnnouncementIndexQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<PublishedAnnouncementIndexQuery, PublishedAnnouncementIndexQueryVariables>(PublishedAnnouncementIndexDocument)
    return useInfiniteQuery<PublishedAnnouncementIndexQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['PublishedAnnouncementIndex.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfinitePublishedAnnouncementIndexQuery.getKey = (variables: PublishedAnnouncementIndexQueryVariables) => ['PublishedAnnouncementIndex.infinite', variables];

export const AnnouncementDocument = `
    query Announcement($projectId: ID!, $announcementId: ID!) {
  project(id: $projectId) {
    id
    publicPageUrl
    author
    slackAuthenticationUrl
    totalConfirmedSubscriptions
    slackSubscription {
      id
    }
    slackProjectSubscription {
      id
    }
    emailSettings {
      primaryColor
      replyToEmail
    }
    categories {
      nodes {
        id
        name
        backgroundColor
        textColor
      }
    }
  }
  announcement(id: $announcementId) {
    id
    name
    author
    scheduledAt
    scheduledAtTimezone
    archived
    shouldNotifyPageSubscribers
    notificationsExcerptOnly
    headline
    subjectLine
    slackMessage
    emailSubscriberCounts: subscriberCounts(transport: SimpleMailTransport)
    slackSubscriberCounts: subscriberCounts(transport: SlackAppTransport)
    totalSubscriberCounts
    slackChannelCounts
    state
    slug
    privatePermalink
    categories {
      id
      name
      backgroundColor
      textColor
    }
    workItems {
      nodes {
        id
        name
      }
    }
    changeTypes {
      nodes {
        id
        name
        color
      }
    }
    videoAsset {
      embedType
      videoUrl
      thumbnailUrl
      heightRatio
    }
    heroImage {
      ...UploadFieldImage
    }
    categories {
      id
      name
      backgroundColor
    }
    workItems {
      edges {
        node {
          id
          name
        }
      }
    }
    headline
    content
    contentType
    excerpt
    excerptWithFallback
    publicPermalink
    publishedAt
    title
    titleWithFallback
    description
    descriptionWithFallback
    author
    authorWithFallback
    shareImage {
      ...UploadFieldImage
    }
    doNotIndex
    externalContentLinks {
      id
      url
      title
      imageUrl
    }
    connectedSources {
      nodes {
        id
        url
        name
        providerName
      }
    }
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useAnnouncementQuery = <
      TData = AnnouncementQuery,
      TError = unknown
    >(
      variables: AnnouncementQueryVariables,
      options?: Omit<UseQueryOptions<AnnouncementQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnnouncementQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnnouncementQuery, TError, TData>(
      {
    queryKey: ['Announcement', variables],
    queryFn: useFetchData<AnnouncementQuery, AnnouncementQueryVariables>(AnnouncementDocument).bind(null, variables),
    ...options
  }
    )};

useAnnouncementQuery.getKey = (variables: AnnouncementQueryVariables) => ['Announcement', variables];

export const useInfiniteAnnouncementQuery = <
      TData = InfiniteData<AnnouncementQuery>,
      TError = unknown
    >(
      variables: AnnouncementQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AnnouncementQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AnnouncementQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AnnouncementQuery, AnnouncementQueryVariables>(AnnouncementDocument)
    return useInfiniteQuery<AnnouncementQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Announcement.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAnnouncementQuery.getKey = (variables: AnnouncementQueryVariables) => ['Announcement.infinite', variables];

export const ArchiveTemplateDocument = `
    mutation archiveTemplate($id: ID!) {
  archiveTemplate(input: {id: $id}) {
    template {
      id
    }
    errors {
      path
      message
    }
  }
}
    `;

export const useArchiveTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ArchiveTemplateMutation, TError, ArchiveTemplateMutationVariables, TContext>) => {
    
    return useMutation<ArchiveTemplateMutation, TError, ArchiveTemplateMutationVariables, TContext>(
      {
    mutationKey: ['archiveTemplate'],
    mutationFn: useFetchData<ArchiveTemplateMutation, ArchiveTemplateMutationVariables>(ArchiveTemplateDocument),
    ...options
  }
    )};

useArchiveTemplateMutation.getKey = () => ['archiveTemplate'];

export const CreateTemplateDocument = `
    mutation createTemplate($projectId: ID!, $marketplaceTemplateId: ID) {
  createTemplate(
    input: {template: {projectId: $projectId, marketplaceTemplateId: $marketplaceTemplateId}}
  ) {
    template {
      id
      name
      description
    }
    errors {
      path
      message
    }
  }
}
    `;

export const useCreateTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTemplateMutation, TError, CreateTemplateMutationVariables, TContext>) => {
    
    return useMutation<CreateTemplateMutation, TError, CreateTemplateMutationVariables, TContext>(
      {
    mutationKey: ['createTemplate'],
    mutationFn: useFetchData<CreateTemplateMutation, CreateTemplateMutationVariables>(CreateTemplateDocument),
    ...options
  }
    )};

useCreateTemplateMutation.getKey = () => ['createTemplate'];

export const RemoveTemplateAttachmentDocument = `
    mutation removeTemplateAttachment($templateId: ID!, $attachment: TemplateAttachment!) {
  removeTemplateAttachment(input: {attachment: $attachment, id: $templateId}) {
    template {
      id
      heroImage {
        ...UploadFieldImage
      }
    }
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useRemoveTemplateAttachmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTemplateAttachmentMutation, TError, RemoveTemplateAttachmentMutationVariables, TContext>) => {
    
    return useMutation<RemoveTemplateAttachmentMutation, TError, RemoveTemplateAttachmentMutationVariables, TContext>(
      {
    mutationKey: ['removeTemplateAttachment'],
    mutationFn: useFetchData<RemoveTemplateAttachmentMutation, RemoveTemplateAttachmentMutationVariables>(RemoveTemplateAttachmentDocument),
    ...options
  }
    )};

useRemoveTemplateAttachmentMutation.getKey = () => ['removeTemplateAttachment'];

export const TemplateEditorDocument = `
    query TemplateEditor($templateId: ID!, $projectId: ID!) {
  project(id: $projectId) {
    ...CategoryTags
  }
  template(id: $templateId) {
    id
    name
    description
    content
    contentType
    excerpt
    excerptWithFallback
    headline
    heroImage {
      ...UploadFieldImage
    }
    categories {
      id
    }
    workItems {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    ${CategoryTagsFragmentDoc}
${UploadFieldImageFragmentDoc}`;

export const useTemplateEditorQuery = <
      TData = TemplateEditorQuery,
      TError = unknown
    >(
      variables: TemplateEditorQueryVariables,
      options?: Omit<UseQueryOptions<TemplateEditorQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TemplateEditorQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TemplateEditorQuery, TError, TData>(
      {
    queryKey: ['TemplateEditor', variables],
    queryFn: useFetchData<TemplateEditorQuery, TemplateEditorQueryVariables>(TemplateEditorDocument).bind(null, variables),
    ...options
  }
    )};

useTemplateEditorQuery.getKey = (variables: TemplateEditorQueryVariables) => ['TemplateEditor', variables];

export const useInfiniteTemplateEditorQuery = <
      TData = InfiniteData<TemplateEditorQuery>,
      TError = unknown
    >(
      variables: TemplateEditorQueryVariables,
      options: Omit<UseInfiniteQueryOptions<TemplateEditorQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<TemplateEditorQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<TemplateEditorQuery, TemplateEditorQueryVariables>(TemplateEditorDocument)
    return useInfiniteQuery<TemplateEditorQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['TemplateEditor.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteTemplateEditorQuery.getKey = (variables: TemplateEditorQueryVariables) => ['TemplateEditor.infinite', variables];

export const TemplatesIndexDocument = `
    query TemplatesIndex($projectId: ID!) {
  project(id: $projectId) {
    templates(first: 100) {
      edges {
        node {
          id
          name
        }
      }
    }
    ...RqMarketplaceTemplatesModal
  }
}
    ${RqMarketplaceTemplatesModalFragmentDoc}`;

export const useTemplatesIndexQuery = <
      TData = TemplatesIndexQuery,
      TError = unknown
    >(
      variables: TemplatesIndexQueryVariables,
      options?: Omit<UseQueryOptions<TemplatesIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TemplatesIndexQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TemplatesIndexQuery, TError, TData>(
      {
    queryKey: ['TemplatesIndex', variables],
    queryFn: useFetchData<TemplatesIndexQuery, TemplatesIndexQueryVariables>(TemplatesIndexDocument).bind(null, variables),
    ...options
  }
    )};

useTemplatesIndexQuery.getKey = (variables: TemplatesIndexQueryVariables) => ['TemplatesIndex', variables];

export const useInfiniteTemplatesIndexQuery = <
      TData = InfiniteData<TemplatesIndexQuery>,
      TError = unknown
    >(
      variables: TemplatesIndexQueryVariables,
      options: Omit<UseInfiniteQueryOptions<TemplatesIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<TemplatesIndexQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<TemplatesIndexQuery, TemplatesIndexQueryVariables>(TemplatesIndexDocument)
    return useInfiniteQuery<TemplatesIndexQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['TemplatesIndex.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteTemplatesIndexQuery.getKey = (variables: TemplatesIndexQueryVariables) => ['TemplatesIndex.infinite', variables];

export const UpdateTemplateDocument = `
    mutation updateTemplate($template: UpdateTemplateAttributes!) {
  updateTemplate(input: {template: $template}) {
    template {
      id
      name
      description
      content
      contentType
      excerpt
      excerptWithFallback
      headline
      heroImage {
        ...UploadFieldImage
      }
      categories {
        id
      }
      workItems {
        edges {
          node {
            id
            name
          }
        }
      }
    }
    errors {
      message
      path
    }
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useUpdateTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTemplateMutation, TError, UpdateTemplateMutationVariables, TContext>) => {
    
    return useMutation<UpdateTemplateMutation, TError, UpdateTemplateMutationVariables, TContext>(
      {
    mutationKey: ['updateTemplate'],
    mutationFn: useFetchData<UpdateTemplateMutation, UpdateTemplateMutationVariables>(UpdateTemplateDocument),
    ...options
  }
    )};

useUpdateTemplateMutation.getKey = () => ['updateTemplate'];

export const ArchiveAnnouncementDocument = `
    mutation ArchiveAnnouncement($announcementId: ID!) {
  archiveAnnouncement(input: {announcementId: $announcementId}) {
    announcement {
      id
      feedbacks {
        edges {
          node {
            id
          }
        }
      }
      ...Card_announcement
    }
    errors {
      path
      message
    }
  }
}
    ${Card_AnnouncementFragmentDoc}`;

export const useArchiveAnnouncementMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ArchiveAnnouncementMutation, TError, ArchiveAnnouncementMutationVariables, TContext>) => {
    
    return useMutation<ArchiveAnnouncementMutation, TError, ArchiveAnnouncementMutationVariables, TContext>(
      {
    mutationKey: ['ArchiveAnnouncement'],
    mutationFn: useFetchData<ArchiveAnnouncementMutation, ArchiveAnnouncementMutationVariables>(ArchiveAnnouncementDocument),
    ...options
  }
    )};

useArchiveAnnouncementMutation.getKey = () => ['ArchiveAnnouncement'];

export const CopyAnnouncementToProjectDocument = `
    mutation CopyAnnouncementToProject($announcementId: ID!, $newProjectId: ID!) {
  copyAnnouncementToProject(
    input: {announcementId: $announcementId, newProjectId: $newProjectId}
  ) {
    announcement {
      id
      name
    }
    targetProject {
      id
      name
    }
    errors {
      message
    }
  }
}
    `;

export const useCopyAnnouncementToProjectMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CopyAnnouncementToProjectMutation, TError, CopyAnnouncementToProjectMutationVariables, TContext>) => {
    
    return useMutation<CopyAnnouncementToProjectMutation, TError, CopyAnnouncementToProjectMutationVariables, TContext>(
      {
    mutationKey: ['CopyAnnouncementToProject'],
    mutationFn: useFetchData<CopyAnnouncementToProjectMutation, CopyAnnouncementToProjectMutationVariables>(CopyAnnouncementToProjectDocument),
    ...options
  }
    )};

useCopyAnnouncementToProjectMutation.getKey = () => ['CopyAnnouncementToProject'];

export const CreateAnnouncementDocument = `
    mutation createAnnouncement($projectId: ID!, $templateId: ID) {
  createAnnouncement(
    input: {announcement: {projectId: $projectId, templateId: $templateId}}
  ) {
    announcement {
      id
      template {
        id
        name
      }
      ...Card_announcement
    }
    errors {
      path
      message
    }
  }
}
    ${Card_AnnouncementFragmentDoc}`;

export const useCreateAnnouncementMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateAnnouncementMutation, TError, CreateAnnouncementMutationVariables, TContext>) => {
    
    return useMutation<CreateAnnouncementMutation, TError, CreateAnnouncementMutationVariables, TContext>(
      {
    mutationKey: ['createAnnouncement'],
    mutationFn: useFetchData<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>(CreateAnnouncementDocument),
    ...options
  }
    )};

useCreateAnnouncementMutation.getKey = () => ['createAnnouncement'];

export const DuplicateAnnouncementDocument = `
    mutation DuplicateAnnouncement($announcementId: ID!) {
  duplicateAnnouncement(input: {announcementId: $announcementId}) {
    announcement {
      id
      ...Card_announcement
      heroImage {
        ...UploadFieldImage
      }
      categories {
        id
        name
        backgroundColor
      }
      workItems {
        edges {
          node {
            id
            name
          }
        }
      }
    }
    errors {
      path
      message
    }
  }
}
    ${Card_AnnouncementFragmentDoc}
${UploadFieldImageFragmentDoc}`;

export const useDuplicateAnnouncementMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DuplicateAnnouncementMutation, TError, DuplicateAnnouncementMutationVariables, TContext>) => {
    
    return useMutation<DuplicateAnnouncementMutation, TError, DuplicateAnnouncementMutationVariables, TContext>(
      {
    mutationKey: ['DuplicateAnnouncement'],
    mutationFn: useFetchData<DuplicateAnnouncementMutation, DuplicateAnnouncementMutationVariables>(DuplicateAnnouncementDocument),
    ...options
  }
    )};

useDuplicateAnnouncementMutation.getKey = () => ['DuplicateAnnouncement'];

export const RqPublishAnnouncementDocument = `
    mutation RQPublishAnnouncement($id: ID!) {
  publishAnnouncement(input: {announcementId: $id}) {
    announcement {
      id
      state
      publishedAt
    }
  }
}
    `;

export const useRqPublishAnnouncementMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RqPublishAnnouncementMutation, TError, RqPublishAnnouncementMutationVariables, TContext>) => {
    
    return useMutation<RqPublishAnnouncementMutation, TError, RqPublishAnnouncementMutationVariables, TContext>(
      {
    mutationKey: ['RQPublishAnnouncement'],
    mutationFn: useFetchData<RqPublishAnnouncementMutation, RqPublishAnnouncementMutationVariables>(RqPublishAnnouncementDocument),
    ...options
  }
    )};

useRqPublishAnnouncementMutation.getKey = () => ['RQPublishAnnouncement'];

export const RemoveAnnouncementWorkItemDocument = `
    mutation removeAnnouncementWorkItem($announcementId: ID!, $workItemId: ID!) {
  removeAnnouncementWorkItem(
    input: {announcementId: $announcementId, workItemId: $workItemId}
  ) {
    announcement {
      id
      workItems {
        edges {
          node {
            id
          }
        }
      }
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useRemoveAnnouncementWorkItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveAnnouncementWorkItemMutation, TError, RemoveAnnouncementWorkItemMutationVariables, TContext>) => {
    
    return useMutation<RemoveAnnouncementWorkItemMutation, TError, RemoveAnnouncementWorkItemMutationVariables, TContext>(
      {
    mutationKey: ['removeAnnouncementWorkItem'],
    mutationFn: useFetchData<RemoveAnnouncementWorkItemMutation, RemoveAnnouncementWorkItemMutationVariables>(RemoveAnnouncementWorkItemDocument),
    ...options
  }
    )};

useRemoveAnnouncementWorkItemMutation.getKey = () => ['removeAnnouncementWorkItem'];

export const RemoveAttachmentDocument = `
    mutation removeAttachment($announcementId: ID!, $attachment: AnnouncementAttachment!) {
  removeAnnouncementAttachment(
    input: {attachment: $attachment, id: $announcementId}
  ) {
    announcement {
      id
      heroImage {
        ...UploadFieldImage
      }
    }
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useRemoveAttachmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveAttachmentMutation, TError, RemoveAttachmentMutationVariables, TContext>) => {
    
    return useMutation<RemoveAttachmentMutation, TError, RemoveAttachmentMutationVariables, TContext>(
      {
    mutationKey: ['removeAttachment'],
    mutationFn: useFetchData<RemoveAttachmentMutation, RemoveAttachmentMutationVariables>(RemoveAttachmentDocument),
    ...options
  }
    )};

useRemoveAttachmentMutation.getKey = () => ['removeAttachment'];

export const RestoreAnnouncementDocument = `
    mutation RestoreAnnouncement($announcementId: ID!) {
  unarchiveAnnouncement(input: {announcementId: $announcementId}) {
    announcement {
      id
      feedbacks {
        edges {
          node {
            id
          }
        }
      }
      ...Card_announcement
    }
    errors {
      path
      message
    }
  }
}
    ${Card_AnnouncementFragmentDoc}`;

export const useRestoreAnnouncementMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RestoreAnnouncementMutation, TError, RestoreAnnouncementMutationVariables, TContext>) => {
    
    return useMutation<RestoreAnnouncementMutation, TError, RestoreAnnouncementMutationVariables, TContext>(
      {
    mutationKey: ['RestoreAnnouncement'],
    mutationFn: useFetchData<RestoreAnnouncementMutation, RestoreAnnouncementMutationVariables>(RestoreAnnouncementDocument),
    ...options
  }
    )};

useRestoreAnnouncementMutation.getKey = () => ['RestoreAnnouncement'];

export const UseScheduleAnnouncementDocument = `
    mutation useScheduleAnnouncement($id: ID!, $scheduledAt: String!, $scheduledAtTimezone: String) {
  scheduleAnnouncement(
    input: {announcementId: $id, scheduledAt: $scheduledAt, scheduledAtTimezone: $scheduledAtTimezone}
  ) {
    announcement {
      id
      state
      scheduledAt
      scheduledAtTimezone
      headline
      content
    }
    errors {
      path
      message
    }
  }
}
    `;

export const useUseScheduleAnnouncementMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UseScheduleAnnouncementMutation, TError, UseScheduleAnnouncementMutationVariables, TContext>) => {
    
    return useMutation<UseScheduleAnnouncementMutation, TError, UseScheduleAnnouncementMutationVariables, TContext>(
      {
    mutationKey: ['useScheduleAnnouncement'],
    mutationFn: useFetchData<UseScheduleAnnouncementMutation, UseScheduleAnnouncementMutationVariables>(UseScheduleAnnouncementDocument),
    ...options
  }
    )};

useUseScheduleAnnouncementMutation.getKey = () => ['useScheduleAnnouncement'];

export const UnscheduleAnnouncementDocument = `
    mutation UnscheduleAnnouncement($id: ID!) {
  unscheduleAnnouncement(input: {announcementId: $id}) {
    announcement {
      id
      state
    }
  }
}
    `;

export const useUnscheduleAnnouncementMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnscheduleAnnouncementMutation, TError, UnscheduleAnnouncementMutationVariables, TContext>) => {
    
    return useMutation<UnscheduleAnnouncementMutation, TError, UnscheduleAnnouncementMutationVariables, TContext>(
      {
    mutationKey: ['UnscheduleAnnouncement'],
    mutationFn: useFetchData<UnscheduleAnnouncementMutation, UnscheduleAnnouncementMutationVariables>(UnscheduleAnnouncementDocument),
    ...options
  }
    )};

useUnscheduleAnnouncementMutation.getKey = () => ['UnscheduleAnnouncement'];

export const UpdateAnnouncementDocument = `
    mutation updateAnnouncement($announcement: UpdateAnnouncementAttributes!) {
  updateAnnouncement(input: {announcement: $announcement}) {
    announcement {
      id
      notificationsExcerptOnly
      ...Content
      ...PublishedAnnouncement
    }
    errors {
      message
      path
    }
  }
}
    ${ContentFragmentDoc}
${UploadFieldImageFragmentDoc}
${PublishedAnnouncementFragmentDoc}`;

export const useUpdateAnnouncementMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateAnnouncementMutation, TError, UpdateAnnouncementMutationVariables, TContext>) => {
    
    return useMutation<UpdateAnnouncementMutation, TError, UpdateAnnouncementMutationVariables, TContext>(
      {
    mutationKey: ['updateAnnouncement'],
    mutationFn: useFetchData<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>(UpdateAnnouncementDocument),
    ...options
  }
    )};

useUpdateAnnouncementMutation.getKey = () => ['updateAnnouncement'];

export const CohortShowDocument = `
    query cohortShow($projectId: ID!, $id: ID!) {
  project(id: $projectId) {
    cohort(id: $id) {
      id
      name
      description
      subscriberCount
      feedbackCount
      voteCount
      subscribers {
        totalCount
      }
      audienceDomains {
        totalCount
      }
    }
  }
}
    `;

export const useCohortShowQuery = <
      TData = CohortShowQuery,
      TError = unknown
    >(
      variables: CohortShowQueryVariables,
      options?: Omit<UseQueryOptions<CohortShowQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CohortShowQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CohortShowQuery, TError, TData>(
      {
    queryKey: ['cohortShow', variables],
    queryFn: useFetchData<CohortShowQuery, CohortShowQueryVariables>(CohortShowDocument).bind(null, variables),
    ...options
  }
    )};

useCohortShowQuery.getKey = (variables: CohortShowQueryVariables) => ['cohortShow', variables];

export const useInfiniteCohortShowQuery = <
      TData = InfiniteData<CohortShowQuery>,
      TError = unknown
    >(
      variables: CohortShowQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CohortShowQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CohortShowQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CohortShowQuery, CohortShowQueryVariables>(CohortShowDocument)
    return useInfiniteQuery<CohortShowQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['cohortShow.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCohortShowQuery.getKey = (variables: CohortShowQueryVariables) => ['cohortShow.infinite', variables];

export const AudienceDomainsIndexDocument = `
    query audienceDomainsIndex($projectId: ID!, $orderBy: OrderBy, $where: Where, $first: Int, $after: String, $before: String) {
  project(id: $projectId) {
    audienceDomains(
      orderBy: $orderBy
      where: $where
      first: $first
      after: $after
      before: $before
    ) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      totalCount
      nodes {
        id
        createdAt
        name
        hostname
        subscriberCount
        feedbackCount
        voteCount
        averageFeedbackSentiment
      }
    }
  }
}
    `;

export const useAudienceDomainsIndexQuery = <
      TData = AudienceDomainsIndexQuery,
      TError = unknown
    >(
      variables: AudienceDomainsIndexQueryVariables,
      options?: Omit<UseQueryOptions<AudienceDomainsIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AudienceDomainsIndexQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AudienceDomainsIndexQuery, TError, TData>(
      {
    queryKey: ['audienceDomainsIndex', variables],
    queryFn: useFetchData<AudienceDomainsIndexQuery, AudienceDomainsIndexQueryVariables>(AudienceDomainsIndexDocument).bind(null, variables),
    ...options
  }
    )};

useAudienceDomainsIndexQuery.getKey = (variables: AudienceDomainsIndexQueryVariables) => ['audienceDomainsIndex', variables];

export const useInfiniteAudienceDomainsIndexQuery = <
      TData = InfiniteData<AudienceDomainsIndexQuery>,
      TError = unknown
    >(
      variables: AudienceDomainsIndexQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AudienceDomainsIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AudienceDomainsIndexQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AudienceDomainsIndexQuery, AudienceDomainsIndexQueryVariables>(AudienceDomainsIndexDocument)
    return useInfiniteQuery<AudienceDomainsIndexQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['audienceDomainsIndex.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAudienceDomainsIndexQuery.getKey = (variables: AudienceDomainsIndexQueryVariables) => ['audienceDomainsIndex.infinite', variables];

export const CohortsIndexDocument = `
    query cohortsIndex($projectId: ID!, $orderBy: OrderBy, $where: Where, $first: Int, $after: String, $before: String) {
  project(id: $projectId) {
    cohorts(
      orderBy: $orderBy
      where: $where
      first: $first
      after: $after
      before: $before
    ) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      totalCount
      nodes {
        id
        name
        description
        subscriberCount
        feedbackCount
        voteCount
      }
    }
  }
}
    `;

export const useCohortsIndexQuery = <
      TData = CohortsIndexQuery,
      TError = unknown
    >(
      variables: CohortsIndexQueryVariables,
      options?: Omit<UseQueryOptions<CohortsIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CohortsIndexQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CohortsIndexQuery, TError, TData>(
      {
    queryKey: ['cohortsIndex', variables],
    queryFn: useFetchData<CohortsIndexQuery, CohortsIndexQueryVariables>(CohortsIndexDocument).bind(null, variables),
    ...options
  }
    )};

useCohortsIndexQuery.getKey = (variables: CohortsIndexQueryVariables) => ['cohortsIndex', variables];

export const useInfiniteCohortsIndexQuery = <
      TData = InfiniteData<CohortsIndexQuery>,
      TError = unknown
    >(
      variables: CohortsIndexQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CohortsIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CohortsIndexQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CohortsIndexQuery, CohortsIndexQueryVariables>(CohortsIndexDocument)
    return useInfiniteQuery<CohortsIndexQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['cohortsIndex.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCohortsIndexQuery.getKey = (variables: CohortsIndexQueryVariables) => ['cohortsIndex.infinite', variables];

export const AuthorizationDocument = `
    query Authorization($projectId: ID!) {
  viewer {
    project(id: $projectId) {
      secureConnectionSettings {
        id
        allowedDomains
      }
    }
  }
}
    `;

export const useAuthorizationQuery = <
      TData = AuthorizationQuery,
      TError = unknown
    >(
      variables: AuthorizationQueryVariables,
      options?: Omit<UseQueryOptions<AuthorizationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AuthorizationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AuthorizationQuery, TError, TData>(
      {
    queryKey: ['Authorization', variables],
    queryFn: useFetchData<AuthorizationQuery, AuthorizationQueryVariables>(AuthorizationDocument).bind(null, variables),
    ...options
  }
    )};

useAuthorizationQuery.getKey = (variables: AuthorizationQueryVariables) => ['Authorization', variables];

export const useInfiniteAuthorizationQuery = <
      TData = InfiniteData<AuthorizationQuery>,
      TError = unknown
    >(
      variables: AuthorizationQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AuthorizationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AuthorizationQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AuthorizationQuery, AuthorizationQueryVariables>(AuthorizationDocument)
    return useInfiniteQuery<AuthorizationQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Authorization.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAuthorizationQuery.getKey = (variables: AuthorizationQueryVariables) => ['Authorization.infinite', variables];

export const RemoveAllowedDomainDocument = `
    mutation RemoveAllowedDomain($input: RemoveAllowedDomainInput!) {
  removeAllowedDomain(input: $input) {
    secureConnection {
      allowedDomains
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useRemoveAllowedDomainMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveAllowedDomainMutation, TError, RemoveAllowedDomainMutationVariables, TContext>) => {
    
    return useMutation<RemoveAllowedDomainMutation, TError, RemoveAllowedDomainMutationVariables, TContext>(
      {
    mutationKey: ['RemoveAllowedDomain'],
    mutationFn: useFetchData<RemoveAllowedDomainMutation, RemoveAllowedDomainMutationVariables>(RemoveAllowedDomainDocument),
    ...options
  }
    )};

useRemoveAllowedDomainMutation.getKey = () => ['RemoveAllowedDomain'];

export const UpdateSecureConnectionDocument = `
    mutation UpdateSecureConnection($input: UpdateSecureConnectionInput!) {
  updateSecureConnection(input: $input) {
    secureConnection {
      allowedDomains
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useUpdateSecureConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSecureConnectionMutation, TError, UpdateSecureConnectionMutationVariables, TContext>) => {
    
    return useMutation<UpdateSecureConnectionMutation, TError, UpdateSecureConnectionMutationVariables, TContext>(
      {
    mutationKey: ['UpdateSecureConnection'],
    mutationFn: useFetchData<UpdateSecureConnectionMutation, UpdateSecureConnectionMutationVariables>(UpdateSecureConnectionDocument),
    ...options
  }
    )};

useUpdateSecureConnectionMutation.getKey = () => ['UpdateSecureConnection'];

export const IdeaEmailPromotionCountDocument = `
    query IdeaEmailPromotionCount($ideaId: ID!) {
  idea(id: $ideaId) {
    emailPromotionCount
  }
}
    `;

export const useIdeaEmailPromotionCountQuery = <
      TData = IdeaEmailPromotionCountQuery,
      TError = unknown
    >(
      variables: IdeaEmailPromotionCountQueryVariables,
      options?: Omit<UseQueryOptions<IdeaEmailPromotionCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<IdeaEmailPromotionCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<IdeaEmailPromotionCountQuery, TError, TData>(
      {
    queryKey: ['IdeaEmailPromotionCount', variables],
    queryFn: useFetchData<IdeaEmailPromotionCountQuery, IdeaEmailPromotionCountQueryVariables>(IdeaEmailPromotionCountDocument).bind(null, variables),
    ...options
  }
    )};

useIdeaEmailPromotionCountQuery.getKey = (variables: IdeaEmailPromotionCountQueryVariables) => ['IdeaEmailPromotionCount', variables];

export const useInfiniteIdeaEmailPromotionCountQuery = <
      TData = InfiniteData<IdeaEmailPromotionCountQuery>,
      TError = unknown
    >(
      variables: IdeaEmailPromotionCountQueryVariables,
      options: Omit<UseInfiniteQueryOptions<IdeaEmailPromotionCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<IdeaEmailPromotionCountQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<IdeaEmailPromotionCountQuery, IdeaEmailPromotionCountQueryVariables>(IdeaEmailPromotionCountDocument)
    return useInfiniteQuery<IdeaEmailPromotionCountQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['IdeaEmailPromotionCount.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteIdeaEmailPromotionCountQuery.getKey = (variables: IdeaEmailPromotionCountQueryVariables) => ['IdeaEmailPromotionCount.infinite', variables];

export const IdeaShowDocument = `
    query IdeaShow($ideaId: ID!) {
  idea(id: $ideaId) {
    id
    name
    notes
    published
    feedbackCount
    ideaVotesCount
    lastFeedback
    deactivatedAt
    createdAt
    categories {
      nodes {
        id
        name
        color
      }
    }
    latestWorkItemId
  }
}
    `;

export const useIdeaShowQuery = <
      TData = IdeaShowQuery,
      TError = unknown
    >(
      variables: IdeaShowQueryVariables,
      options?: Omit<UseQueryOptions<IdeaShowQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<IdeaShowQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<IdeaShowQuery, TError, TData>(
      {
    queryKey: ['IdeaShow', variables],
    queryFn: useFetchData<IdeaShowQuery, IdeaShowQueryVariables>(IdeaShowDocument).bind(null, variables),
    ...options
  }
    )};

useIdeaShowQuery.getKey = (variables: IdeaShowQueryVariables) => ['IdeaShow', variables];

export const useInfiniteIdeaShowQuery = <
      TData = InfiniteData<IdeaShowQuery>,
      TError = unknown
    >(
      variables: IdeaShowQueryVariables,
      options: Omit<UseInfiniteQueryOptions<IdeaShowQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<IdeaShowQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<IdeaShowQuery, IdeaShowQueryVariables>(IdeaShowDocument)
    return useInfiniteQuery<IdeaShowQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['IdeaShow.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteIdeaShowQuery.getKey = (variables: IdeaShowQueryVariables) => ['IdeaShow.infinite', variables];

export const IdeasInboxDocument = `
    query IdeasInbox($projectId: ID!) {
  project(id: $projectId) {
    ideasEnabled
    hasPublishedIdea
  }
}
    `;

export const useIdeasInboxQuery = <
      TData = IdeasInboxQuery,
      TError = unknown
    >(
      variables: IdeasInboxQueryVariables,
      options?: Omit<UseQueryOptions<IdeasInboxQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<IdeasInboxQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<IdeasInboxQuery, TError, TData>(
      {
    queryKey: ['IdeasInbox', variables],
    queryFn: useFetchData<IdeasInboxQuery, IdeasInboxQueryVariables>(IdeasInboxDocument).bind(null, variables),
    ...options
  }
    )};

useIdeasInboxQuery.getKey = (variables: IdeasInboxQueryVariables) => ['IdeasInbox', variables];

export const useInfiniteIdeasInboxQuery = <
      TData = InfiniteData<IdeasInboxQuery>,
      TError = unknown
    >(
      variables: IdeasInboxQueryVariables,
      options: Omit<UseInfiniteQueryOptions<IdeasInboxQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<IdeasInboxQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<IdeasInboxQuery, IdeasInboxQueryVariables>(IdeasInboxDocument)
    return useInfiniteQuery<IdeasInboxQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['IdeasInbox.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteIdeasInboxQuery.getKey = (variables: IdeasInboxQueryVariables) => ['IdeasInbox.infinite', variables];

export const ImportFeedbackDocument = `
    mutation ImportFeedback($projectId: ID!, $feedbacks: [BatchFeedback!]!, $skipOptIn: Boolean) {
  importFeedback(
    input: {projectId: $projectId, feedbacks: $feedbacks, skipOptIn: $skipOptIn}
  ) {
    status
    errors {
      path
      message
    }
  }
}
    `;

export const useImportFeedbackMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ImportFeedbackMutation, TError, ImportFeedbackMutationVariables, TContext>) => {
    
    return useMutation<ImportFeedbackMutation, TError, ImportFeedbackMutationVariables, TContext>(
      {
    mutationKey: ['ImportFeedback'],
    mutationFn: useFetchData<ImportFeedbackMutation, ImportFeedbackMutationVariables>(ImportFeedbackDocument),
    ...options
  }
    )};

useImportFeedbackMutation.getKey = () => ['ImportFeedback'];

export const SendPromotionTestEmailDocument = `
    mutation SendPromotionTestEmail($input: SendPromoteTestInput!) {
  sendPromoteTest(input: $input) {
    success
  }
}
    `;

export const useSendPromotionTestEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendPromotionTestEmailMutation, TError, SendPromotionTestEmailMutationVariables, TContext>) => {
    
    return useMutation<SendPromotionTestEmailMutation, TError, SendPromotionTestEmailMutationVariables, TContext>(
      {
    mutationKey: ['SendPromotionTestEmail'],
    mutationFn: useFetchData<SendPromotionTestEmailMutation, SendPromotionTestEmailMutationVariables>(SendPromotionTestEmailDocument),
    ...options
  }
    )};

useSendPromotionTestEmailMutation.getKey = () => ['SendPromotionTestEmail'];

export const CreateOrganizationProfileDocument = `
    mutation CreateOrganizationProfile($name: String!, $creatorId: ID!, $userRole: UserRoleEnum!, $userReferralSource: UserReferralSourceEnum!) {
  createOrganizationProfile(
    input: {name: $name, creatorId: $creatorId, userRole: $userRole, userReferralSource: $userReferralSource}
  ) {
    projectId
  }
}
    `;

export const useCreateOrganizationProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOrganizationProfileMutation, TError, CreateOrganizationProfileMutationVariables, TContext>) => {
    
    return useMutation<CreateOrganizationProfileMutation, TError, CreateOrganizationProfileMutationVariables, TContext>(
      {
    mutationKey: ['CreateOrganizationProfile'],
    mutationFn: useFetchData<CreateOrganizationProfileMutation, CreateOrganizationProfileMutationVariables>(CreateOrganizationProfileDocument),
    ...options
  }
    )};

useCreateOrganizationProfileMutation.getKey = () => ['CreateOrganizationProfile'];

export const OnboardingTasksDocument = `
    query OnboardingTasks($projectId: ID!) {
  viewer {
    project(id: $projectId) {
      slug
      onboardingTasks {
        addAnnouncement
        addUser
        addWorkItem
        claimSubdomain
        customizeCategories
        customizeColors
        customizeEmail
        customizeHtmlCss
        customizeRoadmapStages
        enableRoadmap
        uploadLogo
      }
    }
  }
}
    `;

export const useOnboardingTasksQuery = <
      TData = OnboardingTasksQuery,
      TError = unknown
    >(
      variables: OnboardingTasksQueryVariables,
      options?: Omit<UseQueryOptions<OnboardingTasksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OnboardingTasksQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OnboardingTasksQuery, TError, TData>(
      {
    queryKey: ['OnboardingTasks', variables],
    queryFn: useFetchData<OnboardingTasksQuery, OnboardingTasksQueryVariables>(OnboardingTasksDocument).bind(null, variables),
    ...options
  }
    )};

useOnboardingTasksQuery.getKey = (variables: OnboardingTasksQueryVariables) => ['OnboardingTasks', variables];

export const useInfiniteOnboardingTasksQuery = <
      TData = InfiniteData<OnboardingTasksQuery>,
      TError = unknown
    >(
      variables: OnboardingTasksQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OnboardingTasksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OnboardingTasksQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OnboardingTasksQuery, OnboardingTasksQueryVariables>(OnboardingTasksDocument)
    return useInfiniteQuery<OnboardingTasksQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['OnboardingTasks.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOnboardingTasksQuery.getKey = (variables: OnboardingTasksQueryVariables) => ['OnboardingTasks.infinite', variables];

export const UpdateOnboardingTasksDocument = `
    mutation UpdateOnboardingTasks($projectId: ID!, $onboardingTasks: UpdateOnboardingTasksAttributes!) {
  updateOnboardingTasks(
    input: {projectId: $projectId, onboardingTasks: $onboardingTasks}
  ) {
    errors {
      message
    }
  }
}
    `;

export const useUpdateOnboardingTasksMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOnboardingTasksMutation, TError, UpdateOnboardingTasksMutationVariables, TContext>) => {
    
    return useMutation<UpdateOnboardingTasksMutation, TError, UpdateOnboardingTasksMutationVariables, TContext>(
      {
    mutationKey: ['UpdateOnboardingTasks'],
    mutationFn: useFetchData<UpdateOnboardingTasksMutation, UpdateOnboardingTasksMutationVariables>(UpdateOnboardingTasksDocument),
    ...options
  }
    )};

useUpdateOnboardingTasksMutation.getKey = () => ['UpdateOnboardingTasks'];

export const WizardDocument = `
    query Wizard($projectId: ID!) {
  project(id: $projectId) {
    emailProjectSubscription {
      id
      categories {
        id
        name
      }
    }
    ...WizardInfoStep
    ...WizardCustomizeStep
    ...WizardCategoriesStep
    ...WizardSubscribersStep
    ...WizardAnnouncementStep
    ...WizardPublicPagePreview
  }
}
    ${WizardInfoStepFragmentDoc}
${WizardCustomizeStepFragmentDoc}
${UploadFieldImageFragmentDoc}
${WizardCategoriesStepFragmentDoc}
${WizardSubscribersStepFragmentDoc}
${WizardAnnouncementStepFragmentDoc}
${WizardPublicPagePreviewFragmentDoc}`;

export const useWizardQuery = <
      TData = WizardQuery,
      TError = unknown
    >(
      variables: WizardQueryVariables,
      options?: Omit<UseQueryOptions<WizardQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<WizardQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<WizardQuery, TError, TData>(
      {
    queryKey: ['Wizard', variables],
    queryFn: useFetchData<WizardQuery, WizardQueryVariables>(WizardDocument).bind(null, variables),
    ...options
  }
    )};

useWizardQuery.getKey = (variables: WizardQueryVariables) => ['Wizard', variables];

export const useInfiniteWizardQuery = <
      TData = InfiniteData<WizardQuery>,
      TError = unknown
    >(
      variables: WizardQueryVariables,
      options: Omit<UseInfiniteQueryOptions<WizardQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<WizardQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<WizardQuery, WizardQueryVariables>(WizardDocument)
    return useInfiniteQuery<WizardQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Wizard.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteWizardQuery.getKey = (variables: WizardQueryVariables) => ['Wizard.infinite', variables];

export const UpdateOnboardingProjectDocument = `
    mutation UpdateOnboardingProject($project: UpdateProjectAttributes!, $mailAppSetting: UpdateMailAppSettingsAttributes!) {
  updateProject(input: {project: $project}) {
    project {
      id
      ...WizardInfoStep
      ...WizardCustomizeStep
      ...WizardCategoriesStep
      ...WizardSubscribersStep
      ...WizardAnnouncementStep
      ...WizardPublicPagePreview
    }
    errors {
      path
      message
    }
  }
  updateMailAppSettings(input: {mailAppSetting: $mailAppSetting}) {
    mailAppSetting {
      id
    }
    errors {
      path
      message
    }
  }
}
    ${WizardInfoStepFragmentDoc}
${WizardCustomizeStepFragmentDoc}
${UploadFieldImageFragmentDoc}
${WizardCategoriesStepFragmentDoc}
${WizardSubscribersStepFragmentDoc}
${WizardAnnouncementStepFragmentDoc}
${WizardPublicPagePreviewFragmentDoc}`;

export const useUpdateOnboardingProjectMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOnboardingProjectMutation, TError, UpdateOnboardingProjectMutationVariables, TContext>) => {
    
    return useMutation<UpdateOnboardingProjectMutation, TError, UpdateOnboardingProjectMutationVariables, TContext>(
      {
    mutationKey: ['UpdateOnboardingProject'],
    mutationFn: useFetchData<UpdateOnboardingProjectMutation, UpdateOnboardingProjectMutationVariables>(UpdateOnboardingProjectDocument),
    ...options
  }
    )};

useUpdateOnboardingProjectMutation.getKey = () => ['UpdateOnboardingProject'];

export const WizardCreateCategoryDocument = `
    mutation WizardCreateCategory($category: CreateCategoryAttributes!) {
  createCategory(input: {category: $category}) {
    category {
      id
      name
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useWizardCreateCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<WizardCreateCategoryMutation, TError, WizardCreateCategoryMutationVariables, TContext>) => {
    
    return useMutation<WizardCreateCategoryMutation, TError, WizardCreateCategoryMutationVariables, TContext>(
      {
    mutationKey: ['WizardCreateCategory'],
    mutationFn: useFetchData<WizardCreateCategoryMutation, WizardCreateCategoryMutationVariables>(WizardCreateCategoryDocument),
    ...options
  }
    )};

useWizardCreateCategoryMutation.getKey = () => ['WizardCreateCategory'];

export const WizardCreateTestAnnouncementDocument = `
    mutation WizardCreateTestAnnouncement($announcement: CreateAnnouncementAttributes!) {
  createAnnouncement(input: {announcement: $announcement}) {
    announcement {
      id
    }
    errors {
      path
      message
    }
  }
}
    `;

export const useWizardCreateTestAnnouncementMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<WizardCreateTestAnnouncementMutation, TError, WizardCreateTestAnnouncementMutationVariables, TContext>) => {
    
    return useMutation<WizardCreateTestAnnouncementMutation, TError, WizardCreateTestAnnouncementMutationVariables, TContext>(
      {
    mutationKey: ['WizardCreateTestAnnouncement'],
    mutationFn: useFetchData<WizardCreateTestAnnouncementMutation, WizardCreateTestAnnouncementMutationVariables>(WizardCreateTestAnnouncementDocument),
    ...options
  }
    )};

useWizardCreateTestAnnouncementMutation.getKey = () => ['WizardCreateTestAnnouncement'];

export const WizardRemoveCategoryDocument = `
    mutation WizardRemoveCategory($categoryId: ID!) {
  removeCategory(input: {id: $categoryId}) {
    category {
      id
      name
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useWizardRemoveCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<WizardRemoveCategoryMutation, TError, WizardRemoveCategoryMutationVariables, TContext>) => {
    
    return useMutation<WizardRemoveCategoryMutation, TError, WizardRemoveCategoryMutationVariables, TContext>(
      {
    mutationKey: ['WizardRemoveCategory'],
    mutationFn: useFetchData<WizardRemoveCategoryMutation, WizardRemoveCategoryMutationVariables>(WizardRemoveCategoryDocument),
    ...options
  }
    )};

useWizardRemoveCategoryMutation.getKey = () => ['WizardRemoveCategory'];

export const WizardRemoveLogoDocument = `
    mutation WizardRemoveLogo($projectId: ID!, $emailSettingsId: ID!) {
  removeProjectLogo(input: {id: $projectId}) {
    project {
      id
      logo {
        ...UploadFieldImage
      }
    }
    errors {
      path
      message
    }
  }
  removeEmailLogo(input: {id: $emailSettingsId}) {
    mailAppSetting {
      id
      logo {
        ...UploadFieldImage
      }
    }
    errors
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useWizardRemoveLogoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<WizardRemoveLogoMutation, TError, WizardRemoveLogoMutationVariables, TContext>) => {
    
    return useMutation<WizardRemoveLogoMutation, TError, WizardRemoveLogoMutationVariables, TContext>(
      {
    mutationKey: ['WizardRemoveLogo'],
    mutationFn: useFetchData<WizardRemoveLogoMutation, WizardRemoveLogoMutationVariables>(WizardRemoveLogoDocument),
    ...options
  }
    )};

useWizardRemoveLogoMutation.getKey = () => ['WizardRemoveLogo'];

export const DeleteAtlassianOauthAppDocument = `
    mutation DeleteAtlassianOauthApp($projectId: ID!, $userId: ID!) {
  deleteAtlassianApp(input: {projectId: $projectId, userId: $userId}) {
    appId
  }
}
    `;

export const useDeleteAtlassianOauthAppMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteAtlassianOauthAppMutation, TError, DeleteAtlassianOauthAppMutationVariables, TContext>) => {
    
    return useMutation<DeleteAtlassianOauthAppMutation, TError, DeleteAtlassianOauthAppMutationVariables, TContext>(
      {
    mutationKey: ['DeleteAtlassianOauthApp'],
    mutationFn: useFetchData<DeleteAtlassianOauthAppMutation, DeleteAtlassianOauthAppMutationVariables>(DeleteAtlassianOauthAppDocument),
    ...options
  }
    )};

useDeleteAtlassianOauthAppMutation.getKey = () => ['DeleteAtlassianOauthApp'];

export const UpdateAtlassianAppDocument = `
    mutation UpdateAtlassianApp($id: ID!, $siteId: String!) {
  updateAtlassianOauthApp(input: {id: $id, siteId: $siteId}) {
    appId
  }
}
    `;

export const useUpdateAtlassianAppMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateAtlassianAppMutation, TError, UpdateAtlassianAppMutationVariables, TContext>) => {
    
    return useMutation<UpdateAtlassianAppMutation, TError, UpdateAtlassianAppMutationVariables, TContext>(
      {
    mutationKey: ['UpdateAtlassianApp'],
    mutationFn: useFetchData<UpdateAtlassianAppMutation, UpdateAtlassianAppMutationVariables>(UpdateAtlassianAppDocument),
    ...options
  }
    )};

useUpdateAtlassianAppMutation.getKey = () => ['UpdateAtlassianApp'];

export const NotificationsDocument = `
    query Notifications($projectId: ID!) {
  viewer {
    project(id: $projectId) {
      id
      name
      publicPageUrl
      subscriberReportEnabled
      feedbackViaEmailEnabled
      feedbackViaSlackEnabled
      slackAuthenticationUrl
      slackSubscription {
        id
      }
      emailSubscription {
        id
      }
    }
  }
}
    `;

export const useNotificationsQuery = <
      TData = NotificationsQuery,
      TError = unknown
    >(
      variables: NotificationsQueryVariables,
      options?: Omit<UseQueryOptions<NotificationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<NotificationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<NotificationsQuery, TError, TData>(
      {
    queryKey: ['Notifications', variables],
    queryFn: useFetchData<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument).bind(null, variables),
    ...options
  }
    )};

useNotificationsQuery.getKey = (variables: NotificationsQueryVariables) => ['Notifications', variables];

export const useInfiniteNotificationsQuery = <
      TData = InfiniteData<NotificationsQuery>,
      TError = unknown
    >(
      variables: NotificationsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<NotificationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<NotificationsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument)
    return useInfiniteQuery<NotificationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Notifications.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteNotificationsQuery.getKey = (variables: NotificationsQueryVariables) => ['Notifications.infinite', variables];

export const UnsubscribeAllDocument = `
    mutation UnsubscribeAll($input: UnsubscribeAllInput!) {
  unsubscribeAll(input: $input) {
    projectId
    errors {
      message
      path
    }
  }
}
    `;

export const useUnsubscribeAllMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnsubscribeAllMutation, TError, UnsubscribeAllMutationVariables, TContext>) => {
    
    return useMutation<UnsubscribeAllMutation, TError, UnsubscribeAllMutationVariables, TContext>(
      {
    mutationKey: ['UnsubscribeAll'],
    mutationFn: useFetchData<UnsubscribeAllMutation, UnsubscribeAllMutationVariables>(UnsubscribeAllDocument),
    ...options
  }
    )};

useUnsubscribeAllMutation.getKey = () => ['UnsubscribeAll'];

export const ToggleSubscriberReportDocument = `
    mutation ToggleSubscriberReport($input: ToggleSubscriberReportInput!) {
  toggleSubscriberReport(input: $input) {
    errors {
      message
      path
    }
  }
}
    `;

export const useToggleSubscriberReportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ToggleSubscriberReportMutation, TError, ToggleSubscriberReportMutationVariables, TContext>) => {
    
    return useMutation<ToggleSubscriberReportMutation, TError, ToggleSubscriberReportMutationVariables, TContext>(
      {
    mutationKey: ['ToggleSubscriberReport'],
    mutationFn: useFetchData<ToggleSubscriberReportMutation, ToggleSubscriberReportMutationVariables>(ToggleSubscriberReportDocument),
    ...options
  }
    )};

useToggleSubscriberReportMutation.getKey = () => ['ToggleSubscriberReport'];

export const UpdateNotificationsDocument = `
    mutation UpdateNotifications($input: ToggleEventInput!) {
  toggleEventType(input: $input) {
    subscription {
      id
      feedbackSubmitted
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useUpdateNotificationsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateNotificationsMutation, TError, UpdateNotificationsMutationVariables, TContext>) => {
    
    return useMutation<UpdateNotificationsMutation, TError, UpdateNotificationsMutationVariables, TContext>(
      {
    mutationKey: ['UpdateNotifications'],
    mutationFn: useFetchData<UpdateNotificationsMutation, UpdateNotificationsMutationVariables>(UpdateNotificationsDocument),
    ...options
  }
    )};

useUpdateNotificationsMutation.getKey = () => ['UpdateNotifications'];

export const FetchProjectRollupDocument = `
    query FetchProjectRollup($projectId: ID!) {
  project(id: $projectId) {
    rollup {
      id
      enabled
      onlyMemberItems
      daysOfTheWeek
      events
      groupedBy
    }
  }
}
    `;

export const useFetchProjectRollupQuery = <
      TData = FetchProjectRollupQuery,
      TError = unknown
    >(
      variables: FetchProjectRollupQueryVariables,
      options?: Omit<UseQueryOptions<FetchProjectRollupQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FetchProjectRollupQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FetchProjectRollupQuery, TError, TData>(
      {
    queryKey: ['FetchProjectRollup', variables],
    queryFn: useFetchData<FetchProjectRollupQuery, FetchProjectRollupQueryVariables>(FetchProjectRollupDocument).bind(null, variables),
    ...options
  }
    )};

useFetchProjectRollupQuery.getKey = (variables: FetchProjectRollupQueryVariables) => ['FetchProjectRollup', variables];

export const useInfiniteFetchProjectRollupQuery = <
      TData = InfiniteData<FetchProjectRollupQuery>,
      TError = unknown
    >(
      variables: FetchProjectRollupQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FetchProjectRollupQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FetchProjectRollupQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<FetchProjectRollupQuery, FetchProjectRollupQueryVariables>(FetchProjectRollupDocument)
    return useInfiniteQuery<FetchProjectRollupQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FetchProjectRollup.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteFetchProjectRollupQuery.getKey = (variables: FetchProjectRollupQueryVariables) => ['FetchProjectRollup.infinite', variables];

export const ToggleRollupDocument = `
    mutation ToggleRollup($projectId: ID!, $active: Boolean!) {
  toggleRollup(input: {projectId: $projectId, active: $active}) {
    rollup {
      id
      enabled
      onlyMemberItems
      daysOfTheWeek
    }
  }
}
    `;

export const useToggleRollupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ToggleRollupMutation, TError, ToggleRollupMutationVariables, TContext>) => {
    
    return useMutation<ToggleRollupMutation, TError, ToggleRollupMutationVariables, TContext>(
      {
    mutationKey: ['ToggleRollup'],
    mutationFn: useFetchData<ToggleRollupMutation, ToggleRollupMutationVariables>(ToggleRollupDocument),
    ...options
  }
    )};

useToggleRollupMutation.getKey = () => ['ToggleRollup'];

export const UpsertRollupDocument = `
    mutation UpsertRollup($rollupId: ID, $projectId: ID, $daysOfTheWeek: [String!]!, $events: [String!]!, $onlyMemberItems: Boolean!, $groupedBy: String!) {
  upsertRollup(
    input: {rollupId: $rollupId, projectId: $projectId, daysOfTheWeek: $daysOfTheWeek, events: $events, onlyMemberItems: $onlyMemberItems, groupedBy: $groupedBy}
  ) {
    rollup {
      id
      daysOfTheWeek
      onlyMemberItems
    }
  }
}
    `;

export const useUpsertRollupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertRollupMutation, TError, UpsertRollupMutationVariables, TContext>) => {
    
    return useMutation<UpsertRollupMutation, TError, UpsertRollupMutationVariables, TContext>(
      {
    mutationKey: ['UpsertRollup'],
    mutationFn: useFetchData<UpsertRollupMutation, UpsertRollupMutationVariables>(UpsertRollupDocument),
    ...options
  }
    )};

useUpsertRollupMutation.getKey = () => ['UpsertRollup'];

export const DestroyUserProfileDocument = `
    mutation DestroyUserProfile($userId: ID!) {
  destroyUser(input: {userId: $userId}) {
    user {
      id
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useDestroyUserProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DestroyUserProfileMutation, TError, DestroyUserProfileMutationVariables, TContext>) => {
    
    return useMutation<DestroyUserProfileMutation, TError, DestroyUserProfileMutationVariables, TContext>(
      {
    mutationKey: ['DestroyUserProfile'],
    mutationFn: useFetchData<DestroyUserProfileMutation, DestroyUserProfileMutationVariables>(DestroyUserProfileDocument),
    ...options
  }
    )};

useDestroyUserProfileMutation.getKey = () => ['DestroyUserProfile'];

export const ProfileUserDocument = `
    query ProfileUser($projectId: ID!) {
  session {
    ...RqProfileFragment
    project(id: $projectId) {
      ...RqNotificationsFragment
    }
  }
}
    ${RqProfileFragmentFragmentDoc}
${UploadFieldImageFragmentDoc}
${RqNotificationsFragmentFragmentDoc}`;

export const useProfileUserQuery = <
      TData = ProfileUserQuery,
      TError = unknown
    >(
      variables: ProfileUserQueryVariables,
      options?: Omit<UseQueryOptions<ProfileUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProfileUserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProfileUserQuery, TError, TData>(
      {
    queryKey: ['ProfileUser', variables],
    queryFn: useFetchData<ProfileUserQuery, ProfileUserQueryVariables>(ProfileUserDocument).bind(null, variables),
    ...options
  }
    )};

useProfileUserQuery.getKey = (variables: ProfileUserQueryVariables) => ['ProfileUser', variables];

export const useInfiniteProfileUserQuery = <
      TData = InfiniteData<ProfileUserQuery>,
      TError = unknown
    >(
      variables: ProfileUserQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProfileUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProfileUserQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ProfileUserQuery, ProfileUserQueryVariables>(ProfileUserDocument)
    return useInfiniteQuery<ProfileUserQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProfileUser.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteProfileUserQuery.getKey = (variables: ProfileUserQueryVariables) => ['ProfileUser.infinite', variables];

export const RemoveUserAvatarImageDocument = `
    mutation RemoveUserAvatarImage($userId: ID!) {
  removeUserAvatarImage(input: {userId: $userId}) {
    user {
      id
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useRemoveUserAvatarImageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveUserAvatarImageMutation, TError, RemoveUserAvatarImageMutationVariables, TContext>) => {
    
    return useMutation<RemoveUserAvatarImageMutation, TError, RemoveUserAvatarImageMutationVariables, TContext>(
      {
    mutationKey: ['RemoveUserAvatarImage'],
    mutationFn: useFetchData<RemoveUserAvatarImageMutation, RemoveUserAvatarImageMutationVariables>(RemoveUserAvatarImageDocument),
    ...options
  }
    )};

useRemoveUserAvatarImageMutation.getKey = () => ['RemoveUserAvatarImage'];

export const UpdateUserProfileDocument = `
    mutation UpdateUserProfile($user: UpdateUserAttributes!) {
  updateUser(input: {user: $user}) {
    user {
      ...RqProfileFragment
    }
    errors {
      path
      message
    }
  }
}
    ${RqProfileFragmentFragmentDoc}
${UploadFieldImageFragmentDoc}`;

export const useUpdateUserProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserProfileMutation, TError, UpdateUserProfileMutationVariables, TContext>) => {
    
    return useMutation<UpdateUserProfileMutation, TError, UpdateUserProfileMutationVariables, TContext>(
      {
    mutationKey: ['UpdateUserProfile'],
    mutationFn: useFetchData<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument),
    ...options
  }
    )};

useUpdateUserProfileMutation.getKey = () => ['UpdateUserProfile'];

export const RoadmapBoardDocument = `
    query RoadmapBoard($projectId: ID!) {
  project(id: $projectId) {
    publicPageUrl
    roadmapEnabled
    roadmapMoveUpdatesEnabled
    roadmapWatchedStages
    categories {
      nodes {
        id
        name
        backgroundColor
        textColor
      }
    }
    projectUsers {
      edges {
        node {
          id
          displayName
          initials
          avatarColor
          avatarImage {
            ...UploadFieldImage
          }
        }
      }
    }
    stages {
      edges {
        node {
          id
          title: name
          description
          position
          published
          cards: workItems {
            nodes {
              id
              laneId: stageId
              name
              position
              categories {
                id
                name
                backgroundColor
                textColor
              }
              changeTypes {
                nodes {
                  id
                  name
                  color
                }
              }
              owner {
                id
                displayName
                initials
                avatarColor
                avatarImage {
                  ...UploadFieldImage
                }
              }
              members {
                id
                displayName
                initials
                avatarColor
                avatarImage {
                  ...UploadFieldImage
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useRoadmapBoardQuery = <
      TData = RoadmapBoardQuery,
      TError = unknown
    >(
      variables: RoadmapBoardQueryVariables,
      options?: Omit<UseQueryOptions<RoadmapBoardQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<RoadmapBoardQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<RoadmapBoardQuery, TError, TData>(
      {
    queryKey: ['RoadmapBoard', variables],
    queryFn: useFetchData<RoadmapBoardQuery, RoadmapBoardQueryVariables>(RoadmapBoardDocument).bind(null, variables),
    ...options
  }
    )};

useRoadmapBoardQuery.getKey = (variables: RoadmapBoardQueryVariables) => ['RoadmapBoard', variables];

export const useInfiniteRoadmapBoardQuery = <
      TData = InfiniteData<RoadmapBoardQuery>,
      TError = unknown
    >(
      variables: RoadmapBoardQueryVariables,
      options: Omit<UseInfiniteQueryOptions<RoadmapBoardQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<RoadmapBoardQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<RoadmapBoardQuery, RoadmapBoardQueryVariables>(RoadmapBoardDocument)
    return useInfiniteQuery<RoadmapBoardQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['RoadmapBoard.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteRoadmapBoardQuery.getKey = (variables: RoadmapBoardQueryVariables) => ['RoadmapBoard.infinite', variables];

export const RoadmapViewDocument = `
    query RoadmapView($projectId: ID!, $viewId: ID!) {
  project(id: $projectId) {
    projectView(id: $viewId) {
      id
      security
      publicPermalink
      restricted
      categories {
        id
        name
      }
      stages {
        id
        name
      }
      owners {
        id
        displayName
      }
      members {
        id
        displayName
      }
    }
  }
}
    `;

export const useRoadmapViewQuery = <
      TData = RoadmapViewQuery,
      TError = unknown
    >(
      variables: RoadmapViewQueryVariables,
      options?: Omit<UseQueryOptions<RoadmapViewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<RoadmapViewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<RoadmapViewQuery, TError, TData>(
      {
    queryKey: ['RoadmapView', variables],
    queryFn: useFetchData<RoadmapViewQuery, RoadmapViewQueryVariables>(RoadmapViewDocument).bind(null, variables),
    ...options
  }
    )};

useRoadmapViewQuery.getKey = (variables: RoadmapViewQueryVariables) => ['RoadmapView', variables];

export const useInfiniteRoadmapViewQuery = <
      TData = InfiniteData<RoadmapViewQuery>,
      TError = unknown
    >(
      variables: RoadmapViewQueryVariables,
      options: Omit<UseInfiniteQueryOptions<RoadmapViewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<RoadmapViewQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<RoadmapViewQuery, RoadmapViewQueryVariables>(RoadmapViewDocument)
    return useInfiniteQuery<RoadmapViewQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['RoadmapView.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteRoadmapViewQuery.getKey = (variables: RoadmapViewQueryVariables) => ['RoadmapView.infinite', variables];

export const RoadmapViewsBoardDocument = `
    query RoadmapViewsBoard($projectId: ID!) {
  project(id: $projectId) {
    name
    heading
    publicPageUrl
    roadmapEnabled
    roadmapMoveUpdatesEnabled
    roadmapWatchedStages
    secured
    categories {
      nodes {
        id
        name
        backgroundColor
        textColor
      }
    }
    projectUsers {
      edges {
        node {
          id
          displayName
          initials
          avatarColor
          avatarImage {
            ...UploadFieldImage
          }
        }
      }
    }
    projectViews {
      edges {
        node {
          id
          name
          security
        }
      }
    }
    stages {
      edges {
        node {
          id
          name
          description
          position
          published
          restricted
          cards: workItems {
            nodes {
              id
              laneId: stageId
              name
              position
              categories {
                id
                name
                backgroundColor
                textColor
              }
              owner {
                id
                displayName
                initials
                avatarColor
                avatarImage {
                  ...UploadFieldImage
                }
              }
              members {
                id
                displayName
                initials
                avatarColor
                avatarImage {
                  ...UploadFieldImage
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useRoadmapViewsBoardQuery = <
      TData = RoadmapViewsBoardQuery,
      TError = unknown
    >(
      variables: RoadmapViewsBoardQueryVariables,
      options?: Omit<UseQueryOptions<RoadmapViewsBoardQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<RoadmapViewsBoardQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<RoadmapViewsBoardQuery, TError, TData>(
      {
    queryKey: ['RoadmapViewsBoard', variables],
    queryFn: useFetchData<RoadmapViewsBoardQuery, RoadmapViewsBoardQueryVariables>(RoadmapViewsBoardDocument).bind(null, variables),
    ...options
  }
    )};

useRoadmapViewsBoardQuery.getKey = (variables: RoadmapViewsBoardQueryVariables) => ['RoadmapViewsBoard', variables];

export const useInfiniteRoadmapViewsBoardQuery = <
      TData = InfiniteData<RoadmapViewsBoardQuery>,
      TError = unknown
    >(
      variables: RoadmapViewsBoardQueryVariables,
      options: Omit<UseInfiniteQueryOptions<RoadmapViewsBoardQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<RoadmapViewsBoardQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<RoadmapViewsBoardQuery, RoadmapViewsBoardQueryVariables>(RoadmapViewsBoardDocument)
    return useInfiniteQuery<RoadmapViewsBoardQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['RoadmapViewsBoard.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteRoadmapViewsBoardQuery.getKey = (variables: RoadmapViewsBoardQueryVariables) => ['RoadmapViewsBoard.infinite', variables];

export const ArchivedWorkItemsDocument = `
    query ArchivedWorkItems($projectId: ID!, $count: Int = 10, $cursor: String) {
  project(id: $projectId) {
    archivedWorkItemsCount: workItems(archived: true) {
      totalCount
    }
    archivedWorkItems: workItems(archived: true, first: $count, after: $cursor) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
          deactivatedAt
          stage {
            id
            name
          }
          feedbacks {
            totalCount
          }
          projectSubscriptions {
            totalCount
          }
        }
      }
    }
  }
}
    `;

export const useArchivedWorkItemsQuery = <
      TData = ArchivedWorkItemsQuery,
      TError = unknown
    >(
      variables: ArchivedWorkItemsQueryVariables,
      options?: Omit<UseQueryOptions<ArchivedWorkItemsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ArchivedWorkItemsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ArchivedWorkItemsQuery, TError, TData>(
      {
    queryKey: ['ArchivedWorkItems', variables],
    queryFn: useFetchData<ArchivedWorkItemsQuery, ArchivedWorkItemsQueryVariables>(ArchivedWorkItemsDocument).bind(null, variables),
    ...options
  }
    )};

useArchivedWorkItemsQuery.getKey = (variables: ArchivedWorkItemsQueryVariables) => ['ArchivedWorkItems', variables];

export const useInfiniteArchivedWorkItemsQuery = <
      TData = InfiniteData<ArchivedWorkItemsQuery>,
      TError = unknown
    >(
      variables: ArchivedWorkItemsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ArchivedWorkItemsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ArchivedWorkItemsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ArchivedWorkItemsQuery, ArchivedWorkItemsQueryVariables>(ArchivedWorkItemsDocument)
    return useInfiniteQuery<ArchivedWorkItemsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ArchivedWorkItems.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteArchivedWorkItemsQuery.getKey = (variables: ArchivedWorkItemsQueryVariables) => ['ArchivedWorkItems.infinite', variables];

export const ImportSubscribersDocument = `
    mutation ImportSubscribers($projectId: ID!, $subscribers: [BatchSubscriber!]!) {
  createBatchEmailSubscriptions(
    input: {projectId: $projectId, subscribers: $subscribers}
  ) {
    status
    errors {
      path
      message
    }
  }
}
    `;

export const useImportSubscribersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ImportSubscribersMutation, TError, ImportSubscribersMutationVariables, TContext>) => {
    
    return useMutation<ImportSubscribersMutation, TError, ImportSubscribersMutationVariables, TContext>(
      {
    mutationKey: ['ImportSubscribers'],
    mutationFn: useFetchData<ImportSubscribersMutation, ImportSubscribersMutationVariables>(ImportSubscribersDocument),
    ...options
  }
    )};

useImportSubscribersMutation.getKey = () => ['ImportSubscribers'];

export const RemoveSubscribersDocument = `
    mutation removeSubscribers($subscriberIds: [ID!]!, $projectId: ID!) {
  removeProjectSubscribers(
    input: {subscriberIds: $subscriberIds, projectId: $projectId}
  ) {
    subscriberIds
  }
}
    `;

export const useRemoveSubscribersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveSubscribersMutation, TError, RemoveSubscribersMutationVariables, TContext>) => {
    
    return useMutation<RemoveSubscribersMutation, TError, RemoveSubscribersMutationVariables, TContext>(
      {
    mutationKey: ['removeSubscribers'],
    mutationFn: useFetchData<RemoveSubscribersMutation, RemoveSubscribersMutationVariables>(RemoveSubscribersDocument),
    ...options
  }
    )};

useRemoveSubscribersMutation.getKey = () => ['removeSubscribers'];

export const SubscribersIndexDocument = `
    query subscribersIndex($projectId: ID!, $where: Where, $orderBy: OrderBy, $first: Int, $after: String, $before: String, $status: [SubscriptionStatus!], $cohortId: ID) {
  project(id: $projectId) {
    name
    cohorts {
      nodes {
        id
        name
      }
    }
    allSubscribers: subscribers {
      totalCount
    }
    subscribers(
      where: $where
      orderBy: $orderBy
      first: $first
      after: $after
      before: $before
      status: $status
      cohortId: $cohortId
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        categories {
          id
          name
          backgroundColor
          textColor
        }
        hasMailTransport
        hasSlackTransport
        audienceDomainId
        audienceDomainHostname
        status
        node {
          id
          initials
          avatarColor
          email
          createdAt
          confirmedAt
          isProjectSubscriber
        }
      }
    }
  }
}
    `;

export const useSubscribersIndexQuery = <
      TData = SubscribersIndexQuery,
      TError = unknown
    >(
      variables: SubscribersIndexQueryVariables,
      options?: Omit<UseQueryOptions<SubscribersIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SubscribersIndexQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SubscribersIndexQuery, TError, TData>(
      {
    queryKey: ['subscribersIndex', variables],
    queryFn: useFetchData<SubscribersIndexQuery, SubscribersIndexQueryVariables>(SubscribersIndexDocument).bind(null, variables),
    ...options
  }
    )};

useSubscribersIndexQuery.getKey = (variables: SubscribersIndexQueryVariables) => ['subscribersIndex', variables];

export const useInfiniteSubscribersIndexQuery = <
      TData = InfiniteData<SubscribersIndexQuery>,
      TError = unknown
    >(
      variables: SubscribersIndexQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SubscribersIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SubscribersIndexQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SubscribersIndexQuery, SubscribersIndexQueryVariables>(SubscribersIndexDocument)
    return useInfiniteQuery<SubscribersIndexQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['subscribersIndex.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSubscribersIndexQuery.getKey = (variables: SubscribersIndexQueryVariables) => ['subscribersIndex.infinite', variables];

export const ExportSubscribersDocument = `
    query exportSubscribers($projectId: ID!) {
  project(id: $projectId) {
    exportSubscribers {
      edges {
        categories {
          id
          name
          backgroundColor
          textColor
        }
        hasMailTransport
        hasSlackTransport
        status
        node {
          id
          email
          createdAt
          confirmedAt
        }
      }
    }
  }
}
    `;

export const useExportSubscribersQuery = <
      TData = ExportSubscribersQuery,
      TError = unknown
    >(
      variables: ExportSubscribersQueryVariables,
      options?: Omit<UseQueryOptions<ExportSubscribersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ExportSubscribersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ExportSubscribersQuery, TError, TData>(
      {
    queryKey: ['exportSubscribers', variables],
    queryFn: useFetchData<ExportSubscribersQuery, ExportSubscribersQueryVariables>(ExportSubscribersDocument).bind(null, variables),
    ...options
  }
    )};

useExportSubscribersQuery.getKey = (variables: ExportSubscribersQueryVariables) => ['exportSubscribers', variables];

export const useInfiniteExportSubscribersQuery = <
      TData = InfiniteData<ExportSubscribersQuery>,
      TError = unknown
    >(
      variables: ExportSubscribersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ExportSubscribersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ExportSubscribersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ExportSubscribersQuery, ExportSubscribersQueryVariables>(ExportSubscribersDocument)
    return useInfiniteQuery<ExportSubscribersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['exportSubscribers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteExportSubscribersQuery.getKey = (variables: ExportSubscribersQueryVariables) => ['exportSubscribers.infinite', variables];

export const SubscriberIndexStatsDocument = `
    query subscriberIndexStats($projectId: ID!) {
  project(id: $projectId) {
    newSubscriptionsThisMonth
    totalConfirmedSubscriptions
  }
}
    `;

export const useSubscriberIndexStatsQuery = <
      TData = SubscriberIndexStatsQuery,
      TError = unknown
    >(
      variables: SubscriberIndexStatsQueryVariables,
      options?: Omit<UseQueryOptions<SubscriberIndexStatsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SubscriberIndexStatsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SubscriberIndexStatsQuery, TError, TData>(
      {
    queryKey: ['subscriberIndexStats', variables],
    queryFn: useFetchData<SubscriberIndexStatsQuery, SubscriberIndexStatsQueryVariables>(SubscriberIndexStatsDocument).bind(null, variables),
    ...options
  }
    )};

useSubscriberIndexStatsQuery.getKey = (variables: SubscriberIndexStatsQueryVariables) => ['subscriberIndexStats', variables];

export const useInfiniteSubscriberIndexStatsQuery = <
      TData = InfiniteData<SubscriberIndexStatsQuery>,
      TError = unknown
    >(
      variables: SubscriberIndexStatsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SubscriberIndexStatsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SubscriberIndexStatsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SubscriberIndexStatsQuery, SubscriberIndexStatsQueryVariables>(SubscriberIndexStatsDocument)
    return useInfiniteQuery<SubscriberIndexStatsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['subscriberIndexStats.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSubscriberIndexStatsQuery.getKey = (variables: SubscriberIndexStatsQueryVariables) => ['subscriberIndexStats.infinite', variables];

export const ConfirmSubscribersDocument = `
    mutation confirmSubscribers($projectId: ID!, $subscriberIds: [ID!]!) {
  confirmSubscribers(
    input: {projectId: $projectId, subscriberIds: $subscriberIds}
  ) {
    errors {
      message
      path
    }
  }
}
    `;

export const useConfirmSubscribersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ConfirmSubscribersMutation, TError, ConfirmSubscribersMutationVariables, TContext>) => {
    
    return useMutation<ConfirmSubscribersMutation, TError, ConfirmSubscribersMutationVariables, TContext>(
      {
    mutationKey: ['confirmSubscribers'],
    mutationFn: useFetchData<ConfirmSubscribersMutation, ConfirmSubscribersMutationVariables>(ConfirmSubscribersDocument),
    ...options
  }
    )};

useConfirmSubscribersMutation.getKey = () => ['confirmSubscribers'];

export const UnsubscribeFromProjectDocument = `
    mutation unsubscribeFromProject($projectId: ID!, $subscriberIds: [ID!]!) {
  unsubscribeFromProject(
    input: {projectId: $projectId, subscriberIds: $subscriberIds}
  ) {
    errors {
      message
      path
    }
  }
}
    `;

export const useUnsubscribeFromProjectMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnsubscribeFromProjectMutation, TError, UnsubscribeFromProjectMutationVariables, TContext>) => {
    
    return useMutation<UnsubscribeFromProjectMutation, TError, UnsubscribeFromProjectMutationVariables, TContext>(
      {
    mutationKey: ['unsubscribeFromProject'],
    mutationFn: useFetchData<UnsubscribeFromProjectMutation, UnsubscribeFromProjectMutationVariables>(UnsubscribeFromProjectDocument),
    ...options
  }
    )};

useUnsubscribeFromProjectMutation.getKey = () => ['unsubscribeFromProject'];

export const ResubscribeToProjectDocument = `
    mutation resubscribeToProject($projectId: ID!, $subscriberIds: [ID!]!) {
  resubscribeToProject(
    input: {projectId: $projectId, subscriberIds: $subscriberIds}
  ) {
    errors {
      message
      path
    }
  }
}
    `;

export const useResubscribeToProjectMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResubscribeToProjectMutation, TError, ResubscribeToProjectMutationVariables, TContext>) => {
    
    return useMutation<ResubscribeToProjectMutation, TError, ResubscribeToProjectMutationVariables, TContext>(
      {
    mutationKey: ['resubscribeToProject'],
    mutationFn: useFetchData<ResubscribeToProjectMutation, ResubscribeToProjectMutationVariables>(ResubscribeToProjectDocument),
    ...options
  }
    )};

useResubscribeToProjectMutation.getKey = () => ['resubscribeToProject'];

export const AllProjectViewsDocument = `
    query AllProjectViews($projectId: ID!) {
  project(id: $projectId) {
    name
    heading
    publicPageUrl
    secured
    restricted
    editable
    projectViews(archived: false) {
      edges {
        node {
          ...ProjectViewItem
        }
      }
    }
  }
}
    ${ProjectViewItemFragmentDoc}`;

export const useAllProjectViewsQuery = <
      TData = AllProjectViewsQuery,
      TError = unknown
    >(
      variables: AllProjectViewsQueryVariables,
      options?: Omit<UseQueryOptions<AllProjectViewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AllProjectViewsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AllProjectViewsQuery, TError, TData>(
      {
    queryKey: ['AllProjectViews', variables],
    queryFn: useFetchData<AllProjectViewsQuery, AllProjectViewsQueryVariables>(AllProjectViewsDocument).bind(null, variables),
    ...options
  }
    )};

useAllProjectViewsQuery.getKey = (variables: AllProjectViewsQueryVariables) => ['AllProjectViews', variables];

export const useInfiniteAllProjectViewsQuery = <
      TData = InfiniteData<AllProjectViewsQuery>,
      TError = unknown
    >(
      variables: AllProjectViewsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AllProjectViewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AllProjectViewsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<AllProjectViewsQuery, AllProjectViewsQueryVariables>(AllProjectViewsDocument)
    return useInfiniteQuery<AllProjectViewsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AllProjectViews.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteAllProjectViewsQuery.getKey = (variables: AllProjectViewsQueryVariables) => ['AllProjectViews.infinite', variables];

export const ArchiveProjectViewDocument = `
    mutation ArchiveProjectView($input: DeactivateProjectViewInput!) {
  deactivateProjectView(input: $input) {
    projectView {
      id
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useArchiveProjectViewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ArchiveProjectViewMutation, TError, ArchiveProjectViewMutationVariables, TContext>) => {
    
    return useMutation<ArchiveProjectViewMutation, TError, ArchiveProjectViewMutationVariables, TContext>(
      {
    mutationKey: ['ArchiveProjectView'],
    mutationFn: useFetchData<ArchiveProjectViewMutation, ArchiveProjectViewMutationVariables>(ArchiveProjectViewDocument),
    ...options
  }
    )};

useArchiveProjectViewMutation.getKey = () => ['ArchiveProjectView'];

export const ArchivedProjectViewsDocument = `
    query ArchivedProjectViews($projectId: ID!) {
  project(id: $projectId) {
    projectViews(archived: true) {
      edges {
        node {
          ...ProjectViewItem
        }
      }
    }
  }
}
    ${ProjectViewItemFragmentDoc}`;

export const useArchivedProjectViewsQuery = <
      TData = ArchivedProjectViewsQuery,
      TError = unknown
    >(
      variables: ArchivedProjectViewsQueryVariables,
      options?: Omit<UseQueryOptions<ArchivedProjectViewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ArchivedProjectViewsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ArchivedProjectViewsQuery, TError, TData>(
      {
    queryKey: ['ArchivedProjectViews', variables],
    queryFn: useFetchData<ArchivedProjectViewsQuery, ArchivedProjectViewsQueryVariables>(ArchivedProjectViewsDocument).bind(null, variables),
    ...options
  }
    )};

useArchivedProjectViewsQuery.getKey = (variables: ArchivedProjectViewsQueryVariables) => ['ArchivedProjectViews', variables];

export const useInfiniteArchivedProjectViewsQuery = <
      TData = InfiniteData<ArchivedProjectViewsQuery>,
      TError = unknown
    >(
      variables: ArchivedProjectViewsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ArchivedProjectViewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ArchivedProjectViewsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ArchivedProjectViewsQuery, ArchivedProjectViewsQueryVariables>(ArchivedProjectViewsDocument)
    return useInfiniteQuery<ArchivedProjectViewsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ArchivedProjectViews.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteArchivedProjectViewsQuery.getKey = (variables: ArchivedProjectViewsQueryVariables) => ['ArchivedProjectViews.infinite', variables];

export const DuplicateProjectViewDocument = `
    mutation DuplicateProjectView($id: ID!) {
  duplicateProjectView(input: {id: $id}) {
    projectView {
      id
    }
  }
}
    `;

export const useDuplicateProjectViewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DuplicateProjectViewMutation, TError, DuplicateProjectViewMutationVariables, TContext>) => {
    
    return useMutation<DuplicateProjectViewMutation, TError, DuplicateProjectViewMutationVariables, TContext>(
      {
    mutationKey: ['DuplicateProjectView'],
    mutationFn: useFetchData<DuplicateProjectViewMutation, DuplicateProjectViewMutationVariables>(DuplicateProjectViewDocument),
    ...options
  }
    )};

useDuplicateProjectViewMutation.getKey = () => ['DuplicateProjectView'];

export const ShowDefaultProjectViewDocument = `
    query ShowDefaultProjectView($projectId: ID!) {
  project(id: $projectId) {
    id
    name
    heading
    subheading
    publicPageUrl
    secured
    roadmapEnabled
    ideasEnabled
    votingEnabled
    voteCountDisplay
    feedbackEnabled
    feedbackForwardEmails
    restricted
    editable
    published
    stages {
      edges {
        node {
          id
          name
          published
        }
      }
    }
    categories {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;

export const useShowDefaultProjectViewQuery = <
      TData = ShowDefaultProjectViewQuery,
      TError = unknown
    >(
      variables: ShowDefaultProjectViewQueryVariables,
      options?: Omit<UseQueryOptions<ShowDefaultProjectViewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ShowDefaultProjectViewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ShowDefaultProjectViewQuery, TError, TData>(
      {
    queryKey: ['ShowDefaultProjectView', variables],
    queryFn: useFetchData<ShowDefaultProjectViewQuery, ShowDefaultProjectViewQueryVariables>(ShowDefaultProjectViewDocument).bind(null, variables),
    ...options
  }
    )};

useShowDefaultProjectViewQuery.getKey = (variables: ShowDefaultProjectViewQueryVariables) => ['ShowDefaultProjectView', variables];

export const useInfiniteShowDefaultProjectViewQuery = <
      TData = InfiniteData<ShowDefaultProjectViewQuery>,
      TError = unknown
    >(
      variables: ShowDefaultProjectViewQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ShowDefaultProjectViewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ShowDefaultProjectViewQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ShowDefaultProjectViewQuery, ShowDefaultProjectViewQueryVariables>(ShowDefaultProjectViewDocument)
    return useInfiniteQuery<ShowDefaultProjectViewQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ShowDefaultProjectView.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteShowDefaultProjectViewQuery.getKey = (variables: ShowDefaultProjectViewQueryVariables) => ['ShowDefaultProjectView.infinite', variables];

export const ShowProjectViewDocument = `
    query ShowProjectView($projectId: ID!, $viewId: ID!) {
  project(id: $projectId) {
    publicPageUrl
    projectView(id: $viewId) {
      id
      archived
      archivedAt
      name
      description
      slug
      publicPermalink
      security
      restricted
      editable
      heading
      subheading
      stages {
        id
      }
      categories {
        id
      }
      audienceDomains {
        totalCount
      }
      owners {
        id
      }
      members {
        id
      }
      subscribers {
        totalCount
      }
    }
    stages {
      edges {
        node {
          id
          name
        }
      }
    }
    projectUsers {
      edges {
        node {
          id
          initials
          displayName
          avatarColor
          avatarImage {
            url
          }
        }
      }
    }
    categories {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;

export const useShowProjectViewQuery = <
      TData = ShowProjectViewQuery,
      TError = unknown
    >(
      variables: ShowProjectViewQueryVariables,
      options?: Omit<UseQueryOptions<ShowProjectViewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ShowProjectViewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ShowProjectViewQuery, TError, TData>(
      {
    queryKey: ['ShowProjectView', variables],
    queryFn: useFetchData<ShowProjectViewQuery, ShowProjectViewQueryVariables>(ShowProjectViewDocument).bind(null, variables),
    ...options
  }
    )};

useShowProjectViewQuery.getKey = (variables: ShowProjectViewQueryVariables) => ['ShowProjectView', variables];

export const useInfiniteShowProjectViewQuery = <
      TData = InfiniteData<ShowProjectViewQuery>,
      TError = unknown
    >(
      variables: ShowProjectViewQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ShowProjectViewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ShowProjectViewQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ShowProjectViewQuery, ShowProjectViewQueryVariables>(ShowProjectViewDocument)
    return useInfiniteQuery<ShowProjectViewQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ShowProjectView.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteShowProjectViewQuery.getKey = (variables: ShowProjectViewQueryVariables) => ['ShowProjectView.infinite', variables];

export const UnarchiveProjectViewDocument = `
    mutation UnarchiveProjectView($input: ActivateProjectViewInput!) {
  activateProjectView(input: $input) {
    projectView {
      id
      archived
    }
  }
}
    `;

export const useUnarchiveProjectViewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnarchiveProjectViewMutation, TError, UnarchiveProjectViewMutationVariables, TContext>) => {
    
    return useMutation<UnarchiveProjectViewMutation, TError, UnarchiveProjectViewMutationVariables, TContext>(
      {
    mutationKey: ['UnarchiveProjectView'],
    mutationFn: useFetchData<UnarchiveProjectViewMutation, UnarchiveProjectViewMutationVariables>(UnarchiveProjectViewDocument),
    ...options
  }
    )};

useUnarchiveProjectViewMutation.getKey = () => ['UnarchiveProjectView'];

export const UpdateProjectViewDocument = `
    mutation UpdateProjectView($input: UpdateProjectViewInput!) {
  updateProjectView(input: $input) {
    projectView {
      id
    }
    errors {
      message
      path
    }
  }
}
    `;

export const useUpdateProjectViewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProjectViewMutation, TError, UpdateProjectViewMutationVariables, TContext>) => {
    
    return useMutation<UpdateProjectViewMutation, TError, UpdateProjectViewMutationVariables, TContext>(
      {
    mutationKey: ['UpdateProjectView'],
    mutationFn: useFetchData<UpdateProjectViewMutation, UpdateProjectViewMutationVariables>(UpdateProjectViewDocument),
    ...options
  }
    )};

useUpdateProjectViewMutation.getKey = () => ['UpdateProjectView'];

export const CreateWebhookDocument = `
    mutation CreateWebhook($name: String!, $url: String!, $username: String, $password: String, $owner: ID!, $eventTypes: [ID!]!) {
  createOutboundWebhook(
    input: {ownerId: $owner, name: $name, url: $url, username: $username, password: $password, eventTypes: $eventTypes}
  ) {
    outboundWebhook {
      id
    }
  }
}
    `;

export const useCreateWebhookMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateWebhookMutation, TError, CreateWebhookMutationVariables, TContext>) => {
    
    return useMutation<CreateWebhookMutation, TError, CreateWebhookMutationVariables, TContext>(
      {
    mutationKey: ['CreateWebhook'],
    mutationFn: useFetchData<CreateWebhookMutation, CreateWebhookMutationVariables>(CreateWebhookDocument),
    ...options
  }
    )};

useCreateWebhookMutation.getKey = () => ['CreateWebhook'];

export const DeleteWebhookDocument = `
    mutation DeleteWebhook($webhookId: ID!) {
  deleteOutboundWebhook(input: {webhookId: $webhookId}) {
    success
  }
}
    `;

export const useDeleteWebhookMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteWebhookMutation, TError, DeleteWebhookMutationVariables, TContext>) => {
    
    return useMutation<DeleteWebhookMutation, TError, DeleteWebhookMutationVariables, TContext>(
      {
    mutationKey: ['DeleteWebhook'],
    mutationFn: useFetchData<DeleteWebhookMutation, DeleteWebhookMutationVariables>(DeleteWebhookDocument),
    ...options
  }
    )};

useDeleteWebhookMutation.getKey = () => ['DeleteWebhook'];

export const FetchEventTypesDocument = `
    query FetchEventTypes($projectId: ID!) {
  project(id: $projectId) {
    eventTypes {
      nodes {
        id
        name
      }
    }
  }
}
    `;

export const useFetchEventTypesQuery = <
      TData = FetchEventTypesQuery,
      TError = unknown
    >(
      variables: FetchEventTypesQueryVariables,
      options?: Omit<UseQueryOptions<FetchEventTypesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FetchEventTypesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FetchEventTypesQuery, TError, TData>(
      {
    queryKey: ['FetchEventTypes', variables],
    queryFn: useFetchData<FetchEventTypesQuery, FetchEventTypesQueryVariables>(FetchEventTypesDocument).bind(null, variables),
    ...options
  }
    )};

useFetchEventTypesQuery.getKey = (variables: FetchEventTypesQueryVariables) => ['FetchEventTypes', variables];

export const useInfiniteFetchEventTypesQuery = <
      TData = InfiniteData<FetchEventTypesQuery>,
      TError = unknown
    >(
      variables: FetchEventTypesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FetchEventTypesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FetchEventTypesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<FetchEventTypesQuery, FetchEventTypesQueryVariables>(FetchEventTypesDocument)
    return useInfiniteQuery<FetchEventTypesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FetchEventTypes.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteFetchEventTypesQuery.getKey = (variables: FetchEventTypesQueryVariables) => ['FetchEventTypes.infinite', variables];

export const FetchWebhookEventsDocument = `
    query FetchWebhookEvents($projectId: ID!, $webhookId: ID!, $count: Int!, $after: String) {
  project(id: $projectId) {
    outboundWebhooks(webhookIds: [$webhookId]) {
      events(first: $count, after: $after) {
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        nodes {
          id
          status
          payload
          createdAt
          eventType {
            id
            name
          }
        }
      }
    }
  }
}
    `;

export const useFetchWebhookEventsQuery = <
      TData = FetchWebhookEventsQuery,
      TError = unknown
    >(
      variables: FetchWebhookEventsQueryVariables,
      options?: Omit<UseQueryOptions<FetchWebhookEventsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FetchWebhookEventsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FetchWebhookEventsQuery, TError, TData>(
      {
    queryKey: ['FetchWebhookEvents', variables],
    queryFn: useFetchData<FetchWebhookEventsQuery, FetchWebhookEventsQueryVariables>(FetchWebhookEventsDocument).bind(null, variables),
    ...options
  }
    )};

useFetchWebhookEventsQuery.getKey = (variables: FetchWebhookEventsQueryVariables) => ['FetchWebhookEvents', variables];

export const useInfiniteFetchWebhookEventsQuery = <
      TData = InfiniteData<FetchWebhookEventsQuery>,
      TError = unknown
    >(
      variables: FetchWebhookEventsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FetchWebhookEventsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FetchWebhookEventsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<FetchWebhookEventsQuery, FetchWebhookEventsQueryVariables>(FetchWebhookEventsDocument)
    return useInfiniteQuery<FetchWebhookEventsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FetchWebhookEvents.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteFetchWebhookEventsQuery.getKey = (variables: FetchWebhookEventsQueryVariables) => ['FetchWebhookEvents.infinite', variables];

export const FetchWebhookInfoDocument = `
    query FetchWebhookInfo($projectId: ID!, $webhookId: ID!) {
  project(id: $projectId) {
    outboundWebhooks(webhookIds: [$webhookId]) {
      id
      name
      url
      status
      enabled
      username
      password
      managed
      owner {
        __typename
      }
      eventTypes {
        id
        name
      }
    }
  }
}
    `;

export const useFetchWebhookInfoQuery = <
      TData = FetchWebhookInfoQuery,
      TError = unknown
    >(
      variables: FetchWebhookInfoQueryVariables,
      options?: Omit<UseQueryOptions<FetchWebhookInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FetchWebhookInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FetchWebhookInfoQuery, TError, TData>(
      {
    queryKey: ['FetchWebhookInfo', variables],
    queryFn: useFetchData<FetchWebhookInfoQuery, FetchWebhookInfoQueryVariables>(FetchWebhookInfoDocument).bind(null, variables),
    ...options
  }
    )};

useFetchWebhookInfoQuery.getKey = (variables: FetchWebhookInfoQueryVariables) => ['FetchWebhookInfo', variables];

export const useInfiniteFetchWebhookInfoQuery = <
      TData = InfiniteData<FetchWebhookInfoQuery>,
      TError = unknown
    >(
      variables: FetchWebhookInfoQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FetchWebhookInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FetchWebhookInfoQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<FetchWebhookInfoQuery, FetchWebhookInfoQueryVariables>(FetchWebhookInfoDocument)
    return useInfiniteQuery<FetchWebhookInfoQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FetchWebhookInfo.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteFetchWebhookInfoQuery.getKey = (variables: FetchWebhookInfoQueryVariables) => ['FetchWebhookInfo.infinite', variables];

export const FetchWebhooksListDocument = `
    query FetchWebhooksList($projectId: ID!) {
  project(id: $projectId) {
    outboundWebhooks {
      id
      name
      url
      enabled
      status
      eventTypes {
        name
      }
      owner {
        __typename
        ... on Project {
          name
        }
        ... on Organization {
          organizationName: name
        }
      }
    }
  }
}
    `;

export const useFetchWebhooksListQuery = <
      TData = FetchWebhooksListQuery,
      TError = unknown
    >(
      variables: FetchWebhooksListQueryVariables,
      options?: Omit<UseQueryOptions<FetchWebhooksListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FetchWebhooksListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FetchWebhooksListQuery, TError, TData>(
      {
    queryKey: ['FetchWebhooksList', variables],
    queryFn: useFetchData<FetchWebhooksListQuery, FetchWebhooksListQueryVariables>(FetchWebhooksListDocument).bind(null, variables),
    ...options
  }
    )};

useFetchWebhooksListQuery.getKey = (variables: FetchWebhooksListQueryVariables) => ['FetchWebhooksList', variables];

export const useInfiniteFetchWebhooksListQuery = <
      TData = InfiniteData<FetchWebhooksListQuery>,
      TError = unknown
    >(
      variables: FetchWebhooksListQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FetchWebhooksListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FetchWebhooksListQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<FetchWebhooksListQuery, FetchWebhooksListQueryVariables>(FetchWebhooksListDocument)
    return useInfiniteQuery<FetchWebhooksListQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FetchWebhooksList.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteFetchWebhooksListQuery.getKey = (variables: FetchWebhooksListQueryVariables) => ['FetchWebhooksList.infinite', variables];

export const RetryWebhookEventDocument = `
    mutation RetryWebhookEvent($webhookEventId: ID!) {
  retryWebhookEvent(input: {webhookEventId: $webhookEventId}) {
    success
  }
}
    `;

export const useRetryWebhookEventMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RetryWebhookEventMutation, TError, RetryWebhookEventMutationVariables, TContext>) => {
    
    return useMutation<RetryWebhookEventMutation, TError, RetryWebhookEventMutationVariables, TContext>(
      {
    mutationKey: ['RetryWebhookEvent'],
    mutationFn: useFetchData<RetryWebhookEventMutation, RetryWebhookEventMutationVariables>(RetryWebhookEventDocument),
    ...options
  }
    )};

useRetryWebhookEventMutation.getKey = () => ['RetryWebhookEvent'];

export const SendWebhookTestEventDocument = `
    mutation SendWebhookTestEvent($webhookId: ID!, $content: String!) {
  sendWebhookTestEvent(input: {webhookId: $webhookId, content: $content}) {
    success
  }
}
    `;

export const useSendWebhookTestEventMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendWebhookTestEventMutation, TError, SendWebhookTestEventMutationVariables, TContext>) => {
    
    return useMutation<SendWebhookTestEventMutation, TError, SendWebhookTestEventMutationVariables, TContext>(
      {
    mutationKey: ['SendWebhookTestEvent'],
    mutationFn: useFetchData<SendWebhookTestEventMutation, SendWebhookTestEventMutationVariables>(SendWebhookTestEventDocument),
    ...options
  }
    )};

useSendWebhookTestEventMutation.getKey = () => ['SendWebhookTestEvent'];

export const ToggleWebhookEnabledDocument = `
    mutation ToggleWebhookEnabled($webhookId: ID!, $enabled: Boolean!) {
  toggleOutboundWebhookEnabled(
    input: {outboundWebhookId: $webhookId, enabled: $enabled}
  ) {
    success
  }
}
    `;

export const useToggleWebhookEnabledMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ToggleWebhookEnabledMutation, TError, ToggleWebhookEnabledMutationVariables, TContext>) => {
    
    return useMutation<ToggleWebhookEnabledMutation, TError, ToggleWebhookEnabledMutationVariables, TContext>(
      {
    mutationKey: ['ToggleWebhookEnabled'],
    mutationFn: useFetchData<ToggleWebhookEnabledMutation, ToggleWebhookEnabledMutationVariables>(ToggleWebhookEnabledDocument),
    ...options
  }
    )};

useToggleWebhookEnabledMutation.getKey = () => ['ToggleWebhookEnabled'];

export const UpdateWebhookDocument = `
    mutation UpdateWebhook($webhookId: ID!, $name: String!, $url: String!, $username: String, $password: String, $enabled: Boolean!, $eventTypes: [ID!]!) {
  updateOutboundWebhook(
    input: {webhookId: $webhookId, name: $name, url: $url, username: $username, password: $password, enabled: $enabled, eventTypes: $eventTypes}
  ) {
    success
  }
}
    `;

export const useUpdateWebhookMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateWebhookMutation, TError, UpdateWebhookMutationVariables, TContext>) => {
    
    return useMutation<UpdateWebhookMutation, TError, UpdateWebhookMutationVariables, TContext>(
      {
    mutationKey: ['UpdateWebhook'],
    mutationFn: useFetchData<UpdateWebhookMutation, UpdateWebhookMutationVariables>(UpdateWebhookDocument),
    ...options
  }
    )};

useUpdateWebhookMutation.getKey = () => ['UpdateWebhook'];

export const VerifyWebhookDocument = `
    mutation VerifyWebhook($webhookId: ID!) {
  verifyOutboundWebhook(input: {outboundWebhookId: $webhookId}) {
    success
  }
}
    `;

export const useVerifyWebhookMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<VerifyWebhookMutation, TError, VerifyWebhookMutationVariables, TContext>) => {
    
    return useMutation<VerifyWebhookMutation, TError, VerifyWebhookMutationVariables, TContext>(
      {
    mutationKey: ['VerifyWebhook'],
    mutationFn: useFetchData<VerifyWebhookMutation, VerifyWebhookMutationVariables>(VerifyWebhookDocument),
    ...options
  }
    )};

useVerifyWebhookMutation.getKey = () => ['VerifyWebhook'];

export const CopyWorkItemToProjectDocument = `
    mutation CopyWorkItemToProject($input: CopyToProjectInput!) {
  copyWorkItemToProject(input: $input) {
    workItem {
      id
      name
    }
    targetProject {
      id
      name
    }
    targetStage {
      id
      name
    }
    errors {
      message
    }
  }
}
    `;

export const useCopyWorkItemToProjectMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CopyWorkItemToProjectMutation, TError, CopyWorkItemToProjectMutationVariables, TContext>) => {
    
    return useMutation<CopyWorkItemToProjectMutation, TError, CopyWorkItemToProjectMutationVariables, TContext>(
      {
    mutationKey: ['CopyWorkItemToProject'],
    mutationFn: useFetchData<CopyWorkItemToProjectMutation, CopyWorkItemToProjectMutationVariables>(CopyWorkItemToProjectDocument),
    ...options
  }
    )};

useCopyWorkItemToProjectMutation.getKey = () => ['CopyWorkItemToProject'];

export const CreateRoadmapUpdateDocument = `
    mutation CreateRoadmapUpdate($title: String!, $content: String!, $workItemId: ID!, $newStageId: ID) {
  createRoadmapUpdate(
    input: {roadmapUpdate: {title: $title, content: $content, workItemId: $workItemId, newStageId: $newStageId}}
  ) {
    roadmapUpdate {
      id
    }
  }
}
    `;

export const useCreateRoadmapUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateRoadmapUpdateMutation, TError, CreateRoadmapUpdateMutationVariables, TContext>) => {
    
    return useMutation<CreateRoadmapUpdateMutation, TError, CreateRoadmapUpdateMutationVariables, TContext>(
      {
    mutationKey: ['CreateRoadmapUpdate'],
    mutationFn: useFetchData<CreateRoadmapUpdateMutation, CreateRoadmapUpdateMutationVariables>(CreateRoadmapUpdateDocument),
    ...options
  }
    )};

useCreateRoadmapUpdateMutation.getKey = () => ['CreateRoadmapUpdate'];

export const CreateWorkItemMovedDocument = `
    mutation CreateWorkItemMoved($workItemId: ID!) {
  createWorkItemMovedUpdate(input: {workItemId: $workItemId}) {
    success
  }
}
    `;

export const useCreateWorkItemMovedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateWorkItemMovedMutation, TError, CreateWorkItemMovedMutationVariables, TContext>) => {
    
    return useMutation<CreateWorkItemMovedMutation, TError, CreateWorkItemMovedMutationVariables, TContext>(
      {
    mutationKey: ['CreateWorkItemMoved'],
    mutationFn: useFetchData<CreateWorkItemMovedMutation, CreateWorkItemMovedMutationVariables>(CreateWorkItemMovedDocument),
    ...options
  }
    )};

useCreateWorkItemMovedMutation.getKey = () => ['CreateWorkItemMoved'];

export const EditorWorkItemDocument = `
    query EditorWorkItem($workItemId: ID!, $projectId: ID!) {
  project(id: $projectId) {
    id
    stages {
      edges {
        cursor
        node {
          id
          name
          published
          restricted
        }
      }
    }
    projectUsers {
      edges {
        node {
          id
          displayName
          initials
          avatarColor
          avatarImage {
            ...UploadFieldImage
          }
        }
      }
    }
    fiscalYearOffset
  }
  workItem(id: $workItemId) {
    id
    name
    publishedAt
    content
    contentType
    stageId
    projectedAt
    projectedAtFormat
    heroImage {
      ...UploadFieldImage
    }
    categories {
      id
      name
      backgroundColor
      textColor
    }
    changeTypes {
      nodes {
        id
        name
        color
      }
    }
    stage {
      published
      restricted
    }
    owner {
      id
      displayName
      initials
      avatarColor
      avatarImage {
        ...UploadFieldImage
      }
    }
    members {
      id
      displayName
      initials
      avatarColor
      avatarImage {
        ...UploadFieldImage
      }
    }
    externalContentLinks {
      id
      url
      title
      imageUrl
    }
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useEditorWorkItemQuery = <
      TData = EditorWorkItemQuery,
      TError = unknown
    >(
      variables: EditorWorkItemQueryVariables,
      options?: Omit<UseQueryOptions<EditorWorkItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<EditorWorkItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<EditorWorkItemQuery, TError, TData>(
      {
    queryKey: ['EditorWorkItem', variables],
    queryFn: useFetchData<EditorWorkItemQuery, EditorWorkItemQueryVariables>(EditorWorkItemDocument).bind(null, variables),
    ...options
  }
    )};

useEditorWorkItemQuery.getKey = (variables: EditorWorkItemQueryVariables) => ['EditorWorkItem', variables];

export const useInfiniteEditorWorkItemQuery = <
      TData = InfiniteData<EditorWorkItemQuery>,
      TError = unknown
    >(
      variables: EditorWorkItemQueryVariables,
      options: Omit<UseInfiniteQueryOptions<EditorWorkItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<EditorWorkItemQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<EditorWorkItemQuery, EditorWorkItemQueryVariables>(EditorWorkItemDocument)
    return useInfiniteQuery<EditorWorkItemQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['EditorWorkItem.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteEditorWorkItemQuery.getKey = (variables: EditorWorkItemQueryVariables) => ['EditorWorkItem.infinite', variables];

export const FeedbackDocument = `
    query Feedback($projectId: ID!, $feedbackableIds: [String!], $count: Int!, $after: String, $archived: Boolean, $organizedState: String, $reaction: Reaction, $importance: Importance, $starred: Boolean, $searchTerm: String, $where: Where) {
  project(id: $projectId) {
    feedbacks(
      first: $count
      after: $after
      archived: $archived
      organizedState: $organizedState
      reaction: $reaction
      importance: $importance
      starred: $starred
      searchTerm: $searchTerm
      where: $where
      feedbackableIds: $feedbackableIds
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          id
          archived
          createdAt
          content
          notes
          reaction
          importance
          affectedCustomerEmail
          affectedCustomer {
            id
            email
            initials
            isProjectSubscriber
          }
          reporter {
            id
            name
            email
          }
          feedbackable {
            id
            archived
            name
            privatePermalink
            __typename
          }
        }
      }
    }
  }
}
    `;

export const useFeedbackQuery = <
      TData = FeedbackQuery,
      TError = unknown
    >(
      variables: FeedbackQueryVariables,
      options?: Omit<UseQueryOptions<FeedbackQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FeedbackQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FeedbackQuery, TError, TData>(
      {
    queryKey: ['Feedback', variables],
    queryFn: useFetchData<FeedbackQuery, FeedbackQueryVariables>(FeedbackDocument).bind(null, variables),
    ...options
  }
    )};

useFeedbackQuery.getKey = (variables: FeedbackQueryVariables) => ['Feedback', variables];

export const useInfiniteFeedbackQuery = <
      TData = InfiniteData<FeedbackQuery>,
      TError = unknown
    >(
      variables: FeedbackQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FeedbackQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FeedbackQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<FeedbackQuery, FeedbackQueryVariables>(FeedbackDocument)
    return useInfiniteQuery<FeedbackQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Feedback.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteFeedbackQuery.getKey = (variables: FeedbackQueryVariables) => ['Feedback.infinite', variables];

export const GetAllProjectsDocument = `
    query GetAllProjects {
  viewer {
    projects {
      nodes {
        id
        name
      }
    }
  }
}
    `;

export const useGetAllProjectsQuery = <
      TData = GetAllProjectsQuery,
      TError = unknown
    >(
      variables?: GetAllProjectsQueryVariables,
      options?: Omit<UseQueryOptions<GetAllProjectsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllProjectsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAllProjectsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAllProjects'] : ['GetAllProjects', variables],
    queryFn: useFetchData<GetAllProjectsQuery, GetAllProjectsQueryVariables>(GetAllProjectsDocument).bind(null, variables),
    ...options
  }
    )};

useGetAllProjectsQuery.getKey = (variables?: GetAllProjectsQueryVariables) => variables === undefined ? ['GetAllProjects'] : ['GetAllProjects', variables];

export const useInfiniteGetAllProjectsQuery = <
      TData = InfiniteData<GetAllProjectsQuery>,
      TError = unknown
    >(
      variables: GetAllProjectsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAllProjectsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAllProjectsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<GetAllProjectsQuery, GetAllProjectsQueryVariables>(GetAllProjectsDocument)
    return useInfiniteQuery<GetAllProjectsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetAllProjects.infinite'] : ['GetAllProjects.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAllProjectsQuery.getKey = (variables?: GetAllProjectsQueryVariables) => variables === undefined ? ['GetAllProjects.infinite'] : ['GetAllProjects.infinite', variables];

export const WorkItemMemberCountsDocument = `
    query WorkItemMemberCounts($workItemId: ID!) {
  workItem(id: $workItemId) {
    members {
      id
    }
    owner {
      id
    }
    projectSubscriptions {
      totalCount
    }
  }
}
    `;

export const useWorkItemMemberCountsQuery = <
      TData = WorkItemMemberCountsQuery,
      TError = unknown
    >(
      variables: WorkItemMemberCountsQueryVariables,
      options?: Omit<UseQueryOptions<WorkItemMemberCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<WorkItemMemberCountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<WorkItemMemberCountsQuery, TError, TData>(
      {
    queryKey: ['WorkItemMemberCounts', variables],
    queryFn: useFetchData<WorkItemMemberCountsQuery, WorkItemMemberCountsQueryVariables>(WorkItemMemberCountsDocument).bind(null, variables),
    ...options
  }
    )};

useWorkItemMemberCountsQuery.getKey = (variables: WorkItemMemberCountsQueryVariables) => ['WorkItemMemberCounts', variables];

export const useInfiniteWorkItemMemberCountsQuery = <
      TData = InfiniteData<WorkItemMemberCountsQuery>,
      TError = unknown
    >(
      variables: WorkItemMemberCountsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<WorkItemMemberCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<WorkItemMemberCountsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<WorkItemMemberCountsQuery, WorkItemMemberCountsQueryVariables>(WorkItemMemberCountsDocument)
    return useInfiniteQuery<WorkItemMemberCountsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['WorkItemMemberCounts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteWorkItemMemberCountsQuery.getKey = (variables: WorkItemMemberCountsQueryVariables) => ['WorkItemMemberCounts.infinite', variables];

export const ProjectStagesDocument = `
    query ProjectStages($projectId: ID!) {
  project(id: $projectId) {
    id
    stages {
      nodes {
        id
        name
        description
        published
      }
    }
  }
}
    `;

export const useProjectStagesQuery = <
      TData = ProjectStagesQuery,
      TError = unknown
    >(
      variables: ProjectStagesQueryVariables,
      options?: Omit<UseQueryOptions<ProjectStagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProjectStagesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProjectStagesQuery, TError, TData>(
      {
    queryKey: ['ProjectStages', variables],
    queryFn: useFetchData<ProjectStagesQuery, ProjectStagesQueryVariables>(ProjectStagesDocument).bind(null, variables),
    ...options
  }
    )};

useProjectStagesQuery.getKey = (variables: ProjectStagesQueryVariables) => ['ProjectStages', variables];

export const useInfiniteProjectStagesQuery = <
      TData = InfiniteData<ProjectStagesQuery>,
      TError = unknown
    >(
      variables: ProjectStagesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProjectStagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProjectStagesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ProjectStagesQuery, ProjectStagesQueryVariables>(ProjectStagesDocument)
    return useInfiniteQuery<ProjectStagesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProjectStages.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteProjectStagesQuery.getKey = (variables: ProjectStagesQueryVariables) => ['ProjectStages.infinite', variables];

export const RemoveHeroImageDocument = `
    mutation RemoveHeroImage($workItemId: ID!, $attachment: WorkItemHeroImage!) {
  removeWorkItemHeroImage(input: {attachment: $attachment, id: $workItemId}) {
    workItem {
      id
      heroImage {
        ...UploadFieldImage
      }
    }
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useRemoveHeroImageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveHeroImageMutation, TError, RemoveHeroImageMutationVariables, TContext>) => {
    
    return useMutation<RemoveHeroImageMutation, TError, RemoveHeroImageMutationVariables, TContext>(
      {
    mutationKey: ['RemoveHeroImage'],
    mutationFn: useFetchData<RemoveHeroImageMutation, RemoveHeroImageMutationVariables>(RemoveHeroImageDocument),
    ...options
  }
    )};

useRemoveHeroImageMutation.getKey = () => ['RemoveHeroImage'];

export const RemoveOwnerDocument = `
    mutation RemoveOwner($workItemId: ID!) {
  removeWorkItemOwner(input: {id: $workItemId}) {
    workItem {
      id
    }
  }
}
    `;

export const useRemoveOwnerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveOwnerMutation, TError, RemoveOwnerMutationVariables, TContext>) => {
    
    return useMutation<RemoveOwnerMutation, TError, RemoveOwnerMutationVariables, TContext>(
      {
    mutationKey: ['RemoveOwner'],
    mutationFn: useFetchData<RemoveOwnerMutation, RemoveOwnerMutationVariables>(RemoveOwnerDocument),
    ...options
  }
    )};

useRemoveOwnerMutation.getKey = () => ['RemoveOwner'];

export const SendRoadmapUpdateTestEmailDocument = `
    mutation SendRoadmapUpdateTestEmail($title: String!, $content: String!, $workItemId: ID!, $newStageId: ID) {
  sendRoadmapUpdateTestEmail(
    input: {roadmapUpdate: {title: $title, content: $content, workItemId: $workItemId, newStageId: $newStageId}}
  ) {
    success
  }
}
    `;

export const useSendRoadmapUpdateTestEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendRoadmapUpdateTestEmailMutation, TError, SendRoadmapUpdateTestEmailMutationVariables, TContext>) => {
    
    return useMutation<SendRoadmapUpdateTestEmailMutation, TError, SendRoadmapUpdateTestEmailMutationVariables, TContext>(
      {
    mutationKey: ['SendRoadmapUpdateTestEmail'],
    mutationFn: useFetchData<SendRoadmapUpdateTestEmailMutation, SendRoadmapUpdateTestEmailMutationVariables>(SendRoadmapUpdateTestEmailDocument),
    ...options
  }
    )};

useSendRoadmapUpdateTestEmailMutation.getKey = () => ['SendRoadmapUpdateTestEmail'];

export const SendWorkItemMovedTestEmailDocument = `
    mutation SendWorkItemMovedTestEmail($workItemId: ID!) {
  createWorkItemMovedUpdate(input: {workItemId: $workItemId, isTestEmail: true}) {
    success
  }
}
    `;

export const useSendWorkItemMovedTestEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendWorkItemMovedTestEmailMutation, TError, SendWorkItemMovedTestEmailMutationVariables, TContext>) => {
    
    return useMutation<SendWorkItemMovedTestEmailMutation, TError, SendWorkItemMovedTestEmailMutationVariables, TContext>(
      {
    mutationKey: ['SendWorkItemMovedTestEmail'],
    mutationFn: useFetchData<SendWorkItemMovedTestEmailMutation, SendWorkItemMovedTestEmailMutationVariables>(SendWorkItemMovedTestEmailDocument),
    ...options
  }
    )};

useSendWorkItemMovedTestEmailMutation.getKey = () => ['SendWorkItemMovedTestEmail'];

export const UpdateWorkItemDocument = `
    mutation UpdateWorkItem($workItem: UpdateWorkItemAttributes!) {
  updateWorkItem(input: {workItem: $workItem}) {
    workItem {
      id
      name
      content
      projectedAt
      projectedAtFormat
      displayTimeline
      heroImage {
        ...UploadFieldImage
      }
      categories {
        id
        name
        backgroundColor
        textColor
      }
      owner {
        id
        displayName
        initials
        avatarImage {
          ...UploadFieldImage
        }
      }
      members {
        id
        displayName
        initials
        avatarImage {
          ...UploadFieldImage
        }
      }
    }
    errors {
      message
      path
    }
  }
}
    ${UploadFieldImageFragmentDoc}`;

export const useUpdateWorkItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateWorkItemMutation, TError, UpdateWorkItemMutationVariables, TContext>) => {
    
    return useMutation<UpdateWorkItemMutation, TError, UpdateWorkItemMutationVariables, TContext>(
      {
    mutationKey: ['UpdateWorkItem'],
    mutationFn: useFetchData<UpdateWorkItemMutation, UpdateWorkItemMutationVariables>(UpdateWorkItemDocument),
    ...options
  }
    )};

useUpdateWorkItemMutation.getKey = () => ['UpdateWorkItem'];

export const UpdatesWorkItemDocument = `
    query UpdatesWorkItem($workItemId: ID!) {
  workItem(id: $workItemId) {
    id
    roadmapUpdates {
      id
      title
      content
      createdAt
      author {
        id
        name
        email
      }
    }
  }
}
    `;

export const useUpdatesWorkItemQuery = <
      TData = UpdatesWorkItemQuery,
      TError = unknown
    >(
      variables: UpdatesWorkItemQueryVariables,
      options?: Omit<UseQueryOptions<UpdatesWorkItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UpdatesWorkItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UpdatesWorkItemQuery, TError, TData>(
      {
    queryKey: ['UpdatesWorkItem', variables],
    queryFn: useFetchData<UpdatesWorkItemQuery, UpdatesWorkItemQueryVariables>(UpdatesWorkItemDocument).bind(null, variables),
    ...options
  }
    )};

useUpdatesWorkItemQuery.getKey = (variables: UpdatesWorkItemQueryVariables) => ['UpdatesWorkItem', variables];

export const useInfiniteUpdatesWorkItemQuery = <
      TData = InfiniteData<UpdatesWorkItemQuery>,
      TError = unknown
    >(
      variables: UpdatesWorkItemQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UpdatesWorkItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UpdatesWorkItemQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<UpdatesWorkItemQuery, UpdatesWorkItemQueryVariables>(UpdatesWorkItemDocument)
    return useInfiniteQuery<UpdatesWorkItemQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['UpdatesWorkItem.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteUpdatesWorkItemQuery.getKey = (variables: UpdatesWorkItemQueryVariables) => ['UpdatesWorkItem.infinite', variables];

export const WorkItemIdeasDocument = `
    query WorkItemIdeas($workItemId: ID!) {
  workItem: node(id: $workItemId) {
    ... on WorkItem {
      ideas {
        id
        name
      }
    }
  }
}
    `;

export const useWorkItemIdeasQuery = <
      TData = WorkItemIdeasQuery,
      TError = unknown
    >(
      variables: WorkItemIdeasQueryVariables,
      options?: Omit<UseQueryOptions<WorkItemIdeasQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<WorkItemIdeasQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<WorkItemIdeasQuery, TError, TData>(
      {
    queryKey: ['WorkItemIdeas', variables],
    queryFn: useFetchData<WorkItemIdeasQuery, WorkItemIdeasQueryVariables>(WorkItemIdeasDocument).bind(null, variables),
    ...options
  }
    )};

useWorkItemIdeasQuery.getKey = (variables: WorkItemIdeasQueryVariables) => ['WorkItemIdeas', variables];

export const useInfiniteWorkItemIdeasQuery = <
      TData = InfiniteData<WorkItemIdeasQuery>,
      TError = unknown
    >(
      variables: WorkItemIdeasQueryVariables,
      options: Omit<UseInfiniteQueryOptions<WorkItemIdeasQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<WorkItemIdeasQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<WorkItemIdeasQuery, WorkItemIdeasQueryVariables>(WorkItemIdeasDocument)
    return useInfiniteQuery<WorkItemIdeasQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['WorkItemIdeas.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteWorkItemIdeasQuery.getKey = (variables: WorkItemIdeasQueryVariables) => ['WorkItemIdeas.infinite', variables];

export const WorkItemShowDocument = `
    query WorkItemShow($workItemId: ID!, $projectId: ID!) {
  project(id: $projectId) {
    id
    roadmapMoveUpdatesEnabled
    roadmapWatchedStages
    stages {
      nodes {
        id
        name
      }
    }
  }
  workItem(id: $workItemId) {
    id
    name
    displayTimeline
    events {
      nodes {
        id
        eventType
        createdAt
        internalOnly
        data
      }
    }
    stage {
      id
      published
      showOnPublicRoadmap
    }
    ideas {
      id
      privatePermalink
      name
    }
  }
}
    `;

export const useWorkItemShowQuery = <
      TData = WorkItemShowQuery,
      TError = unknown
    >(
      variables: WorkItemShowQueryVariables,
      options?: Omit<UseQueryOptions<WorkItemShowQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<WorkItemShowQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<WorkItemShowQuery, TError, TData>(
      {
    queryKey: ['WorkItemShow', variables],
    queryFn: useFetchData<WorkItemShowQuery, WorkItemShowQueryVariables>(WorkItemShowDocument).bind(null, variables),
    ...options
  }
    )};

useWorkItemShowQuery.getKey = (variables: WorkItemShowQueryVariables) => ['WorkItemShow', variables];

export const useInfiniteWorkItemShowQuery = <
      TData = InfiniteData<WorkItemShowQuery>,
      TError = unknown
    >(
      variables: WorkItemShowQueryVariables,
      options: Omit<UseInfiniteQueryOptions<WorkItemShowQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<WorkItemShowQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<WorkItemShowQuery, WorkItemShowQueryVariables>(WorkItemShowDocument)
    return useInfiniteQuery<WorkItemShowQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['WorkItemShow.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteWorkItemShowQuery.getKey = (variables: WorkItemShowQueryVariables) => ['WorkItemShow.infinite', variables];

export const PublishWorkItemDocument = `
    mutation publishWorkItem($id: ID!) {
  publishWorkItem(input: {id: $id}) {
    workItem {
      id
      state
      publishedAt
    }
  }
}
    `;

export const usePublishWorkItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PublishWorkItemMutation, TError, PublishWorkItemMutationVariables, TContext>) => {
    
    return useMutation<PublishWorkItemMutation, TError, PublishWorkItemMutationVariables, TContext>(
      {
    mutationKey: ['publishWorkItem'],
    mutationFn: useFetchData<PublishWorkItemMutation, PublishWorkItemMutationVariables>(PublishWorkItemDocument),
    ...options
  }
    )};

usePublishWorkItemMutation.getKey = () => ['publishWorkItem'];

export const UnpublishWorkItemDocument = `
    mutation unpublishWorkItem($id: ID!) {
  unpublishWorkItem(input: {id: $id}) {
    workItem {
      id
      state
      publishedAt
    }
  }
}
    `;

export const useUnpublishWorkItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnpublishWorkItemMutation, TError, UnpublishWorkItemMutationVariables, TContext>) => {
    
    return useMutation<UnpublishWorkItemMutation, TError, UnpublishWorkItemMutationVariables, TContext>(
      {
    mutationKey: ['unpublishWorkItem'],
    mutationFn: useFetchData<UnpublishWorkItemMutation, UnpublishWorkItemMutationVariables>(UnpublishWorkItemDocument),
    ...options
  }
    )};

useUnpublishWorkItemMutation.getKey = () => ['unpublishWorkItem'];
